/*
 * Generated by graphql-codegen. Do not modify this file manually.
 */

import type { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Represents basis points (Bps). Transported as an int */
  Bps: { input: number; output: number; }
  /** Represents a monetary value in cents of USD. Transported as an int (e.g., 1000 for $10.00). */
  Cents: { input: import("@betterment/core").Money; output: import("@betterment/core").Money; }
  /**
   * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string.
   */
  Date: { input: string; output: Date; }
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC and any UTC offset other than 0 will be rejected.
   */
  DateTime: { input: Date; output: Date; }
  /** Represents HTML rendered content. Transported as a String. E.g.: "<b>Hello</b> world". */
  HTML: { input: string; output: DocumentFragment; }
  /**
   * The unencoded legacy system identifier for a record. This provides for client-side backwards compatibility
   * when passing ID values from GraphQL contexts to REST-backed contexts. See: Description for `scalar ID`.
   */
  LegacyID: { input: number; output: number; }
  /**
   * The unencoded legacy system identifier for a record, when it exists as a string. This provides for client-side backwards
   * compatibility when passing string-based ID values from GraphQL contexts to
   * REST-backed contexts. See: Description for `scalar ID`.
   */
  LegacyUUID: { input: string; output: string; }
  /** Represents a percent value. Transported as a Float. Ex: 50 represents 50%, and 0.5 represents 0.5%. */
  Percent: { input: number; output: number; }
  /** A Tax Identification Number */
  TIN: { input: string; output: string; }
  /** Represents a url. Transported as a String. E.g.: "https://example.com/some/where". */
  URL: { input: string; output: string; }
};

/** An entity that can hold accounts, such as a Client or Trust */
export type AccountHolder = {
  /** The id of the account holder. */
  id: Scalars['ID']['output'];
};

/** Enum of Account Types available for filtering in activity */
export enum AccountTypeFilterOption {
  /** Individual taxable */
  IndividualTaxable = 'INDIVIDUAL_TAXABLE',
  /** Inherited IRA */
  InheritedIra = 'INHERITED_IRA',
  /** Joint taxable */
  JointTaxable = 'JOINT_TAXABLE',
  /** Roth 401(k) */
  Roth_401K = 'ROTH_401K',
  /** Roth IRA */
  RothIra = 'ROTH_IRA',
  /** SEP IRA */
  SepIra = 'SEP_IRA',
  /** Traditional 401(k) */
  Traditional_401K = 'TRADITIONAL_401K',
  /** Traditional IRA */
  TraditionalIra = 'TRADITIONAL_IRA',
  /** Trust taxable */
  TrustTaxable = 'TRUST_TAXABLE'
}

/** YTD return data for a managed account */
export type AccountYtdReturn = {
  __typename: 'AccountYtdReturn';
  /** The managed account ID */
  accountId: Scalars['ID']['output'];
  /** The YTD return data (percentage and dollar amount) */
  ytdReturn: Maybe<YtdReturn>;
};

/** The relationship type of an advisor to their clients */
export enum ActivityAdvisorType {
  /** All */
  All = 'ALL',
  /** Primary */
  Primary = 'PRIMARY',
  /** Secondary */
  Secondary = 'SECONDARY'
}

/** The inputs used to filter transactional activity. */
export type ActivityFilterInput = {
  /** The selected activity item types by which to filter. */
  activityTypes?: InputMaybe<Array<ActivityItemTypeFilterOption>>;
  /** The type of advisor role by which to filter activity items. */
  advisorType?: InputMaybe<ActivityAdvisorType>;
  /** The client ids selected for which to filter. */
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The name of the selected date range by which to filter. */
  dateRange?: InputMaybe<DateRangeOption>;
  /** The end time for the custom date range option. */
  endTimeExclusive?: InputMaybe<Scalars['Date']['input']>;
  /** The selected account types by which to filter. */
  legalAccountTypes?: InputMaybe<Array<AccountTypeFilterOption>>;
  /** The start time for the custom date range option. */
  startTimeInclusive?: InputMaybe<Scalars['Date']['input']>;
};

/** An item of financial activity. */
export type ActivityItem = {
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /** The id of the item. */
  id: Scalars['ID']['output'];
  /** A list of statuses representing the current and historical state of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
};

/** An activity item representing a change in a user's portfolio or its allocation */
export type ActivityItemAllocationChange = ActivityItem & {
  __typename: 'ActivityItemAllocationChange';
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /** The id of the item. */
  id: Scalars['ID']['output'];
  /** A description of the new allocation. */
  newPortfolioDescription: Scalars['String']['output'];
  /** A list of statuses representing the current and historical state of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
};

/** The connection type for ActivityItem. */
export type ActivityItemConnection = {
  __typename: 'ActivityItemConnection';
  /** A list of edges. */
  edges: Array<ActivityItemEdge>;
  /** A list of nodes. */
  nodes: Array<ActivityItemAllocationChange | ActivityItemDeposit | ActivityItemFee | ActivityItemOrder | ActivityItemOther | ActivityItemTradeGroup | ActivityItemTransferGroup | ActivityItemWithdrawal>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An activity item representing a deposit (money inflow) */
export type ActivityItemDeposit = ActivityItem & {
  __typename: 'ActivityItemDeposit';
  /** The amount of the activity item. */
  amount: Maybe<Scalars['Cents']['output']>;
  /** The ID of the deposit request */
  depositRequestId: Maybe<Scalars['ID']['output']>;
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /** The sub account to which the deposit was made. */
  destinationAccount: CashAccount | DirectTradingAccount | ManagedSubAccount;
  /** The id of the item. */
  id: Scalars['ID']['output'];
  /** The transaction memo, if any. */
  memo: Maybe<Scalars['String']['output']>;
  /** Indicates whether the deposit was returned */
  returned: Scalars['Boolean']['output'];
  /** The bank account from which the deposit was made. */
  sourceAccount: Maybe<BankAccount>;
  /** A list of statuses representing the current and historical state of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
};

/** An edge in a connection for activity items */
export type ActivityItemEdge = {
  __typename: 'ActivityItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ActivityItemAllocationChange | ActivityItemDeposit | ActivityItemFee | ActivityItemOrder | ActivityItemOther | ActivityItemTradeGroup | ActivityItemTransferGroup | ActivityItemWithdrawal;
};

/** An activity item representing a fee */
export type ActivityItemFee = ActivityItem & {
  __typename: 'ActivityItemFee';
  /** The amount of the activity item. */
  amount: Maybe<Scalars['Cents']['output']>;
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /** The reason for an on-demand advisory fee. */
  feeReason: Maybe<Scalars['String']['output']>;
  /** The id of the item. */
  id: Scalars['ID']['output'];
  /** A list of statuses representing the current and historical state of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
};

/** The details of the order and resulting trading activity item */
export type ActivityItemOrder = ActivityItem & {
  __typename: 'ActivityItemOrder';
  /** The URL to the activity reports page with the current objects filter params */
  activityReportsUrl: Maybe<Scalars['URL']['output']>;
  /** The amount the order was submitted for */
  amountRequested: Maybe<Scalars['Cents']['output']>;
  /** The actual amount that was traded. */
  amountTraded: Maybe<Scalars['Cents']['output']>;
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /** The id of the item. */
  id: Scalars['ID']['output'];
  /** The security that was bought or sold */
  security: SecurityFund | SecurityStock;
  /** The price per share for the order, if the order is complete */
  sharePrice: Maybe<Scalars['Cents']['output']>;
  /** The number of shares the order was submitted for */
  sharesRequested: Maybe<Scalars['String']['output']>;
  /** The actual number of shares that were traded. */
  sharesTraded: Maybe<Scalars['String']['output']>;
  /** A list of statuses representing the current and historical state of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
  /** The trade side for activity item trade (e.g. BUY or SELL) */
  tradeSide: ActivityItemTradeSide;
};

/** A default type for an activity item */
export type ActivityItemOther = ActivityItem & {
  __typename: 'ActivityItemOther';
  /** The amount of the activity item. */
  amount: Maybe<Scalars['Cents']['output']>;
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /** The id of the item. */
  id: Scalars['ID']['output'];
  /** A list of statuses representing the current and historical state of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
};

/** The stage of an activity item */
export enum ActivityItemStage {
  /** The activity item has been canceled and will not be processed. */
  Canceled = 'CANCELED',
  /** The activity item has been successfully processed. */
  Completed = 'COMPLETED',
  /** The activity item has a failed status. */
  Failed = 'FAILED',
  /** The activity item has been initiated but not yet processed. */
  Initiated = 'INITIATED',
  /** The activity item has been returned, indicating a failure or reversal of the transaction. */
  Returned = 'RETURNED',
  /** The activity item has been sent for processing. */
  Sent = 'SENT'
}

/** The status of an activity item */
export type ActivityItemStatus = {
  __typename: 'ActivityItemStatus';
  /** A description of the status */
  description: Maybe<Scalars['String']['output']>;
  /** The message displayed with the status of the activity item */
  message: Maybe<Scalars['String']['output']>;
  /** The stage of the activity item */
  stage: ActivityItemStage;
  /** The time the status was set */
  timestamp: Maybe<Scalars['DateTime']['output']>;
};

/** The details of the trade activity item */
export type ActivityItemTrade = {
  __typename: 'ActivityItemTrade';
  /** The cents amount for the buy or sell trade */
  amount: Scalars['Cents']['output'];
  /** The security that was bought or sold */
  security: SecurityFund | SecurityStock;
  /** The price per share of the asset at the time of the trade */
  sharePrice: Scalars['Cents']['output'];
  /** The number of shares bought or sold */
  shares: Scalars['String']['output'];
  /** The reason for the trade i.e. rebalance or tlh */
  tradeAttribution: Maybe<Scalars['String']['output']>;
  /** The reason for the trade, if there is one. Either a rebalance or tax loss harvesting or null. */
  tradeAttributionV2: Maybe<ActivityItemTradeAttribution>;
  /** The trade side for activity item trade (e.g. BUY or SELL) */
  tradeSide: ActivityItemTradeSide;
};

/** The reason for the trade, if there is one. Either a rebalance or tax loss harvesting or null. */
export enum ActivityItemTradeAttribution {
  /** The attribution type for rebalance. */
  Rebalance = 'REBALANCE',
  /** The attribution type for tax_loss_harvest. */
  TaxLossHarvest = 'TAX_LOSS_HARVEST'
}

/** An activity item representing a Trade (transfer of assets) */
export type ActivityItemTradeGroup = ActivityItem & {
  __typename: 'ActivityItemTradeGroup';
  /** The URL to the activity reports page with the current objects filter params */
  activityReportsUrl: Maybe<Scalars['URL']['output']>;
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /** The id of the item. */
  id: Scalars['ID']['output'];
  /** The details for purchases associated with the trade(s) */
  purchases: Array<ActivityItemTrade>;
  /** The total amount of the purchases associated with the trade(s) */
  purchasesAmount: Scalars['Cents']['output'];
  /** The details for sales associated with the trade(s) */
  sales: Array<ActivityItemTrade>;
  /** The total amount of the sales associated with the trade(s) */
  salesAmount: Scalars['Cents']['output'];
  /** A list of statuses representing the current and historical state of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
};

/** The trade side for activity item trade (e.g. BUY or SELL) */
export enum ActivityItemTradeSide {
  /** The buy side of a trade. */
  Buy = 'BUY',
  /** The sell side of a trade. */
  Sell = 'SELL'
}

/** The details of the trade activity item */
export type ActivityItemTransfer = {
  __typename: 'ActivityItemTransfer';
  /** The cents amount for individual transfer item */
  amount: Scalars['Cents']['output'];
  /** The type of asset transferred (i.e. cash or security) No longer supported. Use asset_type_v_2 instead */
  assetType: Scalars['String']['output'];
  /** The type of asset transferred (i.e. cash or security) */
  assetTypeV2: ActivityItemTransferAssetType;
  /** The account to which the asset was transferred */
  destinationAccount: Maybe<CashAccount | DirectTradingAccount | ManagedSubAccount>;
  /** The requested dollar amount for the transfer */
  requestedDollarTransferAmount: Maybe<Scalars['Cents']['output']>;
  /** The security that was transferred */
  security: Maybe<SecurityFund | SecurityStock>;
  /** The price per share of the asset at the time of the trade */
  sharePrice: Maybe<Scalars['Cents']['output']>;
  /** The number of shares transferred */
  shares: Maybe<Scalars['String']['output']>;
  /** The account from which the asset was transferred */
  sourceAccount: Maybe<CashAccount | DirectTradingAccount | ManagedSubAccount>;
  /** The ID of the transfer request */
  transferRequestId: Maybe<Scalars['ID']['output']>;
};

/** The asset type for activity item transfer (e.g. CASH or SECURITY) */
export enum ActivityItemTransferAssetType {
  /** The transfer is a cash type. */
  Cash = 'CASH',
  /** The transfer is a security type. */
  Security = 'SECURITY'
}

/** An activity item representing a transfer (money inflow) */
export type ActivityItemTransferGroup = ActivityItem & {
  __typename: 'ActivityItemTransferGroup';
  /** The URL to the activity reports page with the current objects filter params */
  activityReportsUrl: Maybe<Scalars['URL']['output']>;
  /** The amount of the activity item. */
  amount: Maybe<Scalars['Cents']['output']>;
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /** The sub account to which the transfer was made. */
  destinationAccount: Maybe<CashAccount | DirectTradingAccount | ManagedSubAccount>;
  /** The id of the item. */
  id: Scalars['ID']['output'];
  /** Indicates if the transfer is a full transfer. */
  isFullTransfer: Scalars['Boolean']['output'];
  /** The sub account from which the transfer was made. */
  sourceAccount: Maybe<CashAccount | DirectTradingAccount | ManagedSubAccount>;
  /** A list of statuses representing the current and historical state of the activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
  /** The individual transfers associated with the grouped transfer item. */
  transferItems: Array<ActivityItemTransfer>;
};

/** The transaction types by which the user can filter their activity. */
export enum ActivityItemTypeFilterOption {
  /** The type for allocation changes */
  AllocationChange = 'ALLOCATION_CHANGE',
  /** The type for deposits */
  Deposit = 'DEPOSIT',
  /** The type for fees */
  Fees = 'FEES',
  /** The type for all unmapped activity */
  Other = 'OTHER',
  /** The type for trading */
  Trade = 'TRADE',
  /** The type for transfers */
  Transfer = 'TRANSFER',
  /** The type for withdrawals */
  Withdrawal = 'WITHDRAWAL'
}

/** An activity item representing a withdrawal (money outflow) */
export type ActivityItemWithdrawal = ActivityItem & {
  __typename: 'ActivityItemWithdrawal';
  /** The amount of the activity item. */
  amount: Maybe<Scalars['Cents']['output']>;
  /** The description of the activity item. */
  description: Scalars['String']['output'];
  /** The bank account to which the withdrawal was made. */
  destinationAccount: Maybe<BankAccount>;
  /** The id of the item. */
  id: Scalars['ID']['output'];
  /** Indicates whether the withdrawal is a full withdrawal */
  isFullWithdrawal: Scalars['Boolean']['output'];
  /** The transaction memo, if any. */
  memo: Maybe<Scalars['String']['output']>;
  /** The sub account from which the withdrawal was made. */
  sourceAccount: CashAccount | DirectTradingAccount | ManagedSubAccount;
  /** The statuses of the withdrawal activity item. */
  statuses: Array<ActivityItemStatus>;
  /** The sub account the activity item belongs to. */
  subAccount: CashAccount | DirectTradingAccount | ManagedSubAccount;
  /** The time the activity item took place. */
  timestamp: Scalars['DateTime']['output'];
  /** The ID of the deposit request */
  withdrawalRequestId: Maybe<Scalars['ID']['output']>;
};

/**
 *     This union type represents an advised retirement plan. The supported types are:
 *
 *     * StandardFourOhOneKPlanType - Represents standard plans, both onboarding and active.
 *     * SoloFourOhOneKPlanType - A plan record that is created after clients accept
 * their invitations. Always represents an active plan.
 *     * ClientEnvelopeType - Represents onboarding solo plans.
 */
export type AdvisedPlan = Solo401kClientEnvelope | SoloFourOhOneKPlan | StandardFourOhOneKPlan;

/** A B4A Advisor */
export type Advisor = {
  __typename: 'Advisor';
  /** The current announcement to display to the advisor, if any. */
  currentAnnouncement: Maybe<Announcement>;
  /** The firm the advisor belongs to */
  firm: Firm;
  /** The unique identifier for the advisor */
  id: Scalars['ID']['output'];
  /** Whether the advisor has admin privileges */
  isAdmin: Scalars['Boolean']['output'];
  /** Whether the advisor has compliance role */
  isCompliance: Scalars['Boolean']['output'];
  /**
   * Advisor logo URLs in different sizes, including both normal and knocked out variants -
   *         this will fallback to using the firm logos if the advisor does not have custom logos set
   */
  logo: Maybe<Logo>;
  /** A set of messages for the advisor. */
  messages: Array<Message>;
  /** The name of the advisor */
  name: Scalars['String']['output'];
};


/** A B4A Advisor */
export type AdvisorMessagesArgs = {
  location: MessageLocation;
};

/** Stores the information for goal created by advisors */
export type AdvisorGoalCreation = {
  __typename: 'AdvisorGoalCreation';
  /** The unique Identifier for the goal creation */
  id: Scalars['ID']['output'];
  /** Indicates if auto adjust is enabled for the goal's portfolio. */
  isAutoAdjustEnabled: Scalars['Boolean']['output'];
  /** The account used for the owners goals */
  ownerAccount: AdvisorGoalCreationAccount;
  /** The a combination of the portfolio display name and the strategy title */
  portfolioStrategyDisplayName: Maybe<Scalars['String']['output']>;
  /** The term years for a user using default calculations */
  roundedTermYears: Maybe<Scalars['Int']['output']>;
  /** The account used for spouses goals */
  spouseAccount: AdvisorGoalCreationAccount;
};

/** Stores the information the accounts that are used to create a goal during the advisor goal creation flow */
export type AdvisorGoalCreationAccount = {
  __typename: 'AdvisorGoalCreationAccount';
  /** Indicates if auto adjust is enabled for the goal's portfolio. */
  isAutoAdjustEnabled: Scalars['Boolean']['output'];
  /** The a combination of the portfolio display name and the strategy title */
  portfolioStrategyDisplayName: Maybe<Scalars['String']['output']>;
  /** The term years for a user using default calculations */
  roundedTermYears: Scalars['Int']['output'];
};

/** The plan type of an Advisor 401k RFP */
export enum AdvisorRfpPlanType {
  /** Conversion plan */
  Conversion = 'CONVERSION',
  /** New plan */
  New = 'NEW',
  /** SIMPLE IRA plan */
  SimpleIra = 'SIMPLE_IRA',
  /** Solo 401(k) conversion plan */
  SoloKConversion = 'SOLO_K_CONVERSION'
}

/** An advised household affected by a billing plan change */
export type AffectedHousehold = {
  __typename: 'AffectedHousehold';
  /** The unique Identifier for the household */
  id: Scalars['ID']['output'];
  /** The name of the household based on single-user, multi-user, trust */
  name: Scalars['String']['output'];
  /** The open goals associated with the household */
  openGoals: Array<LegacyGoal>;
};

/** Common interface for all agreement documents */
export type AgreementDocument = {
  /** Whether this agreement version is active and available for use */
  active: Scalars['Boolean']['output'];
  /** When this document was created/uploaded */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Token for secure access */
  token: Maybe<Scalars['String']['output']>;
};

/** An announcement to display to the advisor on the summary page. */
export type Announcement = {
  __typename: 'Announcement';
  /** The unique name of the announcement. */
  name: Scalars['String']['output'];
  /** The display steps for the announcement modal. */
  steps: Array<AnnouncementStep>;
};

/** A record of an advisor dismissing an announcement. */
export type AnnouncementDismissal = {
  __typename: 'AnnouncementDismissal';
  /** The unique identifier for the dismissal. */
  id: Scalars['ID']['output'];
};

/** Redirect configuration for an announcement CTA. */
export type AnnouncementRedirect = {
  __typename: 'AnnouncementRedirect';
  /** Link target (_self, _blank). */
  target: Maybe<Scalars['String']['output']>;
  /** The URL to redirect to. */
  url: Scalars['String']['output'];
};

/** A single step in an announcement modal. */
export type AnnouncementStep = {
  __typename: 'AnnouncementStep';
  /** The body text. */
  body: Scalars['HTML']['output'];
  /** Optional call-to-action for this step. */
  cta: Maybe<AnnouncementStepCta>;
  /** The heading text. */
  heading: Scalars['HTML']['output'];
  /** Optional image for this step. */
  image: Maybe<AnnouncementStepImage>;
};

/** A call-to-action for an announcement step. */
export type AnnouncementStepCta = {
  __typename: 'AnnouncementStepCta';
  /** Optional redirect when the CTA is clicked. */
  redirect: Maybe<AnnouncementRedirect>;
  /** The CTA button text. */
  text: Scalars['String']['output'];
};

/** An image for an announcement step. */
export type AnnouncementStepImage = {
  __typename: 'AnnouncementStepImage';
  /** Alt text for the image. */
  alt: Maybe<Scalars['String']['output']>;
  /** Full URL to the image. */
  url: Scalars['String']['output'];
};

/** The 401(k) contributions for a specific year. */
export type Annual = {
  __typename: 'Annual';
  /** The 401(k) contribution amount and projection. */
  result: Contribution;
  /** A tax year. */
  taxYear: TaxYear;
};

/** The aggregate IRA contributions for a specific year. */
export type AnnualIraContributions = {
  __typename: 'AnnualIraContributions';
  /** The projected IRA contribution. */
  result: IraContributions;
  /** A unique identifier for an IraContributionsResult */
  taxYear: TaxYear;
};

/** A summary of accounts within a group, reflecting the eventual state after all pending migrations complete. */
export type AssignedAccountSummary = {
  __typename: 'AssignedAccountSummary';
  /** A derived ID for caching purposes. */
  id: Scalars['ID']['output'];
  /** Number of accounts currently mid-migration into this portfolio (subset of total). */
  incomingMigration: Scalars['Int']['output'];
  /** Number of SBLOC-pledged accounts. */
  sblocPledged: Scalars['Int']['output'];
  /** Number of tax-advantaged accounts in the eventual assigned state. */
  taxAdvantaged: Scalars['Int']['output'];
  /** Number of taxable accounts in the eventual assigned state. */
  taxable: Scalars['Int']['output'];
  /**
   * Total number of open accounts in the eventual assigned state: includes
   * accounts currently migrating in, excludes accounts currently migrating away.
   */
  total: Scalars['Int']['output'];
};

/** Managed account-specific autoglide details. */
export type Autoglide = {
  __typename: 'Autoglide';
  /** Indicates that autoglide is enabled for the account. */
  isEnabled: Scalars['Boolean']['output'];
};

/** A bank account that can be used for funding/withdrawing from other accounts at Betterment. */
export type BankAccount = {
  __typename: 'BankAccount';
  /** The icon representing the account. */
  icon: ThemedAsset;
  /** The unique id for the external account. */
  id: Scalars['ID']['output'];
  /** The display name for the external account */
  name: Scalars['String']['output'];
};

/** Relationship of a legal account beneficiary to the legal account holder */
export enum BeneficiaryRelationship {
  /** Legal entity (e.g., charity) */
  Entity = 'ENTITY',
  /** Family member/friend */
  Friend = 'FRIEND',
  /** Spouse */
  Spouse = 'SPOUSE'
}

/** Betterment portfolio details */
export type BettermentModelPortfolio = {
  __typename: 'BettermentModelPortfolio';
  /** Allocation Label */
  allocationLabel: Scalars['String']['output'];
  /** The brochure URL (aka the marketing website or https://betterment.com portfolio page) */
  brochureUrl: Maybe<Scalars['String']['output']>;
  /** The portfolio icon */
  icon: Maybe<ThemedAsset>;
  /** The id of the model portfolio */
  id: Scalars['ID']['output'];
  /** The white paper url */
  informationUrl: Maybe<Scalars['String']['output']>;
  /** The name of the model portfolio */
  name: Scalars['String']['output'];
  /** The quarterly update id */
  quarterlyUpdateId: Maybe<Scalars['String']['output']>;
  /** The quick compare short description of the model portfolio */
  quickCompareShortDescription: Maybe<Scalars['String']['output']>;
  /** The short description of the model portfolio */
  shortDescription: Maybe<Scalars['String']['output']>;
};

/** options for how often a firm is billed; associated with Firm */
export enum BillingFrequency {
  /** The firm bills monthly */
  Monthly = 'MONTHLY',
  /** The firm bills quarterly */
  Quarterly = 'QUARTERLY'
}

/** Billing plan details */
export type BillingPlan = {
  __typename: 'BillingPlan';
  /** The billing rate for the billing plan */
  billingRate: BillingRate;
  /** Whether the billing plan is the default plan for the firm */
  firmDefault: Scalars['Boolean']['output'];
  /** The unique identifier for the billing plan */
  id: Scalars['ID']['output'];
  /** The description of the last change that occurred for the billing plan */
  latestChangeDescription: Scalars['String']['output'];
  /** The name of the billing plan */
  name: Scalars['String']['output'];
  /** The number of clients assigned to the billing plan */
  numberOfClients: Scalars['Int']['output'];
  /** The payment type for the billing plan */
  paymentType: PaymentType;
  /** Details about how the platform fee is shared between the advisor and clients */
  platformFeeAllocation: PlatformFeeAllocation;
};

/** Input structure for a billing plan payment type. */
export type BillingPlanPaymentTypeInput = {
  /** The id of the billing plan that is having its payment type updated */
  id: Scalars['ID']['input'];
  /** The enum for the payment type */
  paymentType: PaymentType;
};

/** The billing rate for a billing plan represented as fixed, asset based, or tiered */
export type BillingRate = BillingRateAssetBased | BillingRateFixed | BillingRateTiered;

/** An asset based rate for a billing plan */
export type BillingRateAssetBased = {
  __typename: 'BillingRateAssetBased';
  /** The fee for the billing rate represented in bps */
  feeBps: Scalars['Bps']['output'];
};

/** An asset based rate for a billing plan */
export type BillingRateAssetBasedInput = {
  /** The fee for the billing rate represented in bps */
  feeRate: Scalars['Bps']['input'];
};

/** A fixed rate for a billing plan */
export type BillingRateFixed = {
  __typename: 'BillingRateFixed';
  /** The fee for the billing rate represented in cents */
  feeCents: Scalars['Cents']['output'];
};

/** A fixed rate for a billing plan */
export type BillingRateFixedInput = {
  /** The fee for the billing rate represented in cents */
  feeAmount: Scalars['Cents']['input'];
};

/** This is used to define the billing rate for a billing plan. It can be asset-based, fixed, or tiered. */
export type BillingRateInput =
  /** The asset based configuration for the billing plan. */
  { assetBasedConfiguration: BillingRateAssetBasedInput; fixedConfiguration?: never; tieredConfiguration?: never; }
  |  /** The fixed configuration for the billing plan. */
  { assetBasedConfiguration?: never; fixedConfiguration: BillingRateFixedInput; tieredConfiguration?: never; }
  |  /** The tiered configuration for the billing plan. */
  { assetBasedConfiguration?: never; fixedConfiguration?: never; tieredConfiguration: BillingRateTieredInput; };

/** A range for a tier within a tiered billing plan */
export type BillingRateRange = {
  __typename: 'BillingRateRange';
  /** The firm fee for the tier in cents or bps */
  firmFee: SingleBillingRate;
  /** The upper bound of the tier represented in cents */
  tierEnd: Maybe<Scalars['Cents']['output']>;
};

/** Represents a tier in a tiered billing rate configuration. */
export type BillingRateRangeInput = {
  /** the fee configuration for the tier */
  firmFee: SingleBillingRateInput;
  /** The ending AUM in cents for the tier */
  tierEnd?: InputMaybe<Scalars['Cents']['input']>;
};

/** A tiered rate for a billing plan */
export type BillingRateTiered = {
  __typename: 'BillingRateTiered';
  /** The method for applying tiered rates */
  calculationMethod: TieredFeeCalculationMethod;
  /** The fee for the billing rate represented in an array of BillingRateRanges */
  tiers: Array<BillingRateRange>;
};

/** A tiered rate for a billing plan */
export type BillingRateTieredInput = {
  /** The method for applying tiered rates */
  calculationMethod?: InputMaybe<TieredFeeCalculationMethod>;
  /** The tiers of a tiered billing rate represented as an array of ranges */
  tiers: Array<BillingRateRangeInput>;
};

/** Details on a task that's blocking a plan from onboarding into Betterment. */
export type BlockingTask = {
  __typename: 'BlockingTask';
  /** Details on what action needs is being completed before the onboarding process can continue. */
  description: Scalars['String']['output'];
  /** A human-readable name for the task. */
  name: Scalars['String']['output'];
  /** The type of task. */
  type: Scalars['String']['output'];
};

/** Name and fee attempt data tied to a BulkFeeAttempt record */
export type BulkFeeAttempt = {
  __typename: 'BulkFeeAttempt';
  /** An array of fee attempts within the bulk fee attempt */
  feeAttempts: FeeAttemptsResult;
  /** The unique identifier for the bulk fee attempt */
  id: Scalars['ID']['output'];
  /** The name of the batch attempt provided by the creator */
  name: Scalars['String']['output'];
};

/** Batch of fees applied to advised clients */
export type BulkFeeIntent = {
  __typename: 'BulkFeeIntent';
  /** When the bulk fee intent was created */
  createdAt: Scalars['DateTime']['output'];
  /** The advisor who created the bulk fee intent (null if not created by an advisor) */
  createdBy: Maybe<Advisor>;
  /** The number of fee attempts that failed to process */
  failedCount: Maybe<Scalars['Int']['output']>;
  /** UUID of the bulk fee intent */
  id: Scalars['ID']['output'];
  /** The name of the bulk fee intent provided by the creator */
  name: Scalars['String']['output'];
  /** Date the firm was paid fees for a successful or partially successful batch */
  paidToFirmOn: Maybe<Scalars['Date']['output']>;
  /** Status of the bulk fee intent */
  status: BulkFeeIntentStatus;
  /** The total number of fee attempts submitted in the bulk fee intent */
  submittedCount: Scalars['Int']['output'];
  /** The filename of the uploaded CSV of fees */
  uploadedCsvFilename: Scalars['String']['output'];
};

/** The status of the bulk fee intent */
export enum BulkFeeIntentStatus {
  /** The bulk fee intent has been completed with any outcome (successful, failed, partial success) */
  Completed = 'COMPLETED',
  /** The bulk fee intent is currently being processed. */
  Processing = 'PROCESSING'
}

/**
 * Represents a pending bulk transfer action. Bulk transfers move
 * accounts from one model portfolio to another, allowing advisors to
 * transition multiple clients simultaneously. The transfer executes after
 * trading hours.
 */
export type BulkTransferPendingAction = PendingAction & PortfolioChangePendingAction & {
  __typename: 'BulkTransferPendingAction';
  /** The timestamp when the bulk transfer was initiated. */
  createdAt: Scalars['DateTime']['output'];
  /** The portfolio that will be applied to the account once this change completes. */
  futurePortfolio: FuturePortfolio;
  /** The unique identifier for this pending action. */
  id: Scalars['ID']['output'];
};

/** A high yield savings account that's part of the Cash Reserve program. */
export type CashAccount = EnvelopeAccount & LegalSubAccount & PerformanceAccount & {
  __typename: 'CashAccount';
  /** The individuals or entities that hold the account. */
  accountHolders: Array<Client | Trust>;
  /** The cash APY details for the account. */
  apy: CashApy;
  /** The balance of the account. */
  balance: Scalars['Cents']['output'];
  /** The envelope that contains the given account. */
  envelope: Envelope;
  /** FDIC insurance details for the account. */
  fdicInsurance: CashFdicInsurance;
  /** The icon representing the account. */
  icon: ThemedAsset;
  /** The id of the account. */
  id: Scalars['ID']['output'];
  /**
   * The legacy goal ID for the account. For compatibility with retail.
   * @deprecated Will be deleted in the future. Prepare to use the id field wherever possible.
   */
  legacyGoalId: Scalars['LegacyID']['output'];
  /** The legacy ID for this account. */
  legacySubAccountId: Scalars['LegacyID']['output'];
  /** The legal account holding this sub account. */
  legalAccount: LegalAccount;
  /** A set of messages for the account. */
  messages: Array<Message>;
  /** The name used to represent the account. */
  name: Scalars['String']['output'];
  /** The performance of the account. */
  performance: Performance;
  /** All recurring transaction configs involving this cash account. */
  recurringTransactionConfigs: Array<RecurringTransactionConfig>;
  /** The users who have access to the account. */
  users: Array<Client>;
};


/** A high yield savings account that's part of the Cash Reserve program. */
export type CashAccountBalanceArgs = {
  includePending: Scalars['Boolean']['input'];
};


/** A high yield savings account that's part of the Cash Reserve program. */
export type CashAccountMessagesArgs = {
  location: MessageLocation;
};


/** A high yield savings account that's part of the Cash Reserve program. */
export type CashAccountPerformanceArgs = {
  dateRangeOption?: DateRangeOption;
};

/** APY details for a given goal */
export type CashApy = {
  __typename: 'CashApy';
  /** Accompanying explanation with additional details for the APY */
  explanation: Scalars['HTML']['output'];
  /** Whether or not the given goal is currently receiving an APY boost based on any promotions. */
  isBoostActive: Scalars['Boolean']['output'];
  /** Whether or not the given goal is eligible for an APY boost based on any promotions. */
  isBoostEligible: Scalars['Boolean']['output'];
  /** The APY for the given account. */
  rate: Scalars['String']['output'];
};

/** FDIC insurance details for a cash account. */
export type CashFdicInsurance = {
  __typename: 'CashFdicInsurance';
  /** The amount covered by FDIC insurance for the given cash account */
  amount: Scalars['String']['output'];
  /** Accompanying explanation of the amount covered by FDIC insurance */
  explanation: Scalars['HTML']['output'];
};

/** An advisor's client */
export type Client = AccountHolder & {
  __typename: 'Client';
  /** The client's preferred first name */
  commonFirstName: Scalars['String']['output'];
  /** The client's formatted full name, using their preferred first name when available */
  commonFullName: Scalars['String']['output'];
  /** Provides data for the user's employers, if there are any. */
  employers: Array<Employer>;
  /** Provides data for the user's 401(k) contributions, if there are any. */
  fourOhOneKContributions: Maybe<Result>;
  /** The household the client belongs to */
  household: Household;
  /** The unique identifier of the client's household */
  householdId: Scalars['ID']['output'];
  /** The unique Identifier for the given client */
  id: Scalars['ID']['output'];
  /** Provides data for the user's IRA contributions, if there are any. */
  iraContributions: Maybe<IraContributionsResult>;
  /** The client's last name */
  lastName: Scalars['String']['output'];
  /** The legal full name for the given client */
  legalFullName: Scalars['String']['output'];
  /** Portfolio control settings for this client. Includes tax loss harvesting status and securities lending enrollment. */
  portfolioControls: UserPortfolioControls;
};

/** Potential beneficiary that is associated with a potential account */
export type ClientAccountBeneficiary = {
  __typename: 'ClientAccountBeneficiary';
  /** The date of birth of the potential beneficiary, only present for human beneficiaries */
  dateOfBirth: Maybe<Scalars['Date']['output']>;
  /** The allocation percentage of the potential beneficiary on the potential account */
  distributionShare: Scalars['Percent']['output'];
  /** The full name of the potential beneficiary */
  fullName: Scalars['String']['output'];
  /** The unique identifier for the given potential beneficiary */
  id: Scalars['ID']['output'];
  /** The relationship type of the potential beneficiary to the prospective client */
  relationship: ClientAccountBeneficiaryRelationship;
  /** The tax identifier of the potential beneficiary, may be null for non entity beneficiaries */
  taxIdentifier: Maybe<Scalars['TIN']['output']>;
};

/** Input structure for a Client Account Beneficiary. */
export type ClientAccountBeneficiaryInput = {
  /** Date of birth of the potential beneficiary. May be null if the potential beneficiary is an entity */
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  /** Distribution Share allocated to the beneficiary */
  distributionShare: Scalars['Percent']['input'];
  /** Full name of the beneficiary */
  fullName: Scalars['String']['input'];
  /** ID of the potential beneficiary record to update if present */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Flag to determine whether the beneficiary is primary or contingent */
  primary: Scalars['Boolean']['input'];
  /** Relationship of the potential beneficiary to the client */
  relationship: ClientAccountBeneficiaryRelationship;
  /** Tax Identification number of the potential beneficiary, may be null if the potential beneficiary is not an entity */
  taxIdentifier?: InputMaybe<Scalars['TIN']['input']>;
};

/** Enum of the relationship types of an account beneficiary to the account holder */
export enum ClientAccountBeneficiaryRelationship {
  /** Legal entity (e.g., charity) */
  Entity = 'ENTITY',
  /** Family member/friend */
  Friend = 'FRIEND',
  /** Spouse */
  Spouse = 'SPOUSE'
}

/** Legal account type associated with a prospective client */
export type ClientAccountTypeSummary = {
  __typename: 'ClientAccountTypeSummary';
  /** Collection of contingent beneficiaries for this account type for the prospective client */
  contingentBeneficiaries: Array<ClientAccountBeneficiary>;
  /** Display name of the account's type */
  displayName: Scalars['String']['output'];
  /** Collection of primary beneficiaries for this account type for the prospective client */
  primaryBeneficiaries: Array<ClientAccountBeneficiary>;
  /** Display name of the account type */
  type: LegalAccountType;
};

/** An advisor's client envelope for prospective client onboarding */
export type ClientEnvelope = ClientEnvelopeInterface & {
  __typename: 'ClientEnvelope';
  /** Collection of funding bank accounts associated with the client envelope */
  bankAccounts: Maybe<Array<ClientEnvelopeBankAccount>>;
  /** Collection of clients that belong to a client envelope */
  clients: Array<ClientEnvelopeClient>;
  /** The envelope ID */
  id: Scalars['ID']['output'];
  /** Collection of proposed legal accounts that belong to multiple clients in the household */
  jointAccounts: Maybe<Array<ClientAccountTypeSummary>>;
};

/** Funding bank accounts associated with a client envelope */
export type ClientEnvelopeBankAccount = {
  __typename: 'ClientEnvelopeBankAccount';
  /** The masked account number of the bank account. */
  accountNumber: Scalars['String']['output'];
  /** The name of the bank associated with the bank account, if known. */
  bankName: Maybe<Scalars['String']['output']>;
  /** The unique Identifier for the bank account */
  id: Scalars['ID']['output'];
  /** Represents the account type. Checking accounts are false, savings accounts are true */
  isSavings: Scalars['Boolean']['output'];
  /** The routing number of the bank account. */
  routingNumber: Scalars['String']['output'];
};

/** Input structure for a Client Account Funding Bank Account. */
export type ClientEnvelopeBankAccountInput = {
  /** The account number of the bank account. */
  accountNumber: Scalars['String']['input'];
  /** ID of the potential bank account record to update if present */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Represents the account type. Checking accounts are false, savings accounts are true */
  isSavings: Scalars['Boolean']['input'];
  /** The routing number of the bank account. */
  routingNumber: Scalars['String']['input'];
};

/** Prospective client associated with a client envelope */
export type ClientEnvelopeClient = {
  __typename: 'ClientEnvelopeClient';
  /** The first name of the prospective client */
  firstName: Scalars['String']['output'];
  /** The unique Identifier for the given prospective client */
  id: Scalars['ID']['output'];
  /** Collection of proposed account types associated to the prospective client */
  individualAccounts: Array<ClientAccountTypeSummary>;
  /** Records of the invitations sent to the plan owner and (possibly) their spouse. */
  invites: Array<ClientEnvelopeInvitation>;
  /** The last name of the prospective client */
  lastName: Scalars['String']['output'];
};

/** Attributes that all types of client envelopes are concerned with. */
export type ClientEnvelopeInterface = {
  /** Collection of clients that belong to a client envelope */
  clients: Array<ClientEnvelopeClient>;
  /** The envelope ID */
  id: Scalars['ID']['output'];
};

/** Details on a client envelope invitation */
export type ClientEnvelopeInvitation = {
  __typename: 'ClientEnvelopeInvitation';
  /** The CoPilot ID for the invitation. Can be used to trigger CoPilot actions. */
  copilotPendingId: Maybe<Scalars['ID']['output']>;
  /** The time that the envelope can no longer be accepted. */
  expiresAt: Maybe<Scalars['DateTime']['output']>;
  /** The envelope ID. */
  id: Scalars['ID']['output'];
};

/** The 401(k) contributions for a user. */
export type Contribution = {
  __typename: 'Contribution';
  /** The amount of 401(k) contributions. */
  amount: Scalars['Cents']['output'];
  /** A unique identifier for a FourOhOneKContributions */
  id: Scalars['ID']['output'];
  /** A projection of future 401(k) contributions. */
  projection: Maybe<Projection>;
};

/** Input structure for Client Envelope Beneficiaries mutations */
export type ContributionDetailInput = {
  /** The type of contributions */
  contributionType: Solo401kConversionContributionCategory;
  /** The date of the initial roth contribution, if the contributionType is roth */
  initialRothContributionOn?: InputMaybe<Scalars['Date']['input']>;
  /** The inception-to-date employee contributions */
  itdEmployeeContributions?: InputMaybe<Scalars['Cents']['input']>;
  /** The inception-to-date employer contributions */
  itdEmployerContributions?: InputMaybe<Scalars['Cents']['input']>;
  /** The total amount from past rollovers */
  itdRolloverAmount?: InputMaybe<Scalars['Cents']['input']>;
  /** The year-to-date employee contributions */
  ytdEmployeeContributions?: InputMaybe<Scalars['Cents']['input']>;
  /** The year-to-date employer contributions */
  ytdEmployerContributions?: InputMaybe<Scalars['Cents']['input']>;
};

/** Autogenerated input type of CreateBulkFeeIntentMutation */
export type CreateBulkFeeIntentMutationInput = {
  /** The id of the bulk fee attempt that the bulk fee intent will be created based off of */
  bulkFeeAttemptId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateBulkFeeIntentMutation. */
export type CreateBulkFeeIntentMutationPayload = {
  __typename: 'CreateBulkFeeIntentMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateBulkFeeIntentMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateBulkFeeIntentMutation execution as type BulkFeeIntent. */
  result: Maybe<BulkFeeIntent>;
};

/** Autogenerated input type of CreateClientActivityCsvExportMutation */
export type CreateClientActivityCsvExportMutationInput = {
  /** Filters to apply to the activity search. */
  filters?: InputMaybe<ActivityFilterInput>;
};

/** Autogenerated return type of CreateClientActivityCsvExportMutation. */
export type CreateClientActivityCsvExportMutationPayload = {
  __typename: 'CreateClientActivityCsvExportMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateClientActivityCsvExportMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateClientActivityCsvExportMutation execution as type CsvExport. */
  result: Maybe<CsvExport>;
};

/** Autogenerated input type of CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutation */
export type CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationInput = {
  /** The ID of the plan */
  planId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutation. */
export type CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationPayload = {
  __typename: 'CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationPayload';
  /**
   * The user-displayable errors produced while attempting to resolve
   * CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutation.
   */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the
   * CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutation execution as type
   * Solo401kConversionIntent.
   */
  result: Maybe<Solo401kConversionIntent>;
};

/** Autogenerated input type of CreateDraftSolo401kConversionIntentMutation */
export type CreateDraftSolo401kConversionIntentMutationInput = {
  /** The ID of the plan owner */
  planOwnerId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateDraftSolo401kConversionIntentMutation. */
export type CreateDraftSolo401kConversionIntentMutationPayload = {
  __typename: 'CreateDraftSolo401kConversionIntentMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateDraftSolo401kConversionIntentMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateDraftSolo401kConversionIntentMutation execution as type Solo401kConversionIntent. */
  result: Maybe<Solo401kConversionIntent>;
};

/** Autogenerated input type of CreateFinancialSecurityOrderRequestMutation */
export type CreateFinancialSecurityOrderRequestMutationInput = {
  /** Determines if the order request is to buy or sell the security */
  direction: FinancialSecurityOrderRequestDirection;
  /** Custody's security ID for the security to order */
  financialSecurityId: Scalars['ID']['input'];
  /** Optional ID of the previously generated preview. Used for recordkeeping */
  previewId?: InputMaybe<Scalars['ID']['input']>;
  /** Sell the entire position, only valid for sales */
  sellAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** The price per share in cents at the time of the order request */
  sharePriceCents?: InputMaybe<Scalars['Int']['input']>;
  /** The account within which to perform the trade */
  subAccountId: Scalars['ID']['input'];
  /** Dollar amount or number of shares requested for the order */
  value: FinancialSecurityOrderRequestValueInput;
};

/** Autogenerated return type of CreateFinancialSecurityOrderRequestMutation. */
export type CreateFinancialSecurityOrderRequestMutationPayload = {
  __typename: 'CreateFinancialSecurityOrderRequestMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateFinancialSecurityOrderRequestMutation. */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the CreateFinancialSecurityOrderRequestMutation
   * execution as type FinancialSecurityOrderRequest.
   */
  result: Maybe<FinancialSecurityOrderRequest>;
};

/** Autogenerated input type of CreateFinancialSecuritySellOrderTaxImpactPreviewMutation */
export type CreateFinancialSecuritySellOrderTaxImpactPreviewMutationInput = {
  /** The financial security ID for the security to order */
  financialSecurityId: Scalars['ID']['input'];
  /** The account within which to perform the trade */
  subAccountId: Scalars['ID']['input'];
  /** Dollar amount or number of shares requested for the order */
  value: FinancialSecurityOrderRequestValueInput;
};

/** Autogenerated return type of CreateFinancialSecuritySellOrderTaxImpactPreviewMutation. */
export type CreateFinancialSecuritySellOrderTaxImpactPreviewMutationPayload = {
  __typename: 'CreateFinancialSecuritySellOrderTaxImpactPreviewMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateFinancialSecuritySellOrderTaxImpactPreviewMutation. */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the
   * CreateFinancialSecuritySellOrderTaxImpactPreviewMutation execution as type
   * FinancialSecuritySellOrderTaxImpactPreview.
   */
  result: Maybe<FinancialSecuritySellOrderTaxImpactPreview>;
};

/** Autogenerated return type of CreateFirmBillableAccountsCsvExportMutation. */
export type CreateFirmBillableAccountsCsvExportMutationPayload = {
  __typename: 'CreateFirmBillableAccountsCsvExportMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateFirmBillableAccountsCsvExportMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateFirmBillableAccountsCsvExportMutation execution as type CsvExport. */
  result: Maybe<CsvExport>;
};

/** Dictionary of key and display text pairs */
export type CreateFourOhOneKReportInputArguments = {
  /** The attribute used to create a 401(k) report */
  attribute?: InputMaybe<Scalars['String']['input']>;
  /** The value of the attribute used to create a 401(k) report */
  value?: InputMaybe<Scalars['Date']['input']>;
};

/** Autogenerated input type of CreateFourOhOneKReportMutation */
export type CreateFourOhOneKReportMutationInput = {
  /** The list of arguments used to create the report */
  arguments: Array<CreateFourOhOneKReportInputArguments>;
  /** The ID of the 401(k) plan */
  planId: Scalars['ID']['input'];
  /** The type of report to run */
  type: Scalars['String']['input'];
};

/** Autogenerated return type of CreateFourOhOneKReportMutation. */
export type CreateFourOhOneKReportMutationPayload = {
  __typename: 'CreateFourOhOneKReportMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateFourOhOneKReportMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateFourOhOneKReportMutation execution as type CreateFourOhOneKReportPayload. */
  result: Maybe<CreateFourOhOneKReportPayload>;
};

/** Payload for create report mutation */
export type CreateFourOhOneKReportPayload = {
  __typename: 'CreateFourOhOneKReportPayload';
  /** The attributes and values used to create a 401(k) report */
  endDate: Maybe<Scalars['Date']['output']>;
  /** The plan id of the 401(k) report */
  startDate: Maybe<Scalars['Date']['output']>;
  /** The file type of the report */
  type: Scalars['String']['output'];
};

/** Autogenerated input type of CreateFourOhOneKRequestForProposalMutation */
export type CreateFourOhOneKRequestForProposalMutationInput = {
  /** Additional notes or details about the RFP submission */
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  /** Whether the advisor is currently advising the client */
  advisorCurrentlyAdvisingClient?: InputMaybe<Scalars['Boolean']['input']>;
  /** Advisory fee in basis points */
  advisoryFeeBps: Scalars['Bps']['input'];
  /** Name of the client's company */
  clientCompanyName: Scalars['String']['input'];
  /** Full name of the client */
  clientFullName?: InputMaybe<Scalars['String']['input']>;
  /** Estimated assets under management in cents */
  estimatedAssetsCents?: InputMaybe<Scalars['Cents']['input']>;
  /** Expected number of plan participants */
  expectedParticipants: Scalars['Int']['input'];
  /** Other payroll provider specified by the advisor */
  otherPayrollProvider?: InputMaybe<Scalars['String']['input']>;
  /** Client's payroll provider */
  payrollProvider?: InputMaybe<Scalars['String']['input']>;
  /** Type of 401(k) plan */
  planType: AdvisorRfpPlanType;
  /** Target date to launch the 401(k) plan */
  targetLaunchDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Autogenerated return type of CreateFourOhOneKRequestForProposalMutation. */
export type CreateFourOhOneKRequestForProposalMutationPayload = {
  __typename: 'CreateFourOhOneKRequestForProposalMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateFourOhOneKRequestForProposalMutation. */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the CreateFourOhOneKRequestForProposalMutation
   * execution as type CreateFourOhOneKRequestForProposalResult.
   */
  result: Maybe<CreateFourOhOneKRequestForProposalResult>;
};

/** Payload for CreateFourOhOneKRequestForProposal mutation */
export type CreateFourOhOneKRequestForProposalResult = {
  __typename: 'CreateFourOhOneKRequestForProposalResult';
  /** Whether the submission successfully saved */
  isSuccess: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateTradePreviewMutation */
export type CreateTradePreviewMutationInput = {
  /** The type of action being requested */
  actionType: TradePreviewAction;
  /** The drift threshold. If null, the current drift threshold will be used */
  driftThreshold?: InputMaybe<Scalars['Percent']['input']>;
  /** The edit_portfolio_strategy_flow id. Required when actionType is EDIT_PORTFOLIO_STRATEGY. */
  editPortfolioStrategyFlowId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID corresponding to the goal for which the preview is being created */
  managedAccountId: Scalars['ID']['input'];
  /** The new risk level id. If null, the current risk level will be used */
  riskLevelId?: InputMaybe<Scalars['ID']['input']>;
  /** The trading instruction to use for the preview */
  tradingInstruction: TradePreviewTradingInstruction;
};

/** Autogenerated return type of CreateTradePreviewMutation. */
export type CreateTradePreviewMutationPayload = {
  __typename: 'CreateTradePreviewMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateTradePreviewMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateTradePreviewMutation execution as type TradePreview. */
  result: Maybe<TradePreview>;
};

/** Active record that represents data exported as a CSV */
export type CsvExport = {
  __typename: 'CsvExport';
  /** Unique identifier of the csv export */
  id: Scalars['ID']['output'];
  /** The generation status of the csv file */
  status: CsvExportStatus;
};

/** The status of a csv export */
export enum CsvExportStatus {
  /** Complete */
  Complete = 'COMPLETE',
  /** Error */
  Error = 'ERROR',
  /** Generating */
  Generating = 'GENERATING'
}

/** Date range options used to filter certain queries. */
export enum DateRangeOption {
  /** All time */
  AllTime = 'ALL_TIME',
  /** Custom */
  Custom = 'CUSTOM',
  /** Past five years */
  PastFiveYears = 'PAST_FIVE_YEARS',
  /** Past month */
  PastMonth = 'PAST_MONTH',
  /** Past three months */
  PastThreeMonths = 'PAST_THREE_MONTHS',
  /** Past three years */
  PastThreeYears = 'PAST_THREE_YEARS',
  /** Past two years */
  PastTwoYears = 'PAST_TWO_YEARS',
  /** Past year */
  PastYear = 'PAST_YEAR',
  /** Year to date */
  YearToDate = 'YEAR_TO_DATE'
}

/** Dictionary of key and display text pairs */
export type Dictionary = {
  __typename: 'Dictionary';
  /** The human-readable display text for the tax filing status */
  displayText: Scalars['String']['output'];
  /** The string identifier of the tax filing status */
  key: Scalars['String']['output'];
};

/** An investment account that is used for direct trading */
export type DirectTradingAccount = EnvelopeAccount & LegalSubAccount & {
  __typename: 'DirectTradingAccount';
  /** The individuals or entities that hold the account. */
  accountHolders: Array<Client | Trust>;
  /** The balance of the account balance (including pending). */
  balance: Scalars['Cents']['output'];
  /** Cash balance values for direct trading account */
  cashBalances: DirectTradingCashBalances;
  /** The envelope that contains the given sub account. */
  envelope: Envelope;
  /** The icon representing the account. */
  icon: ThemedAsset;
  /** The unique identifier of the direct trading account  */
  id: Scalars['ID']['output'];
  /** The legacy ID for this account */
  legacySubAccountId: Scalars['LegacyID']['output'];
  /** The legal account holding this sub account. */
  legalAccount: LegalAccount;
  /** A set of messages for the account. */
  messages: Array<Message>;
  /** The name representing the account. */
  name: Scalars['String']['output'];
  /** The performance of the account. */
  performance: Performance;
  /** The security positions held within the account. */
  securityPositions: Array<DirectTradingSecurityPosition>;
  /** The users who have access to the account */
  users: Array<Client>;
};


/** An investment account that is used for direct trading */
export type DirectTradingAccountMessagesArgs = {
  location: MessageLocation;
};


/** An investment account that is used for direct trading */
export type DirectTradingAccountPerformanceArgs = {
  dateRangeOption?: DateRangeOption;
};

/** Cash balance values for direct trading account */
export type DirectTradingCashBalances = {
  __typename: 'DirectTradingCashBalances';
  /** boolean to determine if there's any pending cash balance. */
  anyPending: Scalars['Boolean']['output'];
  /** Cash balance customer can use as buying power */
  availableBalance: Scalars['Cents']['output'];
  /** Cash total balance, using pending inflow/outflow in calculation */
  totalBalance: Scalars['Cents']['output'];
};

/** The held position of a given security for a direct trading account. */
export type DirectTradingSecurityPosition = {
  __typename: 'DirectTradingSecurityPosition';
  /** The amount held. */
  amount: Scalars['Cents']['output'];
  /**
   * The average cost for the security position
   * @deprecated Use averageCostV2 instead.
   */
  averageCost: Scalars['Cents']['output'];
  /** The average cost for the security position */
  averageCostV2: Maybe<Scalars['Cents']['output']>;
  /** The financial security being held. */
  financialSecurity: FinancialSecurityFund | FinancialSecurityStock;
  /** Flags if any pending orders are present for this position */
  hasPendingOrders: Scalars['Boolean']['output'];
  /** The number of shares held. */
  shares: Scalars['Float']['output'];
  /** Today's return percent for the security position */
  todaysReturn: Maybe<DirectTradingSecurityPositionReturn>;
  /**
   * Today's return for the security position.
   * @deprecated Use todaysReturn#amount instead.
   */
  todaysReturnAmount: Scalars['Cents']['output'];
  /**
   * Today's return percent for the security position.
   * @deprecated Use todaysReturn#percent instead.
   */
  todaysReturnPercent: Scalars['Percent']['output'];
  /**
   * The total cost of the security position.
   * @deprecated Use totalCostV2 instead.
   */
  totalCost: Scalars['Cents']['output'];
  /** The total cost of the security position. */
  totalCostV2: Maybe<Scalars['Cents']['output']>;
  /** The total return percent for the security position */
  totalReturn: Maybe<DirectTradingSecurityPositionReturn>;
  /**
   * The total return amount for the security position.
   * @deprecated Use totalReturn#amount instead.
   */
  totalReturnAmount: Scalars['Cents']['output'];
  /**
   * Today's return percent for the security position.
   * @deprecated Use totalReturn#percent instead.
   */
  totalReturnPercent: Scalars['Percent']['output'];
};

/** A gain/loss return for a position held by the user. */
export type DirectTradingSecurityPositionReturn = {
  __typename: 'DirectTradingSecurityPositionReturn';
  /** The return expressed as an amount. */
  amount: Scalars['Cents']['output'];
  /** The return expressed as a percent. */
  percent: Scalars['Percent']['output'];
};

/** Financial and legal disclosures */
export type Disclosures = {
  __typename: 'Disclosures';
  /** Explains what balances shown on the Direct Trading account overview include */
  directTradingBalanceDisclosure: Scalars['HTML']['output'];
  /** Explains how Betterment calculates and reports portfolio performance */
  performanceDisclosure: Scalars['HTML']['output'];
};

/** Autogenerated input type of DismissAnnouncementMutation */
export type DismissAnnouncementMutationInput = {
  /** The name of the announcement to dismiss */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of DismissAnnouncementMutation. */
export type DismissAnnouncementMutationPayload = {
  __typename: 'DismissAnnouncementMutationPayload';
  /** The user-displayable errors produced while attempting to resolve DismissAnnouncementMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the DismissAnnouncementMutation execution as type AnnouncementDismissal. */
  result: Maybe<AnnouncementDismissal>;
};

/** Autogenerated return type of DismissCsvActivityExportBannerMutation. */
export type DismissCsvActivityExportBannerMutationPayload = {
  __typename: 'DismissCsvActivityExportBannerMutationPayload';
  /** The user-displayable errors produced while attempting to resolve DismissCsvActivityExportBannerMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the DismissCsvActivityExportBannerMutation execution as type CsvExport. */
  result: Maybe<CsvExport>;
};

/** Autogenerated return type of DismissFirmBillableAccountsCsvExportMutation. */
export type DismissFirmBillableAccountsCsvExportMutationPayload = {
  __typename: 'DismissFirmBillableAccountsCsvExportMutationPayload';
  /** The user-displayable errors produced while attempting to resolve DismissFirmBillableAccountsCsvExportMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the DismissFirmBillableAccountsCsvExportMutation execution as type CsvExport. */
  result: Maybe<CsvExport>;
};

/** A recoverable error that can be displaying to the User. */
export type DisplayableError = {
  __typename: 'DisplayableError';
  /** A human-readable error message to display to the user explaining the error and remediating actions. */
  message: Scalars['String']['output'];
  /** The path, the Operation entity or Input value that is the source of the error. */
  path: Array<Scalars['String']['output']>;
};

/** A model portfolio resource representing a downloadable document. */
export type DocumentModelPortfolioResource = ModelPortfolioResource & {
  __typename: 'DocumentModelPortfolioResource';
  /** The URL to download the document. */
  downloadUrl: Scalars['URL']['output'];
  /** The unique identifier for the resource. */
  id: Scalars['ID']['output'];
  /** The display title of the resource. */
  title: Scalars['String']['output'];
  /** The type of resource (tear sheet, methodology, etc.). */
  type: ModelPortfolioResourceType;
};

/**
 * Information about the drift for a given portfolio. Drift describes how much a portfolio's
 *       asset allocation has changed from its target allocation due to the performance of the underlying assets.
 *       Drift is the difference between the portfolio's target allocation and its
 * current allocation, expressed as a percentage.
 */
export type Drift = {
  __typename: 'Drift';
  /** The overall portfolio drift percent (from target). */
  current: Scalars['Percent']['output'];
  /**
   * A derived identifier for this Drift, composed of the underlying goal ID.
   * Intended as a unique-enough key for client caching and list rendering. Not a
   * database primary key.
   */
  id: Scalars['ID']['output'];
  /**
   * Portfolios have a predefined drift threshold. When drift exceeds this value,
   * rebalancing will occur if enabled. This value indicates if drift is above the
   * defined threshold.
   */
  isAboveThreshold: Scalars['Boolean']['output'];
  /** The predefined drift threshold for the portfolio. */
  threshold: Scalars['Percent']['output'];
};

/** Type that describes the result of a send email action. */
export type EmailDispatch = {
  __typename: 'EmailDispatch';
  /** Was an email sent or enqueued as a result of this request? */
  wasEmailSent: Scalars['Boolean']['output'];
};

/** An employer of the user; a plan sponsor for the user's employee benefits plan. */
export type Employer = {
  __typename: 'Employer';
  /** The configuration for the employer's 401(k) contributions. */
  contributionConfig: Maybe<EmployerConfig>;
  /** Provides data for the employers 401(k) contributions. */
  fourOhOneKContributions: Maybe<EmployerResult>;
  /** A unique identifier for an Employer */
  id: Scalars['ID']['output'];
  /** The name of the employer. */
  name: Scalars['String']['output'];
  /** The solo 401(k) plan associated with this employer. */
  soloFourOhOneKPlan: Maybe<SoloFourOhOneKPlan>;
};

/** The employer's 401(k) contribution configuration. */
export type EmployerConfig = {
  __typename: 'EmployerConfig';
  /** Employer contributions frequency. */
  frequency: EmployerFrequency;
  /** A unique identifier for an EmployerFourOhOneKContributionConfig */
  id: Scalars['ID']['output'];
  /** The maximum amount the employer will contribute. */
  limit: Scalars['Cents']['output'];
};

/** The employer 401(k) contributions for a user. */
export type EmployerContributions = {
  __typename: 'EmployerContributions';
  /** The amount of employer 401(k) contributions received. */
  amount: Scalars['Cents']['output'];
  /** The current balance after gains/losses of employer 401(k) contributions. */
  balance: Scalars['Cents']['output'];
  /** A unique identifier for an EmployerFourOhOneKContributions */
  id: Scalars['ID']['output'];
  /** A projection of future employer 401(k) contributions. */
  projection: Maybe<Projection>;
  /** The vested amount and percent of employer 401(k) contributions. */
  vested: Maybe<Vested>;
};

/** The frequency of employer 401(k) contributions */
export enum EmployerFrequency {
  /** Annually */
  Annual = 'ANNUAL',
  /** Bi-monthly */
  BiMonthly = 'BI_MONTHLY',
  /** Bi-weekly */
  BiWeekly = 'BI_WEEKLY',
  /** Monthly */
  Monthly = 'MONTHLY',
  /** Quarterly */
  Quarterly = 'QUARTERLY',
  /** Semi-Annually */
  SemiAnnual = 'SEMI_ANNUAL',
  /** Semi-Monthly */
  SemiMonthly = 'SEMI_MONTHLY',
  /** Weekly */
  Weekly = 'WEEKLY'
}

/** The 401(k) contributions for a user. */
export type EmployerResult = {
  __typename: 'EmployerResult';
  /** All Employer 401(k) contributions. */
  allTime: EmployerContributions;
  /** A unique identifier for an EmployerFourOhOneKContributionsResult */
  id: Scalars['ID']['output'];
  /** This year Employer 401(k) contributions. */
  thisYear: EmployerContributions;
};

/**
 * An organization of part of the user's finances, grouped together to help the
 * user observe and plan out their finances in the context of their goals. An
 * envelope can contain multiple different 'accounts', which are smaller units of
 * financial organization, representing individual accounts or portfolios managing
 * accounts. In general, with the exception of external accounts that the user has
 * linked for aggregation purposes but not assigned to an envelope, every piece of
 * the user's financial picture is contained within an envelope.
 */
export type Envelope = {
  __typename: 'Envelope';
  /** The accounts contained within and organized by the envelope. */
  accounts: Array<CashAccount | DirectTradingAccount | ManagedAccount>;
  /** The balance of the envelope; null if no available balance to show. */
  balance: Maybe<Scalars['Cents']['output']>;
  /** The id of the envelope. */
  id: Scalars['ID']['output'];
  /** The envelope's purpose. */
  purpose: Maybe<PurposeEmergencyFund | PurposeMajorPurchase | PurposeRetirementGrowth | PurposeRetirementIncome>;
  /** The user who owns the envelope. */
  user: Client;
};

/** A top-level financial account within an envelope. */
export type EnvelopeAccount = {
  /** The individuals or entities that hold the account. */
  accountHolders: Array<Client | Trust>;
  /**
   * The envelope holding the account. Beware not to use this field to access
   * complex data about an envelope's accounts cyclically, such that a user with a
   * very high number of account's could end up executing an operation with a
   * dramatically high runtime complexity.
   */
  envelope: Envelope;
  /** The icon used to represent the account. */
  icon: ThemedAsset;
  /** The unique identifier for the envelope */
  id: Scalars['ID']['output'];
  /** A set of messages for the account. */
  messages: Array<Message>;
  /** The name used to represent the account. */
  name: Scalars['String']['output'];
};


/** A top-level financial account within an envelope. */
export type EnvelopeAccountMessagesArgs = {
  location: MessageLocation;
};

/** YTD return data for an envelope */
export type EnvelopeYtdReturn = {
  __typename: 'EnvelopeYtdReturn';
  /** The envelope ID */
  envelopeId: Scalars['ID']['output'];
  /** The YTD return data (percentage and dollar amount) */
  ytdReturn: Maybe<YtdReturn>;
};

/** Estimated date for a trade request */
export type EstimatedTradeDate = {
  __typename: 'EstimatedTradeDate';
  /** Estimated date of the trade completion */
  date: Scalars['Date']['output'];
  /** Human readable description of the trade completion timing */
  description: Scalars['String']['output'];
};

/** Estimated time range for a trade request */
export type EstimatedTradeTimeRange = {
  __typename: 'EstimatedTradeTimeRange';
  /** Human readable description of the trade completion day */
  dayDescription: Scalars['String']['output'];
  /** Estimated end time of the trade completion window */
  endTime: Scalars['DateTime']['output'];
  /** Estimated start time of the trade completion window */
  startTime: Scalars['DateTime']['output'];
  /** Human readable description of the trade completion time window */
  timeRangeDescription: Scalars['String']['output'];
};

/** Estimated timing of a trade request */
export type EstimatedTradeTiming = EstimatedTradeDate | EstimatedTradeTimeRange;

/** An executed agreement document, optionally linked to a DocuSign envelope */
export type ExecutedAgreement = AgreementDocument & {
  __typename: 'ExecutedAgreement';
  /** Whether this agreement version is active and available for use */
  active: Scalars['Boolean']['output'];
  /** When this agreement version was approved (null if not approved) */
  approvedAt: Maybe<Scalars['DateTime']['output']>;
  /** When this document was created/uploaded */
  createdAt: Scalars['DateTime']['output'];
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Whether this agreement was executed via DocuSign */
  isDocusignAgreement: Scalars['Boolean']['output'];
  /** Human-readable name for this agreement version (e.g., "Q4 2025 Investment Advisory Agreement") */
  name: Scalars['String']['output'];
  /** Token for secure access */
  token: Maybe<Scalars['String']['output']>;
};

/**
 * A fund's expense ratio is its annual fee, measured as a percent of the
 * investment in the fund. This value is expressed as a percentage of the total
 * assets in the portfolio.
 */
export type ExpenseRatio = {
  __typename: 'ExpenseRatio';
  /** An explanation of expense ratio and the impact it has on your investment. */
  explanation: Scalars['String']['output'];
  /**
   * In the context of a portfolio, this is the expense ratio in aggregate for all
   * funds in the portfolio, calculated by taking the weighted average of the
   * expense ratios of each fund in the portfolio. In the context of a fund, this
   * is the fund's expense ratio.
   */
  value: Scalars['Percent']['output'];
};

/** The model portfolio for 401(k) plans that have 'Fund Menus'. */
export type ExternallyAdvisedPlanPortfolio = {
  __typename: 'ExternallyAdvisedPlanPortfolio';
  /** A value used for client-side caching purposes. */
  id: Scalars['ID']['output'];
  /** The name of the portfolio. */
  name: Maybe<Scalars['String']['output']>;
  /** The 'grandparent groups' on the Fund Menu. */
  securityCategoryGroups: Array<SecurityCategoryGroup>;
};

/** An individual fee attempt within a BulkFeeAttempt */
export type FeeAttempt = {
  __typename: 'FeeAttempt';
  /** The account associated with the fee attempt */
  account: CashAccount | DirectTradingAccount | ManagedSubAccount;
  /** The amount the client will be charged */
  amount: Scalars['Cents']['output'];
  /** The optional description or reason of the fee attempt */
  reason: Maybe<Scalars['String']['output']>;
};

/** A batch of fee attempts that passed validation */
export type FeeAttemptBatch = {
  __typename: 'FeeAttemptBatch';
  /** An array of fee attempts that passed validation */
  attempts: Array<FeeAttempt>;
};

/** A fee attempt that failed validation */
export type FeeAttemptFailure = {
  __typename: 'FeeAttemptFailure';
  /**
   * The account to be charged the fee. The fields to be returned are the account name, type, and owner.
   * If the inputted account is invalid, returns the raw inputted account number as a string.
   */
  account: FeeAttemptInputAccount;
  /**
   * The amount to be charged for the fee attempt.
   * If the inputted amount is invalid, returns the raw inputted amount as a string.
   */
  amount: FeeAttemptInputAmount;
  /** The failure reasons tied to the fee attempt */
  failureReasons: Array<FeeAttemptFailureReason>;
  /** The row of the fee attempt within the uploaded CSV file */
  row: Scalars['Int']['output'];
};

/**
 * Enum representing failures encountered during fee attempt processing. These are a
 * fixed set of expected failures that can occur during validation of a fee attempt.
 */
export enum FeeAttemptFailureReason {
  /** The account is closed and cannot be charged fees */
  AccountClosed = 'ACCOUNT_CLOSED',
  /** The account specified does not exist for the firm */
  AccountNotFound = 'ACCOUNT_NOT_FOUND',
  /** The description provided is too long */
  DescriptionTooLong = 'DESCRIPTION_TOO_LONG',
  /** The fee amount exceeds the maximum allowed fee amount */
  ExceedsMaxFeeAmount = 'EXCEEDS_MAX_FEE_AMOUNT',
  /** The account is not eligible to be charged fees */
  IneligibleAccount = 'INELIGIBLE_ACCOUNT',
  /** The fee is greater than the billable balance in the account */
  InsufficientBalance = 'INSUFFICIENT_BALANCE',
  /** The combined fees for this account are greater than the billable balance in the account */
  InsufficientBalanceCombined = 'INSUFFICIENT_BALANCE_COMBINED',
  /** The amount specified is invalid (e.g. not a number) */
  InvalidAmount = 'INVALID_AMOUNT',
  /** The amount specified is non positive (e.g. less than or equal to zero) */
  NonPositiveAmount = 'NON_POSITIVE_AMOUNT'
}

/**
 * The account to be charged the fee. Returns either a valid LegalSubAccount
 * or the raw inputted account number as a string if invalid.
 */
export type FeeAttemptInputAccount = CashAccount | InvalidAccountString | ManagedSubAccount;

/**
 * The amount to be charged for the fee attempt. Returns either valid Cents
 * or the raw inputted amount as a string if invalid.
 */
export type FeeAttemptInputAmount = InvalidAmountString | ValidCents;

/**
 * Result of processing fee attempts. Returns either a batch of valid attempts
 * or a batch of failures if validation errors occurred.
 */
export type FeeAttemptsResult = FeeAttemptBatch | InvalidFeeAttemptBatch;

/** A configuration for platform related fees. */
export type FeeConfiguration = {
  __typename: 'FeeConfiguration';
  /** The platform fee tiers for the firm. */
  platformFeeTiers: Array<PlatformFeeTier>;
};

/** A financial security representing a single stock or fund (ETF, mutual fund). */
export type FinancialSecurity = {
  /** The unique ID for the financial security. */
  id: Scalars['ID']['output'];
  /** The name of company for the financial security. */
  name: Scalars['String']['output'];
  /** The ticker symbol for the financial security. */
  symbol: Scalars['String']['output'];
};

/** A fund instance of FinancialSecurityInterface. */
export type FinancialSecurityFund = FinancialSecurity & {
  __typename: 'FinancialSecurityFund';
  /** The unique ID for the financial security. */
  id: Scalars['ID']['output'];
  /** The name of the fund. */
  name: Scalars['String']['output'];
  /**
   * A prospectus is a written document used in finance to inform the public of the
   * relevant details about an offering of securities, such as stocks, bonds, and
   * mutual funds. The prospectus is part of a company's registration statement,
   * which is filed with the SEC. Betterment does not host the prospectus; this is
   * a link to the fund's prospectus on the fund company's website.
   */
  prospectusUrl: Scalars['URL']['output'];
  /** The ticker symbol for the financial security. */
  symbol: Scalars['String']['output'];
};

/** A single security order request */
export type FinancialSecurityOrderRequest = {
  __typename: 'FinancialSecurityOrderRequest';
  /** the single security order request id */
  id: Scalars['ID']['output'];
  /** Order status */
  status: FinancialSecurityOrderRequestStatus;
};

/** Determines if the order request is to buy or sell the security */
export enum FinancialSecurityOrderRequestDirection {
  /** Buy */
  Buy = 'BUY',
  /** Sell */
  Sell = 'SELL'
}

/** The status of a financial security order request */
export enum FinancialSecurityOrderRequestStatus {
  /** Canceled */
  Canceled = 'CANCELED',
  /** Completed */
  Completed = 'COMPLETED',
  /** Created */
  Created = 'CREATED',
  /** Failed */
  Failed = 'FAILED',
  /** Requested */
  Requested = 'REQUESTED'
}

/** dollar amount or number of shares requested for order request */
export type FinancialSecurityOrderRequestValueInput =
  /** dollar amount value requested */
  { amount: Scalars['Cents']['input']; shares?: never; }
  |  /** amount of shares requested */
  { amount?: never; shares: Scalars['Float']['input']; };

/** The tax impact preview for a sell order */
export type FinancialSecuritySellOrderTaxImpactPreview = {
  __typename: 'FinancialSecuritySellOrderTaxImpactPreview';
  /** Gains details for the owner of the account */
  gainsDetails: Maybe<GainsDetails>;
  /** The unique Identifier for the given preview */
  id: Scalars['ID']['output'];
  /** The client's estimated remaining gain allowance after this order. Can be Null if a gains allowance is not set. */
  remainingGainsAllowance: Maybe<Scalars['Cents']['output']>;
  /** Estimated tax impact from the trade */
  taxImpactPreview: TaxImpact;
};

/** A stock instance of FinancialSecurityInterface. */
export type FinancialSecurityStock = FinancialSecurity & {
  __typename: 'FinancialSecurityStock';
  /** The unique ID for the financial security. */
  id: Scalars['ID']['output'];
  /** The name of the company for the stock. */
  name: Scalars['String']['output'];
  /** The ticker symbol for the financial security. */
  symbol: Scalars['String']['output'];
};

/** A B4A Firm */
export type Firm = {
  __typename: 'Firm';
  /** Whether account creation is allowed for the firm */
  accountCreationAllowed: Scalars['Boolean']['output'];
  /** How often a firm is billed */
  billingFrequency: BillingFrequency;
  /** The single billing plan associated with the firm */
  billingPlan: Maybe<BillingPlan>;
  /** The billing plans associated with the firm */
  billingPlans: Array<BillingPlan>;
  /** A single bulk fee attempt associated with the firm */
  bulkFeeAttempt: Maybe<BulkFeeAttempt>;
  /** The count of bulk fee intents associated with the firm */
  bulkFeeIntentCount: Scalars['Int']['output'];
  /** The bulk fee intents associated with the firm */
  bulkFeeIntents: Array<BulkFeeIntent>;
  /** All executed agreements for this firm. Multiple active versions are supported. */
  executedAgreements: Array<ExecutedAgreement>;
  /** Platform fee configuration for the firm */
  feeConfiguration: Maybe<FeeConfiguration>;
  /** Whether 401(k) features are enabled for the firm */
  fourOhOneKEnabled: Scalars['Boolean']['output'];
  /** Whether the firm is 401(k) only */
  fourOhOneKOnly: Scalars['Boolean']['output'];
  /** The unique identifier for the firm */
  id: Scalars['ID']['output'];
  /** The name of the firm */
  name: Scalars['String']['output'];
  /** Platform Fee associated with the firm */
  platformFee: Scalars['Bps']['output'];
  /** Whether the firm requires advisors to confirm impersonation before accessing client data */
  requiresImpersonationConfirmation: Scalars['Boolean']['output'];
  /** The path to start inviting a new client for this firm */
  startClientInvitePath: Scalars['URL']['output'];
};


/** A B4A Firm */
export type FirmBillingPlanArgs = {
  id: Scalars['ID']['input'];
};


/** A B4A Firm */
export type FirmBulkFeeAttemptArgs = {
  id: Scalars['ID']['input'];
};


/** A B4A Firm */
export type FirmBulkFeeIntentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** A B4A Firm */
export type FirmExecutedAgreementsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A document for a 401(k) plan */
export type FourOhOneKDocument = {
  __typename: 'FourOhOneKDocument';
  /** Date the document took effect */
  effectiveDate: Scalars['Date']['output'];
  /** Unique identifier for the document */
  id: Scalars['ID']['output'];
  /** Type of the document */
  type: FourOhOneKDocumentType;
};

/** Document types for 401(k) plans */
export enum FourOhOneKDocumentType {
  /** Plan Asset Transfer Instructions */
  AssetTransferInstructions = 'asset_transfer_instructions',
  /** Custodial Letter of Acceptance */
  CustodialLetterOfAcceptance = 'custodial_letter_of_acceptance',
  /** Prior Recordkeeper Deconversion Letter */
  DeconversionNotice = 'deconversion_notice',
  /** Conversion One-Pager Reference Guide */
  OnePager = 'one_pager',
  /** Quarterly statement */
  PlanStatement = 'plan_statement',
  /** Plan document */
  PriorPlanDocument = 'prior_plan_document',
  /** QDIA Notice and Fee Disclosure */
  QdiaFeeDisclosure = 'qdia_fee_disclosure',
  /** Summary plan description */
  SummaryPlanDescription = 'summary_plan_description',
  /** Inspira Letter of Acceptance */
  TrusteeLetterOfAcceptance = 'trustee_letter_of_acceptance'
}

/** A task to be completed by a plan manager when adding a 401(k) plan to Betterment. */
export type FourOhOneKOnboardingTask = {
  __typename: 'FourOhOneKOnboardingTask';
  /**
   * Details on what's preventing this task from being workable.
   * This description will point to another task that needs to be completed before this one.
   * Multiple tasks can block a single task, but this will always describe the highest priority blocking task.
   */
  blockedDescription: Maybe<Scalars['String']['output']>;
  /** The date the task was completed on. */
  completedAt: Maybe<Scalars['Date']['output']>;
  /** The plan manager who completed the task. Will only be set if the task is completed. */
  completingPlanManager: Maybe<FourOhOneKPlanManager>;
  /** Details on the task's requirements. */
  description: Scalars['String']['output'];
  /** The date that the task needs to be completed by. */
  dueDate: Maybe<Scalars['Date']['output']>;
  /** The unique identifier for the onboarding task. */
  id: Scalars['ID']['output'];
  /** The name of the task. */
  name: Scalars['String']['output'];
  /** Whether or not this task is ready to be worked on. */
  ready: Maybe<Scalars['Boolean']['output']>;
  /** A short-form code representing the type of task. */
  type: Scalars['String']['output'];
};

/** A 401(k) plan. Can be either a standard employer-sponsored plan or a solo 401(k) for self-employed individuals. */
export type FourOhOneKPlan = {
  /** The unique identifier for the 401(k) plan (B4b::Api::Data::Plan#id) */
  id: Scalars['ID']['output'];
  /** The investment options for 401(k) plans when Betterment is the 3(38). */
  investmentOptions: Maybe<Array<BettermentModelPortfolio>>;
  /** A set of messages for the 401(k) plan. */
  messages: Array<Message>;
  /** The model portfolio for 401(k) plans that have 'Fund Menus' */
  modelPortfolio: Maybe<ExternallyAdvisedPlanPortfolio>;
  /** The name entity that owns the plan. */
  name: Scalars['String']['output'];
  /** Information about the 401(k) onboarding. */
  onboarding: FourOhOneKPlanOnboarding;
  /** Performance indicators for the 401(k) plan. */
  performanceIndicators: FourOhOneKPlanPerformanceIndicators;
  /** The consent status of the plan for sending data in outbound integration feeds */
  planFeedConsent: Scalars['Boolean']['output'];
  /** The plan fiduciary */
  planFiduciary: FourOhOneKPlanFiduciary;
  /** The name of the default portfolio for 401(k) plans that are managed by Betterment */
  qdiaFundName: Maybe<Scalars['String']['output']>;
  /** Options for creating reports for this 401(k) plan. */
  reportCreationOptions: Array<FourOhOneKReportCreationOption>;
  /** Advisor reports associated with this 401(k) plan. */
  reports: Maybe<Array<FourOhOneKReport>>;
  /** The status of the 401(k) plan, either onboarding or active. */
  status: FourOhOneKPlanStatusType;
  /** The type of the plan (solo or standard). */
  type: FourOhOneKPlanType;
};


/** A 401(k) plan. Can be either a standard employer-sponsored plan or a solo 401(k) for self-employed individuals. */
export type FourOhOneKPlanMessagesArgs = {
  location: MessageLocation;
};

/** Returns who is the fiduciary for a given 401(k) plan. */
export type FourOhOneKPlanFiduciary = {
  __typename: 'FourOhOneKPlanFiduciary';
  /** Whether the fiduciary is an advisor */
  isAdvisor: Scalars['Boolean']['output'];
  /** Whether the fiduciary is Betterment */
  isBetterment: Scalars['Boolean']['output'];
};

/** The launch status of a 401(k) plan */
export enum FourOhOneKPlanLaunchStatusType {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Complete */
  Complete = 'COMPLETE',
  /** Missed */
  Missed = 'MISSED',
  /** Off Track */
  OffTrack = 'OFF_TRACK',
  /** On Hold */
  OnHold = 'ON_HOLD',
  /** On Track */
  OnTrack = 'ON_TRACK'
}

/** A 401(k) plan manager */
export type FourOhOneKPlanManager = {
  __typename: 'FourOhOneKPlanManager';
  /** The authorization tier of the 401(k) plan manager */
  authorizationTier: PlanManagerAuthorizationTier;
  /** The email address of the 401(k) plan manager */
  email: Scalars['String']['output'];
  /** The first name of the 401(k) plan manager */
  firstName: Scalars['String']['output'];
  /** The ID of the plan manager */
  id: Scalars['ID']['output'];
  /** The last name of the 401(k) plan manager */
  lastName: Scalars['String']['output'];
  /** Indicates if this is the 401(k) plan manager that is active and an administrator */
  primary: Scalars['Boolean']['output'];
  /** The title of the 401(k) plan manager */
  title: Scalars['String']['output'];
};

/** Information about the 401(k) plan onboarding process */
export type FourOhOneKPlanOnboarding = {
  __typename: 'FourOhOneKPlanOnboarding';
  /**
   * Indicates a task that is blocking the onboarding from moving forward. This
   * usually means that an internal task needs to be completed
   * before the plan manager can continue onboarding.
   */
  blockingTask: Maybe<BlockingTask>;
  /** The name of the client or employer for the onboarding plan. */
  clientNickname: Scalars['String']['output'];
  /** The number of completed tasks */
  completedTasksCount: Scalars['Int']['output'];
  /** The unique identifier for the 401(k) onboarding */
  id: Scalars['ID']['output'];
  /** Whether or not the plan is a conversion or a new plan. */
  isConversion: Scalars['Boolean']['output'];
  /** Whether or not the payroll provider the plan will be configured with is integrated with our system or manual. */
  isIntegratedPayrollProvider: Scalars['Boolean']['output'];
  /** The payroll launch date */
  launchDate: Scalars['Date']['output'];
  /** The launch status of the 401(k) onboarding */
  launchStatus: FourOhOneKPlanLaunchStatusType;
  /** Whether or not the payroll integration launch is off track. */
  payrollIntegrationLaunchOffTrack: Scalars['Boolean']['output'];
  /** The name of the payroll provider the plan will be configured with during onboarding. */
  payrollProviderName: Scalars['String']['output'];
  /**
   * Whether or not there is a significant gap in time for a payroll integration to
   * be configured on the payroll provider's end. This indicates
   * that there is usually a longer period of time than usual, up to a couple of
   * weeks, during which plan managers onboarding the plan need
   * to wait a period of time after configuring the integration on their end, in
   * order for the payroll integration to be complete.
   */
  pendingLongPayrollIntegrationSetupPeriod: Scalars['Boolean']['output'];
  /** Whether or not a plan document has been created and sent to the plan sponsor. */
  planDocumentSent: Scalars['Boolean']['output'];
  /** The Betterment agent dedicated to supporting the onboarding for the plan. */
  supportAgent: FourOhOneKPlanSupportAgent;
  /** The onboarding tasks for this 401(k) plan */
  tasks: Array<FourOhOneKOnboardingTask>;
  /** An authorized third party administrator of the 401k plan. */
  thirdPartyAdministrator: Maybe<FourOhOneKThirdPartyAdministrator>;
  /** The number of total tasks */
  totalTasksCount: Scalars['Int']['output'];
  /** If the plan is a conversion, the date on which funds from the deconverting plan are wired. */
  wireDate: Maybe<Scalars['Date']['output']>;
};

/** Performance indicators for a 401(k) plan */
export type FourOhOneKPlanPerformanceIndicators = {
  __typename: 'FourOhOneKPlanPerformanceIndicators';
  /** The number of currently contributing participants in the 401(k) plan. */
  currentlyContributingParticipants: Scalars['Int']['output'];
  /** The number of eligible participants in the 401(k) plan. */
  eligibleParticipants: Scalars['Int']['output'];
  /** The total balance of participants in the 401(k) plan. */
  totalPlanBalanceCents: Scalars['Cents']['output'];
};

/** The status of a 401(k) plan */
export enum FourOhOneKPlanStatusType {
  /** Active */
  Active = 'ACTIVE',
  /** Onboarding */
  Onboarding = 'ONBOARDING'
}

/** The Betterment agent supporting the plan. */
export type FourOhOneKPlanSupportAgent = {
  __typename: 'FourOhOneKPlanSupportAgent';
  /** The url to book time with the agent. Typically a Calendly link. */
  contactUrl: Maybe<Scalars['String']['output']>;
  /** The external email which plan owners and managers can use to contact the agent. */
  email: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the agent */
  id: Scalars['ID']['output'];
  /** The full name of the agent. */
  name: Maybe<Scalars['String']['output']>;
};

/** Support resources for 401(k) plans */
export type FourOhOneKPlanSupportResource = {
  __typename: 'FourOhOneKPlanSupportResource';
  /** The Client Success Manager for the advisor's first 401(k) plan, if one is assigned */
  agent: Maybe<FourOhOneKPlanSupportAgent>;
  /** Contact information for 401(k) plan support */
  contact: SupportContact;
};

/** The type of a 401(k) plan */
export enum FourOhOneKPlanType {
  /** Solo 401(k) */
  Solo = 'SOLO',
  /** Standard 401(k) */
  Standard = 'STANDARD'
}

/** Input structure for an FourOhOneKPlans Where query. */
export type FourOhOneKPlansWhereInput = {
  /** A status representing the plan is in onboarding or not. */
  status?: InputMaybe<FourOhOneKPlanStatusType>;
};

/** A report for a 401(k) plan */
export type FourOhOneKReport = {
  __typename: 'FourOhOneKReport';
  /** The format of the report file (PDF or CSV) */
  contentType: FourOhOneKReportContentType;
  /** The timestamp when the report was created */
  createdAt: Scalars['DateTime']['output'];
  /** The end date of the reporting period */
  endDate: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for the 401(k) report */
  id: Scalars['ID']['output'];
  /** The name of the report */
  name: Scalars['String']['output'];
  /** The start date of the reporting period */
  startDate: Maybe<Scalars['DateTime']['output']>;
  /** The current status of the report (Pending, Success, or Failure) */
  status: FourOhOneKReportStatus;
};

/** The content type of a 401(k) report file */
export enum FourOhOneKReportContentType {
  /** A csv file */
  Csv = 'CSV',
  /** A PDF file */
  Pdf = 'PDF',
  /** A zip file */
  Zip = 'ZIP'
}

/** Options available for creating a 401(k) plan report */
export type FourOhOneKReportCreationOption = {
  __typename: 'FourOhOneKReportCreationOption';
  /** The columns included in the report */
  columns: Array<Scalars['String']['output']>;
  /** The description of the report */
  description: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the report creation option */
  id: Scalars['ID']['output'];
  /** The inputs required to create the report */
  inputs: Array<FourOhOneKReportInputOption>;
  /** Whether the report is commonly run */
  isCommon: Scalars['Boolean']['output'];
  /** The name of the report creation option */
  name: Scalars['String']['output'];
  /** The type of the report creation option */
  type: Scalars['String']['output'];
};

/** Input options for creating a 401(k) plan report */
export type FourOhOneKReportInputOption = {
  __typename: 'FourOhOneKReportInputOption';
  /** The attribute name of the input option */
  attribute: Scalars['String']['output'];
  /** The label of the input option */
  label: Scalars['String']['output'];
  /** The type of the input option */
  type: Scalars['String']['output'];
};

/** The status of a 401(k) report */
export enum FourOhOneKReportStatus {
  /** Complete */
  Complete = 'COMPLETE',
  /** Generating */
  Generating = 'GENERATING',
  /** Pending */
  Pending = 'PENDING'
}

/** An authorized third party administrator of a 401k plan. */
export type FourOhOneKThirdPartyAdministrator = {
  __typename: 'FourOhOneKThirdPartyAdministrator';
  /** he direct contact's email of the adminstrator. */
  contactEmail: Scalars['String']['output'];
  /** The direct contact's full name of the adminstrator. */
  contactName: Scalars['String']['output'];
  /** The unique identifier for the administrator */
  id: Scalars['ID']['output'];
  /** The name of the organization of the administrator. */
  organizationName: Scalars['String']['output'];
};

/**
 * Represents the future state of a portfolio once a pending action completes.
 * This type provides a preview of what the portfolio will look like, containing
 * only the essential fields needed for UI display.
 */
export type FuturePortfolio = {
  __typename: 'FuturePortfolio';
  /**
   * The portfolio strategy's name. For advisor custom portfolios, this is provided
   * by the advisor. For Betterment portfolios, this is the customer-facing
   * portfolio name (e.g. Innovative Technology, Core, Socially Responsible
   * Investing, etc.). For self directed portfolios, 'Flexible Portfolio' or
   * 'Advised 401(k)'.
   */
  strategyName: Scalars['String']['output'];
  /**
   * For portfolios with 101 risk levels, this will be a description of the
   * stock/bonds allocation (e.g., '80% stocks, 20% bonds').
   * - For portfolios with fewer than 101 risk levels (aka 'sparse portfolios'),
   * this will be the risk level name (e.g., Conservative, Moderate, Aggressive).
   * For a flexpo portfolio, this value describes the percentage of stocks/bonds
   * represented by the current target allocation (e.g., '80% stocks, 20% bonds').
   * - For an advised 401k, for a portfolio targeting just one ticker/fund, this
   * value will describe that one ticker/fund (e.g., 'VLXVX | Vanguard Target
   * Retirement 2065 Fund'), or for a portfolio targeting multiple tickers, 'Custom'.
   */
  targetAllocationDescription: Scalars['String']['output'];
};

/** Gains information */
export type Gains = {
  __typename: 'Gains';
  /** The gain amount in cents. */
  gainAmount: Scalars['Cents']['output'];
  /** The loss amount in cents. */
  lossAmount: Scalars['Cents']['output'];
  /** The net amount of gains in cents. */
  netAmount: Scalars['Cents']['output'];
};

/** Gains details of a taxpaying entity (e.g, a human user or a trust) */
export type GainsDetails = {
  __typename: 'GainsDetails';
  /** The annual gains allowance */
  annualGainsAllowance: Scalars['Cents']['output'];
  /** The year-to-date realized gains */
  realizedGains: Scalars['Cents']['output'];
};

/** The performance of a given security over specified time periods. */
export type HistoricalPerformance = {
  __typename: 'HistoricalPerformance';
  /** The performance benchmark return percent (represented as a percentage via a float) of a security in a given time period. */
  benchmarkReturnPercent: Maybe<Scalars['Percent']['output']>;
  /** The returns (represented as a percentage via a float) of a security in a given time period */
  returnPercent: Maybe<Scalars['Percent']['output']>;
  /** The time period of a given security's performance data (e.g. '5 years') */
  timePeriod: Scalars['String']['output'];
};

/** An advised household */
export type Household = {
  __typename: 'Household';
  /** YTD returns for all managed accounts in the household */
  accountYtdReturns: Array<AccountYtdReturn>;
  /** The accounts associated with the household */
  accounts: Array<CashAccount | DirectTradingAccount | ManagedAccount>;
  /** The gains allowance groups associated with the household */
  annualGainsSummaries: Array<Summary>;
  /** The billing plan associated with the household */
  billingPlan: BillingPlan;
  /**
   * The effective platform fee for the household, considering overrides, BAN, firm
   * platform fee, etc. This is the gross fee rate and does not account for netting.
   */
  effectivePlatformFee: Scalars['Bps']['output'];
  /** YTD returns for all envelopes in the household */
  envelopeYtdReturns: Array<EnvelopeYtdReturn>;
  /** The accounts associated with the household */
  envelopes: Array<Envelope>;
  /** The total balance of the household's external accounts */
  externalSyncedBalance: Scalars['Cents']['output'];
  /** The unique Identifier for the household */
  id: Scalars['ID']['output'];
  /** The members of the household */
  members: Array<Client>;
  /** A set of messages for the household. */
  messages: Array<Message>;
  /** The name of the household */
  name: Scalars['String']['output'];
  /** The open goals associated with the household */
  openGoals: Array<LegacyGoal>;
  /**
   * The total balance of the household. This includes both Betterment
   *             and external accounts and also reflects pending deposits and withdrawals.
   */
  totalBalance: Scalars['Cents']['output'];
  /** The total earnings of the household */
  totalEarnings: Scalars['Cents']['output'];
};


/** An advised household */
export type HouseholdMessagesArgs = {
  location: MessageLocation;
};


/** An advised household */
export type HouseholdTotalEarningsArgs = {
  dateRangeOption?: TotalEarnedDateRange;
};

/** Result Union for Query.household query, returns either Household or RecordNotFoundResult. */
export type HouseholdResult = Household | RecordNotFoundResult;

/** The raw inputted account number as a string when the account is invalid */
export type InvalidAccountString = {
  __typename: 'InvalidAccountString';
  /** The raw account number string that was input */
  value: Scalars['String']['output'];
};

/** The raw inputted amount as a string when the amount is invalid */
export type InvalidAmountString = {
  __typename: 'InvalidAmountString';
  /** The raw amount string that was input */
  value: Scalars['String']['output'];
};

/** A batch of fee attempts that failed validation */
export type InvalidFeeAttemptBatch = {
  __typename: 'InvalidFeeAttemptBatch';
  /** An array of fee attempts that failed validation */
  failures: Array<FeeAttemptFailure>;
};

/** The aggregate IRA contributions for a user. */
export type IraContributions = {
  __typename: 'IraContributions';
  /** The aggregated amount of IRA contributions. */
  amount: Scalars['Cents']['output'];
  /** A projection of future IRA contributions. */
  projection: Maybe<IraContributionsProjection>;
};

/** Filter conditions for the IRA contributions by year.  */
export type IraContributionsByYearWhere = {
  /** If provided, filters the result to only include years eligible or ineligible for contribution. */
  isEligibleForContributions?: InputMaybe<Scalars['Boolean']['input']>;
  /** If provided, filters the result to exclude years not specified. */
  taxYears?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** A projection of IRA contributions. */
export type IraContributionsProjection = {
  __typename: 'IraContributionsProjection';
  /** A unique identifier for an IraContributionsProjection */
  id: Scalars['ID']['output'];
  /** Projected total contributions for the given time period. */
  total: Scalars['Cents']['output'];
};

/** The aggregate IRA contributions for a user. */
export type IraContributionsResult = {
  __typename: 'IraContributionsResult';
  /** IRA contributions by year. */
  byYear: Array<AnnualIraContributions>;
};


/** The aggregate IRA contributions for a user. */
export type IraContributionsResultByYearArgs = {
  where?: InputMaybe<IraContributionsByYearWhere>;
};

/** A Goal - Legacy modeling. Use Envelopes instead. */
export type LegacyGoal = {
  __typename: 'LegacyGoal';
  /** The current balance of the goal's sub accounts */
  currentBalance: Scalars['Cents']['output'];
  /** The absolute drift of the goal's holdings */
  drift: Scalars['Percent']['output'];
  /** Whether the goal's drift is higher than the goal's effective drift threshold */
  hasHighDrift: Scalars['Boolean']['output'];
  /** The unique identifier for the goal */
  id: Scalars['ID']['output'];
  /** Legal account type of the goal's sub account, 'Multiple accounts' if multiple sub accounts */
  legalAccountType: Scalars['String']['output'];
  /** The name of the goal */
  name: Scalars['String']['output'];
};

/** A security held in a portfolio. */
export type LegacySecurity = {
  __typename: 'LegacySecurity';
  /** The category of a given security (e.g. 'Large Blend') */
  category: Scalars['String']['output'];
  /** The general gross expense ratio of a given security, returned as a float. */
  expenseRatioPercent: Scalars['Percent']['output'];
  /** The performance of a given security over specified time periods. */
  historicalPerformances: Array<HistoricalPerformance>;
  /** A value used for client-side caching purposes. */
  id: Scalars['ID']['output'];
  /** The inception date of a given security. */
  inceptionDate: Scalars['Date']['output'];
  /** The name of the given security. */
  name: Scalars['String']['output'];
  /** The net expense ratio of a given security, returned as a float. */
  netExpenseRatioPercent: Scalars['Percent']['output'];
  /** The URL to the prospectus of a given security. */
  prospectusUrl: Scalars['String']['output'];
  /** The ticker symbol of a given security. */
  symbol: Scalars['String']['output'];
};

/** An account within a Goal */
export type LegacySubAccount = {
  __typename: 'LegacySubAccount';
  /** The display name for the given Sub Account. */
  displayName: Scalars['String']['output'];
  /** The unique ID for the given Sub Account. */
  id: Scalars['ID']['output'];
  /** Funds in Traditional IRA awaiting Roth conversion */
  pendingConversionFunds: Scalars['Cents']['output'];
};

/**
 * The type of OmniTransfer transaction option presented to a user. Marked as
 * legacy to indicate that future development in the `TransferOption` type and the
 * OmniTransfer flow should be done in a way that's agnostic to differences between
 * transfer types.
 */
export enum LegacyTransferType {
  /** Deposit */
  Deposit = 'DEPOSIT',
  /** Transfer */
  Transfer = 'TRANSFER',
  /** Withdrawal */
  Withdrawal = 'WITHDRAWAL'
}

/** A legal account holding assets in the client's investing and banking sub-accounts */
export type LegalAccount = {
  __typename: 'LegalAccount';
  /** The display name for a given legal account */
  displayName: Scalars['String']['output'];
  /** The ID for the legal account. */
  id: Scalars['ID']['output'];
  /** The name(s) of the owner(s) of the legal account */
  owner: Scalars['String']['output'];
  /** The type of ownership for the account */
  ownershipType: LegalAccountOwnershipType;
  /** A legal account's primary beneficiaries */
  primaryBeneficiaries: Array<LegalAccountBeneficiary>;
  /** The SBLOC loan associated with this legal account, if any. */
  sblocLoan: Maybe<SblocLoan>;
  /** The solo 401(k) plan associated with this legal account, if any. */
  soloFourOhOneKPlan: Maybe<SoloFourOhOneKPlan>;
  /** The type of account, as recognized by the IRS for tax purposes. */
  taxationType: LegalAccountTaxationType;
  /** The type of legal account */
  type: LegalAccountType;
};

/** A beneficiary for a legal account */
export type LegalAccountBeneficiary = {
  __typename: 'LegalAccountBeneficiary';
  /** The beneficiary's date of birth */
  dateOfBirth: Maybe<Scalars['Date']['output']>;
  /** The beneficiary's distribution share */
  distributionShare: Scalars['Percent']['output'];
  /** The beneficiary's full name */
  fullName: Scalars['String']['output'];
  /** The ID for the beneficiary. */
  id: Scalars['ID']['output'];
  /** A beneficiary's relation to the legal account holder */
  relationship: BeneficiaryRelationship;
  /** A beneficiary's Tax ID/EIN when it is a trust */
  taxId: Maybe<Scalars['TIN']['output']>;
};

/** The type of owner of the account. Currently, only TAXABLE accounts can be owned as JOINT or TRUST. */
export enum LegalAccountOwnershipType {
  /** Owned by an individual user */
  Individual = 'INDIVIDUAL',
  /** Jointly owned */
  Joint = 'JOINT',
  /** Owned by a trust */
  Trust = 'TRUST'
}

/** The type of account as recognized by the IRS for tax purposes. */
export enum LegalAccountTaxationType {
  /** Holding 529 account */
  Holding_529 = 'HOLDING_529',
  /** HSA (Health Savings Account) */
  Hsa = 'HSA',
  /** Roth 401k */
  Roth_401K = 'ROTH_401K',
  /** Roth IRA (Roth Individual Retirement Arrangement) */
  RothIra = 'ROTH_IRA',
  /** SEP IRA (Simplified Employee Pension Individual Retirement Arrangement) */
  SepIra = 'SEP_IRA',
  /** Taxable account */
  Taxable = 'TAXABLE',
  /** Traditional 401k */
  Traditional_401K = 'TRADITIONAL_401K',
  /** Traditional IRA (Traditional Individual Retirement Arrangement) */
  TraditionalIra = 'TRADITIONAL_IRA'
}

/** Enum of Legal Account Types */
export enum LegalAccountType {
  /** 529 Plan */
  Holding_529 = 'HOLDING_529',
  /** Health Savings Account */
  Hsa = 'HSA',
  /** Individual taxable */
  IndividualTaxable = 'INDIVIDUAL_TAXABLE',
  /** Joint taxable */
  JointTaxable = 'JOINT_TAXABLE',
  /** Roth 401(k) */
  Roth_401K = 'ROTH_401K',
  /** Roth IRA */
  RothIra = 'ROTH_IRA',
  /** SEP IRA */
  SepIra = 'SEP_IRA',
  /** Traditional 401(k) */
  Traditional_401K = 'TRADITIONAL_401K',
  /** Traditional IRA */
  TraditionalIra = 'TRADITIONAL_IRA',
  /** Trust taxable */
  TrustTaxable = 'TRUST_TAXABLE'
}

/** A sub account of a LegalAccount */
export type LegalSubAccount = {
  /** The envelope that contains the given sub account. */
  envelope: Envelope;
  /** The id of the account. */
  id: Scalars['ID']['output'];
  /** The legacy ID for this instance of a LegalSubAccount */
  legacySubAccountId: Scalars['LegacyID']['output'];
  /** The legal account holding this sub account. */
  legalAccount: LegalAccount;
  /** The name of the account */
  name: Scalars['String']['output'];
  /** The users who have access to the account */
  users: Array<Client>;
};

/** A model portfolio resource that references an external or internal URL. */
export type LinkModelPortfolioResource = ModelPortfolioResource & {
  __typename: 'LinkModelPortfolioResource';
  /** The unique identifier for the resource. */
  id: Scalars['ID']['output'];
  /** The display title of the resource. */
  title: Scalars['String']['output'];
  /** The type of resource (tear sheet, methodology, etc.). */
  type: ModelPortfolioResourceType;
  /** The URL for the resource. */
  url: Scalars['URL']['output'];
};

/** Logo URLs in different sizes */
export type Logo = {
  __typename: 'Logo';
  /** The URL path to the large logo image */
  large: Maybe<Scalars['URL']['output']>;
  /** The URL path to the large knocked out (white) logo image */
  largeKnockout: Maybe<Scalars['URL']['output']>;
  /** The URL path to the medium logo image */
  medium: Maybe<Scalars['URL']['output']>;
  /** The URL path to the medium knocked out (white) logo image */
  mediumKnockout: Maybe<Scalars['URL']['output']>;
};

/** An investing-focused account managed by Betterment. */
export type ManagedAccount = EnvelopeAccount & {
  __typename: 'ManagedAccount';
  /** The individuals or entities that hold the account. */
  accountHolders: Array<Client | Trust>;
  /** The autoglide eligibility and status for the account. */
  autoglide: Autoglide;
  /** The balance of the account. */
  balance: Scalars['Cents']['output'];
  /**
   * The envelope holding the account. Beware not to use this field to access
   * complex data about an envelope's accounts cyclically, such that a user with a
   * very high number of account's could end up executing an operation with a
   * dramatically high runtime complexity.
   */
  envelope: Envelope;
  /** The icon representing the account. */
  icon: ThemedAsset;
  /** The unique identifier for the envelope */
  id: Scalars['ID']['output'];
  /** Whether the account is tax-coordinated. */
  isTaxCoordinated: Scalars['Boolean']['output'];
  /**
   * Alias for legacy_id. The legacy Goal ID for compatibility with retail.
   * @deprecated Use legacyId instead
   */
  legacyGoalId: Scalars['ID']['output'];
  /** The ID for the managed account (identical to the legacy Goal ID), as recognized by our legacy REST APIs. */
  legacyId: Scalars['ID']['output'];
  /** A set of messages for the account. */
  messages: Array<Message>;
  /** The name representing the account. */
  name: Scalars['String']['output'];
  /** All payroll contribution configs for this account's sub accounts. */
  payrollContributionConfigs: Array<PayrollContributionConfig>;
  /**
   * Pending actions that are scheduled or in progress for this managed account.
   * These actions may affect trading, portfolio previews, or account state.
   * Examples include portfolio migrations, strategy changes, and bulk transfers.
   */
  pendingActions: Array<ManagedAccountPendingAction>;
  /** The performance of the account. */
  performance: Performance;
  /** Portfolio metadata, performance, etc. */
  portfolio: RiskLevelBasedPortfolio | SelfDirectedPortfolio;
  /** All recurring transaction configs for this account's sub accounts. */
  recurringTransactionConfigs: Array<RecurringTransactionConfig>;
  /** The security group positions for the account. */
  securityGroupPositions: Array<SecurityGroupPosition>;
  /** A specific sub-account by ID. */
  subAccount: Maybe<ManagedSubAccount>;
  /** A collection of accounts in a Betterment-managed portfolio. */
  subAccounts: Array<ManagedSubAccount>;
  /** The time-weighted return of the envelope calculated from the sub accounts. */
  timeWeightedReturns: Scalars['Percent']['output'];
  /** The users associated with the account via legal account memberships. */
  users: Array<Client>;
};


/** An investing-focused account managed by Betterment. */
export type ManagedAccountBalanceArgs = {
  includePending: Scalars['Boolean']['input'];
};


/** An investing-focused account managed by Betterment. */
export type ManagedAccountMessagesArgs = {
  location: MessageLocation;
};


/** An investing-focused account managed by Betterment. */
export type ManagedAccountPerformanceArgs = {
  dateRangeOption?: DateRangeOption;
};


/** An investing-focused account managed by Betterment. */
export type ManagedAccountSubAccountArgs = {
  id: Scalars['ID']['input'];
};

/**
 * Union of all pending action types that can occur on a managed account.
 *
 * Use the __typename field to determine the specific action type when querying.
 */
export type ManagedAccountPendingAction = BulkTransferPendingAction | PortfolioMigrationPendingAction | RebalanceNowPendingAction | StrategyChangePendingAction;

/**
 * A portfolio held in a managed account. Could be a Betterment portfolio strategy
 * (e.g. Core, Innovative Technology, etc.), an advisor custom portfolio, advised
 * 401(k), or flexible portfolio. There are two types of managed portfolios:
 * risk-based and self-directed. A risk-based portfolio is a portfolio that is made
 * up of 1 or more risk levels (i.e. 101 stock allocations, named risk levels,
 * etc.). A self-directed portfolio is a portfolio that is based on the user's own
 * investment choices (flexible portfolio or advised 401(k)).
 */
export type ManagedPortfolio = {
  /** Contains all of the portfolio's drift details. */
  drift: Drift;
  /** The unique ID for the portfolio. */
  id: Scalars['ID']['output'];
  /** Whether the advisor is eligible to choose another portfolio strategy. */
  isStrategySelectionEligible: Scalars['Boolean']['output'];
  /** Contains all of the portfolio's rebalance feature details. */
  rebalance: Rebalance;
  /**
   * The portfolio strategy's name. For advisor custom portfolios, this is provided
   * by the advisor. For Betterment portfolios, this is the customer-facing
   * portfolio name (e.g. Innovative Technology, Core, Socially Responsible
   * Investing, etc.). For self directed portfolios, 'Flexible Portfolio' or
   * 'Advised 401(k)'
   */
  strategyName: Scalars['String']['output'];
  /**
   * For portfolios with 101 risk levels, this will be a description of the
   * stock/bonds allocation (e.g., '80% stocks, 20% bonds').
   * - For portfolios with fewer than 101 risk levels (aka 'sparse portfolios'),
   * the this will be the risk level name (e.g., Conservative, Moderate,
   * Aggressive). For a flexpo portfolio, this value describes the percentage of
   * stocks/bonds represented by the current target allocation (e.g., '80% stocks, 20% bonds').
   * - For an advised 401k, for a portfolio targeting just one ticker/fund, this
   * value will describe that one ticker/fund (e.g., 'VLXVX | Vanguard Target
   * Retirement 2065 Fund'), or for a portfolio targeting multiple tickers, 'Custom'.
   */
  targetAllocationDescription: Scalars['String']['output'];
};

/** A sub-account of a Betterment-managed account. */
export type ManagedSubAccount = LegalSubAccount & PayrollContributionConfigAccount & {
  __typename: 'ManagedSubAccount';
  /** The balance of the sub account. */
  balance: Scalars['Cents']['output'];
  /** The envelope that contains the given sub account. */
  envelope: Envelope;
  /** Whether the account has pending transactions (deposits, withdrawals, or transfers) that may affect trade execution. */
  hasPendingTransactions: Scalars['Boolean']['output'];
  /** The icon used to represent the sub account. */
  icon: ThemedAsset;
  /** The unique ID for the given account. */
  id: Scalars['ID']['output'];
  /** The legacy ID for the sub account */
  legacySubAccountId: Scalars['LegacyID']['output'];
  /** The legal account holding this sub account. */
  legalAccount: LegalAccount;
  /** The name of the sub account. */
  name: Scalars['String']['output'];
  /** The users who have access to the account */
  users: Array<Client>;
};


/** A sub-account of a Betterment-managed account. */
export type ManagedSubAccountBalanceArgs = {
  includePending: Scalars['Boolean']['input'];
};

/** A message to display to the advisor. */
export type Message = {
  __typename: 'Message';
  /** The body of the message. */
  body: Scalars['HTML']['output'];
  /** The CTA of the message. */
  cta: Maybe<MessageCtaLink | MessageCtaModal>;
  /** The unique identifier for the message. */
  id: Scalars['ID']['output'];
  /** Whether the message can be dismissed. */
  isDismissible: Scalars['Boolean']['output'];
  /** The style of the message. */
  style: MessageStyle;
  /** The title of the message. */
  title: Maybe<Scalars['String']['output']>;
};

/** CTA for a message */
export type MessageCta = {
  /** The text for the CTA. */
  text: Scalars['String']['output'];
};

/** CTA link for a message. */
export type MessageCtaLink = MessageCta & {
  __typename: 'MessageCtaLink';
  /** Whether the link is an impersonation link. */
  impersonationLink: Scalars['Boolean']['output'];
  /** The text for the CTA. */
  text: Scalars['String']['output'];
  /** The themed asset set for all holdings image url */
  url: Scalars['URL']['output'];
};

/** CTA modal for a message. */
export type MessageCtaModal = MessageCta & {
  __typename: 'MessageCtaModal';
  /** The content for the modal of the CTA. */
  content: Scalars['HTML']['output'];
  /** The text for the CTA. */
  text: Scalars['String']['output'];
};

/** The location of the message. */
export enum MessageLocation {
  /** accounts_page */
  AccountsPage = 'ACCOUNTS_PAGE',
  /** four_oh_one_k_plan_overview */
  FourOhOneKPlanOverview = 'FOUR_OH_ONE_K_PLAN_OVERVIEW',
  /** household_overview */
  HouseholdOverview = 'HOUSEHOLD_OVERVIEW',
  /** summary */
  Summary = 'SUMMARY'
}

/** The style of the message. */
export enum MessageStyle {
  /** A message that communicates an error state, intended to be displayed as a red banner. */
  Error = 'ERROR',
  /** A message that communicates a general information state, intended to be displayed as a blue banner. */
  Info = 'INFO',
  /** A message that communicates success state, intended to be displayed as a green banner. */
  Success = 'SUCCESS',
  /** A message that communicates a general information state, intended to be displayed as a yellow banner. */
  Warning = 'WARNING'
}

/** Capabilities or characteristics associated with a model portfolio. */
export enum ModelPortfolioFeature {
  /** Automatic adjustment of portfolio allocations based on market conditions. */
  AutoAdjust = 'AUTO_ADJUST',
  /** Tax-aware portfolio management across multiple accounts. */
  TaxCoordination = 'TAX_COORDINATION',
  /** Tax loss harvesting to offset capital gains. */
  TaxLossHarvesting = 'TAX_LOSS_HARVESTING'
}

/** Model Portfolio Provider details */
export type ModelPortfolioProvider = {
  __typename: 'ModelPortfolioProvider';
  /** The description of the model portfolio provider */
  description: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the model portfolio provider */
  id: Scalars['ID']['output'];
  /** The brand logo of the model portfolio provider */
  logo: Maybe<ThemedAsset>;
  /** The number of model portfolios offered by the provider */
  modelPortfolioCount: Scalars['Int']['output'];
  /** The paginated list of model portfolios offered by the provider */
  modelPortfolios: ProviderModelPortfolioConnection;
  /** The name of the model portfolio provider */
  name: Scalars['String']['output'];
};


/** Model Portfolio Provider details */
export type ModelPortfolioProviderModelPortfoliosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for ModelPortfolioProvider. */
export type ModelPortfolioProviderConnection = {
  __typename: 'ModelPortfolioProviderConnection';
  /** A list of edges. */
  edges: Array<ModelPortfolioProviderEdge>;
  /** A list of nodes. */
  nodes: Array<ModelPortfolioProvider>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total number of model portfolio providers */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection for model portfolio providers */
export type ModelPortfolioProviderEdge = {
  __typename: 'ModelPortfolioProviderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ModelPortfolioProvider;
};

/** A link or downloadable document relevant to a model portfolio. */
export type ModelPortfolioResource = {
  /** The unique identifier for the resource. */
  id: Scalars['ID']['output'];
  /** The display title of the resource. */
  title: Scalars['String']['output'];
  /** The type of resource (tear sheet, methodology, etc.). */
  type: ModelPortfolioResourceType;
};

/** The type of resource associated with a model portfolio. */
export enum ModelPortfolioResourceType {
  /** Marketing or informational brochure about the portfolio. */
  Brochure = 'BROCHURE',
  /** Form ADV brochure for the portfolio. */
  FormAdv = 'FORM_ADV',
  /** Documentation explaining the investment strategy and approach. */
  Methodology = 'METHODOLOGY',
  /** Legal or regulatory disclosure documents for the strategy. */
  StrategyDisclosure = 'STRATEGY_DISCLOSURE',
  /** A quarterly or periodic performance summary document. */
  TearSheet = 'TEAR_SHEET'
}

/** A risk level within a model portfolio, defining the allocation across security groups. */
export type ModelPortfolioRiskLevel = {
  __typename: 'ModelPortfolioRiskLevel';
  /** The unique identifier for the risk level. */
  id: Scalars['ID']['output'];
  /** Display name of the risk level (e.g. '90% Stocks, 10% Bonds'). */
  name: Scalars['String']['output'];
  /** Allocation for this risk level, ordered by descending target weight. */
  securityGroupAllocations: Array<RiskLevelSecurityGroupAllocation>;
};

/** A security group as part of a model portfolio definition. */
export type ModelPortfolioSecurityGroup = {
  __typename: 'ModelPortfolioSecurityGroup';
  /** Information about the securities in the group, asset class, and purpose in the portfolio. */
  description: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the security group. */
  id: Scalars['ID']['output'];
  /** The name of the security group (e.g. U.S. Large Cap Stocks). */
  name: Scalars['String']['output'];
  /** The primary tax-deferred security for this security group. */
  primarySecurityTaxDeferred: FinancialSecurityFund | FinancialSecurityStock;
  /** The primary taxable security for this security group. */
  primarySecurityTaxable: FinancialSecurityFund | FinancialSecurityStock;
  /** The secondary tax-deferred security for this security group. */
  secondarySecurityTaxDeferred: Maybe<FinancialSecurityFund | FinancialSecurityStock>;
  /** The secondary taxable security for this security group. */
  secondarySecurityTaxable: Maybe<FinancialSecurityFund | FinancialSecurityStock>;
};

/** The entrypoint for all institutional schema mutations */
export type Mutation = {
  __typename: 'Mutation';
  /** Creates a bulk fee intent for on demand billing for a firm based on a bulk fee attempt */
  createBulkFeeIntent: CreateBulkFeeIntentMutationPayload;
  /** Creates a CSV export of advisor client activities with optional filters. */
  createClientActivityCsvExport: CreateClientActivityCsvExportMutationPayload;
  /** Creates a new draft Solo 401(k) Conversion intent record for the provided `planId` (401k only advisors) */
  createDraft401kOnlyAdvisorSoloFourOhOneKConversionIntent: CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationPayload;
  /** Creates a new draft Solo 401(k) Conversion intent record for the provided `planOwnerId` */
  createDraftSoloFourOhOneKConversionIntent: CreateDraftSolo401kConversionIntentMutationPayload;
  /** Submits an order for a single security */
  createFinancialSecurityOrderRequest: CreateFinancialSecurityOrderRequestMutationPayload;
  /** Creates a tax impact preview for a single security sell order */
  createFinancialSecuritySellOrderTaxImpactPreview: CreateFinancialSecuritySellOrderTaxImpactPreviewMutationPayload;
  /** Creates a CSV export of firm billable accounts */
  createFirmBillableAccountsCsvExport: CreateFirmBillableAccountsCsvExportMutationPayload;
  /** Create a new 401(k) report for a 401(k) plan */
  createFourOhOneKReport: CreateFourOhOneKReportMutationPayload;
  /** Creates an Advisor 401(k) Request for Proposal Submission record given the form submission values */
  createFourOhOneKRequestForProposal: CreateFourOhOneKRequestForProposalMutationPayload;
  /** Runs a trading preview for the given action type and associated id */
  createTradePreview: CreateTradePreviewMutationPayload;
  /** Dismisses an advisor announcement so it is no longer shown */
  dismissAdvisorAnnouncement: DismissAnnouncementMutationPayload;
  /** Dismisses the UI banner for the csv export download so it doesn't re-render */
  dismissCsvActivityExportBanner: DismissCsvActivityExportBannerMutationPayload;
  /** Dismisses the CSV export of firm billable accounts */
  dismissFirmBillableAccountsCsvExport: DismissFirmBillableAccountsCsvExportMutationPayload;
  /** Publishes a Solo 401(k) Conversion intent for the provided `conversion_intent_id` */
  publishSolo401kConversionIntent: PublishSolo401kConversionIntentMutationPayload;
  /** Removes the custom QDIA fund lineup from a Solo 401(k) plan */
  removeSolo401kQdiaFundLineup: RemoveSolo401kQdiaFundLineupMutationPayload;
  /** Sends an email invitation to the specified client with a link to enroll themselves in securities lending */
  sendClientSecuritiesLendingInvitation: SendClientSecuritiesLendingInvitationMutationPayload;
  /** Unenrolls client from securities lending */
  unenrollClientFromSecuritiesLending: UnenrollClientFromSecuritiesLendingMutationPayload;
  /** Updated the payment types for the provided billing plans */
  updateBillingPlanPaymentTypes: UpdateBillingPlanPaymentTypesMutationPayload;
  /** Updates a client envelope's funding bank accounts. */
  updateClientEnvelopeBankAccounts: UpdateClientEnvelopeBankAccountsMutationPayload;
  /** Updates the potential account on the given client envelope with the provided beneficiary information. */
  updateClientEnvelopeBeneficiaries: UpdateClientEnvelopeBeneficiariesMutationPayload;
  /** Update the default billing plan of a firm */
  updateDefaultBillingPlan: UpdateDefaultBillingPlanMutationPayload;
  /** Updates the current billing plan for a household */
  updateHouseholdBillingPlan: UpdateHouseholdBillingPlanMutationPayload;
  /** Enables or disables rebalancing for a managed portfolio, and optionally updates the drift threshold percentage. */
  updateManagedPortfolioRebalancing: UpdateManagedPortfolioRebalancingMutationPayload;
  /** Updates whether a firm is subscribed to a given outbound integration */
  updateOutboundIntegrationSubscription: UpdateOutboundIntegrationSubscriptionMutationPayload;
  /** Updates the consent status for a given plan */
  updatePlanFeedConsent: UpdatePlanFeedConsentMutationPayload;
  /** Updates the QDIA fund lineup for a client envelope's solo 401(k) plan by uploading CSV content. */
  updateQdiaFundLineup: UpdateQdiaFundLineupMutationPayload;
  /** Updates the contribution details for a specific member in a Solo 401(K) conversion */
  updateSolo401kConversionIntentContributions: UpdateSolo401kConversionIntentContributionsMutationPayload;
  /** Updates the Funds sourcing type for an existing Solo 401(k) conversion */
  updateSolo401kConversionIntentFundsType: UpdateSolo401kConversionIntentFundsTypeMutationPayload;
  /**
   * Upserts a billing plan for the firm. If the billing plan already exists, it will be updated;
   *               otherwise, a new one will be created.
   */
  upsertBillingPlan: UpsertBillingPlanMutationPayload;
  /** Validates the potential beneficiary */
  validateClientEnvelopeBeneficiary: ValidateClientEnvelopeBeneficiaryMutationPayload;
  /** Validates a single security order request before submission */
  validateFinancialSecurityOrderRequest: ValidateFinancialSecurityOrderRequestMutationPayload;
  /** Validate a Solo 401(k) Conversion intent for the provided `conversion_intent_id` */
  validateSolo401kConversionIntent: ValidateSolo401kConversionIntentMutationPayload;
  /** Validates the information provided in the Solo 401(k) plan form */
  validateSolo401kPlanForm: ValidateSolo401kPlanFormMutationPayload;
};


/** The entrypoint for all institutional schema mutations */
export type MutationCreateBulkFeeIntentArgs = {
  input: CreateBulkFeeIntentMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationCreateClientActivityCsvExportArgs = {
  input: CreateClientActivityCsvExportMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationCreateDraft401kOnlyAdvisorSoloFourOhOneKConversionIntentArgs = {
  input: CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationCreateDraftSoloFourOhOneKConversionIntentArgs = {
  input: CreateDraftSolo401kConversionIntentMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationCreateFinancialSecurityOrderRequestArgs = {
  input: CreateFinancialSecurityOrderRequestMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationCreateFinancialSecuritySellOrderTaxImpactPreviewArgs = {
  input: CreateFinancialSecuritySellOrderTaxImpactPreviewMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationCreateFourOhOneKReportArgs = {
  input: CreateFourOhOneKReportMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationCreateFourOhOneKRequestForProposalArgs = {
  input: CreateFourOhOneKRequestForProposalMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationCreateTradePreviewArgs = {
  input: CreateTradePreviewMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationDismissAdvisorAnnouncementArgs = {
  input: DismissAnnouncementMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationPublishSolo401kConversionIntentArgs = {
  input: PublishSolo401kConversionIntentMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationRemoveSolo401kQdiaFundLineupArgs = {
  input: RemoveSolo401kQdiaFundLineupMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationSendClientSecuritiesLendingInvitationArgs = {
  input: SendClientSecuritiesLendingInvitationMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationUnenrollClientFromSecuritiesLendingArgs = {
  input: UnenrollClientFromSecuritiesLendingMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationUpdateBillingPlanPaymentTypesArgs = {
  input: UpdateBillingPlanPaymentTypesMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationUpdateClientEnvelopeBankAccountsArgs = {
  input: UpdateClientEnvelopeBankAccountsMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationUpdateClientEnvelopeBeneficiariesArgs = {
  input: UpdateClientEnvelopeBeneficiariesMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationUpdateDefaultBillingPlanArgs = {
  input: UpdateDefaultBillingPlanMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationUpdateHouseholdBillingPlanArgs = {
  input: UpdateHouseholdBillingPlanMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationUpdateManagedPortfolioRebalancingArgs = {
  input: UpdateManagedPortfolioRebalancingMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationUpdateOutboundIntegrationSubscriptionArgs = {
  input: UpdateOutboundIntegrationSubscriptionMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationUpdatePlanFeedConsentArgs = {
  input: UpdatePlanFeedConsentMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationUpdateQdiaFundLineupArgs = {
  input: UpdateQdiaFundLineupMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationUpdateSolo401kConversionIntentContributionsArgs = {
  input: UpdateSolo401kConversionIntentContributionsMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationUpdateSolo401kConversionIntentFundsTypeArgs = {
  input: UpdateSolo401kConversionIntentFundsTypeMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationUpsertBillingPlanArgs = {
  input: UpsertBillingPlanMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationValidateClientEnvelopeBeneficiaryArgs = {
  input: ValidateClientEnvelopeBeneficiaryMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationValidateFinancialSecurityOrderRequestArgs = {
  input: ValidateFinancialSecurityOrderRequestMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationValidateSolo401kConversionIntentArgs = {
  input: ValidateSolo401kConversionIntentMutationInput;
};


/** The entrypoint for all institutional schema mutations */
export type MutationValidateSolo401kPlanFormArgs = {
  input: ValidateSolo401kPlanFormMutationInput;
};

/** Platform fee is either paid by the advisor or the client, not shared */
export type NotSharedPlatformFeeAllocation = {
  __typename: 'NotSharedPlatformFeeAllocation';
  /** The party responsible for paying the platform fee */
  paidBy: PlatformFeePaidBy;
};

/** Defines if the platform fee is paid by the advisor only or the client only */
export type NotSharedPlatformFeeInput = {
  /** The party responsible for paying the platform fee */
  paidBy: PlatformFeePaidBy;
};

/** Configuration for an outbound integration */
export type OutboundIntegration = {
  __typename: 'OutboundIntegration';
  /** Components of the outbound integration */
  components: Maybe<Array<Scalars['String']['output']>>;
  /** The description of the outbound integration */
  description: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the outbound integration */
  id: Scalars['ID']['output'];
  /** The type of outbound integration */
  integrationType: OutboundIntegrationType;
  /** Whether the current advisors firm is subscribed to the outbound integration */
  isSubscribed: Scalars['Boolean']['output'];
  /** Url for "How to set up integration" article */
  learnMoreUrl: Maybe<Scalars['String']['output']>;
  /** Outbound Integration Logo */
  logoUrl: Maybe<Scalars['String']['output']>;
  /** The name of the outbound integration */
  name: Scalars['String']['output'];
};

/** The integration type for an outbound integration */
export enum OutboundIntegrationType {
  /** A custodial feed integration for exporting advised 401(k) data */
  Advised_401KCustodialFeed = 'ADVISED_401K_CUSTODIAL_FEED',
  /** A feed integration for exporting SBLOC data */
  SblocFeed = 'SBLOC_FEED',
  /** A custodial feed integration for exporting wealth data */
  WealthCustodialFeed = 'WEALTH_CUSTODIAL_FEED'
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

/** The payment type for a billing plan */
export enum PaymentType {
  /** The billing plan bills from cash */
  CashReserveFirst = 'CASH_RESERVE_FIRST',
  /** The billing plan bills from investments */
  SubAccount = 'SUB_ACCOUNT'
}

/** A configuration of an employee deferral from the user's paycheck into one of their accounts. */
export type PayrollContributionConfig = {
  __typename: 'PayrollContributionConfig';
  /** The value of the deferral applied to bonus pay periods, as either a currency amount or a percentage. */
  bonusValue: Maybe<PayrollContributionConfigValue>;
  /** The destination name for the config. */
  destinationName: Scalars['String']['output'];
  /** The id of the config. */
  id: Scalars['ID']['output'];
  /** The value of the deferral, as either a currency amount or a percentage. */
  value: PayrollContributionConfigValue;
};

/** An account used as a destination for payroll contribution configs. */
export type PayrollContributionConfigAccount = {
  /** The id of the account. */
  id: Scalars['ID']['output'];
};

/** The amount for a payroll contribution config, as either a currency amount or a percentage. */
export type PayrollContributionConfigValue = PayrollContributionConfigValueAmount | PayrollContributionConfigValuePercent;

/** The amount value for a payroll contribution config. */
export type PayrollContributionConfigValueAmount = {
  __typename: 'PayrollContributionConfigValueAmount';
  /** The value as an amount. */
  amount: Scalars['Cents']['output'];
};

/** The percent value for a payroll contribution config. */
export type PayrollContributionConfigValuePercent = {
  __typename: 'PayrollContributionConfigValuePercent';
  /** The value as a percent. */
  percent: Scalars['Percent']['output'];
};

/**
 * Represents a pending action on a managed account that may affect trading,
 * portfolio state, or account behavior. Pending actions are operations that have
 * been initiated but not yet completed, such as portfolio migrations, strategy
 * changes, or bulk transfers.
 *
 * Use the __typename field to determine the specific action type when querying.
 */
export type PendingAction = {
  /**
   * The timestamp when this pending action was created. This field ensures
   * pending actions can be sorted consistently in collections (e.g., oldest
   * first, newest first).
   */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier for this pending action. */
  id: Scalars['ID']['output'];
};

/** Aggregated performance data: related accounts. */
export type Performance = {
  __typename: 'Performance';
  /** Performance history metrics for this performance context. */
  history: PerformanceHistory;
  /** Performance totals metrics for this performance context. */
  totals: PerformanceTotals;
};

/** An account participating in performance aggregation. */
export type PerformanceAccount = {
  /** The icon used to represent the account. */
  icon: ThemedAsset;
  /** The id of the item. */
  id: Scalars['ID']['output'];
  /** The name used to represent the account. */
  name: Scalars['String']['output'];
  /** The performance of the account. */
  performance: Performance;
};


/** An account participating in performance aggregation. */
export type PerformanceAccountPerformanceArgs = {
  dateRangeOption?: DateRangeOption;
};

/** A history of account balances/performance over time. */
export type PerformanceHistory = {
  __typename: 'PerformanceHistory';
  /** A description of how recent the data is. */
  recencyDescription: Scalars['String']['output'];
};

/** Provides performance summary of any interest-bearing instrument(s). */
export type PerformanceInterest = {
  __typename: 'PerformanceInterest';
  /** Total amount of accrued but unpaid interest. */
  accrued: Scalars['Cents']['output'];
  /** Detailed explanation of the accrual and payment strategy used by the underlying interest-bearing instrument(s) */
  accruedExplanation: Scalars['String']['output'];
  /** Total amount of interest that has been fully paid out to date. */
  paid: Scalars['Cents']['output'];
};

/** Provides performance data for goals. */
export type PerformanceTotals = {
  __typename: 'PerformanceTotals';
  /**
   * The total earned of the Goals over the given date range. This value includes
   * market changes, dividends (including pending), interest paid, and total fees
   */
  earned: Scalars['Cents']['output'];
  /** Provides performance summary of any interest-bearing instrument(s). */
  interest: Maybe<PerformanceInterest>;
};

/** The authorization tier of a 401(k) plan manager */
export enum PlanManagerAuthorizationTier {
  /** Administrator */
  Administrator = 'ADMINISTRATOR',
  /** Staff */
  Staff = 'STAFF',
  /** View Only */
  ViewOnly = 'VIEW_ONLY'
}

/** Details about how the platform fee is allocated between the advisor and clients */
export type PlatformFeeAllocation = NotSharedPlatformFeeAllocation | SharedPlatformFeeAllocation;

/** Defines how the platform fee is allocated between the advisor and the client */
export type PlatformFeeAllocationInput =
  /** Whether the platform fee is paid by the advisor only or the client only */
  { notShared: NotSharedPlatformFeeInput; shared?: never; }
  |  /** The portion of the platform fee paid by the client, in basis points */
  { notShared?: never; shared: SharedPlatformFeeInput; };

/** The party responsible for paying the platform fee */
export enum PlatformFeePaidBy {
  /** Platform fee is paid only by the advisor */
  AdvisorOnly = 'ADVISOR_ONLY',
  /** Platform fee is paid only by the client */
  ClientOnly = 'CLIENT_ONLY'
}

/** A tier for platform fees, which defines the fee structure based on the amount. */
export type PlatformFeeTier = {
  __typename: 'PlatformFeeTier';
  /** The fee in bps */
  fee: Scalars['Bps']['output'];
  /** This is the maximum amount for which this tier applies. If null, it applies to all amounts above the tier start. */
  tierEnd: Maybe<Scalars['Cents']['output']>;
};

/**
 * Represents a pending action that changes the portfolio configuration (strategy,
 * target allocation, or model portfolio version). This intermediate interface
 * groups together all pending actions that have a future portfolio state, making
 * queries simpler by allowing a single fragment instead of multiple type-specific
 * fragments.
 *
 * Use the __typename field to determine the specific action type when querying.
 */
export type PortfolioChangePendingAction = {
  /**
   * The timestamp when this pending action was created. This field ensures
   * pending actions can be sorted consistently in collections (e.g., oldest
   * first, newest first).
   */
  createdAt: Scalars['DateTime']['output'];
  /** The future portfolio state that will be applied once this action completes. */
  futurePortfolio: FuturePortfolio;
  /** The unique identifier for this pending action. */
  id: Scalars['ID']['output'];
};

/**
 * Represents a pending portfolio migration action. Portfolio migrations occur when
 * a managed account's portfolio is updated to a new version of a model portfolio.
 * These migrations wait until after trading hours to execute.
 */
export type PortfolioMigrationPendingAction = PendingAction & PortfolioChangePendingAction & {
  __typename: 'PortfolioMigrationPendingAction';
  /** The timestamp when the Portfolio Migration was created, i.e., the portfolio change was saved and published.  */
  createdAt: Scalars['DateTime']['output'];
  /** The future portfolio state that will be applied once this migration completes. */
  futurePortfolio: FuturePortfolio;
  /** The unique identifier for this pending action. */
  id: Scalars['ID']['output'];
  /** Defines whether or not the portfolio is firm-designed. */
  isFirmDesigned: Scalars['Boolean']['output'];
};

/** A projection of 401(K) contributions. */
export type Projection = {
  __typename: 'Projection';
  /** A unique identifier for an FourOhOneK::Contributions::ProjectionType */
  id: Scalars['ID']['output'];
  /** Total contributions for the given time period. */
  total: Scalars['Cents']['output'];
};

/** A provider-based model portfolio (Betterment or partner). */
export type ProviderModelPortfolio = {
  __typename: 'ProviderModelPortfolio';
  /** Default risk level and corresponding allocation for the model portfolio. */
  defaultRiskLevel: ModelPortfolioRiskLevel;
  /** Detailed descriptive text providing additional context about the model portfolio. */
  detailedDescription: Maybe<Scalars['String']['output']>;
  /** Capabilities or characteristics associated with the model portfolio. */
  features: Array<ModelPortfolioFeature>;
  /** The unique identifier for the model portfolio. */
  id: Scalars['ID']['output'];
  /** The provider offering this model portfolio. */
  modelPortfolioProvider: ModelPortfolioProvider;
  /** The name of the model portfolio. */
  name: Scalars['String']['output'];
  /** Related documents and external or internal references for the model portfolio. */
  resources: Array<DocumentModelPortfolioResource | LinkModelPortfolioResource>;
  /** Short descriptive text summarizing the model portfolio. */
  summary: Maybe<Scalars['String']['output']>;
};

/** The connection type for ProviderModelPortfolio. */
export type ProviderModelPortfolioConnection = {
  __typename: 'ProviderModelPortfolioConnection';
  /** A list of edges. */
  edges: Array<ProviderModelPortfolioEdge>;
  /** A list of nodes. */
  nodes: Array<ProviderModelPortfolio>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The total number of model portfolios */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection for provider model portfolios */
export type ProviderModelPortfolioEdge = {
  __typename: 'ProviderModelPortfolioEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ProviderModelPortfolio;
};

/** Autogenerated input type of PublishSolo401kConversionIntentMutation */
export type PublishSolo401kConversionIntentMutationInput = {
  /** Whether the advisor has checked the confirmation checkbox */
  confirmationChecked: Scalars['Boolean']['input'];
  /** The ID for identifying the intent record */
  solo401kConversionIntentId: Scalars['ID']['input'];
};

/** Autogenerated return type of PublishSolo401kConversionIntentMutation. */
export type PublishSolo401kConversionIntentMutationPayload = {
  __typename: 'PublishSolo401kConversionIntentMutationPayload';
  /** The user-displayable errors produced while attempting to resolve PublishSolo401kConversionIntentMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the PublishSolo401kConversionIntentMutation execution as type Solo401kConversionIntent. */
  result: Maybe<Solo401kConversionIntent>;
};

/**
 * The reason an envelope exists. It may be just to organize some of the user's
 * finances, or it may be to make progress towards a specific financial goal.
 */
export type Purpose = {
  /** The age at which the purpose should be completed. */
  ageAtCompletion: Maybe<Scalars['Int']['output']>;
  /** The icon used to represent the envelope and its purpose. */
  icon: ThemedAsset;
  /** The unique ID of the purpose. */
  id: Scalars['ID']['output'];
  /** DEPRECATED: The goal ID to use to edit the purpose in legacy application code. */
  legacyGoalId: Scalars['LegacyID']['output'];
  /** The name of the purpose, previously known as the envelope's name, or a goal's name. */
  name: Scalars['String']['output'];
  /** The status of the purpose (eg. on track, off track, achieved,...) */
  purposeStatus: PurposeStatus;
  /** The target amount of the purpose. */
  targetAmount: Maybe<Scalars['Cents']['output']>;
  /** The target date of the purpose. */
  targetDate: Maybe<Scalars['Date']['output']>;
};

/** A purpose for building an emergency fund. */
export type PurposeEmergencyFund = Purpose & {
  __typename: 'PurposeEmergencyFund';
  /** The age at which the purpose should be completed. */
  ageAtCompletion: Maybe<Scalars['Int']['output']>;
  /** The icon used to represent the envelope and its purpose. */
  icon: ThemedAsset;
  /** The unique ID of the purpose. */
  id: Scalars['ID']['output'];
  /** DEPRECATED: The goal ID to use to edit the purpose in legacy application code. */
  legacyGoalId: Scalars['LegacyID']['output'];
  /** The name of the purpose, previously known as the envelope's name, or a goal's name. */
  name: Scalars['String']['output'];
  /** The status of the purpose (eg. on track, off track, achieved, ...) */
  purposeStatus: PurposeStatus;
  /** The target amount of the purpose. */
  targetAmount: Maybe<Scalars['Cents']['output']>;
  /** The target date of the purpose. */
  targetDate: Maybe<Scalars['Date']['output']>;
};

/** A purpose for saving towards a major purchase. */
export type PurposeMajorPurchase = Purpose & {
  __typename: 'PurposeMajorPurchase';
  /** The age at which the purpose should be completed. */
  ageAtCompletion: Maybe<Scalars['Int']['output']>;
  /** The icon used to represent the envelope and its purpose. */
  icon: ThemedAsset;
  /** The unique ID of the purpose. */
  id: Scalars['ID']['output'];
  /** DEPRECATED: The goal ID to use to edit the purpose in legacy application code. */
  legacyGoalId: Scalars['LegacyID']['output'];
  /** The name of the purpose, previously known as the envelope's name, or a goal's name. */
  name: Scalars['String']['output'];
  /** The status of the purpose (eg. on track, off track, achieved,...) */
  purposeStatus: PurposeStatus;
  /** The target amount of the purpose. */
  targetAmount: Maybe<Scalars['Cents']['output']>;
  /** The target date of the purpose. */
  targetDate: Maybe<Scalars['Date']['output']>;
};

/** A purpose for growing retirement savings. */
export type PurposeRetirementGrowth = Purpose & {
  __typename: 'PurposeRetirementGrowth';
  /** The age at which the purpose should be completed. */
  ageAtCompletion: Maybe<Scalars['Int']['output']>;
  /** The icon used to represent the envelope and its purpose. */
  icon: ThemedAsset;
  /** The unique ID of the purpose. */
  id: Scalars['ID']['output'];
  /** DEPRECATED: The goal ID to use to edit the purpose in legacy application code. */
  legacyGoalId: Scalars['LegacyID']['output'];
  /** The name of the purpose, previously known as the envelope's name, or a goal's name. */
  name: Scalars['String']['output'];
  /** The status of the purpose (eg. on track, off track, achieved,...) */
  purposeStatus: PurposeStatus;
  /** The target amount of the purpose. */
  targetAmount: Maybe<Scalars['Cents']['output']>;
  /** The target date of the purpose. */
  targetDate: Maybe<Scalars['Date']['output']>;
};

/** A purpose tracking the user's progress in spending their retirement savings. */
export type PurposeRetirementIncome = Purpose & {
  __typename: 'PurposeRetirementIncome';
  /** The age at which the purpose should be completed. */
  ageAtCompletion: Maybe<Scalars['Int']['output']>;
  /** The icon used to represent the envelope and its purpose. */
  icon: ThemedAsset;
  /** The unique ID of the purpose. */
  id: Scalars['ID']['output'];
  /** DEPRECATED: The goal ID to use to edit the purpose in legacy application code. */
  legacyGoalId: Scalars['LegacyID']['output'];
  /** The age at which the user expects to no longer need retirement spending. */
  lifeExpectancyAge: Scalars['Int']['output'];
  /** The name of the purpose, previously known as the envelope's name, or a goal's name. */
  name: Scalars['String']['output'];
  /** A projection of the outcome and expected progress for the retirement income purpose. */
  projection: PurposeRetirementIncomeProjection;
  /** The status of the purpose (eg. on track, off track, achieved,...) */
  purposeStatus: PurposeStatus;
  /** The target amount of the purpose. */
  targetAmount: Maybe<Scalars['Cents']['output']>;
  /** The target date of the purpose. */
  targetDate: Maybe<Scalars['Date']['output']>;
};

/**
 * A projected future for a retirement income purpose. Retirement income
 * projections express the rate at which the user will draw down their retirement
 * savings, and how long it will take to deplete their current balance.
 */
export type PurposeRetirementIncomeProjection = {
  __typename: 'PurposeRetirementIncomeProjection';
  /** The recommended monthly withdrawal amount for the user, given their current life expectancy and ad-hoc deposit amount. */
  recommendedMonthlyOutflows: Maybe<Scalars['Cents']['output']>;
};

/** The purpose status. Returns no_target, finished, time_passed, off_track, on_track for non-retirement purposes */
export enum PurposeStatus {
  /** Purpose has been achieved */
  Finished = 'FINISHED',
  /** Not saving enough for retirement */
  NotSavingEnough = 'NOT_SAVING_ENOUGH',
  /** Purpose does not have a target value */
  NoTarget = 'NO_TARGET',
  /** Purpose is off track */
  OffTrack = 'OFF_TRACK',
  /** Purpose is on track */
  OnTrack = 'ON_TRACK',
  /** Saved enough for retirement */
  SavedEnough = 'SAVED_ENOUGH',
  /** Saving enough for retirement */
  SavingEnough = 'SAVING_ENOUGH',
  /** The target date has passed */
  TimePassed = 'TIME_PASSED'
}

/** The entrypoint for all institutional schema queries */
export type Query = {
  __typename: 'Query';
  /** The user's financial activity. */
  activityConnection: ActivityItemConnection;
  /** The options for filtering a users transactional activity by date range. */
  activityDateRangeOptions: Array<DateRangeOption>;
  /** The options for filtering a users transactional activity by the user. */
  activityItemClientOptions: Array<Client>;
  /** The options for filtering a users transactional activity by item type. */
  activityItemTypeOptions: Array<ActivityItemTypeFilterOption>;
  /** Provides the goal creation flow for the advisor by id */
  advisorGoalCreation: Maybe<AdvisorGoalCreation>;
  /** The options for filtering activity by the type of advisory relationship between advisor and client */
  advisorTypeOptions: Array<ActivityAdvisorType>;
  /** Returns an account summary for a model portfolio */
  assignedAccountSummary: AssignedAccountSummary;
  /** Find households affected by a billing plan change */
  billingPlanAffectedHouseholds: Array<AffectedHousehold>;
  /** The attached csv record for the activity csv report. */
  clientActivityCsvExport: Maybe<CsvExport>;
  /** Provides a client envelope for the advisor by id */
  clientEnvelope: ClientEnvelope;
  /** The currently logged-in advisor */
  currentAdvisor: Advisor;
  /** Financial and legal disclosures */
  disclosures: Disclosures;
  /** Provides a dictionary of available employment statuses */
  employmentStatuses: Array<Dictionary>;
  /** Find an envelope account by ID */
  envelopeAccount: CashAccount | DirectTradingAccount | ManagedAccount;
  /** Provides trade timing for the given financial security */
  estimatedTradeTiming: EstimatedTradeTiming;
  /** Provides a dictionary of available federal tax rates */
  federalTaxRates: Array<Dictionary>;
  /** Find the firm of the current advisor */
  firm: Firm;
  /** The csv record for the firm billable accounts csv report. */
  firmBillableAccountsCsvExport: Maybe<CsvExport>;
  /** Provides a 401(k) plan (aka B4b::Api::Data::Plan) by id */
  fourOhOneKPlan: Maybe<SoloFourOhOneKPlan | StandardFourOhOneKPlan>;
  /** Provides a list of 401(k) plans (aka B4b::Api::Data::Plan) by the current advisor id */
  fourOhOneKPlans: Maybe<Array<AdvisedPlan>>;
  /** Provides a collection of highlighted model portfolio providers available for the advisor */
  highlightedModelPortfolioProviders: Array<ModelPortfolioProvider>;
  /** Find a household by ID */
  household: HouseholdResult;
  /**
   * Find a goal by ID
   * @deprecated Used for legacy performance improvements. Use Envelopes instead.
   */
  legacyGoal: LegacyGoal;
  /**
   * Find a sub account by ID
   * @deprecated Used for legacy performance improvements. Use Envelopes instead.
   */
  legacySubAccount: LegacySubAccount;
  /** All sub accounts for the current advisor. */
  legalSubAccounts: Array<CashAccount | DirectTradingAccount | ManagedSubAccount>;
  /** A single managed account. */
  managedAccount: ManagedAccount;
  /** Provides a paginated connection of model portfolio providers */
  modelPortfolioProviderConnection: ModelPortfolioProviderConnection;
  /** Provides a collection of subscribable and active firm integrations */
  outboundIntegrations: Array<OutboundIntegration>;
  /** Find a provider model portfolio by ID */
  providerModelPortfolio: ProviderModelPortfolio;
  /** Fetches a security position for a managed account by managed account ID and financial security ID. */
  securityPosition: Maybe<SecurityPositionsBySecurity>;
  /** Find the specific Solo401k Conversion intent by ID, scoped to the current advisor */
  solo401kConversionIntent: Solo401kConversionIntent;
  /** Find Solo401k Conversion intents, scoped to the current advisor */
  solo401kConversionIntents: Array<Solo401kConversionIntent>;
  /** Support resources and contact information */
  support: SupportResources;
  /** Provides a dictionary of available tax filing statuses */
  taxFilingStatuses: Array<Dictionary>;
};


/** The entrypoint for all institutional schema queries */
export type QueryActivityConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ActivityFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The entrypoint for all institutional schema queries */
export type QueryActivityItemClientOptionsArgs = {
  householdId?: InputMaybe<Scalars['ID']['input']>;
};


/** The entrypoint for all institutional schema queries */
export type QueryAdvisorGoalCreationArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all institutional schema queries */
export type QueryAssignedAccountSummaryArgs = {
  modelPortfolioId: Scalars['ID']['input'];
};


/** The entrypoint for all institutional schema queries */
export type QueryBillingPlanAffectedHouseholdsArgs = {
  billingPlanId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset: Scalars['Int']['input'];
  searchText?: InputMaybe<Scalars['String']['input']>;
};


/** The entrypoint for all institutional schema queries */
export type QueryClientEnvelopeArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all institutional schema queries */
export type QueryEnvelopeAccountArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all institutional schema queries */
export type QueryEstimatedTradeTimingArgs = {
  financialSecurityId: Scalars['ID']['input'];
  orderSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The entrypoint for all institutional schema queries */
export type QueryFourOhOneKPlanArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all institutional schema queries */
export type QueryFourOhOneKPlansArgs = {
  where?: InputMaybe<FourOhOneKPlansWhereInput>;
};


/** The entrypoint for all institutional schema queries */
export type QueryHouseholdArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all institutional schema queries */
export type QueryLegacyGoalArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all institutional schema queries */
export type QueryLegacySubAccountArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all institutional schema queries */
export type QueryManagedAccountArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all institutional schema queries */
export type QueryModelPortfolioProviderConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** The entrypoint for all institutional schema queries */
export type QueryProviderModelPortfolioArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all institutional schema queries */
export type QuerySecurityPositionArgs = {
  financialSecurityId: Scalars['ID']['input'];
  managedAccountId: Scalars['ID']['input'];
};


/** The entrypoint for all institutional schema queries */
export type QuerySolo401kConversionIntentArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all institutional schema queries */
export type QuerySolo401kConversionIntentsArgs = {
  planOwnerId: Scalars['ID']['input'];
  status?: InputMaybe<Solo401kConversionIntentStatus>;
};

/**
 * Information about the rebalancing features as relevant to the given portfolio.
 * Rebalancing is a feature of our portfolio management system, where Betterment
 * will automatically buy and sell assets as the market changes to keep the user's
 * portfolio close to its target allocation (aka, reducing the 'drift' between the
 * portfolio and its target allocation).
 */
export type Rebalance = {
  __typename: 'Rebalance';
  /**
   * A derived identifier for this Rebalance, composed of the underlying goal ID.
   * Intended as a unique-enough key for client caching and list rendering. Not a
   * database primary key.
   */
  id: Scalars['ID']['output'];
  /** Customer's rebalancing preference (user-controllable setting). */
  isCustomerEnabled: Scalars['Boolean']['output'];
  /** Overall rebalancing status (true when both customer and system settings allow rebalancing). */
  isEnabled: Scalars['Boolean']['output'];
  /** Whether the user is eligible to trigger a manual rebalance now action */
  isRebalanceNowEligible: Scalars['Boolean']['output'];
  /**
   * System-level rebalancing override (controlled by admin tools and automated
   * workflows. can disable rebalancing regardless of customer setting).
   */
  isSystemEnabled: Scalars['Boolean']['output'];
};

/**
 * Represents a pending Rebalance Now request. Rebalance Now requests trade securities to
 * bring the portfolio back to its target allocation without changing the portfolio
 * strategy or target allocation. These actions execute during trading hours.
 */
export type RebalanceNowPendingAction = PendingAction & {
  __typename: 'RebalanceNowPendingAction';
  /** The timestamp when this Rebalance Now Intent was submitted.  */
  createdAt: Scalars['DateTime']['output'];
  /** The unique identifier for this pending action. */
  id: Scalars['ID']['output'];
};

/** A Result Type representing the absence of a record/object for the Query conditions. */
export type RecordNotFoundResult = {
  __typename: 'RecordNotFoundResult';
  /** Dummy field for an otherwise empty type. */
  reason: Maybe<Scalars['String']['output']>;
};

/**
 * A configuration for a user-defined recurring transaction between accounts.
 * Source and destination accounts can be internal betterment accounts or external
 * bank accounts, so this type encompasses all of what have been historically known
 * as 'auto-deposits', 'recurring transfers', and 'auto-withdrawals' (use the
 * `legacyTransferType` field to disambiguate between those three concepts). For
 * employer 401k deferral configurations, see `DeferralSetting`.
 */
export type RecurringTransactionConfig = {
  __typename: 'RecurringTransactionConfig';
  /** The amount of the transaction. */
  amount: Scalars['Cents']['output'];
  /** The name of the destination account for the config. */
  destinationName: Scalars['String']['output'];
  /** The frequency at which the transaction occurs. */
  frequency: RecurringTransactionFrequency;
  /** The ID for the config. */
  id: Scalars['ID']['output'];
  /** Whether the config is editable by the current user. */
  isEditable: Scalars['Boolean']['output'];
  /** The ID for the config, as recognized by our legacy REST APIs. */
  legacyId: Maybe<Scalars['LegacyID']['output']>;
  /**
   * The type of OmniTransfer transaction type presented to a user. Marked as
   * legacy to indicate that future development in the OmniTransfer flow should be
   * done in a way that's agnostic to differences between transfer types.
   */
  legacyTransferType: LegacyTransferType;
  /** The ID for the config, as recognized by our legacy REST APIs. */
  legacyUuid: Maybe<Scalars['LegacyUUID']['output']>;
  /** The source account for the config. Returns null if the source is not a Cash account. */
  source: Maybe<CashAccount>;
  /** The name of the source account for the config. */
  sourceName: Scalars['String']['output'];
};

/**
 * Possible configurations of a recurring transaction's frequency. Acceptable day
 * of week values are 1-5 (Monday-Friday), and acceptable day of month values are 1-28.
 */
export type RecurringTransactionFrequency = RecurringTransactionFrequencyAnnually | RecurringTransactionFrequencyEveryOtherWeek | RecurringTransactionFrequencyMonthly | RecurringTransactionFrequencyTwiceAMonth | RecurringTransactionFrequencyWeekly;

/** Frequency for transactions executing once a year. */
export type RecurringTransactionFrequencyAnnually = {
  __typename: 'RecurringTransactionFrequencyAnnually';
  /** The day of the month. */
  day: Scalars['Int']['output'];
  /** The month. */
  month: Scalars['Int']['output'];
};

/** Frequency for transactions executing every other week. */
export type RecurringTransactionFrequencyEveryOtherWeek = {
  __typename: 'RecurringTransactionFrequencyEveryOtherWeek';
  /** The day of week. */
  day: Scalars['Int']['output'];
};

/** Frequency for transactions executing once a month. */
export type RecurringTransactionFrequencyMonthly = {
  __typename: 'RecurringTransactionFrequencyMonthly';
  /** The day of month. */
  day: Scalars['Int']['output'];
};

/** Frequency for transactions executing twice a month. */
export type RecurringTransactionFrequencyTwiceAMonth = {
  __typename: 'RecurringTransactionFrequencyTwiceAMonth';
  /** The first day of month. */
  firstDay: Scalars['Int']['output'];
  /** The second day of month. */
  secondDay: Scalars['Int']['output'];
};

/** Frequency for transactions executing once a week. */
export type RecurringTransactionFrequencyWeekly = {
  __typename: 'RecurringTransactionFrequencyWeekly';
  /** The day of week. */
  day: Scalars['Int']['output'];
};

/** Autogenerated input type of RemoveSolo401kQdiaFundLineupMutation */
export type RemoveSolo401kQdiaFundLineupMutationInput = {
  /** The ID of the Solo 401(k) plan. */
  solo401kPlanId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveSolo401kQdiaFundLineupMutation. */
export type RemoveSolo401kQdiaFundLineupMutationPayload = {
  __typename: 'RemoveSolo401kQdiaFundLineupMutationPayload';
  /** The user-displayable errors produced while attempting to resolve RemoveSolo401kQdiaFundLineupMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the RemoveSolo401kQdiaFundLineupMutation execution as type Solo401kPlan. */
  result: Maybe<Solo401kPlan>;
};

/** The 401(k) contributions for a user. */
export type Result = {
  __typename: 'Result';
  /** A unique identifier for a FourOhOneKContributionsResult */
  id: Scalars['ID']['output'];
  /** 401(k) contributions this year. */
  thisYear: Annual;
};

/**
 * A portfolio that is made up of a collection of 1 or more risk levels. Each risk
 * level is a collection of security groups that are designed to achieve a specific
 * risk/return profile. The autoglide feature, when available, automatically
 * adjusts the portfolio's risk level over time in order to decrease risk as the
 * user approaches retirement. Some portfolios have 101 risk levels, each
 * representing a stock (vs. bond) allocation percentage from 0% to 100%. Other
 * portfolios have fewer than 101 risk levels (aka 'sparse portfolios'), which are
 * named risk levels (e.g., Conservative, Moderate, Aggressive). A risk level is
 * unique to a tax treatment (taxable, tax deferred, tax coordinated).
 */
export type RiskLevelBasedPortfolio = ManagedPortfolio & {
  __typename: 'RiskLevelBasedPortfolio';
  /** Contains all of the portfolio's drift details. */
  drift: Drift;
  /** The unique ID for the portfolio. */
  id: Scalars['ID']['output'];
  /** Whether the advisor is eligible to choose another portfolio strategy. */
  isStrategySelectionEligible: Scalars['Boolean']['output'];
  /** Contains all of the portfolio's rebalance feature details. */
  rebalance: Rebalance;
  /**
   * The portfolio strategy's name. For advisor custom portfolios, this is provided
   * by the advisor. For Betterment portfolios, this is the customer-facing
   * portfolio name (e.g. Innovative Technology, Core, Socially Responsible
   * Investing, etc.). For self directed portfolios, 'Flexible Portfolio' or
   * 'Advised 401(k)'
   */
  strategyName: Scalars['String']['output'];
  /**
   * For portfolios with 101 risk levels, this will be a description of the
   * stock/bonds allocation (e.g., '80% stocks, 20% bonds').
   * - For portfolios with fewer than 101 risk levels (aka 'sparse portfolios'),
   * the this will be the risk level name (e.g., Conservative, Moderate,
   * Aggressive). For a flexpo portfolio, this value describes the percentage of
   * stocks/bonds represented by the current target allocation (e.g., '80% stocks, 20% bonds').
   * - For an advised 401k, for a portfolio targeting just one ticker/fund, this
   * value will describe that one ticker/fund (e.g., 'VLXVX | Vanguard Target
   * Retirement 2065 Fund'), or for a portfolio targeting multiple tickers, 'Custom'.
   */
  targetAllocationDescription: Scalars['String']['output'];
};

/** The allocation of a security group within a risk level. */
export type RiskLevelSecurityGroupAllocation = {
  __typename: 'RiskLevelSecurityGroupAllocation';
  /** The security group for this allocation. */
  securityGroup: ModelPortfolioSecurityGroup;
  /** The target weight of this security group in the portfolio, expressed as a percentage. */
  targetWeight: Scalars['Percent']['output'];
};

/** A securities-backed line of credit (SBLOC) loan associated with a legal account. */
export type SblocLoan = {
  __typename: 'SblocLoan';
  /** The unique ID for the SBLOC loan. Currently the legal account ID. */
  id: Scalars['ID']['output'];
};

/** Securities lending enrollment information for a client */
export type SecuritiesLending = {
  __typename: 'SecuritiesLending';
  /**
   * Whether securities lending is currently enabled for this client.
   *             True if status is ENROLLED, false otherwise.
   */
  enabled: Scalars['Boolean']['output'];
  /**
   * The current enrollment status for securities lending.
   *             Matches retail SecuritiesLendingStatus enum
   */
  status: SecuritiesLendingStatus;
};

/** The status of securities lending enrollment for a user */
export enum SecuritiesLendingStatus {
  /** User is currently enrolled in securities lending */
  Enrolled = 'ENROLLED',
  /** User is not eligible for securities lending */
  Ineligible = 'INELIGIBLE',
  /** User needs to complete legal account setup to enroll */
  LegalAccountRequired = 'LEGAL_ACCOUNT_REQUIRED',
  /** User has never enrolled in securities lending */
  NeverEnrolled = 'NEVER_ENROLLED',
  /** User was enrolled but has since unenrolled */
  Unenrolled = 'UNENROLLED',
  /** Status is unknown */
  Unknown = 'UNKNOWN'
}

/** A security (stock, ETF, mutual fund, bond, etc.) that can be held in a portfolio. */
export type Security = {
  /** The unique ID for the security. */
  id: Scalars['ID']['output'];
  /** The name of the security. */
  name: Scalars['String']['output'];
  /** The ticker symbol for the security. */
  symbol: Scalars['String']['output'];
};

/** The 'grandparent groups' on the Fund Menu. */
export type SecurityCategoryGroup = {
  __typename: 'SecurityCategoryGroup';
  /** A value used for client-side caching purposes. */
  id: Scalars['ID']['output'];
  /** The name of the 'grandparent' group. */
  name: Scalars['String']['output'];
  /** The securities in the 'grandparent' group. */
  securities: Array<LegacySecurity>;
};

/**
 * An instance of SecurityInterface for an exchange traded fund (ETF). ETFs are is
 * an investment funds that hold multiple underlying assets and can be bought and
 * sold on an exchange, much like an individual stock.
 */
export type SecurityFund = Security & {
  __typename: 'SecurityFund';
  /**
   * The expense ratio is the total annual fund operating expenses divided by the
   * average dollar value of the fund's assets under management (AUM). Essentially,
   * it is the fund's annual fee, measured as a percent of the investment in the fund.
   */
  expenseRatio: ExpenseRatio;
  /** The unique ID for the security. */
  id: Scalars['ID']['output'];
  /** The name of the fund. */
  name: Scalars['String']['output'];
  /**
   * A prospectus is a written document used in finance to inform the public of the
   * relevant details about an offering of securities, such as stocks, bonds, and
   * mutual funds. The prospectus is part of a company's registration statement,
   * which is filed with the SEC. Betterment does not host the prospectus; this is
   * a link to the fund's prospectus on the fund company's website.
   */
  prospectusUrl: Scalars['URL']['output'];
  /** The ticker symbol for the security. */
  symbol: Scalars['String']['output'];
  /**
   * Tax-loss harvesting helps investors reduce taxes by offsetting the amount they
   * have to claim as capital gains or income. The TLH priority is the order in
   * which Betterment will sell securities to harvest tax losses, in the following
   * order: 1: This is the preferred ticker in its respective security group. If
   * possible, this ticker will be purchased.2: This is the second-priority ticker.
   * If the preferred ticker needs to be sold to harvest tax losses, this ticker
   * will be purchased.null: This ticker is a sell-only substitute. It is holdable
   * but cannot be purchased. It can be sold to harvest tax losses.0: A rogue security.
   */
  tlhPriority: Maybe<Scalars['Int']['output']>;
};

/** A position for a single security group. */
export type SecurityGroupPosition = {
  __typename: 'SecurityGroupPosition';
  /** The amount held by the position in cents. */
  amount: Scalars['Cents']['output'];
  /** The average expense ratio, expressed as a percent, of all of the securities in the position. */
  averageExpenseRatioPercent: Scalars['Percent']['output'];
  /** The stock percent of the position. */
  currentWeight: Scalars['Percent']['output'];
  /** The drift of the position from the defined weight. */
  drift: Scalars['Percent']['output'];
  /** The total fees for all securities in the position in cents. */
  fundFees: Scalars['Cents']['output'];
  /** The unique ID for the given security group. */
  id: Scalars['ID']['output'];
  /** Whether the position contains any rogue securities. */
  isRogueSecurity: Scalars['Boolean']['output'];
  /** The security group of the position. */
  securityGroup: SecurityGroupSummary;
  /** The actual security positions held. */
  securityPositions: Array<SecurityPosition>;
  /** The distinct security positions held across all sub accounts */
  securityPositionsBySecurity: Array<SecurityPositionsBySecurity>;
};

/**
 * A summary of a security group, including its allocation and securities. A
 * security group is defined by a common theme, such as asset class, industry, or
 * issuer. The securities in the group may be held interchangeably (based on their
 * TLH priority) in order to enable tax loss harvesting. A security group also
 * defines a target allocation, which represents the defined total percentage of a
 * portfolio that should be held by the group.
 */
export type SecurityGroupSummary = {
  __typename: 'SecurityGroupSummary';
  /**
   * The description for the security group provides information such as what types
   * securities are defined in the group, who the securities are issued by, what
   * industry exposure is provided, and the purpose of the group in the portfolio.
   */
  description: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the security group. */
  id: Scalars['ID']['output'];
  /**
   * The name of the security group, which indicates the asset class of securities
   * defined in the group (e.g. U.S. Large Cap Stocks).
   */
  name: Scalars['String']['output'];
  /**
   * The securities within this security group.
   * @deprecated does not work for TCP goals
   */
  securities: Array<SecurityFund | SecurityStock>;
  /** Securities that are holdable but cannot be purchased. Can be sold to harvest tax losses. */
  sellOnlySubstituteSecurities: Array<FinancialSecurityFund | FinancialSecurityStock>;
  /**
   * The target weight of the security group in the portfolio definition for the
   * risk level that this security group belongs to. The value is expressed as the
   * percentage of the portfolio that is allocated to this group. For example, a
   * target weight of 0.1 means that 10% of the portfolio is allocated to this
   * security group.
   */
  targetWeight: Scalars['Percent']['output'];
};

/** The held position of a given security in a portfolio. */
export type SecurityPosition = {
  __typename: 'SecurityPosition';
  /** The amount held. */
  amount: Scalars['Cents']['output'];
  /** The expense amount if the position is a fund. */
  expenseAmount: Maybe<Scalars['Cents']['output']>;
  /** The market representation of the security. */
  financialSecurity: FinancialSecurityFund | FinancialSecurityStock;
  /** The representation of the security within the security group. */
  security: SecurityFund | SecurityStock;
  /** The number of shares held. */
  shares: Scalars['Float']['output'];
};

/** The distinct held position of a given security in a portfolio across sub accounts. */
export type SecurityPositionsBySecurity = {
  __typename: 'SecurityPositionsBySecurity';
  /** The amount held by the distinct ticker position in cents. */
  amount: Scalars['Cents']['output'];
  /** The average stock percent of the positions. */
  currentWeight: Scalars['Percent']['output'];
  /** The security name */
  displayName: Scalars['String']['output'];
  /** The expense amount if the position is a fund. */
  expenseAmount: Maybe<Scalars['Cents']['output']>;
  /** The market representation of the security. */
  financialSecurity: FinancialSecurityFund | FinancialSecurityStock;
  /** The unique ID for the given distinct security positions. */
  id: Scalars['ID']['output'];
  /** All orders (buy or sell) for this security position with 'created' or 'requested' status. */
  pendingOrders: Array<FinancialSecurityOrderRequest>;
  /** The sub account positions for the specific security */
  securityPositionsBySubAccount: Array<SecurityPositionsBySubAccount>;
  /** The number of shares held. */
  shares: Scalars['Float']['output'];
  /** The symbol */
  symbol: Scalars['String']['output'];
};

/** The sub account within a specific security. */
export type SecurityPositionsBySubAccount = {
  __typename: 'SecurityPositionsBySubAccount';
  /** The amount held. */
  amount: Scalars['Cents']['output'];
  /** The expense amount if the position is a fund. */
  expenseAmount: Maybe<Scalars['Cents']['output']>;
  /** The unique ID for the given account positions. */
  id: Scalars['ID']['output'];
  /** The actual security positions held. */
  securityPositions: Array<SecurityPosition>;
  /** The number of shares held. */
  shares: Scalars['Float']['output'];
  /** The sub account */
  subAccount: CashAccount | DirectTradingAccount | ManagedSubAccount;
};

/** A stock instance of SecurityInterface. */
export type SecurityStock = Security & {
  __typename: 'SecurityStock';
  /** The unique ID for the security. */
  id: Scalars['ID']['output'];
  /** name of company for security */
  name: Scalars['String']['output'];
  /** The ticker symbol for the security. */
  symbol: Scalars['String']['output'];
};

/**
 * A self-directed portfolio is not modeled using risk levels, but is instead a
 * simple collection of security groups. There are different types of self-directed
 * portfolios: Flexible portfolio: This is Betterment's 'build your own portfolio'
 * feature. It allows users to select their own security groups and assign weights
 * to them. Advised 401(k): This is a self-directed portfolio that is created by an
 * advisor. The advisor selects the available security groups and assigns targets
 * weights to them, but the user can change the weights.
 */
export type SelfDirectedPortfolio = ManagedPortfolio & {
  __typename: 'SelfDirectedPortfolio';
  /** Contains all of the portfolio's drift details. */
  drift: Drift;
  /** The unique ID for the portfolio. */
  id: Scalars['ID']['output'];
  /** Whether the advisor is eligible to choose another portfolio strategy. */
  isStrategySelectionEligible: Scalars['Boolean']['output'];
  /** Contains all of the portfolio's rebalance feature details. */
  rebalance: Rebalance;
  /**
   * The portfolio strategy's name. For advisor custom portfolios, this is provided
   * by the advisor. For Betterment portfolios, this is the customer-facing
   * portfolio name (e.g. Innovative Technology, Core, Socially Responsible
   * Investing, etc.). For self directed portfolios, 'Flexible Portfolio' or
   * 'Advised 401(k)'
   */
  strategyName: Scalars['String']['output'];
  /**
   * For portfolios with 101 risk levels, this will be a description of the
   * stock/bonds allocation (e.g., '80% stocks, 20% bonds').
   * - For portfolios with fewer than 101 risk levels (aka 'sparse portfolios'),
   * the this will be the risk level name (e.g., Conservative, Moderate,
   * Aggressive). For a flexpo portfolio, this value describes the percentage of
   * stocks/bonds represented by the current target allocation (e.g., '80% stocks, 20% bonds').
   * - For an advised 401k, for a portfolio targeting just one ticker/fund, this
   * value will describe that one ticker/fund (e.g., 'VLXVX | Vanguard Target
   * Retirement 2065 Fund'), or for a portfolio targeting multiple tickers, 'Custom'.
   */
  targetAllocationDescription: Scalars['String']['output'];
};

/** Autogenerated input type of SendClientSecuritiesLendingInvitationMutation */
export type SendClientSecuritiesLendingInvitationMutationInput = {
  /** The ID of the user to send the invite email to */
  clientId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendClientSecuritiesLendingInvitationMutation. */
export type SendClientSecuritiesLendingInvitationMutationPayload = {
  __typename: 'SendClientSecuritiesLendingInvitationMutationPayload';
  /** The user-displayable errors produced while attempting to resolve SendClientSecuritiesLendingInvitationMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the SendClientSecuritiesLendingInvitationMutation execution as type EmailDispatch. */
  result: Maybe<EmailDispatch>;
};

/** Platform fee is shared between the advisor and clients */
export type SharedPlatformFeeAllocation = {
  __typename: 'SharedPlatformFeeAllocation';
  /** The fee amount that the client pays, represented in basis points (bps) */
  clientPortion: Scalars['Bps']['output'];
};

/** Defines how the platform fee is allocated between the advisor and the client */
export type SharedPlatformFeeInput = {
  /** The portion of the platform fee paid by the client, in basis points */
  clientPortion: Scalars['Bps']['input'];
};

/** The billing rate for a billing plan represented as fixed, or asset based */
export type SingleBillingRate = BillingRateAssetBased | BillingRateFixed;

/** Input type for tiered billing configurations. */
export type SingleBillingRateInput =
  /** Configuration For Asset Based Tier. */
  { assetBasedConfiguration: BillingRateAssetBasedInput; fixedConfiguration?: never; }
  |  /** Configuration For Fixed Tier. */
  { assetBasedConfiguration?: never; fixedConfiguration: BillingRateFixedInput; };

/** An envelope representing a retirement advisor inviting clients to join a solo 401k plan. */
export type Solo401kClientEnvelope = ClientEnvelopeInterface & {
  __typename: 'Solo401kClientEnvelope';
  /** Collection of clients that belong to a client envelope */
  clients: Array<ClientEnvelopeClient>;
  /** The envelope ID */
  id: Scalars['ID']['output'];
  /** The name of the plan. */
  name: Scalars['String']['output'];
  /** The plan owner (the self-employed individual who owns this solo 401(k)). */
  owner: Maybe<ClientEnvelopeClient>;
  /** When the envelope was published and invitations initially sent to clients */
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  /** The type of plan. Since this represents a solo plan invitation, it will always be 'solo' */
  type: FourOhOneKPlanType;
};

/** The type of Solo 401(K) conversion Contribution */
export enum Solo401kConversionContributionCategory {
  /** Roth Solo 401(k) contributions */
  Roth = 'roth',
  /** Traditional Solo 401(k) contributions */
  Traditional = 'traditional'
}

/** The information related to a Solo 401(K) conversion contribution */
export type Solo401kConversionContributionDetail = {
  __typename: 'Solo401kConversionContributionDetail';
  /** The type of contributions */
  contributionType: Solo401kConversionContributionCategory;
  /** The uuid for identifying the contribution detail object */
  id: Scalars['ID']['output'];
  /** The date of the initial roth contribution, if the contributionType is roth */
  initialRothContributionOn: Maybe<Scalars['Date']['output']>;
  /** The inception-to-date employee contributions */
  itdEmployeeContributions: Maybe<Scalars['Cents']['output']>;
  /** The inception-to-date employer contributions */
  itdEmployerContributions: Maybe<Scalars['Cents']['output']>;
  /** The total amount from past rollovers */
  itdRolloverAmount: Maybe<Scalars['Cents']['output']>;
  /** The year-to-date employee contributions */
  ytdEmployeeContributions: Maybe<Scalars['Cents']['output']>;
  /** The year-to-date employer contributions */
  ytdEmployerContributions: Maybe<Scalars['Cents']['output']>;
};

/** The type of Solo 401(K) conversion Contribution */
export enum Solo401kConversionFundsCategory {
  /** Roth Solo 401(k) contributions */
  Roth = 'ROTH',
  /** Traditional Solo 401(k) contributions */
  Traditional = 'TRADITIONAL',
  /** A mix of Traditional and Roth Solo 401(k) funds */
  TraditionalAndRoth = 'TRADITIONAL_AND_ROTH'
}

/** Configuration for a Solo 401(k) conversion intent */
export type Solo401kConversionIntent = {
  __typename: 'Solo401kConversionIntent';
  /** The name of the employer listed on the conversion intent's plan */
  employerName: Scalars['String']['output'];
  /** The unique Identifier for the given intent */
  id: Scalars['ID']['output'];
  /** Whether the Solo 401(k) plan definition includes a spouse */
  includesSpouse: Scalars['Boolean']['output'];
  /** The type of funds included in the overall plan; both spouse and owner inclusions are considered */
  overallFundTypeInclusion: Maybe<Solo401kConversionFundsCategory>;
  /** The type of funds included in the plan owner's 401(k) plan */
  ownerFundTypeInclusion: Maybe<Solo401kConversionFundsCategory>;
  /** The advised client that owns the Solo 401(k) plan */
  planOwner: Client;
  /** The details of the plan owner's contributions */
  planOwnerContributions: Array<Solo401kConversionContributionDetail>;
  /** The advised client that is the Solo 401(k) plan's spouse */
  planSpouse: Maybe<Client>;
  /** The details of the plan owner's spouse's contributions */
  planSpouseContributions: Array<Solo401kConversionContributionDetail>;
  /** The type of funds included in the plan spouse's 401(k) plan */
  spouseFundTypeInclusion: Maybe<Solo401kConversionFundsCategory>;
  /** The intent's status */
  status: Solo401kConversionIntentStatus;
};

/** The status of the Solo 401(k) conversion intent */
export enum Solo401kConversionIntentStatus {
  /** Approved by the plan owner */
  Approved = 'APPROVED',
  /** Not yet published, editable by the advisor */
  Draft = 'DRAFT',
  /** Visible and ready for the plan owner to approve */
  Published = 'PUBLISHED'
}

/** A draft Solo 401(k) plan within a client envelope. */
export type Solo401kPlan = {
  __typename: 'Solo401kPlan';
  /** The ID of the draft solo 401(k) plan. */
  id: Scalars['ID']['output'];
  /** The name of the solo 401(k) plan. */
  planName: Maybe<Scalars['String']['output']>;
  /** The custom QDIA fund lineup CSV content, if set. */
  qdiaFundLineup: Maybe<Scalars['String']['output']>;
};

/** Represents the validated business information for a Solo 401(k) plan */
export type Solo401kPlanBusinessInfo = {
  /** The validated address line 1 */
  addressLine1: Scalars['String']['input'];
  /** The validated address line 2 */
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  /** The validated phone number */
  phoneNumber: Scalars['String']['input'];
};

/** The Participant in a solo 401(k) plan. */
export type SoloFourOhOneKParticipant = {
  __typename: 'SoloFourOhOneKParticipant';
  /** The full name of the participant. */
  fullName: Scalars['String']['output'];
  /** A unique identifier for a solo 401(k) plan participant. */
  id: Scalars['ID']['output'];
};

/**
 * A solo 401(k) plan for self-employed individuals. Managed by a single plan
 * owner, optionally with a spouse as co-participant.
 */
export type SoloFourOhOneKPlan = FourOhOneKPlan & {
  __typename: 'SoloFourOhOneKPlan';
  /** Documents for this Solo 401(k) plan */
  documents: Array<FourOhOneKDocument>;
  /** The unique identifier for the 401(k) plan (B4b::Api::Data::Plan#id) */
  id: Scalars['ID']['output'];
  /** The investment options for 401(k) plans when Betterment is the 3(38). */
  investmentOptions: Maybe<Array<BettermentModelPortfolio>>;
  /** A set of messages for the 401(k) plan. */
  messages: Array<Message>;
  /** The model portfolio for 401(k) plans that have 'Fund Menus' */
  modelPortfolio: Maybe<ExternallyAdvisedPlanPortfolio>;
  /** The name entity that owns the plan. */
  name: Scalars['String']['output'];
  /** Information about the 401(k) onboarding. */
  onboarding: FourOhOneKPlanOnboarding;
  /** The plan owner (the self-employed individual who owns this solo 401(k)). */
  owner: Maybe<SoloFourOhOneKParticipant>;
  /** The participants in this solo 401(k) plan. */
  participants: Array<SoloFourOhOneKParticipant>;
  /** Performance indicators for the 401(k) plan. */
  performanceIndicators: FourOhOneKPlanPerformanceIndicators;
  /** The consent status of the plan for sending data in outbound integration feeds */
  planFeedConsent: Scalars['Boolean']['output'];
  /** The plan fiduciary */
  planFiduciary: FourOhOneKPlanFiduciary;
  /** The name of the default portfolio for 401(k) plans that are managed by Betterment */
  qdiaFundName: Maybe<Scalars['String']['output']>;
  /** Options for creating reports for this 401(k) plan. */
  reportCreationOptions: Array<FourOhOneKReportCreationOption>;
  /** Advisor reports associated with this 401(k) plan. */
  reports: Maybe<Array<FourOhOneKReport>>;
  /** The status of the 401(k) plan, either onboarding or active. */
  status: FourOhOneKPlanStatusType;
  /** The type of the plan (solo or standard). */
  type: FourOhOneKPlanType;
};


/**
 * A solo 401(k) plan for self-employed individuals. Managed by a single plan
 * owner, optionally with a spouse as co-participant.
 */
export type SoloFourOhOneKPlanMessagesArgs = {
  location: MessageLocation;
};

/** A standard employer-sponsored 401(k) plan with one or more plan managers. */
export type StandardFourOhOneKPlan = FourOhOneKPlan & {
  __typename: 'StandardFourOhOneKPlan';
  /** The unique identifier for the 401(k) plan (B4b::Api::Data::Plan#id) */
  id: Scalars['ID']['output'];
  /** The investment options for 401(k) plans when Betterment is the 3(38). */
  investmentOptions: Maybe<Array<BettermentModelPortfolio>>;
  /** A set of messages for the 401(k) plan. */
  messages: Array<Message>;
  /** The model portfolio for 401(k) plans that have 'Fund Menus' */
  modelPortfolio: Maybe<ExternallyAdvisedPlanPortfolio>;
  /** The name entity that owns the plan. */
  name: Scalars['String']['output'];
  /** Information about the 401(k) onboarding. */
  onboarding: FourOhOneKPlanOnboarding;
  /** Performance indicators for the 401(k) plan. */
  performanceIndicators: FourOhOneKPlanPerformanceIndicators;
  /** The consent status of the plan for sending data in outbound integration feeds */
  planFeedConsent: Scalars['Boolean']['output'];
  /** The plan fiduciary */
  planFiduciary: FourOhOneKPlanFiduciary;
  /** The plan managers associated with this 401(k) plan. */
  planManagers: Array<FourOhOneKPlanManager>;
  /** The name of the default portfolio for 401(k) plans that are managed by Betterment */
  qdiaFundName: Maybe<Scalars['String']['output']>;
  /** Options for creating reports for this 401(k) plan. */
  reportCreationOptions: Array<FourOhOneKReportCreationOption>;
  /** Advisor reports associated with this 401(k) plan. */
  reports: Maybe<Array<FourOhOneKReport>>;
  /** The status of the 401(k) plan, either onboarding or active. */
  status: FourOhOneKPlanStatusType;
  /** The type of the plan (solo or standard). */
  type: FourOhOneKPlanType;
};


/** A standard employer-sponsored 401(k) plan with one or more plan managers. */
export type StandardFourOhOneKPlanMessagesArgs = {
  location: MessageLocation;
};

/** Represents a pending strategy change request action. */
export type StrategyChangePendingAction = PendingAction & PortfolioChangePendingAction & {
  __typename: 'StrategyChangePendingAction';
  /** The timestamp when the strategy change request was initiated. */
  createdAt: Scalars['DateTime']['output'];
  /** The future portfolio that will be applied to the account once this change completes. */
  futurePortfolio: FuturePortfolio;
  /** The unique identifier for this pending action. */
  id: Scalars['ID']['output'];
};

/** An annual gains allowance with associated identifying information and year-to-date usage */
export type Summary = {
  __typename: 'Summary';
  /** The gain allowance of the group */
  annualGainsAllowance: Maybe<Scalars['Cents']['output']>;
  /**
   * This is a db ID of the lowest taxpayer id in the group to make it
   * deterministic. It doesn't matter which taxpayer's ID is used as the url to
   * edit the gains allowance grabs it from the taxpayer. Since all taxpayers in
   * the group share the same gains allowance, any taxpayer's ID will work.
   */
  identifyingTaxpayerId: Scalars['ID']['output'];
  /** The year-to-date long term gains and losses. */
  longTerm: Gains;
  /** The name of the gains allowance group */
  name: Scalars['String']['output'];
  /** The year-to-date short term gains and losses. */
  shortTerm: Gains;
  /** The year-to-date gains amount in cents. This is the net realized gains for all taxpayers associated. */
  yearToDateNetRealizedGains: Scalars['Cents']['output'];
};

/** Contact information for a support channel */
export type SupportContact = {
  __typename: 'SupportContact';
  /** The email address */
  email: Scalars['String']['output'];
  /** The phone number */
  phone: Scalars['String']['output'];
  /** The weekday business hours */
  weekdayHours: Scalars['String']['output'];
};

/** Support resources and contact information */
export type SupportResources = {
  __typename: 'SupportResources';
  /** Contact information for advisor support */
  advisor: SupportContact;
  /** Contact information for client support */
  client: SupportContact;
  /** Support resources for 401(k) plans. Null when the advisor has no 401(k) plans. */
  fourOhOneKPlan: Maybe<FourOhOneKPlanSupportResource>;
};

/** Estimated tax impact for a trade */
export type TaxImpact = {
  __typename: 'TaxImpact';
  /** Resulting long-term gain for the scenario */
  longTermGain: Scalars['Cents']['output'];
  /** Resulting long-term loss for the scenario */
  longTermLoss: Scalars['Cents']['output'];
  /** Resulting long-term permanently washed for the scenario */
  longTermPermanentlyWashed: Scalars['Cents']['output'];
  /** Resulting long-term washed for the scenario */
  longTermWashed: Scalars['Cents']['output'];
  /** Resulting net estimated taxes for the scenario */
  netEstimatedTaxes: Scalars['Cents']['output'];
  /** The total expected gain/loss of the trades */
  netGain: Scalars['Cents']['output'];
  /** Resulting net long-term for the scenario */
  netLongTerm: Scalars['Cents']['output'];
  /** Resulting net short-term for the scenario */
  netShortTerm: Scalars['Cents']['output'];
  /** Resulting short-term gain for the scenario */
  shortTermGain: Scalars['Cents']['output'];
  /** Resulting short-term loss for the scenario */
  shortTermLoss: Scalars['Cents']['output'];
  /** Resulting short-term permanently washed for the scenario */
  shortTermPermanentlyWashed: Scalars['Cents']['output'];
  /** Resulting short-term washed for the scenario */
  shortTermWashed: Scalars['Cents']['output'];
  /** Indicates if the scenario is affected by pending transactions on the account */
  transactionPending: Scalars['Boolean']['output'];
};

/** A tax year. */
export type TaxYear = {
  __typename: 'TaxYear';
  /** 401(k) contribution limit for the tax year. */
  fourOhOneKContributionLimit: Scalars['Cents']['output'];
  /** A unique identifier for the tax year. */
  id: Scalars['ID']['output'];
  /** IRA contribution limit for the tax year. */
  iraContributionLimit: Scalars['Cents']['output'];
  /** 401(k) contribution catch up eligbility for the tax year. */
  isEligibleForFourOhOneKContributionCatchUp: Scalars['Boolean']['output'];
  /** IRA contribution catch up eligbility for the tax year. */
  isEligibleForIraContributionCatchUp: Scalars['Boolean']['output'];
  /** Indicate if IRA contributions can be made for the tax year. */
  isEligibleForIraContributions: Scalars['Boolean']['output'];
  /** The tax year. */
  year: Scalars['Int']['output'];
};

/** A set of assets for each supported theme. */
export type ThemedAsset = {
  __typename: 'ThemedAsset';
  /** A url for an asset to be displayed in dark mode. */
  dark: Scalars['URL']['output'];
  /** An id used to identify the asset. */
  id: Scalars['ID']['output'];
  /** A url for an asset to be displayed in light mode. */
  light: Scalars['URL']['output'];
};

/** The method for applying tiered rates */
export enum TieredFeeCalculationMethod {
  /** Tiered billing plan rates will be applied at the current applicable tier, without regard to lower tiers */
  Cliff = 'CLIFF',
  /** Tiered billing plan rates will be applied progressively across tiers */
  Progressive = 'PROGRESSIVE'
}

/** Date Range Options for Total Earned */
export enum TotalEarnedDateRange {
  /** All time */
  AllTime = 'ALL_TIME',
  /** Past month */
  PastMonth = 'PAST_MONTH',
  /** Past three months */
  PastThreeMonths = 'PAST_THREE_MONTHS',
  /** Past two years */
  PastTwoYears = 'PAST_TWO_YEARS',
  /** Past year */
  PastYear = 'PAST_YEAR',
  /** Year to date */
  YearToDate = 'YEAR_TO_DATE'
}

/** Result of a trading preview */
export type TradePreview = {
  __typename: 'TradePreview';
  /** The trades performed during the trading scenario */
  expectedTrades: Array<TradePreviewExpectedTrade>;
  /** Gains details for the owner of the account */
  gainsDetails: Maybe<GainsDetails>;
  /** The unique Identifier for the given preview */
  id: Scalars['ID']['output'];
  /** Resulting long-term gain for the scenario */
  longTermGain: Scalars['Cents']['output'];
  /** Resulting long-term loss for the scenario */
  longTermLoss: Scalars['Cents']['output'];
  /** Resulting long-term permanently washed for the scenario */
  longTermPermanentlyWashed: Scalars['Cents']['output'];
  /** Resulting long-term washed for the scenario */
  longTermWashed: Scalars['Cents']['output'];
  /** Resulting net estimated taxes for the scenario */
  netEstimatedTaxes: Scalars['Cents']['output'];
  /** The total expected gain/loss of the trades */
  netGain: Scalars['Cents']['output'];
  /** Resulting net long-term for the scenario */
  netLongTerm: Scalars['Cents']['output'];
  /** Resulting net short-term for the scenario */
  netShortTerm: Scalars['Cents']['output'];
  /** Indicates the amount of drift after the scenario is run */
  postTradeDrift: Scalars['Percent']['output'];
  /** Indicates the amount of drift before the scenario is run */
  preTradeDrift: Scalars['Percent']['output'];
  /** The drift threshold for rebalancing used for the simulation */
  rebalanceDriftThreshold: Scalars['Percent']['output'];
  /** The estimated client's remaining gain allowance after this trading action */
  remainingGainsAllowance: Maybe<Scalars['Cents']['output']>;
  /** Resulting short-term gain for the scenario */
  shortTermGain: Scalars['Cents']['output'];
  /** Resulting short-term loss for the scenario */
  shortTermLoss: Scalars['Cents']['output'];
  /** Resulting short-term permanently washed for the scenario */
  shortTermPermanentlyWashed: Scalars['Cents']['output'];
  /** Resulting short-term washed for the scenario */
  shortTermWashed: Scalars['Cents']['output'];
  /** The trading instruction used for the preview */
  tradingInstruction: TradePreviewTradingInstruction;
  /** Indicates if the scenario is affected by pending transactions on the account */
  transactionPending: Scalars['Boolean']['output'];
};

/** The type of trading action you want a preview for */
export enum TradePreviewAction {
  /** A rebalance using the existing account holdings and target risk level */
  EditRebalanceSettings = 'EDIT_REBALANCE_SETTINGS',
  /** An unconstrained rebalance using the existing account holdings and target risk level */
  RebalanceNow = 'REBALANCE_NOW'
}

/** Simulated trade of a security group in a trading preview */
export type TradePreviewExpectedSecurityGroupTrade = {
  __typename: 'TradePreviewExpectedSecurityGroupTrade';
  /** buy or sell */
  action: TradePreviewExpectedTradeAction;
  /** notional value of the security group after the trade */
  afterTradeValue: Scalars['Cents']['output'];
  /** weight of the security group in the portfolio after the trade */
  afterTradeWeight: Scalars['Percent']['output'];
  /** notional value of the security group before the trade */
  beforeTradeValue: Scalars['Cents']['output'];
  /** weight of the security group in the portfolio before the trade */
  beforeTradeWeight: Scalars['Percent']['output'];
  /** the security group description */
  description: Scalars['String']['output'];
  /** The individual trades performed on the securities in the group */
  expectedSecurityTrades: Array<TradePreviewExpectedSecurityTrade>;
  /** unique Identifier for the trade */
  id: Scalars['ID']['output'];
  /** the security group name */
  name: Scalars['String']['output'];
  /** The target weight of the security group in the portfolio */
  targetWeight: Scalars['Percent']['output'];
  /** notional value of the trade */
  tradeValue: Scalars['Cents']['output'];
};

/** Simulated trade of an individual security in a trading preview */
export type TradePreviewExpectedSecurityTrade = {
  __typename: 'TradePreviewExpectedSecurityTrade';
  /** buy or sell */
  action: TradePreviewExpectedTradeAction;
  /** notional value of the asset after the trade */
  afterTradeValue: Scalars['Cents']['output'];
  /** weight of the asset in the portfolio after the trade */
  afterTradeWeight: Scalars['Percent']['output'];
  /** notional value of the asset before the trade */
  beforeTradeValue: Scalars['Cents']['output'];
  /** weight of the asset in the portfolio before the trade */
  beforeTradeWeight: Scalars['Percent']['output'];
  /** longer visible name of the traded asset, e.g: Fidelity High Income */
  displayName: Scalars['String']['output'];
  /** unique Identifier for the trade */
  id: Scalars['ID']['output'];
  /** ticker symbol for the trade */
  tickerSymbol: Scalars['String']['output'];
  /** notional value of the trade */
  tradeValue: Scalars['Cents']['output'];
};

/** Simulated trade of a trading preview */
export type TradePreviewExpectedTrade = TradePreviewExpectedSecurityGroupTrade | TradePreviewExpectedSecurityTrade;

/** The type of trade action performed */
export enum TradePreviewExpectedTradeAction {
  /** A purchase */
  Buy = 'BUY',
  /** A sale */
  Sell = 'SELL'
}

/** Trading instruction for the preview */
export enum TradePreviewTradingInstruction {
  /** Avoid short term capital gains, respect gains allowance, do not respect drift threshold */
  NoStcg = 'NO_STCG',
  /** Avoid short term capital gains, respect gains allowance, respect drift threshold */
  SetTargetAndRebalance = 'SET_TARGET_AND_REBALANCE',
  /** No tax or gains allowance constraints */
  Unconstrained = 'UNCONSTRAINED'
}

/** A trust */
export type Trust = AccountHolder & {
  __typename: 'Trust';
  /** The id of the trust */
  id: Scalars['ID']['output'];
  /**
   * The individual grantor of the trust, applicable for 'grantor trusts' that use
   * the grantor's SSN as their tax identification number
   */
  individualGrantor: Maybe<Client>;
  /**
   * The display name of the trust. For grantor trusts, this is the grantor's full
   * name; otherwise, it's the trust's nickname or legal name
   */
  name: Scalars['String']['output'];
};

/** Autogenerated input type of UnenrollClientFromSecuritiesLendingMutation */
export type UnenrollClientFromSecuritiesLendingMutationInput = {
  /** The ID of the client to unenroll from securities lending. */
  clientId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnenrollClientFromSecuritiesLendingMutation. */
export type UnenrollClientFromSecuritiesLendingMutationPayload = {
  __typename: 'UnenrollClientFromSecuritiesLendingMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UnenrollClientFromSecuritiesLendingMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UnenrollClientFromSecuritiesLendingMutation execution as type UserPortfolioControls. */
  result: Maybe<UserPortfolioControls>;
};

/** Autogenerated input type of UpdateBillingPlanPaymentTypesMutation */
export type UpdateBillingPlanPaymentTypesMutationInput = {
  /** The array of billing plans and their new payment types */
  billingPlanPaymentTypes: Array<BillingPlanPaymentTypeInput>;
};

/** Autogenerated return type of UpdateBillingPlanPaymentTypesMutation. */
export type UpdateBillingPlanPaymentTypesMutationPayload = {
  __typename: 'UpdateBillingPlanPaymentTypesMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateBillingPlanPaymentTypesMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateBillingPlanPaymentTypesMutation execution as type Firm. */
  result: Maybe<Firm>;
};

/** Autogenerated input type of UpdateClientEnvelopeBankAccountsMutation */
export type UpdateClientEnvelopeBankAccountsMutationInput = {
  /** The funding bank accounts to upsert for the client envelope. */
  clientEnvelopeBankAccounts: Array<ClientEnvelopeBankAccountInput>;
  /** The id of the client envelope to update. */
  clientEnvelopeId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateClientEnvelopeBankAccountsMutation. */
export type UpdateClientEnvelopeBankAccountsMutationPayload = {
  __typename: 'UpdateClientEnvelopeBankAccountsMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateClientEnvelopeBankAccountsMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateClientEnvelopeBankAccountsMutation execution as type ClientEnvelope. */
  result: Maybe<ClientEnvelope>;
};

/** Autogenerated input type of UpdateClientEnvelopeBeneficiariesMutation */
export type UpdateClientEnvelopeBeneficiariesMutationInput = {
  /** The legal_account_type of the client envelope accounts to update. */
  clientEnvelopeAccountType: LegalAccountType;
  /** The new primary beneficiaries for the potential account */
  clientEnvelopeBeneficiaries: Array<ClientAccountBeneficiaryInput>;
  /** The id of the client to update. */
  clientEnvelopeClientId: Scalars['ID']['input'];
  /** The id of the client envelope to update. */
  clientEnvelopeId: Scalars['ID']['input'];
  /** The new contingent beneficiaries for the potential account */
  contingentClientEnvelopeBeneficiaries?: InputMaybe<Array<ClientAccountBeneficiaryInput>>;
};

/** Autogenerated return type of UpdateClientEnvelopeBeneficiariesMutation. */
export type UpdateClientEnvelopeBeneficiariesMutationPayload = {
  __typename: 'UpdateClientEnvelopeBeneficiariesMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateClientEnvelopeBeneficiariesMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateClientEnvelopeBeneficiariesMutation execution as type ClientEnvelope. */
  result: Maybe<ClientEnvelope>;
};

/** Autogenerated input type of UpdateDefaultBillingPlanMutation */
export type UpdateDefaultBillingPlanMutationInput = {
  /** The id of the billing plan that is being set as a firm's default */
  billingPlanId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateDefaultBillingPlanMutation. */
export type UpdateDefaultBillingPlanMutationPayload = {
  __typename: 'UpdateDefaultBillingPlanMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateDefaultBillingPlanMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateDefaultBillingPlanMutation execution as type Firm. */
  result: Maybe<Firm>;
};

/** Autogenerated input type of UpdateHouseholdBillingPlanMutation */
export type UpdateHouseholdBillingPlanMutationInput = {
  /** Target billing plan ID for the update */
  billingPlanId: Scalars['ID']['input'];
  /** ID of the household to update */
  householdId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateHouseholdBillingPlanMutation. */
export type UpdateHouseholdBillingPlanMutationPayload = {
  __typename: 'UpdateHouseholdBillingPlanMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateHouseholdBillingPlanMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateHouseholdBillingPlanMutation execution as type Household. */
  result: Maybe<Household>;
};

/** Autogenerated input type of UpdateManagedPortfolioRebalancingMutation */
export type UpdateManagedPortfolioRebalancingMutationInput = {
  /** The drift threshold percentage for the portfolio. This is optional when enabling rebalancing. */
  driftThreshold?: InputMaybe<Scalars['Percent']['input']>;
  /** The ID of the ManagedAccount. */
  managedAccountId: Scalars['ID']['input'];
  /** Whether rebalancing is enabled or disabled. */
  rebalanceEnabled: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateManagedPortfolioRebalancingMutation. */
export type UpdateManagedPortfolioRebalancingMutationPayload = {
  __typename: 'UpdateManagedPortfolioRebalancingMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateManagedPortfolioRebalancingMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateManagedPortfolioRebalancingMutation execution as type ManagedPortfolio. */
  result: Maybe<RiskLevelBasedPortfolio | SelfDirectedPortfolio>;
};

/** Autogenerated input type of UpdateOutboundIntegrationSubscriptionMutation */
export type UpdateOutboundIntegrationSubscriptionMutationInput = {
  /** The id of the outbound integration to subscribe or unsubscribe the firm to */
  id: Scalars['ID']['input'];
  /** Whether the firm should be subscribed to the feed */
  isSubscribed: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateOutboundIntegrationSubscriptionMutation. */
export type UpdateOutboundIntegrationSubscriptionMutationPayload = {
  __typename: 'UpdateOutboundIntegrationSubscriptionMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateOutboundIntegrationSubscriptionMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateOutboundIntegrationSubscriptionMutation execution as type OutboundIntegration. */
  result: Maybe<OutboundIntegration>;
};

/** Autogenerated input type of UpdatePlanFeedConsentMutation */
export type UpdatePlanFeedConsentMutationInput = {
  /** Whether consent has been given for the plan's info to be included in outbound feeds */
  planFeedConsent: Scalars['Boolean']['input'];
  /** The id of the plan that consent is being recorded for */
  planId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePlanFeedConsentMutation. */
export type UpdatePlanFeedConsentMutationPayload = {
  __typename: 'UpdatePlanFeedConsentMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdatePlanFeedConsentMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdatePlanFeedConsentMutation execution as type FourOhOneKPlan. */
  result: Maybe<SoloFourOhOneKPlan | StandardFourOhOneKPlan>;
};

/** Autogenerated input type of UpdateQdiaFundLineupMutation */
export type UpdateQdiaFundLineupMutationInput = {
  /** The CSV content representing the QDIA fund lineup, with headers: ticker, qdia_designation. */
  csvContent: Scalars['String']['input'];
  /** The id of the solo 401(k) plan whose QDIA fund lineup will be updated. */
  solo401kPlanId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateQdiaFundLineupMutation. */
export type UpdateQdiaFundLineupMutationPayload = {
  __typename: 'UpdateQdiaFundLineupMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateQdiaFundLineupMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateQdiaFundLineupMutation execution as type Solo401kPlan. */
  result: Maybe<Solo401kPlan>;
};

/** Autogenerated input type of UpdateSolo401kConversionIntentContributionsMutation */
export type UpdateSolo401kConversionIntentContributionsMutationInput = {
  /** The contribution details associated with this plan member */
  contributionDetails: Array<ContributionDetailInput>;
  /** The ID of the plan member, likely the plan owner or the spouse of the plan owner */
  memberId: Scalars['ID']['input'];
  /** The ID for identifying the intent record */
  solo401kConversionIntentId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSolo401kConversionIntentContributionsMutation. */
export type UpdateSolo401kConversionIntentContributionsMutationPayload = {
  __typename: 'UpdateSolo401kConversionIntentContributionsMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateSolo401kConversionIntentContributionsMutation. */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the
   * UpdateSolo401kConversionIntentContributionsMutation execution as type
   * Solo401kConversionIntent.
   */
  result: Maybe<Solo401kConversionIntent>;
};

/** Autogenerated input type of UpdateSolo401kConversionIntentFundsTypeMutation */
export type UpdateSolo401kConversionIntentFundsTypeMutationInput = {
  /** The type of funds included in the 401(k) plan */
  fundsType: Solo401kConversionFundsCategory;
  /** The ID of the plan member, likely the plan owner or the spouse of the plan owner */
  memberId: Scalars['ID']['input'];
  /** The ID for identifying the intent record */
  solo401kConversionIntentId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSolo401kConversionIntentFundsTypeMutation. */
export type UpdateSolo401kConversionIntentFundsTypeMutationPayload = {
  __typename: 'UpdateSolo401kConversionIntentFundsTypeMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpdateSolo401kConversionIntentFundsTypeMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpdateSolo401kConversionIntentFundsTypeMutation execution as type Solo401kConversionIntent. */
  result: Maybe<Solo401kConversionIntent>;
};

/** Input type for upserting a billing plan. */
export type UpsertBillingPlanInput = {
  /** The billing rate for the billing plan. */
  billingRate: BillingRateInput;
  /** ID of the billing plan to edit. Leave empty to create a new billing plan. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Name of the billing plan */
  name: Scalars['String']['input'];
  /** Where the billing plan pays from */
  paymentType: PaymentType;
  /** The share of platform fee between advisor and client */
  platformFeeAllocation: PlatformFeeAllocationInput;
};

/** Autogenerated input type of UpsertBillingPlanMutation */
export type UpsertBillingPlanMutationInput = {
  /** Input to create or edit a billing plan. */
  billingPlan: UpsertBillingPlanInput;
};

/** Autogenerated return type of UpsertBillingPlanMutation. */
export type UpsertBillingPlanMutationPayload = {
  __typename: 'UpsertBillingPlanMutationPayload';
  /** The user-displayable errors produced while attempting to resolve UpsertBillingPlanMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the UpsertBillingPlanMutation execution as type Firm. */
  result: Maybe<Firm>;
};

/** Portfolio control settings for a client */
export type UserPortfolioControls = {
  __typename: 'UserPortfolioControls';
  /** Securities lending enrollment information for this client */
  securitiesLending: SecuritiesLending;
  /** Whether tax loss harvesting is enabled for this client. */
  taxLossHarvestingEnabled: Scalars['Boolean']['output'];
};

/** A valid amount in cents */
export type ValidCents = {
  __typename: 'ValidCents';
  /** The amount in cents */
  value: Scalars['Cents']['output'];
};

/** Autogenerated input type of ValidateClientEnvelopeBeneficiaryMutation */
export type ValidateClientEnvelopeBeneficiaryMutationInput = {
  /** The client envelope beneficiary to validate. */
  beneficiary: ClientAccountBeneficiaryInput;
  /** The id of the containing client envelope */
  clientEnvelopeId: Scalars['ID']['input'];
  /** The account type of the client envelope goal to validate its beneficiary. */
  legalAccountType: LegalAccountType;
  /** The primary owner of the beneficiary */
  primaryUserKey: Scalars['String']['input'];
  /** The secondary owner of the beneficiary */
  secondaryUserKey?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ValidateClientEnvelopeBeneficiaryMutation. */
export type ValidateClientEnvelopeBeneficiaryMutationPayload = {
  __typename: 'ValidateClientEnvelopeBeneficiaryMutationPayload';
  /** The user-displayable errors produced while attempting to resolve ValidateClientEnvelopeBeneficiaryMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the ValidateClientEnvelopeBeneficiaryMutation execution as type Boolean. */
  result: Maybe<Scalars['Boolean']['output']>;
};

/** The result of validating a custody single security order request */
export type ValidateFinancialSecurityOrderRequest = {
  __typename: 'ValidateFinancialSecurityOrderRequest';
  /** Whether the order is a sale over the sell-all threshold percent of the position in the account */
  aboveSellAllThreshold: Scalars['Boolean']['output'];
  /** The threshold percent above which a sell order should be converted to a sell-all order */
  sellAllThreshold: Scalars['Percent']['output'];
};

/** Autogenerated input type of ValidateFinancialSecurityOrderRequestMutation */
export type ValidateFinancialSecurityOrderRequestMutationInput = {
  /** Determines if the order request is to buy or sell the security */
  direction: FinancialSecurityOrderRequestDirection;
  /** Custody's security ID for the security to order */
  financialSecurityId: Scalars['ID']['input'];
  /** Sell the entire position, only valid for sales */
  sellAll?: InputMaybe<Scalars['Boolean']['input']>;
  /** The price per share in cents at the time of the order request */
  sharePriceCents?: InputMaybe<Scalars['Int']['input']>;
  /** The account within which to perform the trade */
  subAccountId: Scalars['ID']['input'];
  /** Dollar amount or number of shares requested for the order */
  value: FinancialSecurityOrderRequestValueInput;
};

/** Autogenerated return type of ValidateFinancialSecurityOrderRequestMutation. */
export type ValidateFinancialSecurityOrderRequestMutationPayload = {
  __typename: 'ValidateFinancialSecurityOrderRequestMutationPayload';
  /** The user-displayable errors produced while attempting to resolve ValidateFinancialSecurityOrderRequestMutation. */
  displayableErrors: Array<DisplayableError>;
  /**
   * The successful result from the ValidateFinancialSecurityOrderRequestMutation
   * execution as type ValidateFinancialSecurityOrderRequest.
   */
  result: Maybe<ValidateFinancialSecurityOrderRequest>;
};

/** Autogenerated input type of ValidateSolo401kConversionIntentMutation */
export type ValidateSolo401kConversionIntentMutationInput = {
  /** The ID for identifying the intent record */
  solo401kConversionIntentId: Scalars['ID']['input'];
};

/** Autogenerated return type of ValidateSolo401kConversionIntentMutation. */
export type ValidateSolo401kConversionIntentMutationPayload = {
  __typename: 'ValidateSolo401kConversionIntentMutationPayload';
  /** The user-displayable errors produced while attempting to resolve ValidateSolo401kConversionIntentMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the ValidateSolo401kConversionIntentMutation execution as type Solo401kConversionIntent. */
  result: Maybe<Solo401kConversionIntent>;
};

/** Autogenerated input type of ValidateSolo401kPlanFormMutation */
export type ValidateSolo401kPlanFormMutationInput = {
  /** The business information of the plan owner */
  business: Solo401kPlanBusinessInfo;
};

/** Autogenerated return type of ValidateSolo401kPlanFormMutation. */
export type ValidateSolo401kPlanFormMutationPayload = {
  __typename: 'ValidateSolo401kPlanFormMutationPayload';
  /** The user-displayable errors produced while attempting to resolve ValidateSolo401kPlanFormMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the ValidateSolo401kPlanFormMutation execution as type ValidatedSolo401kPlanForm. */
  result: Maybe<ValidatedSolo401kPlanForm>;
};

/** A solo 401k plan validation result */
export type ValidatedSolo401kPlanForm = {
  __typename: 'ValidatedSolo401kPlanForm';
  /** Indicates whether the solo 401k plan form is valid */
  isValid: Scalars['Boolean']['output'];
};

/** Vesting information about the user's employer's 401k contributions */
export type Vested = {
  __typename: 'Vested';
  /** The vested amount of employer 401(k) contributions. */
  amount: Scalars['Cents']['output'];
  /** The vested percent of employer 401(k) contributions. */
  percent: Scalars['Percent']['output'];
};

/** YTD return data */
export type YtdReturn = {
  __typename: 'YtdReturn';
  /** The YTD return dollar amount earned (null if no returns available) */
  amount: Maybe<Scalars['Cents']['output']>;
  /** The YTD money-weighted return percentage (cumulative, not annualized) */
  moneyWeighted: Maybe<Scalars['Percent']['output']>;
  /** The YTD time-weighted return percentage (cumulative, not annualized) */
  timeWeighted: Maybe<Scalars['Percent']['output']>;
};


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AccountHolder": [
      "Client",
      "Trust"
    ],
    "ActivityItem": [
      "ActivityItemAllocationChange",
      "ActivityItemDeposit",
      "ActivityItemFee",
      "ActivityItemOrder",
      "ActivityItemOther",
      "ActivityItemTradeGroup",
      "ActivityItemTransferGroup",
      "ActivityItemWithdrawal"
    ],
    "AdvisedPlan": [
      "Solo401kClientEnvelope",
      "SoloFourOhOneKPlan",
      "StandardFourOhOneKPlan"
    ],
    "AgreementDocument": [
      "ExecutedAgreement"
    ],
    "BillingRate": [
      "BillingRateAssetBased",
      "BillingRateFixed",
      "BillingRateTiered"
    ],
    "ClientEnvelopeInterface": [
      "ClientEnvelope",
      "Solo401kClientEnvelope"
    ],
    "EnvelopeAccount": [
      "CashAccount",
      "DirectTradingAccount",
      "ManagedAccount"
    ],
    "EstimatedTradeTiming": [
      "EstimatedTradeDate",
      "EstimatedTradeTimeRange"
    ],
    "FeeAttemptInputAccount": [
      "CashAccount",
      "InvalidAccountString",
      "ManagedSubAccount"
    ],
    "FeeAttemptInputAmount": [
      "InvalidAmountString",
      "ValidCents"
    ],
    "FeeAttemptsResult": [
      "FeeAttemptBatch",
      "InvalidFeeAttemptBatch"
    ],
    "FinancialSecurity": [
      "FinancialSecurityFund",
      "FinancialSecurityStock"
    ],
    "FourOhOneKPlan": [
      "SoloFourOhOneKPlan",
      "StandardFourOhOneKPlan"
    ],
    "HouseholdResult": [
      "Household",
      "RecordNotFoundResult"
    ],
    "LegalSubAccount": [
      "CashAccount",
      "DirectTradingAccount",
      "ManagedSubAccount"
    ],
    "ManagedAccountPendingAction": [
      "BulkTransferPendingAction",
      "PortfolioMigrationPendingAction",
      "RebalanceNowPendingAction",
      "StrategyChangePendingAction"
    ],
    "ManagedPortfolio": [
      "RiskLevelBasedPortfolio",
      "SelfDirectedPortfolio"
    ],
    "MessageCta": [
      "MessageCtaLink",
      "MessageCtaModal"
    ],
    "ModelPortfolioResource": [
      "DocumentModelPortfolioResource",
      "LinkModelPortfolioResource"
    ],
    "PayrollContributionConfigAccount": [
      "ManagedSubAccount"
    ],
    "PayrollContributionConfigValue": [
      "PayrollContributionConfigValueAmount",
      "PayrollContributionConfigValuePercent"
    ],
    "PendingAction": [
      "BulkTransferPendingAction",
      "PortfolioMigrationPendingAction",
      "RebalanceNowPendingAction",
      "StrategyChangePendingAction"
    ],
    "PerformanceAccount": [
      "CashAccount"
    ],
    "PlatformFeeAllocation": [
      "NotSharedPlatformFeeAllocation",
      "SharedPlatformFeeAllocation"
    ],
    "PortfolioChangePendingAction": [
      "BulkTransferPendingAction",
      "PortfolioMigrationPendingAction",
      "StrategyChangePendingAction"
    ],
    "Purpose": [
      "PurposeEmergencyFund",
      "PurposeMajorPurchase",
      "PurposeRetirementGrowth",
      "PurposeRetirementIncome"
    ],
    "RecurringTransactionFrequency": [
      "RecurringTransactionFrequencyAnnually",
      "RecurringTransactionFrequencyEveryOtherWeek",
      "RecurringTransactionFrequencyMonthly",
      "RecurringTransactionFrequencyTwiceAMonth",
      "RecurringTransactionFrequencyWeekly"
    ],
    "Security": [
      "SecurityFund",
      "SecurityStock"
    ],
    "SingleBillingRate": [
      "BillingRateAssetBased",
      "BillingRateFixed"
    ],
    "TradePreviewExpectedTrade": [
      "TradePreviewExpectedSecurityGroupTrade",
      "TradePreviewExpectedSecurityTrade"
    ]
  }
};
      export default result;
    


export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  AdvisedPlan:
    | ( Solo401kClientEnvelope )
    | ( Omit<SoloFourOhOneKPlan, 'documents' | 'messages'> & { documents: Array<_RefType['FourOhOneKDocument']>, messages: Array<_RefType['Message']> } )
    | ( Omit<StandardFourOhOneKPlan, 'messages'> & { messages: Array<_RefType['Message']> } )
  ;
  BillingRate:
    | ( BillingRateAssetBased )
    | ( BillingRateFixed )
    | ( Omit<BillingRateTiered, 'tiers'> & { tiers: Array<_RefType['BillingRateRange']> } )
  ;
  EstimatedTradeTiming:
    | ( EstimatedTradeDate )
    | ( EstimatedTradeTimeRange )
  ;
  FeeAttemptInputAccount:
    | ( Omit<CashAccount, 'accountHolders' | 'envelope' | 'legalAccount' | 'messages' | 'recurringTransactionConfigs' | 'users'> & { accountHolders: Array<_RefType['AccountHolder']>, envelope: _RefType['Envelope'], legalAccount: _RefType['LegalAccount'], messages: Array<_RefType['Message']>, recurringTransactionConfigs: Array<_RefType['RecurringTransactionConfig']>, users: Array<_RefType['Client']> } )
    | ( InvalidAccountString )
    | ( Omit<ManagedSubAccount, 'envelope' | 'legalAccount' | 'users'> & { envelope: _RefType['Envelope'], legalAccount: _RefType['LegalAccount'], users: Array<_RefType['Client']> } )
  ;
  FeeAttemptInputAmount:
    | ( InvalidAmountString )
    | ( ValidCents )
  ;
  FeeAttemptsResult:
    | ( Omit<FeeAttemptBatch, 'attempts'> & { attempts: Array<_RefType['FeeAttempt']> } )
    | ( Omit<InvalidFeeAttemptBatch, 'failures'> & { failures: Array<_RefType['FeeAttemptFailure']> } )
  ;
  HouseholdResult:
    | ( Omit<Household, 'accountYtdReturns' | 'accounts' | 'billingPlan' | 'envelopes' | 'members' | 'messages'> & { accountYtdReturns: Array<_RefType['AccountYtdReturn']>, accounts: Array<_RefType['EnvelopeAccount']>, billingPlan: _RefType['BillingPlan'], envelopes: Array<_RefType['Envelope']>, members: Array<_RefType['Client']>, messages: Array<_RefType['Message']> } )
    | ( RecordNotFoundResult )
  ;
  ManagedAccountPendingAction:
    | ( BulkTransferPendingAction )
    | ( PortfolioMigrationPendingAction )
    | ( RebalanceNowPendingAction )
    | ( StrategyChangePendingAction )
  ;
  PayrollContributionConfigValue:
    | ( PayrollContributionConfigValueAmount )
    | ( PayrollContributionConfigValuePercent )
  ;
  PlatformFeeAllocation:
    | ( NotSharedPlatformFeeAllocation )
    | ( SharedPlatformFeeAllocation )
  ;
  RecurringTransactionFrequency:
    | ( RecurringTransactionFrequencyAnnually )
    | ( RecurringTransactionFrequencyEveryOtherWeek )
    | ( RecurringTransactionFrequencyMonthly )
    | ( RecurringTransactionFrequencyTwiceAMonth )
    | ( RecurringTransactionFrequencyWeekly )
  ;
  SingleBillingRate:
    | ( BillingRateAssetBased )
    | ( BillingRateFixed )
  ;
  TradePreviewExpectedTrade:
    | ( TradePreviewExpectedSecurityGroupTrade )
    | ( TradePreviewExpectedSecurityTrade )
  ;
};

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  AccountHolder:
    | ( Omit<Client, 'employers' | 'household'> & { employers: Array<_RefType['Employer']>, household: _RefType['Household'] } )
    | ( Omit<Trust, 'individualGrantor'> & { individualGrantor?: Maybe<_RefType['Client']> } )
  ;
  ActivityItem:
    | ( Omit<ActivityItemAllocationChange, 'subAccount'> & { subAccount: _RefType['LegalSubAccount'] } )
    | ( Omit<ActivityItemDeposit, 'destinationAccount' | 'subAccount'> & { destinationAccount: _RefType['LegalSubAccount'], subAccount: _RefType['LegalSubAccount'] } )
    | ( Omit<ActivityItemFee, 'subAccount'> & { subAccount: _RefType['LegalSubAccount'] } )
    | ( Omit<ActivityItemOrder, 'security' | 'subAccount'> & { security: _RefType['Security'], subAccount: _RefType['LegalSubAccount'] } )
    | ( Omit<ActivityItemOther, 'subAccount'> & { subAccount: _RefType['LegalSubAccount'] } )
    | ( Omit<ActivityItemTradeGroup, 'purchases' | 'sales' | 'subAccount'> & { purchases: Array<_RefType['ActivityItemTrade']>, sales: Array<_RefType['ActivityItemTrade']>, subAccount: _RefType['LegalSubAccount'] } )
    | ( Omit<ActivityItemTransferGroup, 'destinationAccount' | 'sourceAccount' | 'subAccount' | 'transferItems'> & { destinationAccount?: Maybe<_RefType['LegalSubAccount']>, sourceAccount?: Maybe<_RefType['LegalSubAccount']>, subAccount: _RefType['LegalSubAccount'], transferItems: Array<_RefType['ActivityItemTransfer']> } )
    | ( Omit<ActivityItemWithdrawal, 'sourceAccount' | 'subAccount'> & { sourceAccount: _RefType['LegalSubAccount'], subAccount: _RefType['LegalSubAccount'] } )
  ;
  AgreementDocument: ( ExecutedAgreement );
  ClientEnvelopeInterface:
    | ( ClientEnvelope )
    | ( Solo401kClientEnvelope )
  ;
  EnvelopeAccount:
    | ( Omit<CashAccount, 'accountHolders' | 'envelope' | 'legalAccount' | 'messages' | 'recurringTransactionConfigs' | 'users'> & { accountHolders: Array<_RefType['AccountHolder']>, envelope: _RefType['Envelope'], legalAccount: _RefType['LegalAccount'], messages: Array<_RefType['Message']>, recurringTransactionConfigs: Array<_RefType['RecurringTransactionConfig']>, users: Array<_RefType['Client']> } )
    | ( Omit<DirectTradingAccount, 'accountHolders' | 'envelope' | 'legalAccount' | 'messages' | 'securityPositions' | 'users'> & { accountHolders: Array<_RefType['AccountHolder']>, envelope: _RefType['Envelope'], legalAccount: _RefType['LegalAccount'], messages: Array<_RefType['Message']>, securityPositions: Array<_RefType['DirectTradingSecurityPosition']>, users: Array<_RefType['Client']> } )
    | ( Omit<ManagedAccount, 'accountHolders' | 'envelope' | 'messages' | 'payrollContributionConfigs' | 'pendingActions' | 'portfolio' | 'recurringTransactionConfigs' | 'securityGroupPositions' | 'subAccount' | 'subAccounts' | 'users'> & { accountHolders: Array<_RefType['AccountHolder']>, envelope: _RefType['Envelope'], messages: Array<_RefType['Message']>, payrollContributionConfigs: Array<_RefType['PayrollContributionConfig']>, pendingActions: Array<_RefType['ManagedAccountPendingAction']>, portfolio: _RefType['ManagedPortfolio'], recurringTransactionConfigs: Array<_RefType['RecurringTransactionConfig']>, securityGroupPositions: Array<_RefType['SecurityGroupPosition']>, subAccount?: Maybe<_RefType['ManagedSubAccount']>, subAccounts: Array<_RefType['ManagedSubAccount']>, users: Array<_RefType['Client']> } )
  ;
  FinancialSecurity:
    | ( FinancialSecurityFund )
    | ( FinancialSecurityStock )
  ;
  FourOhOneKPlan:
    | ( Omit<SoloFourOhOneKPlan, 'documents' | 'messages'> & { documents: Array<_RefType['FourOhOneKDocument']>, messages: Array<_RefType['Message']> } )
    | ( Omit<StandardFourOhOneKPlan, 'messages'> & { messages: Array<_RefType['Message']> } )
  ;
  LegalSubAccount:
    | ( Omit<CashAccount, 'accountHolders' | 'envelope' | 'legalAccount' | 'messages' | 'recurringTransactionConfigs' | 'users'> & { accountHolders: Array<_RefType['AccountHolder']>, envelope: _RefType['Envelope'], legalAccount: _RefType['LegalAccount'], messages: Array<_RefType['Message']>, recurringTransactionConfigs: Array<_RefType['RecurringTransactionConfig']>, users: Array<_RefType['Client']> } )
    | ( Omit<DirectTradingAccount, 'accountHolders' | 'envelope' | 'legalAccount' | 'messages' | 'securityPositions' | 'users'> & { accountHolders: Array<_RefType['AccountHolder']>, envelope: _RefType['Envelope'], legalAccount: _RefType['LegalAccount'], messages: Array<_RefType['Message']>, securityPositions: Array<_RefType['DirectTradingSecurityPosition']>, users: Array<_RefType['Client']> } )
    | ( Omit<ManagedSubAccount, 'envelope' | 'legalAccount' | 'users'> & { envelope: _RefType['Envelope'], legalAccount: _RefType['LegalAccount'], users: Array<_RefType['Client']> } )
  ;
  ManagedPortfolio:
    | ( RiskLevelBasedPortfolio )
    | ( SelfDirectedPortfolio )
  ;
  MessageCta:
    | ( MessageCtaLink )
    | ( MessageCtaModal )
  ;
  ModelPortfolioResource:
    | ( DocumentModelPortfolioResource )
    | ( LinkModelPortfolioResource )
  ;
  PayrollContributionConfigAccount: ( Omit<ManagedSubAccount, 'envelope' | 'legalAccount' | 'users'> & { envelope: _RefType['Envelope'], legalAccount: _RefType['LegalAccount'], users: Array<_RefType['Client']> } );
  PendingAction:
    | ( BulkTransferPendingAction )
    | ( PortfolioMigrationPendingAction )
    | ( RebalanceNowPendingAction )
    | ( StrategyChangePendingAction )
  ;
  PerformanceAccount: ( Omit<CashAccount, 'accountHolders' | 'envelope' | 'legalAccount' | 'messages' | 'recurringTransactionConfigs' | 'users'> & { accountHolders: Array<_RefType['AccountHolder']>, envelope: _RefType['Envelope'], legalAccount: _RefType['LegalAccount'], messages: Array<_RefType['Message']>, recurringTransactionConfigs: Array<_RefType['RecurringTransactionConfig']>, users: Array<_RefType['Client']> } );
  PortfolioChangePendingAction:
    | ( BulkTransferPendingAction )
    | ( PortfolioMigrationPendingAction )
    | ( StrategyChangePendingAction )
  ;
  Purpose:
    | ( PurposeEmergencyFund )
    | ( PurposeMajorPurchase )
    | ( PurposeRetirementGrowth )
    | ( PurposeRetirementIncome )
  ;
  Security:
    | ( SecurityFund )
    | ( SecurityStock )
  ;
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AccountHolder: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AccountHolder']>;
  AccountTypeFilterOption: AccountTypeFilterOption;
  AccountYtdReturn: ResolverTypeWrapper<AccountYtdReturn>;
  ActivityAdvisorType: ActivityAdvisorType;
  ActivityFilterInput: ActivityFilterInput;
  ActivityItem: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ActivityItem']>;
  ActivityItemAllocationChange: ResolverTypeWrapper<Omit<ActivityItemAllocationChange, 'subAccount'> & { subAccount: ResolversTypes['LegalSubAccount'] }>;
  ActivityItemConnection: ResolverTypeWrapper<Omit<ActivityItemConnection, 'edges' | 'nodes'> & { edges: Array<ResolversTypes['ActivityItemEdge']>, nodes: Array<ResolversTypes['ActivityItem']> }>;
  ActivityItemDeposit: ResolverTypeWrapper<Omit<ActivityItemDeposit, 'destinationAccount' | 'subAccount'> & { destinationAccount: ResolversTypes['LegalSubAccount'], subAccount: ResolversTypes['LegalSubAccount'] }>;
  ActivityItemEdge: ResolverTypeWrapper<Omit<ActivityItemEdge, 'node'> & { node: ResolversTypes['ActivityItem'] }>;
  ActivityItemFee: ResolverTypeWrapper<Omit<ActivityItemFee, 'subAccount'> & { subAccount: ResolversTypes['LegalSubAccount'] }>;
  ActivityItemOrder: ResolverTypeWrapper<Omit<ActivityItemOrder, 'security' | 'subAccount'> & { security: ResolversTypes['Security'], subAccount: ResolversTypes['LegalSubAccount'] }>;
  ActivityItemOther: ResolverTypeWrapper<Omit<ActivityItemOther, 'subAccount'> & { subAccount: ResolversTypes['LegalSubAccount'] }>;
  ActivityItemStage: ActivityItemStage;
  ActivityItemStatus: ResolverTypeWrapper<ActivityItemStatus>;
  ActivityItemTrade: ResolverTypeWrapper<Omit<ActivityItemTrade, 'security'> & { security: ResolversTypes['Security'] }>;
  ActivityItemTradeAttribution: ActivityItemTradeAttribution;
  ActivityItemTradeGroup: ResolverTypeWrapper<Omit<ActivityItemTradeGroup, 'purchases' | 'sales' | 'subAccount'> & { purchases: Array<ResolversTypes['ActivityItemTrade']>, sales: Array<ResolversTypes['ActivityItemTrade']>, subAccount: ResolversTypes['LegalSubAccount'] }>;
  ActivityItemTradeSide: ActivityItemTradeSide;
  ActivityItemTransfer: ResolverTypeWrapper<Omit<ActivityItemTransfer, 'destinationAccount' | 'security' | 'sourceAccount'> & { destinationAccount?: Maybe<ResolversTypes['LegalSubAccount']>, security?: Maybe<ResolversTypes['Security']>, sourceAccount?: Maybe<ResolversTypes['LegalSubAccount']> }>;
  ActivityItemTransferAssetType: ActivityItemTransferAssetType;
  ActivityItemTransferGroup: ResolverTypeWrapper<Omit<ActivityItemTransferGroup, 'destinationAccount' | 'sourceAccount' | 'subAccount' | 'transferItems'> & { destinationAccount?: Maybe<ResolversTypes['LegalSubAccount']>, sourceAccount?: Maybe<ResolversTypes['LegalSubAccount']>, subAccount: ResolversTypes['LegalSubAccount'], transferItems: Array<ResolversTypes['ActivityItemTransfer']> }>;
  ActivityItemTypeFilterOption: ActivityItemTypeFilterOption;
  ActivityItemWithdrawal: ResolverTypeWrapper<Omit<ActivityItemWithdrawal, 'sourceAccount' | 'subAccount'> & { sourceAccount: ResolversTypes['LegalSubAccount'], subAccount: ResolversTypes['LegalSubAccount'] }>;
  AdvisedPlan: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['AdvisedPlan']>;
  Advisor: ResolverTypeWrapper<Omit<Advisor, 'firm' | 'messages'> & { firm: ResolversTypes['Firm'], messages: Array<ResolversTypes['Message']> }>;
  AdvisorGoalCreation: ResolverTypeWrapper<AdvisorGoalCreation>;
  AdvisorGoalCreationAccount: ResolverTypeWrapper<AdvisorGoalCreationAccount>;
  AdvisorRfpPlanType: AdvisorRfpPlanType;
  AffectedHousehold: ResolverTypeWrapper<AffectedHousehold>;
  AgreementDocument: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['AgreementDocument']>;
  Announcement: ResolverTypeWrapper<Announcement>;
  AnnouncementDismissal: ResolverTypeWrapper<AnnouncementDismissal>;
  AnnouncementRedirect: ResolverTypeWrapper<AnnouncementRedirect>;
  AnnouncementStep: ResolverTypeWrapper<AnnouncementStep>;
  AnnouncementStepCta: ResolverTypeWrapper<AnnouncementStepCta>;
  AnnouncementStepImage: ResolverTypeWrapper<AnnouncementStepImage>;
  Annual: ResolverTypeWrapper<Annual>;
  AnnualIraContributions: ResolverTypeWrapper<AnnualIraContributions>;
  AssignedAccountSummary: ResolverTypeWrapper<AssignedAccountSummary>;
  Autoglide: ResolverTypeWrapper<Autoglide>;
  BankAccount: ResolverTypeWrapper<BankAccount>;
  BeneficiaryRelationship: BeneficiaryRelationship;
  BettermentModelPortfolio: ResolverTypeWrapper<BettermentModelPortfolio>;
  BillingFrequency: BillingFrequency;
  BillingPlan: ResolverTypeWrapper<Omit<BillingPlan, 'billingRate' | 'platformFeeAllocation'> & { billingRate: ResolversTypes['BillingRate'], platformFeeAllocation: ResolversTypes['PlatformFeeAllocation'] }>;
  BillingPlanPaymentTypeInput: BillingPlanPaymentTypeInput;
  BillingRate: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['BillingRate']>;
  BillingRateAssetBased: ResolverTypeWrapper<BillingRateAssetBased>;
  BillingRateAssetBasedInput: BillingRateAssetBasedInput;
  BillingRateFixed: ResolverTypeWrapper<BillingRateFixed>;
  BillingRateFixedInput: BillingRateFixedInput;
  BillingRateInput: BillingRateInput;
  BillingRateRange: ResolverTypeWrapper<Omit<BillingRateRange, 'firmFee'> & { firmFee: ResolversTypes['SingleBillingRate'] }>;
  BillingRateRangeInput: BillingRateRangeInput;
  BillingRateTiered: ResolverTypeWrapper<Omit<BillingRateTiered, 'tiers'> & { tiers: Array<ResolversTypes['BillingRateRange']> }>;
  BillingRateTieredInput: BillingRateTieredInput;
  BlockingTask: ResolverTypeWrapper<BlockingTask>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Bps: ResolverTypeWrapper<Scalars['Bps']['output']>;
  BulkFeeAttempt: ResolverTypeWrapper<Omit<BulkFeeAttempt, 'feeAttempts'> & { feeAttempts: ResolversTypes['FeeAttemptsResult'] }>;
  BulkFeeIntent: ResolverTypeWrapper<Omit<BulkFeeIntent, 'createdBy'> & { createdBy?: Maybe<ResolversTypes['Advisor']> }>;
  BulkFeeIntentStatus: BulkFeeIntentStatus;
  BulkTransferPendingAction: ResolverTypeWrapper<BulkTransferPendingAction>;
  CashAccount: ResolverTypeWrapper<Omit<CashAccount, 'accountHolders' | 'envelope' | 'legalAccount' | 'messages' | 'recurringTransactionConfigs' | 'users'> & { accountHolders: Array<ResolversTypes['AccountHolder']>, envelope: ResolversTypes['Envelope'], legalAccount: ResolversTypes['LegalAccount'], messages: Array<ResolversTypes['Message']>, recurringTransactionConfigs: Array<ResolversTypes['RecurringTransactionConfig']>, users: Array<ResolversTypes['Client']> }>;
  CashApy: ResolverTypeWrapper<CashApy>;
  CashFdicInsurance: ResolverTypeWrapper<CashFdicInsurance>;
  Cents: ResolverTypeWrapper<Scalars['Cents']['output']>;
  Client: ResolverTypeWrapper<Omit<Client, 'employers' | 'household'> & { employers: Array<ResolversTypes['Employer']>, household: ResolversTypes['Household'] }>;
  ClientAccountBeneficiary: ResolverTypeWrapper<ClientAccountBeneficiary>;
  ClientAccountBeneficiaryInput: ClientAccountBeneficiaryInput;
  ClientAccountBeneficiaryRelationship: ClientAccountBeneficiaryRelationship;
  ClientAccountTypeSummary: ResolverTypeWrapper<ClientAccountTypeSummary>;
  ClientEnvelope: ResolverTypeWrapper<ClientEnvelope>;
  ClientEnvelopeBankAccount: ResolverTypeWrapper<ClientEnvelopeBankAccount>;
  ClientEnvelopeBankAccountInput: ClientEnvelopeBankAccountInput;
  ClientEnvelopeClient: ResolverTypeWrapper<ClientEnvelopeClient>;
  ClientEnvelopeInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ClientEnvelopeInterface']>;
  ClientEnvelopeInvitation: ResolverTypeWrapper<ClientEnvelopeInvitation>;
  Contribution: ResolverTypeWrapper<Contribution>;
  ContributionDetailInput: ContributionDetailInput;
  CreateBulkFeeIntentMutationInput: CreateBulkFeeIntentMutationInput;
  CreateBulkFeeIntentMutationPayload: ResolverTypeWrapper<Omit<CreateBulkFeeIntentMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['BulkFeeIntent']> }>;
  CreateClientActivityCsvExportMutationInput: CreateClientActivityCsvExportMutationInput;
  CreateClientActivityCsvExportMutationPayload: ResolverTypeWrapper<CreateClientActivityCsvExportMutationPayload>;
  CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationInput: CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationInput;
  CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationPayload: ResolverTypeWrapper<Omit<CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Solo401kConversionIntent']> }>;
  CreateDraftSolo401kConversionIntentMutationInput: CreateDraftSolo401kConversionIntentMutationInput;
  CreateDraftSolo401kConversionIntentMutationPayload: ResolverTypeWrapper<Omit<CreateDraftSolo401kConversionIntentMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Solo401kConversionIntent']> }>;
  CreateFinancialSecurityOrderRequestMutationInput: CreateFinancialSecurityOrderRequestMutationInput;
  CreateFinancialSecurityOrderRequestMutationPayload: ResolverTypeWrapper<CreateFinancialSecurityOrderRequestMutationPayload>;
  CreateFinancialSecuritySellOrderTaxImpactPreviewMutationInput: CreateFinancialSecuritySellOrderTaxImpactPreviewMutationInput;
  CreateFinancialSecuritySellOrderTaxImpactPreviewMutationPayload: ResolverTypeWrapper<CreateFinancialSecuritySellOrderTaxImpactPreviewMutationPayload>;
  CreateFirmBillableAccountsCsvExportMutationPayload: ResolverTypeWrapper<CreateFirmBillableAccountsCsvExportMutationPayload>;
  CreateFourOhOneKReportInputArguments: CreateFourOhOneKReportInputArguments;
  CreateFourOhOneKReportMutationInput: CreateFourOhOneKReportMutationInput;
  CreateFourOhOneKReportMutationPayload: ResolverTypeWrapper<CreateFourOhOneKReportMutationPayload>;
  CreateFourOhOneKReportPayload: ResolverTypeWrapper<CreateFourOhOneKReportPayload>;
  CreateFourOhOneKRequestForProposalMutationInput: CreateFourOhOneKRequestForProposalMutationInput;
  CreateFourOhOneKRequestForProposalMutationPayload: ResolverTypeWrapper<CreateFourOhOneKRequestForProposalMutationPayload>;
  CreateFourOhOneKRequestForProposalResult: ResolverTypeWrapper<CreateFourOhOneKRequestForProposalResult>;
  CreateTradePreviewMutationInput: CreateTradePreviewMutationInput;
  CreateTradePreviewMutationPayload: ResolverTypeWrapper<Omit<CreateTradePreviewMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['TradePreview']> }>;
  CsvExport: ResolverTypeWrapper<CsvExport>;
  CsvExportStatus: CsvExportStatus;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateRangeOption: DateRangeOption;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  Dictionary: ResolverTypeWrapper<Dictionary>;
  DirectTradingAccount: ResolverTypeWrapper<Omit<DirectTradingAccount, 'accountHolders' | 'envelope' | 'legalAccount' | 'messages' | 'securityPositions' | 'users'> & { accountHolders: Array<ResolversTypes['AccountHolder']>, envelope: ResolversTypes['Envelope'], legalAccount: ResolversTypes['LegalAccount'], messages: Array<ResolversTypes['Message']>, securityPositions: Array<ResolversTypes['DirectTradingSecurityPosition']>, users: Array<ResolversTypes['Client']> }>;
  DirectTradingCashBalances: ResolverTypeWrapper<DirectTradingCashBalances>;
  DirectTradingSecurityPosition: ResolverTypeWrapper<Omit<DirectTradingSecurityPosition, 'financialSecurity'> & { financialSecurity: ResolversTypes['FinancialSecurity'] }>;
  DirectTradingSecurityPositionReturn: ResolverTypeWrapper<DirectTradingSecurityPositionReturn>;
  Disclosures: ResolverTypeWrapper<Disclosures>;
  DismissAnnouncementMutationInput: DismissAnnouncementMutationInput;
  DismissAnnouncementMutationPayload: ResolverTypeWrapper<DismissAnnouncementMutationPayload>;
  DismissCsvActivityExportBannerMutationPayload: ResolverTypeWrapper<DismissCsvActivityExportBannerMutationPayload>;
  DismissFirmBillableAccountsCsvExportMutationPayload: ResolverTypeWrapper<DismissFirmBillableAccountsCsvExportMutationPayload>;
  DisplayableError: ResolverTypeWrapper<DisplayableError>;
  DocumentModelPortfolioResource: ResolverTypeWrapper<DocumentModelPortfolioResource>;
  Drift: ResolverTypeWrapper<Drift>;
  EmailDispatch: ResolverTypeWrapper<EmailDispatch>;
  Employer: ResolverTypeWrapper<Omit<Employer, 'contributionConfig' | 'soloFourOhOneKPlan'> & { contributionConfig?: Maybe<ResolversTypes['EmployerConfig']>, soloFourOhOneKPlan?: Maybe<ResolversTypes['SoloFourOhOneKPlan']> }>;
  EmployerConfig: ResolverTypeWrapper<EmployerConfig>;
  EmployerContributions: ResolverTypeWrapper<EmployerContributions>;
  EmployerFrequency: EmployerFrequency;
  EmployerResult: ResolverTypeWrapper<EmployerResult>;
  Envelope: ResolverTypeWrapper<Omit<Envelope, 'accounts' | 'purpose' | 'user'> & { accounts: Array<ResolversTypes['EnvelopeAccount']>, purpose?: Maybe<ResolversTypes['Purpose']>, user: ResolversTypes['Client'] }>;
  EnvelopeAccount: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['EnvelopeAccount']>;
  EnvelopeYtdReturn: ResolverTypeWrapper<EnvelopeYtdReturn>;
  EstimatedTradeDate: ResolverTypeWrapper<EstimatedTradeDate>;
  EstimatedTradeTimeRange: ResolverTypeWrapper<EstimatedTradeTimeRange>;
  EstimatedTradeTiming: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['EstimatedTradeTiming']>;
  ExecutedAgreement: ResolverTypeWrapper<ExecutedAgreement>;
  ExpenseRatio: ResolverTypeWrapper<ExpenseRatio>;
  ExternallyAdvisedPlanPortfolio: ResolverTypeWrapper<ExternallyAdvisedPlanPortfolio>;
  FeeAttempt: ResolverTypeWrapper<Omit<FeeAttempt, 'account'> & { account: ResolversTypes['LegalSubAccount'] }>;
  FeeAttemptBatch: ResolverTypeWrapper<Omit<FeeAttemptBatch, 'attempts'> & { attempts: Array<ResolversTypes['FeeAttempt']> }>;
  FeeAttemptFailure: ResolverTypeWrapper<Omit<FeeAttemptFailure, 'account' | 'amount'> & { account: ResolversTypes['FeeAttemptInputAccount'], amount: ResolversTypes['FeeAttemptInputAmount'] }>;
  FeeAttemptFailureReason: FeeAttemptFailureReason;
  FeeAttemptInputAccount: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['FeeAttemptInputAccount']>;
  FeeAttemptInputAmount: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['FeeAttemptInputAmount']>;
  FeeAttemptsResult: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['FeeAttemptsResult']>;
  FeeConfiguration: ResolverTypeWrapper<FeeConfiguration>;
  FinancialSecurity: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['FinancialSecurity']>;
  FinancialSecurityFund: ResolverTypeWrapper<FinancialSecurityFund>;
  FinancialSecurityOrderRequest: ResolverTypeWrapper<FinancialSecurityOrderRequest>;
  FinancialSecurityOrderRequestDirection: FinancialSecurityOrderRequestDirection;
  FinancialSecurityOrderRequestStatus: FinancialSecurityOrderRequestStatus;
  FinancialSecurityOrderRequestValueInput: FinancialSecurityOrderRequestValueInput;
  FinancialSecuritySellOrderTaxImpactPreview: ResolverTypeWrapper<FinancialSecuritySellOrderTaxImpactPreview>;
  FinancialSecurityStock: ResolverTypeWrapper<FinancialSecurityStock>;
  Firm: ResolverTypeWrapper<Omit<Firm, 'billingPlan' | 'billingPlans' | 'bulkFeeAttempt' | 'bulkFeeIntents'> & { billingPlan?: Maybe<ResolversTypes['BillingPlan']>, billingPlans: Array<ResolversTypes['BillingPlan']>, bulkFeeAttempt?: Maybe<ResolversTypes['BulkFeeAttempt']>, bulkFeeIntents: Array<ResolversTypes['BulkFeeIntent']> }>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FourOhOneKDocument: ResolverTypeWrapper<FourOhOneKDocument>;
  FourOhOneKDocumentType: FourOhOneKDocumentType;
  FourOhOneKOnboardingTask: ResolverTypeWrapper<FourOhOneKOnboardingTask>;
  FourOhOneKPlan: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['FourOhOneKPlan']>;
  FourOhOneKPlanFiduciary: ResolverTypeWrapper<FourOhOneKPlanFiduciary>;
  FourOhOneKPlanLaunchStatusType: FourOhOneKPlanLaunchStatusType;
  FourOhOneKPlanManager: ResolverTypeWrapper<FourOhOneKPlanManager>;
  FourOhOneKPlanOnboarding: ResolverTypeWrapper<FourOhOneKPlanOnboarding>;
  FourOhOneKPlanPerformanceIndicators: ResolverTypeWrapper<FourOhOneKPlanPerformanceIndicators>;
  FourOhOneKPlanStatusType: FourOhOneKPlanStatusType;
  FourOhOneKPlanSupportAgent: ResolverTypeWrapper<FourOhOneKPlanSupportAgent>;
  FourOhOneKPlanSupportResource: ResolverTypeWrapper<FourOhOneKPlanSupportResource>;
  FourOhOneKPlanType: FourOhOneKPlanType;
  FourOhOneKPlansWhereInput: FourOhOneKPlansWhereInput;
  FourOhOneKReport: ResolverTypeWrapper<FourOhOneKReport>;
  FourOhOneKReportContentType: FourOhOneKReportContentType;
  FourOhOneKReportCreationOption: ResolverTypeWrapper<FourOhOneKReportCreationOption>;
  FourOhOneKReportInputOption: ResolverTypeWrapper<FourOhOneKReportInputOption>;
  FourOhOneKReportStatus: FourOhOneKReportStatus;
  FourOhOneKThirdPartyAdministrator: ResolverTypeWrapper<FourOhOneKThirdPartyAdministrator>;
  FuturePortfolio: ResolverTypeWrapper<FuturePortfolio>;
  Gains: ResolverTypeWrapper<Gains>;
  GainsDetails: ResolverTypeWrapper<GainsDetails>;
  HTML: ResolverTypeWrapper<Scalars['HTML']['output']>;
  HistoricalPerformance: ResolverTypeWrapper<HistoricalPerformance>;
  Household: ResolverTypeWrapper<Omit<Household, 'accountYtdReturns' | 'accounts' | 'billingPlan' | 'envelopes' | 'members' | 'messages'> & { accountYtdReturns: Array<ResolversTypes['AccountYtdReturn']>, accounts: Array<ResolversTypes['EnvelopeAccount']>, billingPlan: ResolversTypes['BillingPlan'], envelopes: Array<ResolversTypes['Envelope']>, members: Array<ResolversTypes['Client']>, messages: Array<ResolversTypes['Message']> }>;
  HouseholdResult: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['HouseholdResult']>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  InvalidAccountString: ResolverTypeWrapper<InvalidAccountString>;
  InvalidAmountString: ResolverTypeWrapper<InvalidAmountString>;
  InvalidFeeAttemptBatch: ResolverTypeWrapper<Omit<InvalidFeeAttemptBatch, 'failures'> & { failures: Array<ResolversTypes['FeeAttemptFailure']> }>;
  IraContributions: ResolverTypeWrapper<IraContributions>;
  IraContributionsByYearWhere: IraContributionsByYearWhere;
  IraContributionsProjection: ResolverTypeWrapper<IraContributionsProjection>;
  IraContributionsResult: ResolverTypeWrapper<IraContributionsResult>;
  LegacyGoal: ResolverTypeWrapper<LegacyGoal>;
  LegacyID: ResolverTypeWrapper<Scalars['LegacyID']['output']>;
  LegacySecurity: ResolverTypeWrapper<LegacySecurity>;
  LegacySubAccount: ResolverTypeWrapper<LegacySubAccount>;
  LegacyTransferType: LegacyTransferType;
  LegacyUUID: ResolverTypeWrapper<Scalars['LegacyUUID']['output']>;
  LegalAccount: ResolverTypeWrapper<Omit<LegalAccount, 'primaryBeneficiaries' | 'soloFourOhOneKPlan'> & { primaryBeneficiaries: Array<ResolversTypes['LegalAccountBeneficiary']>, soloFourOhOneKPlan?: Maybe<ResolversTypes['SoloFourOhOneKPlan']> }>;
  LegalAccountBeneficiary: ResolverTypeWrapper<LegalAccountBeneficiary>;
  LegalAccountOwnershipType: LegalAccountOwnershipType;
  LegalAccountTaxationType: LegalAccountTaxationType;
  LegalAccountType: LegalAccountType;
  LegalSubAccount: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['LegalSubAccount']>;
  LinkModelPortfolioResource: ResolverTypeWrapper<LinkModelPortfolioResource>;
  Logo: ResolverTypeWrapper<Logo>;
  ManagedAccount: ResolverTypeWrapper<Omit<ManagedAccount, 'accountHolders' | 'envelope' | 'messages' | 'payrollContributionConfigs' | 'pendingActions' | 'portfolio' | 'recurringTransactionConfigs' | 'securityGroupPositions' | 'subAccount' | 'subAccounts' | 'users'> & { accountHolders: Array<ResolversTypes['AccountHolder']>, envelope: ResolversTypes['Envelope'], messages: Array<ResolversTypes['Message']>, payrollContributionConfigs: Array<ResolversTypes['PayrollContributionConfig']>, pendingActions: Array<ResolversTypes['ManagedAccountPendingAction']>, portfolio: ResolversTypes['ManagedPortfolio'], recurringTransactionConfigs: Array<ResolversTypes['RecurringTransactionConfig']>, securityGroupPositions: Array<ResolversTypes['SecurityGroupPosition']>, subAccount?: Maybe<ResolversTypes['ManagedSubAccount']>, subAccounts: Array<ResolversTypes['ManagedSubAccount']>, users: Array<ResolversTypes['Client']> }>;
  ManagedAccountPendingAction: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['ManagedAccountPendingAction']>;
  ManagedPortfolio: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ManagedPortfolio']>;
  ManagedSubAccount: ResolverTypeWrapper<Omit<ManagedSubAccount, 'envelope' | 'legalAccount' | 'users'> & { envelope: ResolversTypes['Envelope'], legalAccount: ResolversTypes['LegalAccount'], users: Array<ResolversTypes['Client']> }>;
  Message: ResolverTypeWrapper<Omit<Message, 'cta'> & { cta?: Maybe<ResolversTypes['MessageCta']> }>;
  MessageCta: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['MessageCta']>;
  MessageCtaLink: ResolverTypeWrapper<MessageCtaLink>;
  MessageCtaModal: ResolverTypeWrapper<MessageCtaModal>;
  MessageLocation: MessageLocation;
  MessageStyle: MessageStyle;
  ModelPortfolioFeature: ModelPortfolioFeature;
  ModelPortfolioProvider: ResolverTypeWrapper<Omit<ModelPortfolioProvider, 'modelPortfolios'> & { modelPortfolios: ResolversTypes['ProviderModelPortfolioConnection'] }>;
  ModelPortfolioProviderConnection: ResolverTypeWrapper<ModelPortfolioProviderConnection>;
  ModelPortfolioProviderEdge: ResolverTypeWrapper<ModelPortfolioProviderEdge>;
  ModelPortfolioResource: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ModelPortfolioResource']>;
  ModelPortfolioResourceType: ModelPortfolioResourceType;
  ModelPortfolioRiskLevel: ResolverTypeWrapper<Omit<ModelPortfolioRiskLevel, 'securityGroupAllocations'> & { securityGroupAllocations: Array<ResolversTypes['RiskLevelSecurityGroupAllocation']> }>;
  ModelPortfolioSecurityGroup: ResolverTypeWrapper<Omit<ModelPortfolioSecurityGroup, 'primarySecurityTaxDeferred' | 'primarySecurityTaxable' | 'secondarySecurityTaxDeferred' | 'secondarySecurityTaxable'> & { primarySecurityTaxDeferred: ResolversTypes['FinancialSecurity'], primarySecurityTaxable: ResolversTypes['FinancialSecurity'], secondarySecurityTaxDeferred?: Maybe<ResolversTypes['FinancialSecurity']>, secondarySecurityTaxable?: Maybe<ResolversTypes['FinancialSecurity']> }>;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  NotSharedPlatformFeeAllocation: ResolverTypeWrapper<NotSharedPlatformFeeAllocation>;
  NotSharedPlatformFeeInput: NotSharedPlatformFeeInput;
  OutboundIntegration: ResolverTypeWrapper<OutboundIntegration>;
  OutboundIntegrationType: OutboundIntegrationType;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PaymentType: PaymentType;
  PayrollContributionConfig: ResolverTypeWrapper<Omit<PayrollContributionConfig, 'bonusValue' | 'value'> & { bonusValue?: Maybe<ResolversTypes['PayrollContributionConfigValue']>, value: ResolversTypes['PayrollContributionConfigValue'] }>;
  PayrollContributionConfigAccount: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['PayrollContributionConfigAccount']>;
  PayrollContributionConfigValue: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['PayrollContributionConfigValue']>;
  PayrollContributionConfigValueAmount: ResolverTypeWrapper<PayrollContributionConfigValueAmount>;
  PayrollContributionConfigValuePercent: ResolverTypeWrapper<PayrollContributionConfigValuePercent>;
  PendingAction: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['PendingAction']>;
  Percent: ResolverTypeWrapper<Scalars['Percent']['output']>;
  Performance: ResolverTypeWrapper<Performance>;
  PerformanceAccount: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['PerformanceAccount']>;
  PerformanceHistory: ResolverTypeWrapper<PerformanceHistory>;
  PerformanceInterest: ResolverTypeWrapper<PerformanceInterest>;
  PerformanceTotals: ResolverTypeWrapper<PerformanceTotals>;
  PlanManagerAuthorizationTier: PlanManagerAuthorizationTier;
  PlatformFeeAllocation: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['PlatformFeeAllocation']>;
  PlatformFeeAllocationInput: PlatformFeeAllocationInput;
  PlatformFeePaidBy: PlatformFeePaidBy;
  PlatformFeeTier: ResolverTypeWrapper<PlatformFeeTier>;
  PortfolioChangePendingAction: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['PortfolioChangePendingAction']>;
  PortfolioMigrationPendingAction: ResolverTypeWrapper<PortfolioMigrationPendingAction>;
  Projection: ResolverTypeWrapper<Projection>;
  ProviderModelPortfolio: ResolverTypeWrapper<Omit<ProviderModelPortfolio, 'defaultRiskLevel' | 'resources'> & { defaultRiskLevel: ResolversTypes['ModelPortfolioRiskLevel'], resources: Array<ResolversTypes['ModelPortfolioResource']> }>;
  ProviderModelPortfolioConnection: ResolverTypeWrapper<Omit<ProviderModelPortfolioConnection, 'edges' | 'nodes'> & { edges: Array<ResolversTypes['ProviderModelPortfolioEdge']>, nodes: Array<ResolversTypes['ProviderModelPortfolio']> }>;
  ProviderModelPortfolioEdge: ResolverTypeWrapper<Omit<ProviderModelPortfolioEdge, 'node'> & { node: ResolversTypes['ProviderModelPortfolio'] }>;
  PublishSolo401kConversionIntentMutationInput: PublishSolo401kConversionIntentMutationInput;
  PublishSolo401kConversionIntentMutationPayload: ResolverTypeWrapper<Omit<PublishSolo401kConversionIntentMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Solo401kConversionIntent']> }>;
  Purpose: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Purpose']>;
  PurposeEmergencyFund: ResolverTypeWrapper<PurposeEmergencyFund>;
  PurposeMajorPurchase: ResolverTypeWrapper<PurposeMajorPurchase>;
  PurposeRetirementGrowth: ResolverTypeWrapper<PurposeRetirementGrowth>;
  PurposeRetirementIncome: ResolverTypeWrapper<PurposeRetirementIncome>;
  PurposeRetirementIncomeProjection: ResolverTypeWrapper<PurposeRetirementIncomeProjection>;
  PurposeStatus: PurposeStatus;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  Rebalance: ResolverTypeWrapper<Rebalance>;
  RebalanceNowPendingAction: ResolverTypeWrapper<RebalanceNowPendingAction>;
  RecordNotFoundResult: ResolverTypeWrapper<RecordNotFoundResult>;
  RecurringTransactionConfig: ResolverTypeWrapper<Omit<RecurringTransactionConfig, 'frequency' | 'source'> & { frequency: ResolversTypes['RecurringTransactionFrequency'], source?: Maybe<ResolversTypes['CashAccount']> }>;
  RecurringTransactionFrequency: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['RecurringTransactionFrequency']>;
  RecurringTransactionFrequencyAnnually: ResolverTypeWrapper<RecurringTransactionFrequencyAnnually>;
  RecurringTransactionFrequencyEveryOtherWeek: ResolverTypeWrapper<RecurringTransactionFrequencyEveryOtherWeek>;
  RecurringTransactionFrequencyMonthly: ResolverTypeWrapper<RecurringTransactionFrequencyMonthly>;
  RecurringTransactionFrequencyTwiceAMonth: ResolverTypeWrapper<RecurringTransactionFrequencyTwiceAMonth>;
  RecurringTransactionFrequencyWeekly: ResolverTypeWrapper<RecurringTransactionFrequencyWeekly>;
  RemoveSolo401kQdiaFundLineupMutationInput: RemoveSolo401kQdiaFundLineupMutationInput;
  RemoveSolo401kQdiaFundLineupMutationPayload: ResolverTypeWrapper<RemoveSolo401kQdiaFundLineupMutationPayload>;
  Result: ResolverTypeWrapper<Result>;
  RiskLevelBasedPortfolio: ResolverTypeWrapper<RiskLevelBasedPortfolio>;
  RiskLevelSecurityGroupAllocation: ResolverTypeWrapper<Omit<RiskLevelSecurityGroupAllocation, 'securityGroup'> & { securityGroup: ResolversTypes['ModelPortfolioSecurityGroup'] }>;
  SblocLoan: ResolverTypeWrapper<SblocLoan>;
  SecuritiesLending: ResolverTypeWrapper<SecuritiesLending>;
  SecuritiesLendingStatus: SecuritiesLendingStatus;
  Security: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Security']>;
  SecurityCategoryGroup: ResolverTypeWrapper<SecurityCategoryGroup>;
  SecurityFund: ResolverTypeWrapper<SecurityFund>;
  SecurityGroupPosition: ResolverTypeWrapper<Omit<SecurityGroupPosition, 'securityGroup' | 'securityPositions' | 'securityPositionsBySecurity'> & { securityGroup: ResolversTypes['SecurityGroupSummary'], securityPositions: Array<ResolversTypes['SecurityPosition']>, securityPositionsBySecurity: Array<ResolversTypes['SecurityPositionsBySecurity']> }>;
  SecurityGroupSummary: ResolverTypeWrapper<Omit<SecurityGroupSummary, 'securities' | 'sellOnlySubstituteSecurities'> & { securities: Array<ResolversTypes['Security']>, sellOnlySubstituteSecurities: Array<ResolversTypes['FinancialSecurity']> }>;
  SecurityPosition: ResolverTypeWrapper<Omit<SecurityPosition, 'financialSecurity' | 'security'> & { financialSecurity: ResolversTypes['FinancialSecurity'], security: ResolversTypes['Security'] }>;
  SecurityPositionsBySecurity: ResolverTypeWrapper<Omit<SecurityPositionsBySecurity, 'financialSecurity' | 'securityPositionsBySubAccount'> & { financialSecurity: ResolversTypes['FinancialSecurity'], securityPositionsBySubAccount: Array<ResolversTypes['SecurityPositionsBySubAccount']> }>;
  SecurityPositionsBySubAccount: ResolverTypeWrapper<Omit<SecurityPositionsBySubAccount, 'securityPositions' | 'subAccount'> & { securityPositions: Array<ResolversTypes['SecurityPosition']>, subAccount: ResolversTypes['LegalSubAccount'] }>;
  SecurityStock: ResolverTypeWrapper<SecurityStock>;
  SelfDirectedPortfolio: ResolverTypeWrapper<SelfDirectedPortfolio>;
  SendClientSecuritiesLendingInvitationMutationInput: SendClientSecuritiesLendingInvitationMutationInput;
  SendClientSecuritiesLendingInvitationMutationPayload: ResolverTypeWrapper<SendClientSecuritiesLendingInvitationMutationPayload>;
  SharedPlatformFeeAllocation: ResolverTypeWrapper<SharedPlatformFeeAllocation>;
  SharedPlatformFeeInput: SharedPlatformFeeInput;
  SingleBillingRate: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['SingleBillingRate']>;
  SingleBillingRateInput: SingleBillingRateInput;
  Solo401kClientEnvelope: ResolverTypeWrapper<Solo401kClientEnvelope>;
  Solo401kConversionContributionCategory: Solo401kConversionContributionCategory;
  Solo401kConversionContributionDetail: ResolverTypeWrapper<Solo401kConversionContributionDetail>;
  Solo401kConversionFundsCategory: Solo401kConversionFundsCategory;
  Solo401kConversionIntent: ResolverTypeWrapper<Omit<Solo401kConversionIntent, 'planOwner' | 'planSpouse'> & { planOwner: ResolversTypes['Client'], planSpouse?: Maybe<ResolversTypes['Client']> }>;
  Solo401kConversionIntentStatus: Solo401kConversionIntentStatus;
  Solo401kPlan: ResolverTypeWrapper<Solo401kPlan>;
  Solo401kPlanBusinessInfo: Solo401kPlanBusinessInfo;
  SoloFourOhOneKParticipant: ResolverTypeWrapper<SoloFourOhOneKParticipant>;
  SoloFourOhOneKPlan: ResolverTypeWrapper<Omit<SoloFourOhOneKPlan, 'documents' | 'messages'> & { documents: Array<ResolversTypes['FourOhOneKDocument']>, messages: Array<ResolversTypes['Message']> }>;
  StandardFourOhOneKPlan: ResolverTypeWrapper<Omit<StandardFourOhOneKPlan, 'messages'> & { messages: Array<ResolversTypes['Message']> }>;
  StrategyChangePendingAction: ResolverTypeWrapper<StrategyChangePendingAction>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  Summary: ResolverTypeWrapper<Summary>;
  SupportContact: ResolverTypeWrapper<SupportContact>;
  SupportResources: ResolverTypeWrapper<SupportResources>;
  TIN: ResolverTypeWrapper<Scalars['TIN']['output']>;
  TaxImpact: ResolverTypeWrapper<TaxImpact>;
  TaxYear: ResolverTypeWrapper<TaxYear>;
  ThemedAsset: ResolverTypeWrapper<ThemedAsset>;
  TieredFeeCalculationMethod: TieredFeeCalculationMethod;
  TotalEarnedDateRange: TotalEarnedDateRange;
  TradePreview: ResolverTypeWrapper<Omit<TradePreview, 'expectedTrades'> & { expectedTrades: Array<ResolversTypes['TradePreviewExpectedTrade']> }>;
  TradePreviewAction: TradePreviewAction;
  TradePreviewExpectedSecurityGroupTrade: ResolverTypeWrapper<TradePreviewExpectedSecurityGroupTrade>;
  TradePreviewExpectedSecurityTrade: ResolverTypeWrapper<TradePreviewExpectedSecurityTrade>;
  TradePreviewExpectedTrade: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['TradePreviewExpectedTrade']>;
  TradePreviewExpectedTradeAction: TradePreviewExpectedTradeAction;
  TradePreviewTradingInstruction: TradePreviewTradingInstruction;
  Trust: ResolverTypeWrapper<Omit<Trust, 'individualGrantor'> & { individualGrantor?: Maybe<ResolversTypes['Client']> }>;
  URL: ResolverTypeWrapper<Scalars['URL']['output']>;
  UnenrollClientFromSecuritiesLendingMutationInput: UnenrollClientFromSecuritiesLendingMutationInput;
  UnenrollClientFromSecuritiesLendingMutationPayload: ResolverTypeWrapper<UnenrollClientFromSecuritiesLendingMutationPayload>;
  UpdateBillingPlanPaymentTypesMutationInput: UpdateBillingPlanPaymentTypesMutationInput;
  UpdateBillingPlanPaymentTypesMutationPayload: ResolverTypeWrapper<Omit<UpdateBillingPlanPaymentTypesMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Firm']> }>;
  UpdateClientEnvelopeBankAccountsMutationInput: UpdateClientEnvelopeBankAccountsMutationInput;
  UpdateClientEnvelopeBankAccountsMutationPayload: ResolverTypeWrapper<UpdateClientEnvelopeBankAccountsMutationPayload>;
  UpdateClientEnvelopeBeneficiariesMutationInput: UpdateClientEnvelopeBeneficiariesMutationInput;
  UpdateClientEnvelopeBeneficiariesMutationPayload: ResolverTypeWrapper<UpdateClientEnvelopeBeneficiariesMutationPayload>;
  UpdateDefaultBillingPlanMutationInput: UpdateDefaultBillingPlanMutationInput;
  UpdateDefaultBillingPlanMutationPayload: ResolverTypeWrapper<Omit<UpdateDefaultBillingPlanMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Firm']> }>;
  UpdateHouseholdBillingPlanMutationInput: UpdateHouseholdBillingPlanMutationInput;
  UpdateHouseholdBillingPlanMutationPayload: ResolverTypeWrapper<Omit<UpdateHouseholdBillingPlanMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Household']> }>;
  UpdateManagedPortfolioRebalancingMutationInput: UpdateManagedPortfolioRebalancingMutationInput;
  UpdateManagedPortfolioRebalancingMutationPayload: ResolverTypeWrapper<Omit<UpdateManagedPortfolioRebalancingMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['ManagedPortfolio']> }>;
  UpdateOutboundIntegrationSubscriptionMutationInput: UpdateOutboundIntegrationSubscriptionMutationInput;
  UpdateOutboundIntegrationSubscriptionMutationPayload: ResolverTypeWrapper<UpdateOutboundIntegrationSubscriptionMutationPayload>;
  UpdatePlanFeedConsentMutationInput: UpdatePlanFeedConsentMutationInput;
  UpdatePlanFeedConsentMutationPayload: ResolverTypeWrapper<Omit<UpdatePlanFeedConsentMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['FourOhOneKPlan']> }>;
  UpdateQdiaFundLineupMutationInput: UpdateQdiaFundLineupMutationInput;
  UpdateQdiaFundLineupMutationPayload: ResolverTypeWrapper<UpdateQdiaFundLineupMutationPayload>;
  UpdateSolo401kConversionIntentContributionsMutationInput: UpdateSolo401kConversionIntentContributionsMutationInput;
  UpdateSolo401kConversionIntentContributionsMutationPayload: ResolverTypeWrapper<Omit<UpdateSolo401kConversionIntentContributionsMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Solo401kConversionIntent']> }>;
  UpdateSolo401kConversionIntentFundsTypeMutationInput: UpdateSolo401kConversionIntentFundsTypeMutationInput;
  UpdateSolo401kConversionIntentFundsTypeMutationPayload: ResolverTypeWrapper<Omit<UpdateSolo401kConversionIntentFundsTypeMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Solo401kConversionIntent']> }>;
  UpsertBillingPlanInput: UpsertBillingPlanInput;
  UpsertBillingPlanMutationInput: UpsertBillingPlanMutationInput;
  UpsertBillingPlanMutationPayload: ResolverTypeWrapper<Omit<UpsertBillingPlanMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Firm']> }>;
  UserPortfolioControls: ResolverTypeWrapper<UserPortfolioControls>;
  ValidCents: ResolverTypeWrapper<ValidCents>;
  ValidateClientEnvelopeBeneficiaryMutationInput: ValidateClientEnvelopeBeneficiaryMutationInput;
  ValidateClientEnvelopeBeneficiaryMutationPayload: ResolverTypeWrapper<ValidateClientEnvelopeBeneficiaryMutationPayload>;
  ValidateFinancialSecurityOrderRequest: ResolverTypeWrapper<ValidateFinancialSecurityOrderRequest>;
  ValidateFinancialSecurityOrderRequestMutationInput: ValidateFinancialSecurityOrderRequestMutationInput;
  ValidateFinancialSecurityOrderRequestMutationPayload: ResolverTypeWrapper<ValidateFinancialSecurityOrderRequestMutationPayload>;
  ValidateSolo401kConversionIntentMutationInput: ValidateSolo401kConversionIntentMutationInput;
  ValidateSolo401kConversionIntentMutationPayload: ResolverTypeWrapper<Omit<ValidateSolo401kConversionIntentMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['Solo401kConversionIntent']> }>;
  ValidateSolo401kPlanFormMutationInput: ValidateSolo401kPlanFormMutationInput;
  ValidateSolo401kPlanFormMutationPayload: ResolverTypeWrapper<ValidateSolo401kPlanFormMutationPayload>;
  ValidatedSolo401kPlanForm: ResolverTypeWrapper<ValidatedSolo401kPlanForm>;
  Vested: ResolverTypeWrapper<Vested>;
  YtdReturn: ResolverTypeWrapper<YtdReturn>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AccountHolder: ResolversInterfaceTypes<ResolversParentTypes>['AccountHolder'];
  AccountYtdReturn: AccountYtdReturn;
  ActivityFilterInput: ActivityFilterInput;
  ActivityItem: ResolversInterfaceTypes<ResolversParentTypes>['ActivityItem'];
  ActivityItemAllocationChange: Omit<ActivityItemAllocationChange, 'subAccount'> & { subAccount: ResolversParentTypes['LegalSubAccount'] };
  ActivityItemConnection: Omit<ActivityItemConnection, 'edges' | 'nodes'> & { edges: Array<ResolversParentTypes['ActivityItemEdge']>, nodes: Array<ResolversParentTypes['ActivityItem']> };
  ActivityItemDeposit: Omit<ActivityItemDeposit, 'destinationAccount' | 'subAccount'> & { destinationAccount: ResolversParentTypes['LegalSubAccount'], subAccount: ResolversParentTypes['LegalSubAccount'] };
  ActivityItemEdge: Omit<ActivityItemEdge, 'node'> & { node: ResolversParentTypes['ActivityItem'] };
  ActivityItemFee: Omit<ActivityItemFee, 'subAccount'> & { subAccount: ResolversParentTypes['LegalSubAccount'] };
  ActivityItemOrder: Omit<ActivityItemOrder, 'security' | 'subAccount'> & { security: ResolversParentTypes['Security'], subAccount: ResolversParentTypes['LegalSubAccount'] };
  ActivityItemOther: Omit<ActivityItemOther, 'subAccount'> & { subAccount: ResolversParentTypes['LegalSubAccount'] };
  ActivityItemStatus: ActivityItemStatus;
  ActivityItemTrade: Omit<ActivityItemTrade, 'security'> & { security: ResolversParentTypes['Security'] };
  ActivityItemTradeGroup: Omit<ActivityItemTradeGroup, 'purchases' | 'sales' | 'subAccount'> & { purchases: Array<ResolversParentTypes['ActivityItemTrade']>, sales: Array<ResolversParentTypes['ActivityItemTrade']>, subAccount: ResolversParentTypes['LegalSubAccount'] };
  ActivityItemTransfer: Omit<ActivityItemTransfer, 'destinationAccount' | 'security' | 'sourceAccount'> & { destinationAccount?: Maybe<ResolversParentTypes['LegalSubAccount']>, security?: Maybe<ResolversParentTypes['Security']>, sourceAccount?: Maybe<ResolversParentTypes['LegalSubAccount']> };
  ActivityItemTransferGroup: Omit<ActivityItemTransferGroup, 'destinationAccount' | 'sourceAccount' | 'subAccount' | 'transferItems'> & { destinationAccount?: Maybe<ResolversParentTypes['LegalSubAccount']>, sourceAccount?: Maybe<ResolversParentTypes['LegalSubAccount']>, subAccount: ResolversParentTypes['LegalSubAccount'], transferItems: Array<ResolversParentTypes['ActivityItemTransfer']> };
  ActivityItemWithdrawal: Omit<ActivityItemWithdrawal, 'sourceAccount' | 'subAccount'> & { sourceAccount: ResolversParentTypes['LegalSubAccount'], subAccount: ResolversParentTypes['LegalSubAccount'] };
  AdvisedPlan: ResolversUnionTypes<ResolversParentTypes>['AdvisedPlan'];
  Advisor: Omit<Advisor, 'firm' | 'messages'> & { firm: ResolversParentTypes['Firm'], messages: Array<ResolversParentTypes['Message']> };
  AdvisorGoalCreation: AdvisorGoalCreation;
  AdvisorGoalCreationAccount: AdvisorGoalCreationAccount;
  AffectedHousehold: AffectedHousehold;
  AgreementDocument: ResolversInterfaceTypes<ResolversParentTypes>['AgreementDocument'];
  Announcement: Announcement;
  AnnouncementDismissal: AnnouncementDismissal;
  AnnouncementRedirect: AnnouncementRedirect;
  AnnouncementStep: AnnouncementStep;
  AnnouncementStepCta: AnnouncementStepCta;
  AnnouncementStepImage: AnnouncementStepImage;
  Annual: Annual;
  AnnualIraContributions: AnnualIraContributions;
  AssignedAccountSummary: AssignedAccountSummary;
  Autoglide: Autoglide;
  BankAccount: BankAccount;
  BettermentModelPortfolio: BettermentModelPortfolio;
  BillingPlan: Omit<BillingPlan, 'billingRate' | 'platformFeeAllocation'> & { billingRate: ResolversParentTypes['BillingRate'], platformFeeAllocation: ResolversParentTypes['PlatformFeeAllocation'] };
  BillingPlanPaymentTypeInput: BillingPlanPaymentTypeInput;
  BillingRate: ResolversUnionTypes<ResolversParentTypes>['BillingRate'];
  BillingRateAssetBased: BillingRateAssetBased;
  BillingRateAssetBasedInput: BillingRateAssetBasedInput;
  BillingRateFixed: BillingRateFixed;
  BillingRateFixedInput: BillingRateFixedInput;
  BillingRateInput: BillingRateInput;
  BillingRateRange: Omit<BillingRateRange, 'firmFee'> & { firmFee: ResolversParentTypes['SingleBillingRate'] };
  BillingRateRangeInput: BillingRateRangeInput;
  BillingRateTiered: Omit<BillingRateTiered, 'tiers'> & { tiers: Array<ResolversParentTypes['BillingRateRange']> };
  BillingRateTieredInput: BillingRateTieredInput;
  BlockingTask: BlockingTask;
  Boolean: Scalars['Boolean']['output'];
  Bps: Scalars['Bps']['output'];
  BulkFeeAttempt: Omit<BulkFeeAttempt, 'feeAttempts'> & { feeAttempts: ResolversParentTypes['FeeAttemptsResult'] };
  BulkFeeIntent: Omit<BulkFeeIntent, 'createdBy'> & { createdBy?: Maybe<ResolversParentTypes['Advisor']> };
  BulkTransferPendingAction: BulkTransferPendingAction;
  CashAccount: Omit<CashAccount, 'accountHolders' | 'envelope' | 'legalAccount' | 'messages' | 'recurringTransactionConfigs' | 'users'> & { accountHolders: Array<ResolversParentTypes['AccountHolder']>, envelope: ResolversParentTypes['Envelope'], legalAccount: ResolversParentTypes['LegalAccount'], messages: Array<ResolversParentTypes['Message']>, recurringTransactionConfigs: Array<ResolversParentTypes['RecurringTransactionConfig']>, users: Array<ResolversParentTypes['Client']> };
  CashApy: CashApy;
  CashFdicInsurance: CashFdicInsurance;
  Cents: Scalars['Cents']['output'];
  Client: Omit<Client, 'employers' | 'household'> & { employers: Array<ResolversParentTypes['Employer']>, household: ResolversParentTypes['Household'] };
  ClientAccountBeneficiary: ClientAccountBeneficiary;
  ClientAccountBeneficiaryInput: ClientAccountBeneficiaryInput;
  ClientAccountTypeSummary: ClientAccountTypeSummary;
  ClientEnvelope: ClientEnvelope;
  ClientEnvelopeBankAccount: ClientEnvelopeBankAccount;
  ClientEnvelopeBankAccountInput: ClientEnvelopeBankAccountInput;
  ClientEnvelopeClient: ClientEnvelopeClient;
  ClientEnvelopeInterface: ResolversInterfaceTypes<ResolversParentTypes>['ClientEnvelopeInterface'];
  ClientEnvelopeInvitation: ClientEnvelopeInvitation;
  Contribution: Contribution;
  ContributionDetailInput: ContributionDetailInput;
  CreateBulkFeeIntentMutationInput: CreateBulkFeeIntentMutationInput;
  CreateBulkFeeIntentMutationPayload: Omit<CreateBulkFeeIntentMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['BulkFeeIntent']> };
  CreateClientActivityCsvExportMutationInput: CreateClientActivityCsvExportMutationInput;
  CreateClientActivityCsvExportMutationPayload: CreateClientActivityCsvExportMutationPayload;
  CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationInput: CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationInput;
  CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationPayload: Omit<CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Solo401kConversionIntent']> };
  CreateDraftSolo401kConversionIntentMutationInput: CreateDraftSolo401kConversionIntentMutationInput;
  CreateDraftSolo401kConversionIntentMutationPayload: Omit<CreateDraftSolo401kConversionIntentMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Solo401kConversionIntent']> };
  CreateFinancialSecurityOrderRequestMutationInput: CreateFinancialSecurityOrderRequestMutationInput;
  CreateFinancialSecurityOrderRequestMutationPayload: CreateFinancialSecurityOrderRequestMutationPayload;
  CreateFinancialSecuritySellOrderTaxImpactPreviewMutationInput: CreateFinancialSecuritySellOrderTaxImpactPreviewMutationInput;
  CreateFinancialSecuritySellOrderTaxImpactPreviewMutationPayload: CreateFinancialSecuritySellOrderTaxImpactPreviewMutationPayload;
  CreateFirmBillableAccountsCsvExportMutationPayload: CreateFirmBillableAccountsCsvExportMutationPayload;
  CreateFourOhOneKReportInputArguments: CreateFourOhOneKReportInputArguments;
  CreateFourOhOneKReportMutationInput: CreateFourOhOneKReportMutationInput;
  CreateFourOhOneKReportMutationPayload: CreateFourOhOneKReportMutationPayload;
  CreateFourOhOneKReportPayload: CreateFourOhOneKReportPayload;
  CreateFourOhOneKRequestForProposalMutationInput: CreateFourOhOneKRequestForProposalMutationInput;
  CreateFourOhOneKRequestForProposalMutationPayload: CreateFourOhOneKRequestForProposalMutationPayload;
  CreateFourOhOneKRequestForProposalResult: CreateFourOhOneKRequestForProposalResult;
  CreateTradePreviewMutationInput: CreateTradePreviewMutationInput;
  CreateTradePreviewMutationPayload: Omit<CreateTradePreviewMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['TradePreview']> };
  CsvExport: CsvExport;
  Date: Scalars['Date']['output'];
  DateTime: Scalars['DateTime']['output'];
  Dictionary: Dictionary;
  DirectTradingAccount: Omit<DirectTradingAccount, 'accountHolders' | 'envelope' | 'legalAccount' | 'messages' | 'securityPositions' | 'users'> & { accountHolders: Array<ResolversParentTypes['AccountHolder']>, envelope: ResolversParentTypes['Envelope'], legalAccount: ResolversParentTypes['LegalAccount'], messages: Array<ResolversParentTypes['Message']>, securityPositions: Array<ResolversParentTypes['DirectTradingSecurityPosition']>, users: Array<ResolversParentTypes['Client']> };
  DirectTradingCashBalances: DirectTradingCashBalances;
  DirectTradingSecurityPosition: Omit<DirectTradingSecurityPosition, 'financialSecurity'> & { financialSecurity: ResolversParentTypes['FinancialSecurity'] };
  DirectTradingSecurityPositionReturn: DirectTradingSecurityPositionReturn;
  Disclosures: Disclosures;
  DismissAnnouncementMutationInput: DismissAnnouncementMutationInput;
  DismissAnnouncementMutationPayload: DismissAnnouncementMutationPayload;
  DismissCsvActivityExportBannerMutationPayload: DismissCsvActivityExportBannerMutationPayload;
  DismissFirmBillableAccountsCsvExportMutationPayload: DismissFirmBillableAccountsCsvExportMutationPayload;
  DisplayableError: DisplayableError;
  DocumentModelPortfolioResource: DocumentModelPortfolioResource;
  Drift: Drift;
  EmailDispatch: EmailDispatch;
  Employer: Omit<Employer, 'contributionConfig' | 'soloFourOhOneKPlan'> & { contributionConfig?: Maybe<ResolversParentTypes['EmployerConfig']>, soloFourOhOneKPlan?: Maybe<ResolversParentTypes['SoloFourOhOneKPlan']> };
  EmployerConfig: EmployerConfig;
  EmployerContributions: EmployerContributions;
  EmployerResult: EmployerResult;
  Envelope: Omit<Envelope, 'accounts' | 'purpose' | 'user'> & { accounts: Array<ResolversParentTypes['EnvelopeAccount']>, purpose?: Maybe<ResolversParentTypes['Purpose']>, user: ResolversParentTypes['Client'] };
  EnvelopeAccount: ResolversInterfaceTypes<ResolversParentTypes>['EnvelopeAccount'];
  EnvelopeYtdReturn: EnvelopeYtdReturn;
  EstimatedTradeDate: EstimatedTradeDate;
  EstimatedTradeTimeRange: EstimatedTradeTimeRange;
  EstimatedTradeTiming: ResolversUnionTypes<ResolversParentTypes>['EstimatedTradeTiming'];
  ExecutedAgreement: ExecutedAgreement;
  ExpenseRatio: ExpenseRatio;
  ExternallyAdvisedPlanPortfolio: ExternallyAdvisedPlanPortfolio;
  FeeAttempt: Omit<FeeAttempt, 'account'> & { account: ResolversParentTypes['LegalSubAccount'] };
  FeeAttemptBatch: Omit<FeeAttemptBatch, 'attempts'> & { attempts: Array<ResolversParentTypes['FeeAttempt']> };
  FeeAttemptFailure: Omit<FeeAttemptFailure, 'account' | 'amount'> & { account: ResolversParentTypes['FeeAttemptInputAccount'], amount: ResolversParentTypes['FeeAttemptInputAmount'] };
  FeeAttemptInputAccount: ResolversUnionTypes<ResolversParentTypes>['FeeAttemptInputAccount'];
  FeeAttemptInputAmount: ResolversUnionTypes<ResolversParentTypes>['FeeAttemptInputAmount'];
  FeeAttemptsResult: ResolversUnionTypes<ResolversParentTypes>['FeeAttemptsResult'];
  FeeConfiguration: FeeConfiguration;
  FinancialSecurity: ResolversInterfaceTypes<ResolversParentTypes>['FinancialSecurity'];
  FinancialSecurityFund: FinancialSecurityFund;
  FinancialSecurityOrderRequest: FinancialSecurityOrderRequest;
  FinancialSecurityOrderRequestValueInput: FinancialSecurityOrderRequestValueInput;
  FinancialSecuritySellOrderTaxImpactPreview: FinancialSecuritySellOrderTaxImpactPreview;
  FinancialSecurityStock: FinancialSecurityStock;
  Firm: Omit<Firm, 'billingPlan' | 'billingPlans' | 'bulkFeeAttempt' | 'bulkFeeIntents'> & { billingPlan?: Maybe<ResolversParentTypes['BillingPlan']>, billingPlans: Array<ResolversParentTypes['BillingPlan']>, bulkFeeAttempt?: Maybe<ResolversParentTypes['BulkFeeAttempt']>, bulkFeeIntents: Array<ResolversParentTypes['BulkFeeIntent']> };
  Float: Scalars['Float']['output'];
  FourOhOneKDocument: FourOhOneKDocument;
  FourOhOneKOnboardingTask: FourOhOneKOnboardingTask;
  FourOhOneKPlan: ResolversInterfaceTypes<ResolversParentTypes>['FourOhOneKPlan'];
  FourOhOneKPlanFiduciary: FourOhOneKPlanFiduciary;
  FourOhOneKPlanManager: FourOhOneKPlanManager;
  FourOhOneKPlanOnboarding: FourOhOneKPlanOnboarding;
  FourOhOneKPlanPerformanceIndicators: FourOhOneKPlanPerformanceIndicators;
  FourOhOneKPlanSupportAgent: FourOhOneKPlanSupportAgent;
  FourOhOneKPlanSupportResource: FourOhOneKPlanSupportResource;
  FourOhOneKPlansWhereInput: FourOhOneKPlansWhereInput;
  FourOhOneKReport: FourOhOneKReport;
  FourOhOneKReportCreationOption: FourOhOneKReportCreationOption;
  FourOhOneKReportInputOption: FourOhOneKReportInputOption;
  FourOhOneKThirdPartyAdministrator: FourOhOneKThirdPartyAdministrator;
  FuturePortfolio: FuturePortfolio;
  Gains: Gains;
  GainsDetails: GainsDetails;
  HTML: Scalars['HTML']['output'];
  HistoricalPerformance: HistoricalPerformance;
  Household: Omit<Household, 'accountYtdReturns' | 'accounts' | 'billingPlan' | 'envelopes' | 'members' | 'messages'> & { accountYtdReturns: Array<ResolversParentTypes['AccountYtdReturn']>, accounts: Array<ResolversParentTypes['EnvelopeAccount']>, billingPlan: ResolversParentTypes['BillingPlan'], envelopes: Array<ResolversParentTypes['Envelope']>, members: Array<ResolversParentTypes['Client']>, messages: Array<ResolversParentTypes['Message']> };
  HouseholdResult: ResolversUnionTypes<ResolversParentTypes>['HouseholdResult'];
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  InvalidAccountString: InvalidAccountString;
  InvalidAmountString: InvalidAmountString;
  InvalidFeeAttemptBatch: Omit<InvalidFeeAttemptBatch, 'failures'> & { failures: Array<ResolversParentTypes['FeeAttemptFailure']> };
  IraContributions: IraContributions;
  IraContributionsByYearWhere: IraContributionsByYearWhere;
  IraContributionsProjection: IraContributionsProjection;
  IraContributionsResult: IraContributionsResult;
  LegacyGoal: LegacyGoal;
  LegacyID: Scalars['LegacyID']['output'];
  LegacySecurity: LegacySecurity;
  LegacySubAccount: LegacySubAccount;
  LegacyUUID: Scalars['LegacyUUID']['output'];
  LegalAccount: Omit<LegalAccount, 'primaryBeneficiaries' | 'soloFourOhOneKPlan'> & { primaryBeneficiaries: Array<ResolversParentTypes['LegalAccountBeneficiary']>, soloFourOhOneKPlan?: Maybe<ResolversParentTypes['SoloFourOhOneKPlan']> };
  LegalAccountBeneficiary: LegalAccountBeneficiary;
  LegalSubAccount: ResolversInterfaceTypes<ResolversParentTypes>['LegalSubAccount'];
  LinkModelPortfolioResource: LinkModelPortfolioResource;
  Logo: Logo;
  ManagedAccount: Omit<ManagedAccount, 'accountHolders' | 'envelope' | 'messages' | 'payrollContributionConfigs' | 'pendingActions' | 'portfolio' | 'recurringTransactionConfigs' | 'securityGroupPositions' | 'subAccount' | 'subAccounts' | 'users'> & { accountHolders: Array<ResolversParentTypes['AccountHolder']>, envelope: ResolversParentTypes['Envelope'], messages: Array<ResolversParentTypes['Message']>, payrollContributionConfigs: Array<ResolversParentTypes['PayrollContributionConfig']>, pendingActions: Array<ResolversParentTypes['ManagedAccountPendingAction']>, portfolio: ResolversParentTypes['ManagedPortfolio'], recurringTransactionConfigs: Array<ResolversParentTypes['RecurringTransactionConfig']>, securityGroupPositions: Array<ResolversParentTypes['SecurityGroupPosition']>, subAccount?: Maybe<ResolversParentTypes['ManagedSubAccount']>, subAccounts: Array<ResolversParentTypes['ManagedSubAccount']>, users: Array<ResolversParentTypes['Client']> };
  ManagedAccountPendingAction: ResolversUnionTypes<ResolversParentTypes>['ManagedAccountPendingAction'];
  ManagedPortfolio: ResolversInterfaceTypes<ResolversParentTypes>['ManagedPortfolio'];
  ManagedSubAccount: Omit<ManagedSubAccount, 'envelope' | 'legalAccount' | 'users'> & { envelope: ResolversParentTypes['Envelope'], legalAccount: ResolversParentTypes['LegalAccount'], users: Array<ResolversParentTypes['Client']> };
  Message: Omit<Message, 'cta'> & { cta?: Maybe<ResolversParentTypes['MessageCta']> };
  MessageCta: ResolversInterfaceTypes<ResolversParentTypes>['MessageCta'];
  MessageCtaLink: MessageCtaLink;
  MessageCtaModal: MessageCtaModal;
  ModelPortfolioProvider: Omit<ModelPortfolioProvider, 'modelPortfolios'> & { modelPortfolios: ResolversParentTypes['ProviderModelPortfolioConnection'] };
  ModelPortfolioProviderConnection: ModelPortfolioProviderConnection;
  ModelPortfolioProviderEdge: ModelPortfolioProviderEdge;
  ModelPortfolioResource: ResolversInterfaceTypes<ResolversParentTypes>['ModelPortfolioResource'];
  ModelPortfolioRiskLevel: Omit<ModelPortfolioRiskLevel, 'securityGroupAllocations'> & { securityGroupAllocations: Array<ResolversParentTypes['RiskLevelSecurityGroupAllocation']> };
  ModelPortfolioSecurityGroup: Omit<ModelPortfolioSecurityGroup, 'primarySecurityTaxDeferred' | 'primarySecurityTaxable' | 'secondarySecurityTaxDeferred' | 'secondarySecurityTaxable'> & { primarySecurityTaxDeferred: ResolversParentTypes['FinancialSecurity'], primarySecurityTaxable: ResolversParentTypes['FinancialSecurity'], secondarySecurityTaxDeferred?: Maybe<ResolversParentTypes['FinancialSecurity']>, secondarySecurityTaxable?: Maybe<ResolversParentTypes['FinancialSecurity']> };
  Mutation: Record<PropertyKey, never>;
  NotSharedPlatformFeeAllocation: NotSharedPlatformFeeAllocation;
  NotSharedPlatformFeeInput: NotSharedPlatformFeeInput;
  OutboundIntegration: OutboundIntegration;
  PageInfo: PageInfo;
  PayrollContributionConfig: Omit<PayrollContributionConfig, 'bonusValue' | 'value'> & { bonusValue?: Maybe<ResolversParentTypes['PayrollContributionConfigValue']>, value: ResolversParentTypes['PayrollContributionConfigValue'] };
  PayrollContributionConfigAccount: ResolversInterfaceTypes<ResolversParentTypes>['PayrollContributionConfigAccount'];
  PayrollContributionConfigValue: ResolversUnionTypes<ResolversParentTypes>['PayrollContributionConfigValue'];
  PayrollContributionConfigValueAmount: PayrollContributionConfigValueAmount;
  PayrollContributionConfigValuePercent: PayrollContributionConfigValuePercent;
  PendingAction: ResolversInterfaceTypes<ResolversParentTypes>['PendingAction'];
  Percent: Scalars['Percent']['output'];
  Performance: Performance;
  PerformanceAccount: ResolversInterfaceTypes<ResolversParentTypes>['PerformanceAccount'];
  PerformanceHistory: PerformanceHistory;
  PerformanceInterest: PerformanceInterest;
  PerformanceTotals: PerformanceTotals;
  PlatformFeeAllocation: ResolversUnionTypes<ResolversParentTypes>['PlatformFeeAllocation'];
  PlatformFeeAllocationInput: PlatformFeeAllocationInput;
  PlatformFeeTier: PlatformFeeTier;
  PortfolioChangePendingAction: ResolversInterfaceTypes<ResolversParentTypes>['PortfolioChangePendingAction'];
  PortfolioMigrationPendingAction: PortfolioMigrationPendingAction;
  Projection: Projection;
  ProviderModelPortfolio: Omit<ProviderModelPortfolio, 'defaultRiskLevel' | 'resources'> & { defaultRiskLevel: ResolversParentTypes['ModelPortfolioRiskLevel'], resources: Array<ResolversParentTypes['ModelPortfolioResource']> };
  ProviderModelPortfolioConnection: Omit<ProviderModelPortfolioConnection, 'edges' | 'nodes'> & { edges: Array<ResolversParentTypes['ProviderModelPortfolioEdge']>, nodes: Array<ResolversParentTypes['ProviderModelPortfolio']> };
  ProviderModelPortfolioEdge: Omit<ProviderModelPortfolioEdge, 'node'> & { node: ResolversParentTypes['ProviderModelPortfolio'] };
  PublishSolo401kConversionIntentMutationInput: PublishSolo401kConversionIntentMutationInput;
  PublishSolo401kConversionIntentMutationPayload: Omit<PublishSolo401kConversionIntentMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Solo401kConversionIntent']> };
  Purpose: ResolversInterfaceTypes<ResolversParentTypes>['Purpose'];
  PurposeEmergencyFund: PurposeEmergencyFund;
  PurposeMajorPurchase: PurposeMajorPurchase;
  PurposeRetirementGrowth: PurposeRetirementGrowth;
  PurposeRetirementIncome: PurposeRetirementIncome;
  PurposeRetirementIncomeProjection: PurposeRetirementIncomeProjection;
  Query: Record<PropertyKey, never>;
  Rebalance: Rebalance;
  RebalanceNowPendingAction: RebalanceNowPendingAction;
  RecordNotFoundResult: RecordNotFoundResult;
  RecurringTransactionConfig: Omit<RecurringTransactionConfig, 'frequency' | 'source'> & { frequency: ResolversParentTypes['RecurringTransactionFrequency'], source?: Maybe<ResolversParentTypes['CashAccount']> };
  RecurringTransactionFrequency: ResolversUnionTypes<ResolversParentTypes>['RecurringTransactionFrequency'];
  RecurringTransactionFrequencyAnnually: RecurringTransactionFrequencyAnnually;
  RecurringTransactionFrequencyEveryOtherWeek: RecurringTransactionFrequencyEveryOtherWeek;
  RecurringTransactionFrequencyMonthly: RecurringTransactionFrequencyMonthly;
  RecurringTransactionFrequencyTwiceAMonth: RecurringTransactionFrequencyTwiceAMonth;
  RecurringTransactionFrequencyWeekly: RecurringTransactionFrequencyWeekly;
  RemoveSolo401kQdiaFundLineupMutationInput: RemoveSolo401kQdiaFundLineupMutationInput;
  RemoveSolo401kQdiaFundLineupMutationPayload: RemoveSolo401kQdiaFundLineupMutationPayload;
  Result: Result;
  RiskLevelBasedPortfolio: RiskLevelBasedPortfolio;
  RiskLevelSecurityGroupAllocation: Omit<RiskLevelSecurityGroupAllocation, 'securityGroup'> & { securityGroup: ResolversParentTypes['ModelPortfolioSecurityGroup'] };
  SblocLoan: SblocLoan;
  SecuritiesLending: SecuritiesLending;
  Security: ResolversInterfaceTypes<ResolversParentTypes>['Security'];
  SecurityCategoryGroup: SecurityCategoryGroup;
  SecurityFund: SecurityFund;
  SecurityGroupPosition: Omit<SecurityGroupPosition, 'securityGroup' | 'securityPositions' | 'securityPositionsBySecurity'> & { securityGroup: ResolversParentTypes['SecurityGroupSummary'], securityPositions: Array<ResolversParentTypes['SecurityPosition']>, securityPositionsBySecurity: Array<ResolversParentTypes['SecurityPositionsBySecurity']> };
  SecurityGroupSummary: Omit<SecurityGroupSummary, 'securities' | 'sellOnlySubstituteSecurities'> & { securities: Array<ResolversParentTypes['Security']>, sellOnlySubstituteSecurities: Array<ResolversParentTypes['FinancialSecurity']> };
  SecurityPosition: Omit<SecurityPosition, 'financialSecurity' | 'security'> & { financialSecurity: ResolversParentTypes['FinancialSecurity'], security: ResolversParentTypes['Security'] };
  SecurityPositionsBySecurity: Omit<SecurityPositionsBySecurity, 'financialSecurity' | 'securityPositionsBySubAccount'> & { financialSecurity: ResolversParentTypes['FinancialSecurity'], securityPositionsBySubAccount: Array<ResolversParentTypes['SecurityPositionsBySubAccount']> };
  SecurityPositionsBySubAccount: Omit<SecurityPositionsBySubAccount, 'securityPositions' | 'subAccount'> & { securityPositions: Array<ResolversParentTypes['SecurityPosition']>, subAccount: ResolversParentTypes['LegalSubAccount'] };
  SecurityStock: SecurityStock;
  SelfDirectedPortfolio: SelfDirectedPortfolio;
  SendClientSecuritiesLendingInvitationMutationInput: SendClientSecuritiesLendingInvitationMutationInput;
  SendClientSecuritiesLendingInvitationMutationPayload: SendClientSecuritiesLendingInvitationMutationPayload;
  SharedPlatformFeeAllocation: SharedPlatformFeeAllocation;
  SharedPlatformFeeInput: SharedPlatformFeeInput;
  SingleBillingRate: ResolversUnionTypes<ResolversParentTypes>['SingleBillingRate'];
  SingleBillingRateInput: SingleBillingRateInput;
  Solo401kClientEnvelope: Solo401kClientEnvelope;
  Solo401kConversionContributionDetail: Solo401kConversionContributionDetail;
  Solo401kConversionIntent: Omit<Solo401kConversionIntent, 'planOwner' | 'planSpouse'> & { planOwner: ResolversParentTypes['Client'], planSpouse?: Maybe<ResolversParentTypes['Client']> };
  Solo401kPlan: Solo401kPlan;
  Solo401kPlanBusinessInfo: Solo401kPlanBusinessInfo;
  SoloFourOhOneKParticipant: SoloFourOhOneKParticipant;
  SoloFourOhOneKPlan: Omit<SoloFourOhOneKPlan, 'documents' | 'messages'> & { documents: Array<ResolversParentTypes['FourOhOneKDocument']>, messages: Array<ResolversParentTypes['Message']> };
  StandardFourOhOneKPlan: Omit<StandardFourOhOneKPlan, 'messages'> & { messages: Array<ResolversParentTypes['Message']> };
  StrategyChangePendingAction: StrategyChangePendingAction;
  String: Scalars['String']['output'];
  Summary: Summary;
  SupportContact: SupportContact;
  SupportResources: SupportResources;
  TIN: Scalars['TIN']['output'];
  TaxImpact: TaxImpact;
  TaxYear: TaxYear;
  ThemedAsset: ThemedAsset;
  TradePreview: Omit<TradePreview, 'expectedTrades'> & { expectedTrades: Array<ResolversParentTypes['TradePreviewExpectedTrade']> };
  TradePreviewExpectedSecurityGroupTrade: TradePreviewExpectedSecurityGroupTrade;
  TradePreviewExpectedSecurityTrade: TradePreviewExpectedSecurityTrade;
  TradePreviewExpectedTrade: ResolversUnionTypes<ResolversParentTypes>['TradePreviewExpectedTrade'];
  Trust: Omit<Trust, 'individualGrantor'> & { individualGrantor?: Maybe<ResolversParentTypes['Client']> };
  URL: Scalars['URL']['output'];
  UnenrollClientFromSecuritiesLendingMutationInput: UnenrollClientFromSecuritiesLendingMutationInput;
  UnenrollClientFromSecuritiesLendingMutationPayload: UnenrollClientFromSecuritiesLendingMutationPayload;
  UpdateBillingPlanPaymentTypesMutationInput: UpdateBillingPlanPaymentTypesMutationInput;
  UpdateBillingPlanPaymentTypesMutationPayload: Omit<UpdateBillingPlanPaymentTypesMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Firm']> };
  UpdateClientEnvelopeBankAccountsMutationInput: UpdateClientEnvelopeBankAccountsMutationInput;
  UpdateClientEnvelopeBankAccountsMutationPayload: UpdateClientEnvelopeBankAccountsMutationPayload;
  UpdateClientEnvelopeBeneficiariesMutationInput: UpdateClientEnvelopeBeneficiariesMutationInput;
  UpdateClientEnvelopeBeneficiariesMutationPayload: UpdateClientEnvelopeBeneficiariesMutationPayload;
  UpdateDefaultBillingPlanMutationInput: UpdateDefaultBillingPlanMutationInput;
  UpdateDefaultBillingPlanMutationPayload: Omit<UpdateDefaultBillingPlanMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Firm']> };
  UpdateHouseholdBillingPlanMutationInput: UpdateHouseholdBillingPlanMutationInput;
  UpdateHouseholdBillingPlanMutationPayload: Omit<UpdateHouseholdBillingPlanMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Household']> };
  UpdateManagedPortfolioRebalancingMutationInput: UpdateManagedPortfolioRebalancingMutationInput;
  UpdateManagedPortfolioRebalancingMutationPayload: Omit<UpdateManagedPortfolioRebalancingMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['ManagedPortfolio']> };
  UpdateOutboundIntegrationSubscriptionMutationInput: UpdateOutboundIntegrationSubscriptionMutationInput;
  UpdateOutboundIntegrationSubscriptionMutationPayload: UpdateOutboundIntegrationSubscriptionMutationPayload;
  UpdatePlanFeedConsentMutationInput: UpdatePlanFeedConsentMutationInput;
  UpdatePlanFeedConsentMutationPayload: Omit<UpdatePlanFeedConsentMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['FourOhOneKPlan']> };
  UpdateQdiaFundLineupMutationInput: UpdateQdiaFundLineupMutationInput;
  UpdateQdiaFundLineupMutationPayload: UpdateQdiaFundLineupMutationPayload;
  UpdateSolo401kConversionIntentContributionsMutationInput: UpdateSolo401kConversionIntentContributionsMutationInput;
  UpdateSolo401kConversionIntentContributionsMutationPayload: Omit<UpdateSolo401kConversionIntentContributionsMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Solo401kConversionIntent']> };
  UpdateSolo401kConversionIntentFundsTypeMutationInput: UpdateSolo401kConversionIntentFundsTypeMutationInput;
  UpdateSolo401kConversionIntentFundsTypeMutationPayload: Omit<UpdateSolo401kConversionIntentFundsTypeMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Solo401kConversionIntent']> };
  UpsertBillingPlanInput: UpsertBillingPlanInput;
  UpsertBillingPlanMutationInput: UpsertBillingPlanMutationInput;
  UpsertBillingPlanMutationPayload: Omit<UpsertBillingPlanMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Firm']> };
  UserPortfolioControls: UserPortfolioControls;
  ValidCents: ValidCents;
  ValidateClientEnvelopeBeneficiaryMutationInput: ValidateClientEnvelopeBeneficiaryMutationInput;
  ValidateClientEnvelopeBeneficiaryMutationPayload: ValidateClientEnvelopeBeneficiaryMutationPayload;
  ValidateFinancialSecurityOrderRequest: ValidateFinancialSecurityOrderRequest;
  ValidateFinancialSecurityOrderRequestMutationInput: ValidateFinancialSecurityOrderRequestMutationInput;
  ValidateFinancialSecurityOrderRequestMutationPayload: ValidateFinancialSecurityOrderRequestMutationPayload;
  ValidateSolo401kConversionIntentMutationInput: ValidateSolo401kConversionIntentMutationInput;
  ValidateSolo401kConversionIntentMutationPayload: Omit<ValidateSolo401kConversionIntentMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['Solo401kConversionIntent']> };
  ValidateSolo401kPlanFormMutationInput: ValidateSolo401kPlanFormMutationInput;
  ValidateSolo401kPlanFormMutationPayload: ValidateSolo401kPlanFormMutationPayload;
  ValidatedSolo401kPlanForm: ValidatedSolo401kPlanForm;
  Vested: Vested;
  YtdReturn: YtdReturn;
};

export type ExpensiveDirectiveArgs = {
  reason: Scalars['String']['input'];
};

export type ExpensiveDirectiveResolver<Result, Parent, ContextType = any, Args = ExpensiveDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type OwnedDirectiveArgs = {
  by: Scalars['String']['input'];
};

export type OwnedDirectiveResolver<Result, Parent, ContextType = any, Args = OwnedDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AccountHolderResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountHolder'] = ResolversParentTypes['AccountHolder']> = {
  __resolveType: TypeResolveFn<'Client' | 'Trust', ParentType, ContextType>;
};

export type AccountYtdReturnResolvers<ContextType = any, ParentType extends ResolversParentTypes['AccountYtdReturn'] = ResolversParentTypes['AccountYtdReturn']> = {
  accountId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ytdReturn?: Resolver<Maybe<ResolversTypes['YtdReturn']>, ParentType, ContextType>;
};

export type ActivityItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItem'] = ResolversParentTypes['ActivityItem']> = {
  __resolveType: TypeResolveFn<'ActivityItemAllocationChange' | 'ActivityItemDeposit' | 'ActivityItemFee' | 'ActivityItemOrder' | 'ActivityItemOther' | 'ActivityItemTradeGroup' | 'ActivityItemTransferGroup' | 'ActivityItemWithdrawal', ParentType, ContextType>;
};

export type ActivityItemAllocationChangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemAllocationChange'] = ResolversParentTypes['ActivityItemAllocationChange']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  newPortfolioDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemConnection'] = ResolversParentTypes['ActivityItemConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ActivityItemEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ActivityItem']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
};

export type ActivityItemDepositResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemDeposit'] = ResolversParentTypes['ActivityItemDeposit']> = {
  amount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  depositRequestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  destinationAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  memo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  returned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccount?: Resolver<Maybe<ResolversTypes['BankAccount']>, ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemEdge'] = ResolversParentTypes['ActivityItemEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ActivityItem'], ParentType, ContextType>;
};

export type ActivityItemFeeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemFee'] = ResolversParentTypes['ActivityItemFee']> = {
  amount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  feeReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemOrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemOrder'] = ResolversParentTypes['ActivityItemOrder']> = {
  activityReportsUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  amountRequested?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  amountTraded?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  security?: Resolver<ResolversTypes['Security'], ParentType, ContextType>;
  sharePrice?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  sharesRequested?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sharesTraded?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  tradeSide?: Resolver<ResolversTypes['ActivityItemTradeSide'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemOtherResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemOther'] = ResolversParentTypes['ActivityItemOther']> = {
  amount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemStatus'] = ResolversParentTypes['ActivityItemStatus']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  stage?: Resolver<ResolversTypes['ActivityItemStage'], ParentType, ContextType>;
  timestamp?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
};

export type ActivityItemTradeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemTrade'] = ResolversParentTypes['ActivityItemTrade']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  security?: Resolver<ResolversTypes['Security'], ParentType, ContextType>;
  sharePrice?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  shares?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeAttribution?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tradeAttributionV2?: Resolver<Maybe<ResolversTypes['ActivityItemTradeAttribution']>, ParentType, ContextType>;
  tradeSide?: Resolver<ResolversTypes['ActivityItemTradeSide'], ParentType, ContextType>;
};

export type ActivityItemTradeGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemTradeGroup'] = ResolversParentTypes['ActivityItemTradeGroup']> = {
  activityReportsUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  purchases?: Resolver<Array<ResolversTypes['ActivityItemTrade']>, ParentType, ContextType>;
  purchasesAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  sales?: Resolver<Array<ResolversTypes['ActivityItemTrade']>, ParentType, ContextType>;
  salesAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemTransferResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemTransfer'] = ResolversParentTypes['ActivityItemTransfer']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  assetType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  assetTypeV2?: Resolver<ResolversTypes['ActivityItemTransferAssetType'], ParentType, ContextType>;
  destinationAccount?: Resolver<Maybe<ResolversTypes['LegalSubAccount']>, ParentType, ContextType>;
  requestedDollarTransferAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  security?: Resolver<Maybe<ResolversTypes['Security']>, ParentType, ContextType>;
  sharePrice?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  shares?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceAccount?: Resolver<Maybe<ResolversTypes['LegalSubAccount']>, ParentType, ContextType>;
  transferRequestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
};

export type ActivityItemTransferGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemTransferGroup'] = ResolversParentTypes['ActivityItemTransferGroup']> = {
  activityReportsUrl?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  amount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  destinationAccount?: Resolver<Maybe<ResolversTypes['LegalSubAccount']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isFullTransfer?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sourceAccount?: Resolver<Maybe<ResolversTypes['LegalSubAccount']>, ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  transferItems?: Resolver<Array<ResolversTypes['ActivityItemTransfer']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ActivityItemWithdrawalResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityItemWithdrawal'] = ResolversParentTypes['ActivityItemWithdrawal']> = {
  amount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  destinationAccount?: Resolver<Maybe<ResolversTypes['BankAccount']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isFullWithdrawal?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  memo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sourceAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  statuses?: Resolver<Array<ResolversTypes['ActivityItemStatus']>, ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  withdrawalRequestId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AdvisedPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvisedPlan'] = ResolversParentTypes['AdvisedPlan']> = {
  __resolveType: TypeResolveFn<'Solo401kClientEnvelope' | 'SoloFourOhOneKPlan' | 'StandardFourOhOneKPlan', ParentType, ContextType>;
};

export type AdvisorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Advisor'] = ResolversParentTypes['Advisor']> = {
  currentAnnouncement?: Resolver<Maybe<ResolversTypes['Announcement']>, ParentType, ContextType>;
  firm?: Resolver<ResolversTypes['Firm'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isCompliance?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['Logo']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<AdvisorMessagesArgs, 'location'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AdvisorGoalCreationResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvisorGoalCreation'] = ResolversParentTypes['AdvisorGoalCreation']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAutoAdjustEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  ownerAccount?: Resolver<ResolversTypes['AdvisorGoalCreationAccount'], ParentType, ContextType>;
  portfolioStrategyDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roundedTermYears?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  spouseAccount?: Resolver<ResolversTypes['AdvisorGoalCreationAccount'], ParentType, ContextType>;
};

export type AdvisorGoalCreationAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdvisorGoalCreationAccount'] = ResolversParentTypes['AdvisorGoalCreationAccount']> = {
  isAutoAdjustEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  portfolioStrategyDisplayName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  roundedTermYears?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AffectedHouseholdResolvers<ContextType = any, ParentType extends ResolversParentTypes['AffectedHousehold'] = ResolversParentTypes['AffectedHousehold']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  openGoals?: Resolver<Array<ResolversTypes['LegacyGoal']>, ParentType, ContextType>;
};

export type AgreementDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['AgreementDocument'] = ResolversParentTypes['AgreementDocument']> = {
  __resolveType: TypeResolveFn<'ExecutedAgreement', ParentType, ContextType>;
};

export type AnnouncementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Announcement'] = ResolversParentTypes['Announcement']> = {
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  steps?: Resolver<Array<ResolversTypes['AnnouncementStep']>, ParentType, ContextType>;
};

export type AnnouncementDismissalResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnnouncementDismissal'] = ResolversParentTypes['AnnouncementDismissal']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type AnnouncementRedirectResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnnouncementRedirect'] = ResolversParentTypes['AnnouncementRedirect']> = {
  target?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AnnouncementStepResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnnouncementStep'] = ResolversParentTypes['AnnouncementStep']> = {
  body?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  cta?: Resolver<Maybe<ResolversTypes['AnnouncementStepCta']>, ParentType, ContextType>;
  heading?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  image?: Resolver<Maybe<ResolversTypes['AnnouncementStepImage']>, ParentType, ContextType>;
};

export type AnnouncementStepCtaResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnnouncementStepCta'] = ResolversParentTypes['AnnouncementStepCta']> = {
  redirect?: Resolver<Maybe<ResolversTypes['AnnouncementRedirect']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AnnouncementStepImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnnouncementStepImage'] = ResolversParentTypes['AnnouncementStepImage']> = {
  alt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type AnnualResolvers<ContextType = any, ParentType extends ResolversParentTypes['Annual'] = ResolversParentTypes['Annual']> = {
  result?: Resolver<ResolversTypes['Contribution'], ParentType, ContextType>;
  taxYear?: Resolver<ResolversTypes['TaxYear'], ParentType, ContextType>;
};

export type AnnualIraContributionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnnualIraContributions'] = ResolversParentTypes['AnnualIraContributions']> = {
  result?: Resolver<ResolversTypes['IraContributions'], ParentType, ContextType>;
  taxYear?: Resolver<ResolversTypes['TaxYear'], ParentType, ContextType>;
};

export type AssignedAccountSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['AssignedAccountSummary'] = ResolversParentTypes['AssignedAccountSummary']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  incomingMigration?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sblocPledged?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxAdvantaged?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  taxable?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type AutoglideResolvers<ContextType = any, ParentType extends ResolversParentTypes['Autoglide'] = ResolversParentTypes['Autoglide']> = {
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type BankAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccount'] = ResolversParentTypes['BankAccount']> = {
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type BettermentModelPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['BettermentModelPortfolio'] = ResolversParentTypes['BettermentModelPortfolio']> = {
  allocationLabel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  brochureUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  icon?: Resolver<Maybe<ResolversTypes['ThemedAsset']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  informationUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quarterlyUpdateId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  quickCompareShortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  shortDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type BillingPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingPlan'] = ResolversParentTypes['BillingPlan']> = {
  billingRate?: Resolver<ResolversTypes['BillingRate'], ParentType, ContextType>;
  firmDefault?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  latestChangeDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  numberOfClients?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  paymentType?: Resolver<ResolversTypes['PaymentType'], ParentType, ContextType>;
  platformFeeAllocation?: Resolver<ResolversTypes['PlatformFeeAllocation'], ParentType, ContextType>;
};

export type BillingRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingRate'] = ResolversParentTypes['BillingRate']> = {
  __resolveType: TypeResolveFn<'BillingRateAssetBased' | 'BillingRateFixed' | 'BillingRateTiered', ParentType, ContextType>;
};

export type BillingRateAssetBasedResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingRateAssetBased'] = ResolversParentTypes['BillingRateAssetBased']> = {
  feeBps?: Resolver<ResolversTypes['Bps'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BillingRateFixedResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingRateFixed'] = ResolversParentTypes['BillingRateFixed']> = {
  feeCents?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BillingRateRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingRateRange'] = ResolversParentTypes['BillingRateRange']> = {
  firmFee?: Resolver<ResolversTypes['SingleBillingRate'], ParentType, ContextType>;
  tierEnd?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
};

export type BillingRateTieredResolvers<ContextType = any, ParentType extends ResolversParentTypes['BillingRateTiered'] = ResolversParentTypes['BillingRateTiered']> = {
  calculationMethod?: Resolver<ResolversTypes['TieredFeeCalculationMethod'], ParentType, ContextType>;
  tiers?: Resolver<Array<ResolversTypes['BillingRateRange']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BlockingTaskResolvers<ContextType = any, ParentType extends ResolversParentTypes['BlockingTask'] = ResolversParentTypes['BlockingTask']> = {
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export interface BpsScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Bps'], any> {
  name: 'Bps';
}

export type BulkFeeAttemptResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkFeeAttempt'] = ResolversParentTypes['BulkFeeAttempt']> = {
  feeAttempts?: Resolver<ResolversTypes['FeeAttemptsResult'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type BulkFeeIntentResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkFeeIntent'] = ResolversParentTypes['BulkFeeIntent']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  createdBy?: Resolver<Maybe<ResolversTypes['Advisor']>, ParentType, ContextType>;
  failedCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paidToFirmOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BulkFeeIntentStatus'], ParentType, ContextType>;
  submittedCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  uploadedCsvFilename?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type BulkTransferPendingActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BulkTransferPendingAction'] = ResolversParentTypes['BulkTransferPendingAction']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  futurePortfolio?: Resolver<ResolversTypes['FuturePortfolio'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CashAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['CashAccount'] = ResolversParentTypes['CashAccount']> = {
  accountHolders?: Resolver<Array<ResolversTypes['AccountHolder']>, ParentType, ContextType>;
  apy?: Resolver<ResolversTypes['CashApy'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType, RequireFields<CashAccountBalanceArgs, 'includePending'>>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  fdicInsurance?: Resolver<ResolversTypes['CashFdicInsurance'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyGoalId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  legacySubAccountId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  legalAccount?: Resolver<ResolversTypes['LegalAccount'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<CashAccountMessagesArgs, 'location'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  performance?: Resolver<ResolversTypes['Performance'], ParentType, ContextType, RequireFields<CashAccountPerformanceArgs, 'dateRangeOption'>>;
  recurringTransactionConfigs?: Resolver<Array<ResolversTypes['RecurringTransactionConfig']>, ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['Client']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CashApyResolvers<ContextType = any, ParentType extends ResolversParentTypes['CashApy'] = ResolversParentTypes['CashApy']> = {
  explanation?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  isBoostActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isBoostEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rate?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CashFdicInsuranceResolvers<ContextType = any, ParentType extends ResolversParentTypes['CashFdicInsurance'] = ResolversParentTypes['CashFdicInsurance']> = {
  amount?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  explanation?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
};

export interface CentsScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Cents'], any> {
  name: 'Cents';
}

export type ClientResolvers<ContextType = any, ParentType extends ResolversParentTypes['Client'] = ResolversParentTypes['Client']> = {
  commonFirstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  commonFullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  employers?: Resolver<Array<ResolversTypes['Employer']>, ParentType, ContextType>;
  fourOhOneKContributions?: Resolver<Maybe<ResolversTypes['Result']>, ParentType, ContextType>;
  household?: Resolver<ResolversTypes['Household'], ParentType, ContextType>;
  householdId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  iraContributions?: Resolver<Maybe<ResolversTypes['IraContributionsResult']>, ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  legalFullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  portfolioControls?: Resolver<ResolversTypes['UserPortfolioControls'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClientAccountBeneficiaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientAccountBeneficiary'] = ResolversParentTypes['ClientAccountBeneficiary']> = {
  dateOfBirth?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  distributionShare?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  relationship?: Resolver<ResolversTypes['ClientAccountBeneficiaryRelationship'], ParentType, ContextType>;
  taxIdentifier?: Resolver<Maybe<ResolversTypes['TIN']>, ParentType, ContextType>;
};

export type ClientAccountTypeSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientAccountTypeSummary'] = ResolversParentTypes['ClientAccountTypeSummary']> = {
  contingentBeneficiaries?: Resolver<Array<ResolversTypes['ClientAccountBeneficiary']>, ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  primaryBeneficiaries?: Resolver<Array<ResolversTypes['ClientAccountBeneficiary']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LegalAccountType'], ParentType, ContextType>;
};

export type ClientEnvelopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientEnvelope'] = ResolversParentTypes['ClientEnvelope']> = {
  bankAccounts?: Resolver<Maybe<Array<ResolversTypes['ClientEnvelopeBankAccount']>>, ParentType, ContextType>;
  clients?: Resolver<Array<ResolversTypes['ClientEnvelopeClient']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  jointAccounts?: Resolver<Maybe<Array<ResolversTypes['ClientAccountTypeSummary']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ClientEnvelopeBankAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientEnvelopeBankAccount'] = ResolversParentTypes['ClientEnvelopeBankAccount']> = {
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bankName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isSavings?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  routingNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ClientEnvelopeClientResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientEnvelopeClient'] = ResolversParentTypes['ClientEnvelopeClient']> = {
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  individualAccounts?: Resolver<Array<ResolversTypes['ClientAccountTypeSummary']>, ParentType, ContextType>;
  invites?: Resolver<Array<ResolversTypes['ClientEnvelopeInvitation']>, ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ClientEnvelopeInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientEnvelopeInterface'] = ResolversParentTypes['ClientEnvelopeInterface']> = {
  __resolveType: TypeResolveFn<'ClientEnvelope' | 'Solo401kClientEnvelope', ParentType, ContextType>;
};

export type ClientEnvelopeInvitationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ClientEnvelopeInvitation'] = ResolversParentTypes['ClientEnvelopeInvitation']> = {
  copilotPendingId?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type ContributionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Contribution'] = ResolversParentTypes['Contribution']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  projection?: Resolver<Maybe<ResolversTypes['Projection']>, ParentType, ContextType>;
};

export type CreateBulkFeeIntentMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateBulkFeeIntentMutationPayload'] = ResolversParentTypes['CreateBulkFeeIntentMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['BulkFeeIntent']>, ParentType, ContextType>;
};

export type CreateClientActivityCsvExportMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateClientActivityCsvExportMutationPayload'] = ResolversParentTypes['CreateClientActivityCsvExportMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['CsvExport']>, ParentType, ContextType>;
};

export type CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationPayload'] = ResolversParentTypes['CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Solo401kConversionIntent']>, ParentType, ContextType>;
};

export type CreateDraftSolo401kConversionIntentMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateDraftSolo401kConversionIntentMutationPayload'] = ResolversParentTypes['CreateDraftSolo401kConversionIntentMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Solo401kConversionIntent']>, ParentType, ContextType>;
};

export type CreateFinancialSecurityOrderRequestMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFinancialSecurityOrderRequestMutationPayload'] = ResolversParentTypes['CreateFinancialSecurityOrderRequestMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['FinancialSecurityOrderRequest']>, ParentType, ContextType>;
};

export type CreateFinancialSecuritySellOrderTaxImpactPreviewMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFinancialSecuritySellOrderTaxImpactPreviewMutationPayload'] = ResolversParentTypes['CreateFinancialSecuritySellOrderTaxImpactPreviewMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['FinancialSecuritySellOrderTaxImpactPreview']>, ParentType, ContextType>;
};

export type CreateFirmBillableAccountsCsvExportMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFirmBillableAccountsCsvExportMutationPayload'] = ResolversParentTypes['CreateFirmBillableAccountsCsvExportMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['CsvExport']>, ParentType, ContextType>;
};

export type CreateFourOhOneKReportMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFourOhOneKReportMutationPayload'] = ResolversParentTypes['CreateFourOhOneKReportMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['CreateFourOhOneKReportPayload']>, ParentType, ContextType>;
};

export type CreateFourOhOneKReportPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFourOhOneKReportPayload'] = ResolversParentTypes['CreateFourOhOneKReportPayload']> = {
  endDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type CreateFourOhOneKRequestForProposalMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFourOhOneKRequestForProposalMutationPayload'] = ResolversParentTypes['CreateFourOhOneKRequestForProposalMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['CreateFourOhOneKRequestForProposalResult']>, ParentType, ContextType>;
};

export type CreateFourOhOneKRequestForProposalResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateFourOhOneKRequestForProposalResult'] = ResolversParentTypes['CreateFourOhOneKRequestForProposalResult']> = {
  isSuccess?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type CreateTradePreviewMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateTradePreviewMutationPayload'] = ResolversParentTypes['CreateTradePreviewMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['TradePreview']>, ParentType, ContextType>;
};

export type CsvExportResolvers<ContextType = any, ParentType extends ResolversParentTypes['CsvExport'] = ResolversParentTypes['CsvExport']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['CsvExportStatus'], ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DictionaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Dictionary'] = ResolversParentTypes['Dictionary']> = {
  displayText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type DirectTradingAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectTradingAccount'] = ResolversParentTypes['DirectTradingAccount']> = {
  accountHolders?: Resolver<Array<ResolversTypes['AccountHolder']>, ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  cashBalances?: Resolver<ResolversTypes['DirectTradingCashBalances'], ParentType, ContextType>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacySubAccountId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  legalAccount?: Resolver<ResolversTypes['LegalAccount'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<DirectTradingAccountMessagesArgs, 'location'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  performance?: Resolver<ResolversTypes['Performance'], ParentType, ContextType, RequireFields<DirectTradingAccountPerformanceArgs, 'dateRangeOption'>>;
  securityPositions?: Resolver<Array<ResolversTypes['DirectTradingSecurityPosition']>, ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['Client']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DirectTradingCashBalancesResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectTradingCashBalances'] = ResolversParentTypes['DirectTradingCashBalances']> = {
  anyPending?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  availableBalance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  totalBalance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type DirectTradingSecurityPositionResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectTradingSecurityPosition'] = ResolversParentTypes['DirectTradingSecurityPosition']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  averageCost?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  averageCostV2?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  financialSecurity?: Resolver<ResolversTypes['FinancialSecurity'], ParentType, ContextType>;
  hasPendingOrders?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  shares?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  todaysReturn?: Resolver<Maybe<ResolversTypes['DirectTradingSecurityPositionReturn']>, ParentType, ContextType>;
  todaysReturnAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  todaysReturnPercent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  totalCost?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  totalCostV2?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  totalReturn?: Resolver<Maybe<ResolversTypes['DirectTradingSecurityPositionReturn']>, ParentType, ContextType>;
  totalReturnAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  totalReturnPercent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type DirectTradingSecurityPositionReturnResolvers<ContextType = any, ParentType extends ResolversParentTypes['DirectTradingSecurityPositionReturn'] = ResolversParentTypes['DirectTradingSecurityPositionReturn']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  percent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type DisclosuresResolvers<ContextType = any, ParentType extends ResolversParentTypes['Disclosures'] = ResolversParentTypes['Disclosures']> = {
  directTradingBalanceDisclosure?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  performanceDisclosure?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
};

export type DismissAnnouncementMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DismissAnnouncementMutationPayload'] = ResolversParentTypes['DismissAnnouncementMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['AnnouncementDismissal']>, ParentType, ContextType>;
};

export type DismissCsvActivityExportBannerMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DismissCsvActivityExportBannerMutationPayload'] = ResolversParentTypes['DismissCsvActivityExportBannerMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['CsvExport']>, ParentType, ContextType>;
};

export type DismissFirmBillableAccountsCsvExportMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['DismissFirmBillableAccountsCsvExportMutationPayload'] = ResolversParentTypes['DismissFirmBillableAccountsCsvExportMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['CsvExport']>, ParentType, ContextType>;
};

export type DisplayableErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisplayableError'] = ResolversParentTypes['DisplayableError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
};

export type DocumentModelPortfolioResourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocumentModelPortfolioResource'] = ResolversParentTypes['DocumentModelPortfolioResource']> = {
  downloadUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ModelPortfolioResourceType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DriftResolvers<ContextType = any, ParentType extends ResolversParentTypes['Drift'] = ResolversParentTypes['Drift']> = {
  current?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isAboveThreshold?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  threshold?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type EmailDispatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailDispatch'] = ResolversParentTypes['EmailDispatch']> = {
  wasEmailSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type EmployerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Employer'] = ResolversParentTypes['Employer']> = {
  contributionConfig?: Resolver<Maybe<ResolversTypes['EmployerConfig']>, ParentType, ContextType>;
  fourOhOneKContributions?: Resolver<Maybe<ResolversTypes['EmployerResult']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  soloFourOhOneKPlan?: Resolver<Maybe<ResolversTypes['SoloFourOhOneKPlan']>, ParentType, ContextType>;
};

export type EmployerConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployerConfig'] = ResolversParentTypes['EmployerConfig']> = {
  frequency?: Resolver<ResolversTypes['EmployerFrequency'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type EmployerContributionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployerContributions'] = ResolversParentTypes['EmployerContributions']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  projection?: Resolver<Maybe<ResolversTypes['Projection']>, ParentType, ContextType>;
  vested?: Resolver<Maybe<ResolversTypes['Vested']>, ParentType, ContextType>;
};

export type EmployerResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmployerResult'] = ResolversParentTypes['EmployerResult']> = {
  allTime?: Resolver<ResolversTypes['EmployerContributions'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  thisYear?: Resolver<ResolversTypes['EmployerContributions'], ParentType, ContextType>;
};

export type EnvelopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Envelope'] = ResolversParentTypes['Envelope']> = {
  accounts?: Resolver<Array<ResolversTypes['EnvelopeAccount']>, ParentType, ContextType>;
  balance?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  purpose?: Resolver<Maybe<ResolversTypes['Purpose']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['Client'], ParentType, ContextType>;
};

export type EnvelopeAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnvelopeAccount'] = ResolversParentTypes['EnvelopeAccount']> = {
  __resolveType: TypeResolveFn<'CashAccount' | 'DirectTradingAccount' | 'ManagedAccount', ParentType, ContextType>;
};

export type EnvelopeYtdReturnResolvers<ContextType = any, ParentType extends ResolversParentTypes['EnvelopeYtdReturn'] = ResolversParentTypes['EnvelopeYtdReturn']> = {
  envelopeId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  ytdReturn?: Resolver<Maybe<ResolversTypes['YtdReturn']>, ParentType, ContextType>;
};

export type EstimatedTradeDateResolvers<ContextType = any, ParentType extends ResolversParentTypes['EstimatedTradeDate'] = ResolversParentTypes['EstimatedTradeDate']> = {
  date?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EstimatedTradeTimeRangeResolvers<ContextType = any, ParentType extends ResolversParentTypes['EstimatedTradeTimeRange'] = ResolversParentTypes['EstimatedTradeTimeRange']> = {
  dayDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  endTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  startTime?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  timeRangeDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EstimatedTradeTimingResolvers<ContextType = any, ParentType extends ResolversParentTypes['EstimatedTradeTiming'] = ResolversParentTypes['EstimatedTradeTiming']> = {
  __resolveType: TypeResolveFn<'EstimatedTradeDate' | 'EstimatedTradeTimeRange', ParentType, ContextType>;
};

export type ExecutedAgreementResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExecutedAgreement'] = ResolversParentTypes['ExecutedAgreement']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  approvedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDocusignAgreement?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ExpenseRatioResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExpenseRatio'] = ResolversParentTypes['ExpenseRatio']> = {
  explanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type ExternallyAdvisedPlanPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExternallyAdvisedPlanPortfolio'] = ResolversParentTypes['ExternallyAdvisedPlanPortfolio']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  securityCategoryGroups?: Resolver<Array<ResolversTypes['SecurityCategoryGroup']>, ParentType, ContextType>;
};

export type FeeAttemptResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeAttempt'] = ResolversParentTypes['FeeAttempt']> = {
  account?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type FeeAttemptBatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeAttemptBatch'] = ResolversParentTypes['FeeAttemptBatch']> = {
  attempts?: Resolver<Array<ResolversTypes['FeeAttempt']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FeeAttemptFailureResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeAttemptFailure'] = ResolversParentTypes['FeeAttemptFailure']> = {
  account?: Resolver<ResolversTypes['FeeAttemptInputAccount'], ParentType, ContextType>;
  amount?: Resolver<ResolversTypes['FeeAttemptInputAmount'], ParentType, ContextType>;
  failureReasons?: Resolver<Array<ResolversTypes['FeeAttemptFailureReason']>, ParentType, ContextType>;
  row?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type FeeAttemptInputAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeAttemptInputAccount'] = ResolversParentTypes['FeeAttemptInputAccount']> = {
  __resolveType: TypeResolveFn<'CashAccount' | 'InvalidAccountString' | 'ManagedSubAccount', ParentType, ContextType>;
};

export type FeeAttemptInputAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeAttemptInputAmount'] = ResolversParentTypes['FeeAttemptInputAmount']> = {
  __resolveType: TypeResolveFn<'InvalidAmountString' | 'ValidCents', ParentType, ContextType>;
};

export type FeeAttemptsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeAttemptsResult'] = ResolversParentTypes['FeeAttemptsResult']> = {
  __resolveType: TypeResolveFn<'FeeAttemptBatch' | 'InvalidFeeAttemptBatch', ParentType, ContextType>;
};

export type FeeConfigurationResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeConfiguration'] = ResolversParentTypes['FeeConfiguration']> = {
  platformFeeTiers?: Resolver<Array<ResolversTypes['PlatformFeeTier']>, ParentType, ContextType>;
};

export type FinancialSecurityResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurity'] = ResolversParentTypes['FinancialSecurity']> = {
  __resolveType: TypeResolveFn<'FinancialSecurityFund' | 'FinancialSecurityStock', ParentType, ContextType>;
};

export type FinancialSecurityFundResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityFund'] = ResolversParentTypes['FinancialSecurityFund']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prospectusUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FinancialSecurityOrderRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityOrderRequest'] = ResolversParentTypes['FinancialSecurityOrderRequest']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['FinancialSecurityOrderRequestStatus'], ParentType, ContextType>;
};

export type FinancialSecuritySellOrderTaxImpactPreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecuritySellOrderTaxImpactPreview'] = ResolversParentTypes['FinancialSecuritySellOrderTaxImpactPreview']> = {
  gainsDetails?: Resolver<Maybe<ResolversTypes['GainsDetails']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  remainingGainsAllowance?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  taxImpactPreview?: Resolver<ResolversTypes['TaxImpact'], ParentType, ContextType>;
};

export type FinancialSecurityStockResolvers<ContextType = any, ParentType extends ResolversParentTypes['FinancialSecurityStock'] = ResolversParentTypes['FinancialSecurityStock']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FirmResolvers<ContextType = any, ParentType extends ResolversParentTypes['Firm'] = ResolversParentTypes['Firm']> = {
  accountCreationAllowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  billingFrequency?: Resolver<ResolversTypes['BillingFrequency'], ParentType, ContextType>;
  billingPlan?: Resolver<Maybe<ResolversTypes['BillingPlan']>, ParentType, ContextType, RequireFields<FirmBillingPlanArgs, 'id'>>;
  billingPlans?: Resolver<Array<ResolversTypes['BillingPlan']>, ParentType, ContextType>;
  bulkFeeAttempt?: Resolver<Maybe<ResolversTypes['BulkFeeAttempt']>, ParentType, ContextType, RequireFields<FirmBulkFeeAttemptArgs, 'id'>>;
  bulkFeeIntentCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  bulkFeeIntents?: Resolver<Array<ResolversTypes['BulkFeeIntent']>, ParentType, ContextType, RequireFields<FirmBulkFeeIntentsArgs, 'limit' | 'offset'>>;
  executedAgreements?: Resolver<Array<ResolversTypes['ExecutedAgreement']>, ParentType, ContextType, Partial<FirmExecutedAgreementsArgs>>;
  feeConfiguration?: Resolver<Maybe<ResolversTypes['FeeConfiguration']>, ParentType, ContextType>;
  fourOhOneKEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  fourOhOneKOnly?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  platformFee?: Resolver<ResolversTypes['Bps'], ParentType, ContextType>;
  requiresImpersonationConfirmation?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startClientInvitePath?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
};

export type FourOhOneKDocumentResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKDocument'] = ResolversParentTypes['FourOhOneKDocument']> = {
  effectiveDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['FourOhOneKDocumentType'], ParentType, ContextType>;
};

export type FourOhOneKOnboardingTaskResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKOnboardingTask'] = ResolversParentTypes['FourOhOneKOnboardingTask']> = {
  blockedDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  completedAt?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  completingPlanManager?: Resolver<Maybe<ResolversTypes['FourOhOneKPlanManager']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  dueDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ready?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type FourOhOneKPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKPlan'] = ResolversParentTypes['FourOhOneKPlan']> = {
  __resolveType: TypeResolveFn<'SoloFourOhOneKPlan' | 'StandardFourOhOneKPlan', ParentType, ContextType>;
};

export type FourOhOneKPlanFiduciaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKPlanFiduciary'] = ResolversParentTypes['FourOhOneKPlanFiduciary']> = {
  isAdvisor?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isBetterment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type FourOhOneKPlanManagerResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKPlanManager'] = ResolversParentTypes['FourOhOneKPlanManager']> = {
  authorizationTier?: Resolver<ResolversTypes['PlanManagerAuthorizationTier'], ParentType, ContextType>;
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  primary?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type FourOhOneKPlanOnboardingResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKPlanOnboarding'] = ResolversParentTypes['FourOhOneKPlanOnboarding']> = {
  blockingTask?: Resolver<Maybe<ResolversTypes['BlockingTask']>, ParentType, ContextType>;
  clientNickname?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  completedTasksCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isConversion?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isIntegratedPayrollProvider?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  launchDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  launchStatus?: Resolver<ResolversTypes['FourOhOneKPlanLaunchStatusType'], ParentType, ContextType>;
  payrollIntegrationLaunchOffTrack?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  payrollProviderName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pendingLongPayrollIntegrationSetupPeriod?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  planDocumentSent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  supportAgent?: Resolver<ResolversTypes['FourOhOneKPlanSupportAgent'], ParentType, ContextType>;
  tasks?: Resolver<Array<ResolversTypes['FourOhOneKOnboardingTask']>, ParentType, ContextType>;
  thirdPartyAdministrator?: Resolver<Maybe<ResolversTypes['FourOhOneKThirdPartyAdministrator']>, ParentType, ContextType>;
  totalTasksCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  wireDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
};

export type FourOhOneKPlanPerformanceIndicatorsResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKPlanPerformanceIndicators'] = ResolversParentTypes['FourOhOneKPlanPerformanceIndicators']> = {
  currentlyContributingParticipants?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  eligibleParticipants?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPlanBalanceCents?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type FourOhOneKPlanSupportAgentResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKPlanSupportAgent'] = ResolversParentTypes['FourOhOneKPlanSupportAgent']> = {
  contactUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type FourOhOneKPlanSupportResourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKPlanSupportResource'] = ResolversParentTypes['FourOhOneKPlanSupportResource']> = {
  agent?: Resolver<Maybe<ResolversTypes['FourOhOneKPlanSupportAgent']>, ParentType, ContextType>;
  contact?: Resolver<ResolversTypes['SupportContact'], ParentType, ContextType>;
};

export type FourOhOneKReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKReport'] = ResolversParentTypes['FourOhOneKReport']> = {
  contentType?: Resolver<ResolversTypes['FourOhOneKReportContentType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['FourOhOneKReportStatus'], ParentType, ContextType>;
};

export type FourOhOneKReportCreationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKReportCreationOption'] = ResolversParentTypes['FourOhOneKReportCreationOption']> = {
  columns?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputs?: Resolver<Array<ResolversTypes['FourOhOneKReportInputOption']>, ParentType, ContextType>;
  isCommon?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type FourOhOneKReportInputOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKReportInputOption'] = ResolversParentTypes['FourOhOneKReportInputOption']> = {
  attribute?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type FourOhOneKThirdPartyAdministratorResolvers<ContextType = any, ParentType extends ResolversParentTypes['FourOhOneKThirdPartyAdministrator'] = ResolversParentTypes['FourOhOneKThirdPartyAdministrator']> = {
  contactEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  contactName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  organizationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type FuturePortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['FuturePortfolio'] = ResolversParentTypes['FuturePortfolio']> = {
  strategyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAllocationDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type GainsResolvers<ContextType = any, ParentType extends ResolversParentTypes['Gains'] = ResolversParentTypes['Gains']> = {
  gainAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  lossAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netAmount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type GainsDetailsResolvers<ContextType = any, ParentType extends ResolversParentTypes['GainsDetails'] = ResolversParentTypes['GainsDetails']> = {
  annualGainsAllowance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  realizedGains?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export interface HtmlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['HTML'], any> {
  name: 'HTML';
}

export type HistoricalPerformanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['HistoricalPerformance'] = ResolversParentTypes['HistoricalPerformance']> = {
  benchmarkReturnPercent?: Resolver<Maybe<ResolversTypes['Percent']>, ParentType, ContextType>;
  returnPercent?: Resolver<Maybe<ResolversTypes['Percent']>, ParentType, ContextType>;
  timePeriod?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type HouseholdResolvers<ContextType = any, ParentType extends ResolversParentTypes['Household'] = ResolversParentTypes['Household']> = {
  accountYtdReturns?: Resolver<Array<ResolversTypes['AccountYtdReturn']>, ParentType, ContextType>;
  accounts?: Resolver<Array<ResolversTypes['EnvelopeAccount']>, ParentType, ContextType>;
  annualGainsSummaries?: Resolver<Array<ResolversTypes['Summary']>, ParentType, ContextType>;
  billingPlan?: Resolver<ResolversTypes['BillingPlan'], ParentType, ContextType>;
  effectivePlatformFee?: Resolver<ResolversTypes['Bps'], ParentType, ContextType>;
  envelopeYtdReturns?: Resolver<Array<ResolversTypes['EnvelopeYtdReturn']>, ParentType, ContextType>;
  envelopes?: Resolver<Array<ResolversTypes['Envelope']>, ParentType, ContextType>;
  externalSyncedBalance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  members?: Resolver<Array<ResolversTypes['Client']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<HouseholdMessagesArgs, 'location'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  openGoals?: Resolver<Array<ResolversTypes['LegacyGoal']>, ParentType, ContextType>;
  totalBalance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  totalEarnings?: Resolver<ResolversTypes['Cents'], ParentType, ContextType, RequireFields<HouseholdTotalEarningsArgs, 'dateRangeOption'>>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HouseholdResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['HouseholdResult'] = ResolversParentTypes['HouseholdResult']> = {
  __resolveType: TypeResolveFn<'Household' | 'RecordNotFoundResult', ParentType, ContextType>;
};

export type InvalidAccountStringResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidAccountString'] = ResolversParentTypes['InvalidAccountString']> = {
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidAmountStringResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidAmountString'] = ResolversParentTypes['InvalidAmountString']> = {
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InvalidFeeAttemptBatchResolvers<ContextType = any, ParentType extends ResolversParentTypes['InvalidFeeAttemptBatch'] = ResolversParentTypes['InvalidFeeAttemptBatch']> = {
  failures?: Resolver<Array<ResolversTypes['FeeAttemptFailure']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type IraContributionsResolvers<ContextType = any, ParentType extends ResolversParentTypes['IraContributions'] = ResolversParentTypes['IraContributions']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  projection?: Resolver<Maybe<ResolversTypes['IraContributionsProjection']>, ParentType, ContextType>;
};

export type IraContributionsProjectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['IraContributionsProjection'] = ResolversParentTypes['IraContributionsProjection']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type IraContributionsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['IraContributionsResult'] = ResolversParentTypes['IraContributionsResult']> = {
  byYear?: Resolver<Array<ResolversTypes['AnnualIraContributions']>, ParentType, ContextType, Partial<IraContributionsResultByYearArgs>>;
};

export type LegacyGoalResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacyGoal'] = ResolversParentTypes['LegacyGoal']> = {
  currentBalance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  drift?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  hasHighDrift?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legalAccountType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export interface LegacyIdScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LegacyID'], any> {
  name: 'LegacyID';
}

export type LegacySecurityResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacySecurity'] = ResolversParentTypes['LegacySecurity']> = {
  category?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expenseRatioPercent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  historicalPerformances?: Resolver<Array<ResolversTypes['HistoricalPerformance']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inceptionDate?: Resolver<ResolversTypes['Date'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  netExpenseRatioPercent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  prospectusUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type LegacySubAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegacySubAccount'] = ResolversParentTypes['LegacySubAccount']> = {
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pendingConversionFunds?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export interface LegacyUuidScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['LegacyUUID'], any> {
  name: 'LegacyUUID';
}

export type LegalAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegalAccount'] = ResolversParentTypes['LegalAccount']> = {
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  owner?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ownershipType?: Resolver<ResolversTypes['LegalAccountOwnershipType'], ParentType, ContextType>;
  primaryBeneficiaries?: Resolver<Array<ResolversTypes['LegalAccountBeneficiary']>, ParentType, ContextType>;
  sblocLoan?: Resolver<Maybe<ResolversTypes['SblocLoan']>, ParentType, ContextType>;
  soloFourOhOneKPlan?: Resolver<Maybe<ResolversTypes['SoloFourOhOneKPlan']>, ParentType, ContextType>;
  taxationType?: Resolver<ResolversTypes['LegalAccountTaxationType'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['LegalAccountType'], ParentType, ContextType>;
};

export type LegalAccountBeneficiaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegalAccountBeneficiary'] = ResolversParentTypes['LegalAccountBeneficiary']> = {
  dateOfBirth?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  distributionShare?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  relationship?: Resolver<ResolversTypes['BeneficiaryRelationship'], ParentType, ContextType>;
  taxId?: Resolver<Maybe<ResolversTypes['TIN']>, ParentType, ContextType>;
};

export type LegalSubAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['LegalSubAccount'] = ResolversParentTypes['LegalSubAccount']> = {
  __resolveType: TypeResolveFn<'CashAccount' | 'DirectTradingAccount' | 'ManagedSubAccount', ParentType, ContextType>;
};

export type LinkModelPortfolioResourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['LinkModelPortfolioResource'] = ResolversParentTypes['LinkModelPortfolioResource']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ModelPortfolioResourceType'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LogoResolvers<ContextType = any, ParentType extends ResolversParentTypes['Logo'] = ResolversParentTypes['Logo']> = {
  large?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  largeKnockout?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  medium?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
  mediumKnockout?: Resolver<Maybe<ResolversTypes['URL']>, ParentType, ContextType>;
};

export type ManagedAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManagedAccount'] = ResolversParentTypes['ManagedAccount']> = {
  accountHolders?: Resolver<Array<ResolversTypes['AccountHolder']>, ParentType, ContextType>;
  autoglide?: Resolver<ResolversTypes['Autoglide'], ParentType, ContextType>;
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType, RequireFields<ManagedAccountBalanceArgs, 'includePending'>>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isTaxCoordinated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyGoalId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<ManagedAccountMessagesArgs, 'location'>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  payrollContributionConfigs?: Resolver<Array<ResolversTypes['PayrollContributionConfig']>, ParentType, ContextType>;
  pendingActions?: Resolver<Array<ResolversTypes['ManagedAccountPendingAction']>, ParentType, ContextType>;
  performance?: Resolver<ResolversTypes['Performance'], ParentType, ContextType, RequireFields<ManagedAccountPerformanceArgs, 'dateRangeOption'>>;
  portfolio?: Resolver<ResolversTypes['ManagedPortfolio'], ParentType, ContextType>;
  recurringTransactionConfigs?: Resolver<Array<ResolversTypes['RecurringTransactionConfig']>, ParentType, ContextType>;
  securityGroupPositions?: Resolver<Array<ResolversTypes['SecurityGroupPosition']>, ParentType, ContextType>;
  subAccount?: Resolver<Maybe<ResolversTypes['ManagedSubAccount']>, ParentType, ContextType, RequireFields<ManagedAccountSubAccountArgs, 'id'>>;
  subAccounts?: Resolver<Array<ResolversTypes['ManagedSubAccount']>, ParentType, ContextType>;
  timeWeightedReturns?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['Client']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ManagedAccountPendingActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManagedAccountPendingAction'] = ResolversParentTypes['ManagedAccountPendingAction']> = {
  __resolveType: TypeResolveFn<'BulkTransferPendingAction' | 'PortfolioMigrationPendingAction' | 'RebalanceNowPendingAction' | 'StrategyChangePendingAction', ParentType, ContextType>;
};

export type ManagedPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManagedPortfolio'] = ResolversParentTypes['ManagedPortfolio']> = {
  __resolveType: TypeResolveFn<'RiskLevelBasedPortfolio' | 'SelfDirectedPortfolio', ParentType, ContextType>;
};

export type ManagedSubAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['ManagedSubAccount'] = ResolversParentTypes['ManagedSubAccount']> = {
  balance?: Resolver<ResolversTypes['Cents'], ParentType, ContextType, RequireFields<ManagedSubAccountBalanceArgs, 'includePending'>>;
  envelope?: Resolver<ResolversTypes['Envelope'], ParentType, ContextType>;
  hasPendingTransactions?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacySubAccountId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  legalAccount?: Resolver<ResolversTypes['LegalAccount'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  users?: Resolver<Array<ResolversTypes['Client']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']> = {
  body?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  cta?: Resolver<Maybe<ResolversTypes['MessageCta']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isDismissible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  style?: Resolver<ResolversTypes['MessageStyle'], ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type MessageCtaResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageCta'] = ResolversParentTypes['MessageCta']> = {
  __resolveType: TypeResolveFn<'MessageCtaLink' | 'MessageCtaModal', ParentType, ContextType>;
};

export type MessageCtaLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageCtaLink'] = ResolversParentTypes['MessageCtaLink']> = {
  impersonationLink?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageCtaModalResolvers<ContextType = any, ParentType extends ResolversParentTypes['MessageCtaModal'] = ResolversParentTypes['MessageCtaModal']> = {
  content?: Resolver<ResolversTypes['HTML'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ModelPortfolioProviderResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModelPortfolioProvider'] = ResolversParentTypes['ModelPortfolioProvider']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['ThemedAsset']>, ParentType, ContextType>;
  modelPortfolioCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  modelPortfolios?: Resolver<ResolversTypes['ProviderModelPortfolioConnection'], ParentType, ContextType, Partial<ModelPortfolioProviderModelPortfoliosArgs>>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type ModelPortfolioProviderConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModelPortfolioProviderConnection'] = ResolversParentTypes['ModelPortfolioProviderConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ModelPortfolioProviderEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ModelPortfolioProvider']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ModelPortfolioProviderEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModelPortfolioProviderEdge'] = ResolversParentTypes['ModelPortfolioProviderEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ModelPortfolioProvider'], ParentType, ContextType>;
};

export type ModelPortfolioResourceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModelPortfolioResource'] = ResolversParentTypes['ModelPortfolioResource']> = {
  __resolveType: TypeResolveFn<'DocumentModelPortfolioResource' | 'LinkModelPortfolioResource', ParentType, ContextType>;
};

export type ModelPortfolioRiskLevelResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModelPortfolioRiskLevel'] = ResolversParentTypes['ModelPortfolioRiskLevel']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  securityGroupAllocations?: Resolver<Array<ResolversTypes['RiskLevelSecurityGroupAllocation']>, ParentType, ContextType>;
};

export type ModelPortfolioSecurityGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['ModelPortfolioSecurityGroup'] = ResolversParentTypes['ModelPortfolioSecurityGroup']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  primarySecurityTaxDeferred?: Resolver<ResolversTypes['FinancialSecurity'], ParentType, ContextType>;
  primarySecurityTaxable?: Resolver<ResolversTypes['FinancialSecurity'], ParentType, ContextType>;
  secondarySecurityTaxDeferred?: Resolver<Maybe<ResolversTypes['FinancialSecurity']>, ParentType, ContextType>;
  secondarySecurityTaxable?: Resolver<Maybe<ResolversTypes['FinancialSecurity']>, ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  createBulkFeeIntent?: Resolver<ResolversTypes['CreateBulkFeeIntentMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateBulkFeeIntentArgs, 'input'>>;
  createClientActivityCsvExport?: Resolver<ResolversTypes['CreateClientActivityCsvExportMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateClientActivityCsvExportArgs, 'input'>>;
  createDraft401kOnlyAdvisorSoloFourOhOneKConversionIntent?: Resolver<ResolversTypes['CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateDraft401kOnlyAdvisorSoloFourOhOneKConversionIntentArgs, 'input'>>;
  createDraftSoloFourOhOneKConversionIntent?: Resolver<ResolversTypes['CreateDraftSolo401kConversionIntentMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateDraftSoloFourOhOneKConversionIntentArgs, 'input'>>;
  createFinancialSecurityOrderRequest?: Resolver<ResolversTypes['CreateFinancialSecurityOrderRequestMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateFinancialSecurityOrderRequestArgs, 'input'>>;
  createFinancialSecuritySellOrderTaxImpactPreview?: Resolver<ResolversTypes['CreateFinancialSecuritySellOrderTaxImpactPreviewMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateFinancialSecuritySellOrderTaxImpactPreviewArgs, 'input'>>;
  createFirmBillableAccountsCsvExport?: Resolver<ResolversTypes['CreateFirmBillableAccountsCsvExportMutationPayload'], ParentType, ContextType>;
  createFourOhOneKReport?: Resolver<ResolversTypes['CreateFourOhOneKReportMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateFourOhOneKReportArgs, 'input'>>;
  createFourOhOneKRequestForProposal?: Resolver<ResolversTypes['CreateFourOhOneKRequestForProposalMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateFourOhOneKRequestForProposalArgs, 'input'>>;
  createTradePreview?: Resolver<ResolversTypes['CreateTradePreviewMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateTradePreviewArgs, 'input'>>;
  dismissAdvisorAnnouncement?: Resolver<ResolversTypes['DismissAnnouncementMutationPayload'], ParentType, ContextType, RequireFields<MutationDismissAdvisorAnnouncementArgs, 'input'>>;
  dismissCsvActivityExportBanner?: Resolver<ResolversTypes['DismissCsvActivityExportBannerMutationPayload'], ParentType, ContextType>;
  dismissFirmBillableAccountsCsvExport?: Resolver<ResolversTypes['DismissFirmBillableAccountsCsvExportMutationPayload'], ParentType, ContextType>;
  publishSolo401kConversionIntent?: Resolver<ResolversTypes['PublishSolo401kConversionIntentMutationPayload'], ParentType, ContextType, RequireFields<MutationPublishSolo401kConversionIntentArgs, 'input'>>;
  removeSolo401kQdiaFundLineup?: Resolver<ResolversTypes['RemoveSolo401kQdiaFundLineupMutationPayload'], ParentType, ContextType, RequireFields<MutationRemoveSolo401kQdiaFundLineupArgs, 'input'>>;
  sendClientSecuritiesLendingInvitation?: Resolver<ResolversTypes['SendClientSecuritiesLendingInvitationMutationPayload'], ParentType, ContextType, RequireFields<MutationSendClientSecuritiesLendingInvitationArgs, 'input'>>;
  unenrollClientFromSecuritiesLending?: Resolver<ResolversTypes['UnenrollClientFromSecuritiesLendingMutationPayload'], ParentType, ContextType, RequireFields<MutationUnenrollClientFromSecuritiesLendingArgs, 'input'>>;
  updateBillingPlanPaymentTypes?: Resolver<ResolversTypes['UpdateBillingPlanPaymentTypesMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateBillingPlanPaymentTypesArgs, 'input'>>;
  updateClientEnvelopeBankAccounts?: Resolver<ResolversTypes['UpdateClientEnvelopeBankAccountsMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateClientEnvelopeBankAccountsArgs, 'input'>>;
  updateClientEnvelopeBeneficiaries?: Resolver<ResolversTypes['UpdateClientEnvelopeBeneficiariesMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateClientEnvelopeBeneficiariesArgs, 'input'>>;
  updateDefaultBillingPlan?: Resolver<ResolversTypes['UpdateDefaultBillingPlanMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateDefaultBillingPlanArgs, 'input'>>;
  updateHouseholdBillingPlan?: Resolver<ResolversTypes['UpdateHouseholdBillingPlanMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateHouseholdBillingPlanArgs, 'input'>>;
  updateManagedPortfolioRebalancing?: Resolver<ResolversTypes['UpdateManagedPortfolioRebalancingMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateManagedPortfolioRebalancingArgs, 'input'>>;
  updateOutboundIntegrationSubscription?: Resolver<ResolversTypes['UpdateOutboundIntegrationSubscriptionMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateOutboundIntegrationSubscriptionArgs, 'input'>>;
  updatePlanFeedConsent?: Resolver<ResolversTypes['UpdatePlanFeedConsentMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdatePlanFeedConsentArgs, 'input'>>;
  updateQdiaFundLineup?: Resolver<ResolversTypes['UpdateQdiaFundLineupMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateQdiaFundLineupArgs, 'input'>>;
  updateSolo401kConversionIntentContributions?: Resolver<ResolversTypes['UpdateSolo401kConversionIntentContributionsMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateSolo401kConversionIntentContributionsArgs, 'input'>>;
  updateSolo401kConversionIntentFundsType?: Resolver<ResolversTypes['UpdateSolo401kConversionIntentFundsTypeMutationPayload'], ParentType, ContextType, RequireFields<MutationUpdateSolo401kConversionIntentFundsTypeArgs, 'input'>>;
  upsertBillingPlan?: Resolver<ResolversTypes['UpsertBillingPlanMutationPayload'], ParentType, ContextType, RequireFields<MutationUpsertBillingPlanArgs, 'input'>>;
  validateClientEnvelopeBeneficiary?: Resolver<ResolversTypes['ValidateClientEnvelopeBeneficiaryMutationPayload'], ParentType, ContextType, RequireFields<MutationValidateClientEnvelopeBeneficiaryArgs, 'input'>>;
  validateFinancialSecurityOrderRequest?: Resolver<ResolversTypes['ValidateFinancialSecurityOrderRequestMutationPayload'], ParentType, ContextType, RequireFields<MutationValidateFinancialSecurityOrderRequestArgs, 'input'>>;
  validateSolo401kConversionIntent?: Resolver<ResolversTypes['ValidateSolo401kConversionIntentMutationPayload'], ParentType, ContextType, RequireFields<MutationValidateSolo401kConversionIntentArgs, 'input'>>;
  validateSolo401kPlanForm?: Resolver<ResolversTypes['ValidateSolo401kPlanFormMutationPayload'], ParentType, ContextType, RequireFields<MutationValidateSolo401kPlanFormArgs, 'input'>>;
};

export type NotSharedPlatformFeeAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['NotSharedPlatformFeeAllocation'] = ResolversParentTypes['NotSharedPlatformFeeAllocation']> = {
  paidBy?: Resolver<ResolversTypes['PlatformFeePaidBy'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OutboundIntegrationResolvers<ContextType = any, ParentType extends ResolversParentTypes['OutboundIntegration'] = ResolversParentTypes['OutboundIntegration']> = {
  components?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationType?: Resolver<ResolversTypes['OutboundIntegrationType'], ParentType, ContextType>;
  isSubscribed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  learnMoreUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = {
  endCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPreviousPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  startCursor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type PayrollContributionConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrollContributionConfig'] = ResolversParentTypes['PayrollContributionConfig']> = {
  bonusValue?: Resolver<Maybe<ResolversTypes['PayrollContributionConfigValue']>, ParentType, ContextType>;
  destinationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['PayrollContributionConfigValue'], ParentType, ContextType>;
};

export type PayrollContributionConfigAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrollContributionConfigAccount'] = ResolversParentTypes['PayrollContributionConfigAccount']> = {
  __resolveType: TypeResolveFn<'ManagedSubAccount', ParentType, ContextType>;
};

export type PayrollContributionConfigValueResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrollContributionConfigValue'] = ResolversParentTypes['PayrollContributionConfigValue']> = {
  __resolveType: TypeResolveFn<'PayrollContributionConfigValueAmount' | 'PayrollContributionConfigValuePercent', ParentType, ContextType>;
};

export type PayrollContributionConfigValueAmountResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrollContributionConfigValueAmount'] = ResolversParentTypes['PayrollContributionConfigValueAmount']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PayrollContributionConfigValuePercentResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayrollContributionConfigValuePercent'] = ResolversParentTypes['PayrollContributionConfigValuePercent']> = {
  percent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PendingActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PendingAction'] = ResolversParentTypes['PendingAction']> = {
  __resolveType: TypeResolveFn<'BulkTransferPendingAction' | 'PortfolioMigrationPendingAction' | 'RebalanceNowPendingAction' | 'StrategyChangePendingAction', ParentType, ContextType>;
};

export interface PercentScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Percent'], any> {
  name: 'Percent';
}

export type PerformanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Performance'] = ResolversParentTypes['Performance']> = {
  history?: Resolver<ResolversTypes['PerformanceHistory'], ParentType, ContextType>;
  totals?: Resolver<ResolversTypes['PerformanceTotals'], ParentType, ContextType>;
};

export type PerformanceAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceAccount'] = ResolversParentTypes['PerformanceAccount']> = {
  __resolveType: TypeResolveFn<'CashAccount', ParentType, ContextType>;
};

export type PerformanceHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceHistory'] = ResolversParentTypes['PerformanceHistory']> = {
  recencyDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type PerformanceInterestResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceInterest'] = ResolversParentTypes['PerformanceInterest']> = {
  accrued?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  accruedExplanation?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  paid?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type PerformanceTotalsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PerformanceTotals'] = ResolversParentTypes['PerformanceTotals']> = {
  earned?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  interest?: Resolver<Maybe<ResolversTypes['PerformanceInterest']>, ParentType, ContextType>;
};

export type PlatformFeeAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformFeeAllocation'] = ResolversParentTypes['PlatformFeeAllocation']> = {
  __resolveType: TypeResolveFn<'NotSharedPlatformFeeAllocation' | 'SharedPlatformFeeAllocation', ParentType, ContextType>;
};

export type PlatformFeeTierResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlatformFeeTier'] = ResolversParentTypes['PlatformFeeTier']> = {
  fee?: Resolver<ResolversTypes['Bps'], ParentType, ContextType>;
  tierEnd?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
};

export type PortfolioChangePendingActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioChangePendingAction'] = ResolversParentTypes['PortfolioChangePendingAction']> = {
  __resolveType: TypeResolveFn<'BulkTransferPendingAction' | 'PortfolioMigrationPendingAction' | 'StrategyChangePendingAction', ParentType, ContextType>;
};

export type PortfolioMigrationPendingActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PortfolioMigrationPendingAction'] = ResolversParentTypes['PortfolioMigrationPendingAction']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  futurePortfolio?: Resolver<ResolversTypes['FuturePortfolio'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isFirmDesigned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProjectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Projection'] = ResolversParentTypes['Projection']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type ProviderModelPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProviderModelPortfolio'] = ResolversParentTypes['ProviderModelPortfolio']> = {
  defaultRiskLevel?: Resolver<ResolversTypes['ModelPortfolioRiskLevel'], ParentType, ContextType>;
  detailedDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  features?: Resolver<Array<ResolversTypes['ModelPortfolioFeature']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  modelPortfolioProvider?: Resolver<ResolversTypes['ModelPortfolioProvider'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  resources?: Resolver<Array<ResolversTypes['ModelPortfolioResource']>, ParentType, ContextType>;
  summary?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type ProviderModelPortfolioConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProviderModelPortfolioConnection'] = ResolversParentTypes['ProviderModelPortfolioConnection']> = {
  edges?: Resolver<Array<ResolversTypes['ProviderModelPortfolioEdge']>, ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['ProviderModelPortfolio']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ProviderModelPortfolioEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProviderModelPortfolioEdge'] = ResolversParentTypes['ProviderModelPortfolioEdge']> = {
  cursor?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ProviderModelPortfolio'], ParentType, ContextType>;
};

export type PublishSolo401kConversionIntentMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['PublishSolo401kConversionIntentMutationPayload'] = ResolversParentTypes['PublishSolo401kConversionIntentMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Solo401kConversionIntent']>, ParentType, ContextType>;
};

export type PurposeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Purpose'] = ResolversParentTypes['Purpose']> = {
  __resolveType: TypeResolveFn<'PurposeEmergencyFund' | 'PurposeMajorPurchase' | 'PurposeRetirementGrowth' | 'PurposeRetirementIncome', ParentType, ContextType>;
};

export type PurposeEmergencyFundResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeEmergencyFund'] = ResolversParentTypes['PurposeEmergencyFund']> = {
  ageAtCompletion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyGoalId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purposeStatus?: Resolver<ResolversTypes['PurposeStatus'], ParentType, ContextType>;
  targetAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  targetDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurposeMajorPurchaseResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeMajorPurchase'] = ResolversParentTypes['PurposeMajorPurchase']> = {
  ageAtCompletion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyGoalId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purposeStatus?: Resolver<ResolversTypes['PurposeStatus'], ParentType, ContextType>;
  targetAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  targetDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurposeRetirementGrowthResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeRetirementGrowth'] = ResolversParentTypes['PurposeRetirementGrowth']> = {
  ageAtCompletion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyGoalId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  purposeStatus?: Resolver<ResolversTypes['PurposeStatus'], ParentType, ContextType>;
  targetAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  targetDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurposeRetirementIncomeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeRetirementIncome'] = ResolversParentTypes['PurposeRetirementIncome']> = {
  ageAtCompletion?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  icon?: Resolver<ResolversTypes['ThemedAsset'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  legacyGoalId?: Resolver<ResolversTypes['LegacyID'], ParentType, ContextType>;
  lifeExpectancyAge?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  projection?: Resolver<ResolversTypes['PurposeRetirementIncomeProjection'], ParentType, ContextType>;
  purposeStatus?: Resolver<ResolversTypes['PurposeStatus'], ParentType, ContextType>;
  targetAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  targetDate?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PurposeRetirementIncomeProjectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PurposeRetirementIncomeProjection'] = ResolversParentTypes['PurposeRetirementIncomeProjection']> = {
  recommendedMonthlyOutflows?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  activityConnection?: Resolver<ResolversTypes['ActivityItemConnection'], ParentType, ContextType, RequireFields<QueryActivityConnectionArgs, 'filters'>>;
  activityDateRangeOptions?: Resolver<Array<ResolversTypes['DateRangeOption']>, ParentType, ContextType>;
  activityItemClientOptions?: Resolver<Array<ResolversTypes['Client']>, ParentType, ContextType, RequireFields<QueryActivityItemClientOptionsArgs, 'householdId'>>;
  activityItemTypeOptions?: Resolver<Array<ResolversTypes['ActivityItemTypeFilterOption']>, ParentType, ContextType>;
  advisorGoalCreation?: Resolver<Maybe<ResolversTypes['AdvisorGoalCreation']>, ParentType, ContextType, RequireFields<QueryAdvisorGoalCreationArgs, 'id'>>;
  advisorTypeOptions?: Resolver<Array<ResolversTypes['ActivityAdvisorType']>, ParentType, ContextType>;
  assignedAccountSummary?: Resolver<ResolversTypes['AssignedAccountSummary'], ParentType, ContextType, RequireFields<QueryAssignedAccountSummaryArgs, 'modelPortfolioId'>>;
  billingPlanAffectedHouseholds?: Resolver<Array<ResolversTypes['AffectedHousehold']>, ParentType, ContextType, RequireFields<QueryBillingPlanAffectedHouseholdsArgs, 'billingPlanId' | 'limit' | 'offset'>>;
  clientActivityCsvExport?: Resolver<Maybe<ResolversTypes['CsvExport']>, ParentType, ContextType>;
  clientEnvelope?: Resolver<ResolversTypes['ClientEnvelope'], ParentType, ContextType, RequireFields<QueryClientEnvelopeArgs, 'id'>>;
  currentAdvisor?: Resolver<ResolversTypes['Advisor'], ParentType, ContextType>;
  disclosures?: Resolver<ResolversTypes['Disclosures'], ParentType, ContextType>;
  employmentStatuses?: Resolver<Array<ResolversTypes['Dictionary']>, ParentType, ContextType>;
  envelopeAccount?: Resolver<ResolversTypes['EnvelopeAccount'], ParentType, ContextType, RequireFields<QueryEnvelopeAccountArgs, 'id'>>;
  estimatedTradeTiming?: Resolver<ResolversTypes['EstimatedTradeTiming'], ParentType, ContextType, RequireFields<QueryEstimatedTradeTimingArgs, 'financialSecurityId'>>;
  federalTaxRates?: Resolver<Array<ResolversTypes['Dictionary']>, ParentType, ContextType>;
  firm?: Resolver<ResolversTypes['Firm'], ParentType, ContextType>;
  firmBillableAccountsCsvExport?: Resolver<Maybe<ResolversTypes['CsvExport']>, ParentType, ContextType>;
  fourOhOneKPlan?: Resolver<Maybe<ResolversTypes['FourOhOneKPlan']>, ParentType, ContextType, RequireFields<QueryFourOhOneKPlanArgs, 'id'>>;
  fourOhOneKPlans?: Resolver<Maybe<Array<ResolversTypes['AdvisedPlan']>>, ParentType, ContextType, Partial<QueryFourOhOneKPlansArgs>>;
  highlightedModelPortfolioProviders?: Resolver<Array<ResolversTypes['ModelPortfolioProvider']>, ParentType, ContextType>;
  household?: Resolver<ResolversTypes['HouseholdResult'], ParentType, ContextType, RequireFields<QueryHouseholdArgs, 'id'>>;
  legacyGoal?: Resolver<ResolversTypes['LegacyGoal'], ParentType, ContextType, RequireFields<QueryLegacyGoalArgs, 'id'>>;
  legacySubAccount?: Resolver<ResolversTypes['LegacySubAccount'], ParentType, ContextType, RequireFields<QueryLegacySubAccountArgs, 'id'>>;
  legalSubAccounts?: Resolver<Array<ResolversTypes['LegalSubAccount']>, ParentType, ContextType>;
  managedAccount?: Resolver<ResolversTypes['ManagedAccount'], ParentType, ContextType, RequireFields<QueryManagedAccountArgs, 'id'>>;
  modelPortfolioProviderConnection?: Resolver<ResolversTypes['ModelPortfolioProviderConnection'], ParentType, ContextType, Partial<QueryModelPortfolioProviderConnectionArgs>>;
  outboundIntegrations?: Resolver<Array<ResolversTypes['OutboundIntegration']>, ParentType, ContextType>;
  providerModelPortfolio?: Resolver<ResolversTypes['ProviderModelPortfolio'], ParentType, ContextType, RequireFields<QueryProviderModelPortfolioArgs, 'id'>>;
  securityPosition?: Resolver<Maybe<ResolversTypes['SecurityPositionsBySecurity']>, ParentType, ContextType, RequireFields<QuerySecurityPositionArgs, 'financialSecurityId' | 'managedAccountId'>>;
  solo401kConversionIntent?: Resolver<ResolversTypes['Solo401kConversionIntent'], ParentType, ContextType, RequireFields<QuerySolo401kConversionIntentArgs, 'id'>>;
  solo401kConversionIntents?: Resolver<Array<ResolversTypes['Solo401kConversionIntent']>, ParentType, ContextType, RequireFields<QuerySolo401kConversionIntentsArgs, 'planOwnerId'>>;
  support?: Resolver<ResolversTypes['SupportResources'], ParentType, ContextType>;
  taxFilingStatuses?: Resolver<Array<ResolversTypes['Dictionary']>, ParentType, ContextType>;
};

export type RebalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Rebalance'] = ResolversParentTypes['Rebalance']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isCustomerEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isRebalanceNowEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isSystemEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type RebalanceNowPendingActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebalanceNowPendingAction'] = ResolversParentTypes['RebalanceNowPendingAction']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecordNotFoundResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecordNotFoundResult'] = ResolversParentTypes['RecordNotFoundResult']> = {
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransactionConfigResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionConfig'] = ResolversParentTypes['RecurringTransactionConfig']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  destinationName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  frequency?: Resolver<ResolversTypes['RecurringTransactionFrequency'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEditable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  legacyId?: Resolver<Maybe<ResolversTypes['LegacyID']>, ParentType, ContextType>;
  legacyTransferType?: Resolver<ResolversTypes['LegacyTransferType'], ParentType, ContextType>;
  legacyUuid?: Resolver<Maybe<ResolversTypes['LegacyUUID']>, ParentType, ContextType>;
  source?: Resolver<Maybe<ResolversTypes['CashAccount']>, ParentType, ContextType>;
  sourceName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type RecurringTransactionFrequencyResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionFrequency'] = ResolversParentTypes['RecurringTransactionFrequency']> = {
  __resolveType: TypeResolveFn<'RecurringTransactionFrequencyAnnually' | 'RecurringTransactionFrequencyEveryOtherWeek' | 'RecurringTransactionFrequencyMonthly' | 'RecurringTransactionFrequencyTwiceAMonth' | 'RecurringTransactionFrequencyWeekly', ParentType, ContextType>;
};

export type RecurringTransactionFrequencyAnnuallyResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionFrequencyAnnually'] = ResolversParentTypes['RecurringTransactionFrequencyAnnually']> = {
  day?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  month?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransactionFrequencyEveryOtherWeekResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionFrequencyEveryOtherWeek'] = ResolversParentTypes['RecurringTransactionFrequencyEveryOtherWeek']> = {
  day?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransactionFrequencyMonthlyResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionFrequencyMonthly'] = ResolversParentTypes['RecurringTransactionFrequencyMonthly']> = {
  day?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransactionFrequencyTwiceAMonthResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionFrequencyTwiceAMonth'] = ResolversParentTypes['RecurringTransactionFrequencyTwiceAMonth']> = {
  firstDay?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  secondDay?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RecurringTransactionFrequencyWeeklyResolvers<ContextType = any, ParentType extends ResolversParentTypes['RecurringTransactionFrequencyWeekly'] = ResolversParentTypes['RecurringTransactionFrequencyWeekly']> = {
  day?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RemoveSolo401kQdiaFundLineupMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['RemoveSolo401kQdiaFundLineupMutationPayload'] = ResolversParentTypes['RemoveSolo401kQdiaFundLineupMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Solo401kPlan']>, ParentType, ContextType>;
};

export type ResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['Result'] = ResolversParentTypes['Result']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  thisYear?: Resolver<ResolversTypes['Annual'], ParentType, ContextType>;
};

export type RiskLevelBasedPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskLevelBasedPortfolio'] = ResolversParentTypes['RiskLevelBasedPortfolio']> = {
  drift?: Resolver<ResolversTypes['Drift'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isStrategySelectionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rebalance?: Resolver<ResolversTypes['Rebalance'], ParentType, ContextType>;
  strategyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAllocationDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskLevelSecurityGroupAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['RiskLevelSecurityGroupAllocation'] = ResolversParentTypes['RiskLevelSecurityGroupAllocation']> = {
  securityGroup?: Resolver<ResolversTypes['ModelPortfolioSecurityGroup'], ParentType, ContextType>;
  targetWeight?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type SblocLoanResolvers<ContextType = any, ParentType extends ResolversParentTypes['SblocLoan'] = ResolversParentTypes['SblocLoan']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type SecuritiesLendingResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecuritiesLending'] = ResolversParentTypes['SecuritiesLending']> = {
  enabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['SecuritiesLendingStatus'], ParentType, ContextType>;
};

export type SecurityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Security'] = ResolversParentTypes['Security']> = {
  __resolveType: TypeResolveFn<'SecurityFund' | 'SecurityStock', ParentType, ContextType>;
};

export type SecurityCategoryGroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityCategoryGroup'] = ResolversParentTypes['SecurityCategoryGroup']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  securities?: Resolver<Array<ResolversTypes['LegacySecurity']>, ParentType, ContextType>;
};

export type SecurityFundResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityFund'] = ResolversParentTypes['SecurityFund']> = {
  expenseRatio?: Resolver<ResolversTypes['ExpenseRatio'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  prospectusUrl?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tlhPriority?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SecurityGroupPositionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityGroupPosition'] = ResolversParentTypes['SecurityGroupPosition']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  averageExpenseRatioPercent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  currentWeight?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  drift?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  fundFees?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isRogueSecurity?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  securityGroup?: Resolver<ResolversTypes['SecurityGroupSummary'], ParentType, ContextType>;
  securityPositions?: Resolver<Array<ResolversTypes['SecurityPosition']>, ParentType, ContextType>;
  securityPositionsBySecurity?: Resolver<Array<ResolversTypes['SecurityPositionsBySecurity']>, ParentType, ContextType>;
};

export type SecurityGroupSummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityGroupSummary'] = ResolversParentTypes['SecurityGroupSummary']> = {
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  securities?: Resolver<Array<ResolversTypes['Security']>, ParentType, ContextType>;
  sellOnlySubstituteSecurities?: Resolver<Array<ResolversTypes['FinancialSecurity']>, ParentType, ContextType>;
  targetWeight?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type SecurityPositionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityPosition'] = ResolversParentTypes['SecurityPosition']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  expenseAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  financialSecurity?: Resolver<ResolversTypes['FinancialSecurity'], ParentType, ContextType>;
  security?: Resolver<ResolversTypes['Security'], ParentType, ContextType>;
  shares?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
};

export type SecurityPositionsBySecurityResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityPositionsBySecurity'] = ResolversParentTypes['SecurityPositionsBySecurity']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  currentWeight?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expenseAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  financialSecurity?: Resolver<ResolversTypes['FinancialSecurity'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pendingOrders?: Resolver<Array<ResolversTypes['FinancialSecurityOrderRequest']>, ParentType, ContextType>;
  securityPositionsBySubAccount?: Resolver<Array<ResolversTypes['SecurityPositionsBySubAccount']>, ParentType, ContextType>;
  shares?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SecurityPositionsBySubAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityPositionsBySubAccount'] = ResolversParentTypes['SecurityPositionsBySubAccount']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  expenseAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  securityPositions?: Resolver<Array<ResolversTypes['SecurityPosition']>, ParentType, ContextType>;
  shares?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  subAccount?: Resolver<ResolversTypes['LegalSubAccount'], ParentType, ContextType>;
};

export type SecurityStockResolvers<ContextType = any, ParentType extends ResolversParentTypes['SecurityStock'] = ResolversParentTypes['SecurityStock']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  symbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SelfDirectedPortfolioResolvers<ContextType = any, ParentType extends ResolversParentTypes['SelfDirectedPortfolio'] = ResolversParentTypes['SelfDirectedPortfolio']> = {
  drift?: Resolver<ResolversTypes['Drift'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isStrategySelectionEligible?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  rebalance?: Resolver<ResolversTypes['Rebalance'], ParentType, ContextType>;
  strategyName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetAllocationDescription?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SendClientSecuritiesLendingInvitationMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['SendClientSecuritiesLendingInvitationMutationPayload'] = ResolversParentTypes['SendClientSecuritiesLendingInvitationMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['EmailDispatch']>, ParentType, ContextType>;
};

export type SharedPlatformFeeAllocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SharedPlatformFeeAllocation'] = ResolversParentTypes['SharedPlatformFeeAllocation']> = {
  clientPortion?: Resolver<ResolversTypes['Bps'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SingleBillingRateResolvers<ContextType = any, ParentType extends ResolversParentTypes['SingleBillingRate'] = ResolversParentTypes['SingleBillingRate']> = {
  __resolveType: TypeResolveFn<'BillingRateAssetBased' | 'BillingRateFixed', ParentType, ContextType>;
};

export type Solo401kClientEnvelopeResolvers<ContextType = any, ParentType extends ResolversParentTypes['Solo401kClientEnvelope'] = ResolversParentTypes['Solo401kClientEnvelope']> = {
  clients?: Resolver<Array<ResolversTypes['ClientEnvelopeClient']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['ClientEnvelopeClient']>, ParentType, ContextType>;
  publishedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['FourOhOneKPlanType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Solo401kConversionContributionDetailResolvers<ContextType = any, ParentType extends ResolversParentTypes['Solo401kConversionContributionDetail'] = ResolversParentTypes['Solo401kConversionContributionDetail']> = {
  contributionType?: Resolver<ResolversTypes['Solo401kConversionContributionCategory'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  initialRothContributionOn?: Resolver<Maybe<ResolversTypes['Date']>, ParentType, ContextType>;
  itdEmployeeContributions?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  itdEmployerContributions?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  itdRolloverAmount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  ytdEmployeeContributions?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  ytdEmployerContributions?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
};

export type Solo401kConversionIntentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Solo401kConversionIntent'] = ResolversParentTypes['Solo401kConversionIntent']> = {
  employerName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  includesSpouse?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  overallFundTypeInclusion?: Resolver<Maybe<ResolversTypes['Solo401kConversionFundsCategory']>, ParentType, ContextType>;
  ownerFundTypeInclusion?: Resolver<Maybe<ResolversTypes['Solo401kConversionFundsCategory']>, ParentType, ContextType>;
  planOwner?: Resolver<ResolversTypes['Client'], ParentType, ContextType>;
  planOwnerContributions?: Resolver<Array<ResolversTypes['Solo401kConversionContributionDetail']>, ParentType, ContextType>;
  planSpouse?: Resolver<Maybe<ResolversTypes['Client']>, ParentType, ContextType>;
  planSpouseContributions?: Resolver<Array<ResolversTypes['Solo401kConversionContributionDetail']>, ParentType, ContextType>;
  spouseFundTypeInclusion?: Resolver<Maybe<ResolversTypes['Solo401kConversionFundsCategory']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['Solo401kConversionIntentStatus'], ParentType, ContextType>;
};

export type Solo401kPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['Solo401kPlan'] = ResolversParentTypes['Solo401kPlan']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  planName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  qdiaFundLineup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
};

export type SoloFourOhOneKParticipantResolvers<ContextType = any, ParentType extends ResolversParentTypes['SoloFourOhOneKParticipant'] = ResolversParentTypes['SoloFourOhOneKParticipant']> = {
  fullName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
};

export type SoloFourOhOneKPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['SoloFourOhOneKPlan'] = ResolversParentTypes['SoloFourOhOneKPlan']> = {
  documents?: Resolver<Array<ResolversTypes['FourOhOneKDocument']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentOptions?: Resolver<Maybe<Array<ResolversTypes['BettermentModelPortfolio']>>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<SoloFourOhOneKPlanMessagesArgs, 'location'>>;
  modelPortfolio?: Resolver<Maybe<ResolversTypes['ExternallyAdvisedPlanPortfolio']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  onboarding?: Resolver<ResolversTypes['FourOhOneKPlanOnboarding'], ParentType, ContextType>;
  owner?: Resolver<Maybe<ResolversTypes['SoloFourOhOneKParticipant']>, ParentType, ContextType>;
  participants?: Resolver<Array<ResolversTypes['SoloFourOhOneKParticipant']>, ParentType, ContextType>;
  performanceIndicators?: Resolver<ResolversTypes['FourOhOneKPlanPerformanceIndicators'], ParentType, ContextType>;
  planFeedConsent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  planFiduciary?: Resolver<ResolversTypes['FourOhOneKPlanFiduciary'], ParentType, ContextType>;
  qdiaFundName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportCreationOptions?: Resolver<Array<ResolversTypes['FourOhOneKReportCreationOption']>, ParentType, ContextType>;
  reports?: Resolver<Maybe<Array<ResolversTypes['FourOhOneKReport']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['FourOhOneKPlanStatusType'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['FourOhOneKPlanType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StandardFourOhOneKPlanResolvers<ContextType = any, ParentType extends ResolversParentTypes['StandardFourOhOneKPlan'] = ResolversParentTypes['StandardFourOhOneKPlan']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  investmentOptions?: Resolver<Maybe<Array<ResolversTypes['BettermentModelPortfolio']>>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType, RequireFields<StandardFourOhOneKPlanMessagesArgs, 'location'>>;
  modelPortfolio?: Resolver<Maybe<ResolversTypes['ExternallyAdvisedPlanPortfolio']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  onboarding?: Resolver<ResolversTypes['FourOhOneKPlanOnboarding'], ParentType, ContextType>;
  performanceIndicators?: Resolver<ResolversTypes['FourOhOneKPlanPerformanceIndicators'], ParentType, ContextType>;
  planFeedConsent?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  planFiduciary?: Resolver<ResolversTypes['FourOhOneKPlanFiduciary'], ParentType, ContextType>;
  planManagers?: Resolver<Array<ResolversTypes['FourOhOneKPlanManager']>, ParentType, ContextType>;
  qdiaFundName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportCreationOptions?: Resolver<Array<ResolversTypes['FourOhOneKReportCreationOption']>, ParentType, ContextType>;
  reports?: Resolver<Maybe<Array<ResolversTypes['FourOhOneKReport']>>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['FourOhOneKPlanStatusType'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['FourOhOneKPlanType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StrategyChangePendingActionResolvers<ContextType = any, ParentType extends ResolversParentTypes['StrategyChangePendingAction'] = ResolversParentTypes['StrategyChangePendingAction']> = {
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  futurePortfolio?: Resolver<ResolversTypes['FuturePortfolio'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SummaryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Summary'] = ResolversParentTypes['Summary']> = {
  annualGainsAllowance?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  identifyingTaxpayerId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  longTerm?: Resolver<ResolversTypes['Gains'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  shortTerm?: Resolver<ResolversTypes['Gains'], ParentType, ContextType>;
  yearToDateNetRealizedGains?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
};

export type SupportContactResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportContact'] = ResolversParentTypes['SupportContact']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  weekdayHours?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
};

export type SupportResourcesResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportResources'] = ResolversParentTypes['SupportResources']> = {
  advisor?: Resolver<ResolversTypes['SupportContact'], ParentType, ContextType>;
  client?: Resolver<ResolversTypes['SupportContact'], ParentType, ContextType>;
  fourOhOneKPlan?: Resolver<Maybe<ResolversTypes['FourOhOneKPlanSupportResource']>, ParentType, ContextType>;
};

export interface TinScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['TIN'], any> {
  name: 'TIN';
}

export type TaxImpactResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxImpact'] = ResolversParentTypes['TaxImpact']> = {
  longTermGain?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  longTermLoss?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  longTermPermanentlyWashed?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  longTermWashed?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netEstimatedTaxes?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netGain?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netLongTerm?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netShortTerm?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  shortTermGain?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  shortTermLoss?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  shortTermPermanentlyWashed?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  shortTermWashed?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  transactionPending?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type TaxYearResolvers<ContextType = any, ParentType extends ResolversParentTypes['TaxYear'] = ResolversParentTypes['TaxYear']> = {
  fourOhOneKContributionLimit?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  iraContributionLimit?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  isEligibleForFourOhOneKContributionCatchUp?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEligibleForIraContributionCatchUp?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isEligibleForIraContributions?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  year?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
};

export type ThemedAssetResolvers<ContextType = any, ParentType extends ResolversParentTypes['ThemedAsset'] = ResolversParentTypes['ThemedAsset']> = {
  dark?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  light?: Resolver<ResolversTypes['URL'], ParentType, ContextType>;
};

export type TradePreviewResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradePreview'] = ResolversParentTypes['TradePreview']> = {
  expectedTrades?: Resolver<Array<ResolversTypes['TradePreviewExpectedTrade']>, ParentType, ContextType>;
  gainsDetails?: Resolver<Maybe<ResolversTypes['GainsDetails']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  longTermGain?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  longTermLoss?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  longTermPermanentlyWashed?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  longTermWashed?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netEstimatedTaxes?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netGain?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netLongTerm?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  netShortTerm?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  postTradeDrift?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  preTradeDrift?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  rebalanceDriftThreshold?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  remainingGainsAllowance?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  shortTermGain?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  shortTermLoss?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  shortTermPermanentlyWashed?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  shortTermWashed?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  tradingInstruction?: Resolver<ResolversTypes['TradePreviewTradingInstruction'], ParentType, ContextType>;
  transactionPending?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type TradePreviewExpectedSecurityGroupTradeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradePreviewExpectedSecurityGroupTrade'] = ResolversParentTypes['TradePreviewExpectedSecurityGroupTrade']> = {
  action?: Resolver<ResolversTypes['TradePreviewExpectedTradeAction'], ParentType, ContextType>;
  afterTradeValue?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  afterTradeWeight?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  beforeTradeValue?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  beforeTradeWeight?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expectedSecurityTrades?: Resolver<Array<ResolversTypes['TradePreviewExpectedSecurityTrade']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  targetWeight?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  tradeValue?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradePreviewExpectedSecurityTradeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradePreviewExpectedSecurityTrade'] = ResolversParentTypes['TradePreviewExpectedSecurityTrade']> = {
  action?: Resolver<ResolversTypes['TradePreviewExpectedTradeAction'], ParentType, ContextType>;
  afterTradeValue?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  afterTradeWeight?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  beforeTradeValue?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  beforeTradeWeight?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
  displayName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  tickerSymbol?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tradeValue?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TradePreviewExpectedTradeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TradePreviewExpectedTrade'] = ResolversParentTypes['TradePreviewExpectedTrade']> = {
  __resolveType: TypeResolveFn<'TradePreviewExpectedSecurityGroupTrade' | 'TradePreviewExpectedSecurityTrade', ParentType, ContextType>;
};

export type TrustResolvers<ContextType = any, ParentType extends ResolversParentTypes['Trust'] = ResolversParentTypes['Trust']> = {
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  individualGrantor?: Resolver<Maybe<ResolversTypes['Client']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface UrlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['URL'], any> {
  name: 'URL';
}

export type UnenrollClientFromSecuritiesLendingMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnenrollClientFromSecuritiesLendingMutationPayload'] = ResolversParentTypes['UnenrollClientFromSecuritiesLendingMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['UserPortfolioControls']>, ParentType, ContextType>;
};

export type UpdateBillingPlanPaymentTypesMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateBillingPlanPaymentTypesMutationPayload'] = ResolversParentTypes['UpdateBillingPlanPaymentTypesMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Firm']>, ParentType, ContextType>;
};

export type UpdateClientEnvelopeBankAccountsMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateClientEnvelopeBankAccountsMutationPayload'] = ResolversParentTypes['UpdateClientEnvelopeBankAccountsMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['ClientEnvelope']>, ParentType, ContextType>;
};

export type UpdateClientEnvelopeBeneficiariesMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateClientEnvelopeBeneficiariesMutationPayload'] = ResolversParentTypes['UpdateClientEnvelopeBeneficiariesMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['ClientEnvelope']>, ParentType, ContextType>;
};

export type UpdateDefaultBillingPlanMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateDefaultBillingPlanMutationPayload'] = ResolversParentTypes['UpdateDefaultBillingPlanMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Firm']>, ParentType, ContextType>;
};

export type UpdateHouseholdBillingPlanMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateHouseholdBillingPlanMutationPayload'] = ResolversParentTypes['UpdateHouseholdBillingPlanMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Household']>, ParentType, ContextType>;
};

export type UpdateManagedPortfolioRebalancingMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateManagedPortfolioRebalancingMutationPayload'] = ResolversParentTypes['UpdateManagedPortfolioRebalancingMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['ManagedPortfolio']>, ParentType, ContextType>;
};

export type UpdateOutboundIntegrationSubscriptionMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateOutboundIntegrationSubscriptionMutationPayload'] = ResolversParentTypes['UpdateOutboundIntegrationSubscriptionMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['OutboundIntegration']>, ParentType, ContextType>;
};

export type UpdatePlanFeedConsentMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdatePlanFeedConsentMutationPayload'] = ResolversParentTypes['UpdatePlanFeedConsentMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['FourOhOneKPlan']>, ParentType, ContextType>;
};

export type UpdateQdiaFundLineupMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateQdiaFundLineupMutationPayload'] = ResolversParentTypes['UpdateQdiaFundLineupMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Solo401kPlan']>, ParentType, ContextType>;
};

export type UpdateSolo401kConversionIntentContributionsMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateSolo401kConversionIntentContributionsMutationPayload'] = ResolversParentTypes['UpdateSolo401kConversionIntentContributionsMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Solo401kConversionIntent']>, ParentType, ContextType>;
};

export type UpdateSolo401kConversionIntentFundsTypeMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpdateSolo401kConversionIntentFundsTypeMutationPayload'] = ResolversParentTypes['UpdateSolo401kConversionIntentFundsTypeMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Solo401kConversionIntent']>, ParentType, ContextType>;
};

export type UpsertBillingPlanMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['UpsertBillingPlanMutationPayload'] = ResolversParentTypes['UpsertBillingPlanMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Firm']>, ParentType, ContextType>;
};

export type UserPortfolioControlsResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserPortfolioControls'] = ResolversParentTypes['UserPortfolioControls']> = {
  securitiesLending?: Resolver<ResolversTypes['SecuritiesLending'], ParentType, ContextType>;
  taxLossHarvestingEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type ValidCentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidCents'] = ResolversParentTypes['ValidCents']> = {
  value?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ValidateClientEnvelopeBeneficiaryMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateClientEnvelopeBeneficiaryMutationPayload'] = ResolversParentTypes['ValidateClientEnvelopeBeneficiaryMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
};

export type ValidateFinancialSecurityOrderRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateFinancialSecurityOrderRequest'] = ResolversParentTypes['ValidateFinancialSecurityOrderRequest']> = {
  aboveSellAllThreshold?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  sellAllThreshold?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type ValidateFinancialSecurityOrderRequestMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateFinancialSecurityOrderRequestMutationPayload'] = ResolversParentTypes['ValidateFinancialSecurityOrderRequestMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['ValidateFinancialSecurityOrderRequest']>, ParentType, ContextType>;
};

export type ValidateSolo401kConversionIntentMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateSolo401kConversionIntentMutationPayload'] = ResolversParentTypes['ValidateSolo401kConversionIntentMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['Solo401kConversionIntent']>, ParentType, ContextType>;
};

export type ValidateSolo401kPlanFormMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidateSolo401kPlanFormMutationPayload'] = ResolversParentTypes['ValidateSolo401kPlanFormMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['ValidatedSolo401kPlanForm']>, ParentType, ContextType>;
};

export type ValidatedSolo401kPlanFormResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidatedSolo401kPlanForm'] = ResolversParentTypes['ValidatedSolo401kPlanForm']> = {
  isValid?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
};

export type VestedResolvers<ContextType = any, ParentType extends ResolversParentTypes['Vested'] = ResolversParentTypes['Vested']> = {
  amount?: Resolver<ResolversTypes['Cents'], ParentType, ContextType>;
  percent?: Resolver<ResolversTypes['Percent'], ParentType, ContextType>;
};

export type YtdReturnResolvers<ContextType = any, ParentType extends ResolversParentTypes['YtdReturn'] = ResolversParentTypes['YtdReturn']> = {
  amount?: Resolver<Maybe<ResolversTypes['Cents']>, ParentType, ContextType>;
  moneyWeighted?: Resolver<Maybe<ResolversTypes['Percent']>, ParentType, ContextType>;
  timeWeighted?: Resolver<Maybe<ResolversTypes['Percent']>, ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AccountHolder?: AccountHolderResolvers<ContextType>;
  AccountYtdReturn?: AccountYtdReturnResolvers<ContextType>;
  ActivityItem?: ActivityItemResolvers<ContextType>;
  ActivityItemAllocationChange?: ActivityItemAllocationChangeResolvers<ContextType>;
  ActivityItemConnection?: ActivityItemConnectionResolvers<ContextType>;
  ActivityItemDeposit?: ActivityItemDepositResolvers<ContextType>;
  ActivityItemEdge?: ActivityItemEdgeResolvers<ContextType>;
  ActivityItemFee?: ActivityItemFeeResolvers<ContextType>;
  ActivityItemOrder?: ActivityItemOrderResolvers<ContextType>;
  ActivityItemOther?: ActivityItemOtherResolvers<ContextType>;
  ActivityItemStatus?: ActivityItemStatusResolvers<ContextType>;
  ActivityItemTrade?: ActivityItemTradeResolvers<ContextType>;
  ActivityItemTradeGroup?: ActivityItemTradeGroupResolvers<ContextType>;
  ActivityItemTransfer?: ActivityItemTransferResolvers<ContextType>;
  ActivityItemTransferGroup?: ActivityItemTransferGroupResolvers<ContextType>;
  ActivityItemWithdrawal?: ActivityItemWithdrawalResolvers<ContextType>;
  AdvisedPlan?: AdvisedPlanResolvers<ContextType>;
  Advisor?: AdvisorResolvers<ContextType>;
  AdvisorGoalCreation?: AdvisorGoalCreationResolvers<ContextType>;
  AdvisorGoalCreationAccount?: AdvisorGoalCreationAccountResolvers<ContextType>;
  AffectedHousehold?: AffectedHouseholdResolvers<ContextType>;
  AgreementDocument?: AgreementDocumentResolvers<ContextType>;
  Announcement?: AnnouncementResolvers<ContextType>;
  AnnouncementDismissal?: AnnouncementDismissalResolvers<ContextType>;
  AnnouncementRedirect?: AnnouncementRedirectResolvers<ContextType>;
  AnnouncementStep?: AnnouncementStepResolvers<ContextType>;
  AnnouncementStepCta?: AnnouncementStepCtaResolvers<ContextType>;
  AnnouncementStepImage?: AnnouncementStepImageResolvers<ContextType>;
  Annual?: AnnualResolvers<ContextType>;
  AnnualIraContributions?: AnnualIraContributionsResolvers<ContextType>;
  AssignedAccountSummary?: AssignedAccountSummaryResolvers<ContextType>;
  Autoglide?: AutoglideResolvers<ContextType>;
  BankAccount?: BankAccountResolvers<ContextType>;
  BettermentModelPortfolio?: BettermentModelPortfolioResolvers<ContextType>;
  BillingPlan?: BillingPlanResolvers<ContextType>;
  BillingRate?: BillingRateResolvers<ContextType>;
  BillingRateAssetBased?: BillingRateAssetBasedResolvers<ContextType>;
  BillingRateFixed?: BillingRateFixedResolvers<ContextType>;
  BillingRateRange?: BillingRateRangeResolvers<ContextType>;
  BillingRateTiered?: BillingRateTieredResolvers<ContextType>;
  BlockingTask?: BlockingTaskResolvers<ContextType>;
  Bps?: GraphQLScalarType;
  BulkFeeAttempt?: BulkFeeAttemptResolvers<ContextType>;
  BulkFeeIntent?: BulkFeeIntentResolvers<ContextType>;
  BulkTransferPendingAction?: BulkTransferPendingActionResolvers<ContextType>;
  CashAccount?: CashAccountResolvers<ContextType>;
  CashApy?: CashApyResolvers<ContextType>;
  CashFdicInsurance?: CashFdicInsuranceResolvers<ContextType>;
  Cents?: GraphQLScalarType;
  Client?: ClientResolvers<ContextType>;
  ClientAccountBeneficiary?: ClientAccountBeneficiaryResolvers<ContextType>;
  ClientAccountTypeSummary?: ClientAccountTypeSummaryResolvers<ContextType>;
  ClientEnvelope?: ClientEnvelopeResolvers<ContextType>;
  ClientEnvelopeBankAccount?: ClientEnvelopeBankAccountResolvers<ContextType>;
  ClientEnvelopeClient?: ClientEnvelopeClientResolvers<ContextType>;
  ClientEnvelopeInterface?: ClientEnvelopeInterfaceResolvers<ContextType>;
  ClientEnvelopeInvitation?: ClientEnvelopeInvitationResolvers<ContextType>;
  Contribution?: ContributionResolvers<ContextType>;
  CreateBulkFeeIntentMutationPayload?: CreateBulkFeeIntentMutationPayloadResolvers<ContextType>;
  CreateClientActivityCsvExportMutationPayload?: CreateClientActivityCsvExportMutationPayloadResolvers<ContextType>;
  CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationPayload?: CreateDraft401kOnlyAdvisorSolo401kConversionIntentMutationPayloadResolvers<ContextType>;
  CreateDraftSolo401kConversionIntentMutationPayload?: CreateDraftSolo401kConversionIntentMutationPayloadResolvers<ContextType>;
  CreateFinancialSecurityOrderRequestMutationPayload?: CreateFinancialSecurityOrderRequestMutationPayloadResolvers<ContextType>;
  CreateFinancialSecuritySellOrderTaxImpactPreviewMutationPayload?: CreateFinancialSecuritySellOrderTaxImpactPreviewMutationPayloadResolvers<ContextType>;
  CreateFirmBillableAccountsCsvExportMutationPayload?: CreateFirmBillableAccountsCsvExportMutationPayloadResolvers<ContextType>;
  CreateFourOhOneKReportMutationPayload?: CreateFourOhOneKReportMutationPayloadResolvers<ContextType>;
  CreateFourOhOneKReportPayload?: CreateFourOhOneKReportPayloadResolvers<ContextType>;
  CreateFourOhOneKRequestForProposalMutationPayload?: CreateFourOhOneKRequestForProposalMutationPayloadResolvers<ContextType>;
  CreateFourOhOneKRequestForProposalResult?: CreateFourOhOneKRequestForProposalResultResolvers<ContextType>;
  CreateTradePreviewMutationPayload?: CreateTradePreviewMutationPayloadResolvers<ContextType>;
  CsvExport?: CsvExportResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateTime?: GraphQLScalarType;
  Dictionary?: DictionaryResolvers<ContextType>;
  DirectTradingAccount?: DirectTradingAccountResolvers<ContextType>;
  DirectTradingCashBalances?: DirectTradingCashBalancesResolvers<ContextType>;
  DirectTradingSecurityPosition?: DirectTradingSecurityPositionResolvers<ContextType>;
  DirectTradingSecurityPositionReturn?: DirectTradingSecurityPositionReturnResolvers<ContextType>;
  Disclosures?: DisclosuresResolvers<ContextType>;
  DismissAnnouncementMutationPayload?: DismissAnnouncementMutationPayloadResolvers<ContextType>;
  DismissCsvActivityExportBannerMutationPayload?: DismissCsvActivityExportBannerMutationPayloadResolvers<ContextType>;
  DismissFirmBillableAccountsCsvExportMutationPayload?: DismissFirmBillableAccountsCsvExportMutationPayloadResolvers<ContextType>;
  DisplayableError?: DisplayableErrorResolvers<ContextType>;
  DocumentModelPortfolioResource?: DocumentModelPortfolioResourceResolvers<ContextType>;
  Drift?: DriftResolvers<ContextType>;
  EmailDispatch?: EmailDispatchResolvers<ContextType>;
  Employer?: EmployerResolvers<ContextType>;
  EmployerConfig?: EmployerConfigResolvers<ContextType>;
  EmployerContributions?: EmployerContributionsResolvers<ContextType>;
  EmployerResult?: EmployerResultResolvers<ContextType>;
  Envelope?: EnvelopeResolvers<ContextType>;
  EnvelopeAccount?: EnvelopeAccountResolvers<ContextType>;
  EnvelopeYtdReturn?: EnvelopeYtdReturnResolvers<ContextType>;
  EstimatedTradeDate?: EstimatedTradeDateResolvers<ContextType>;
  EstimatedTradeTimeRange?: EstimatedTradeTimeRangeResolvers<ContextType>;
  EstimatedTradeTiming?: EstimatedTradeTimingResolvers<ContextType>;
  ExecutedAgreement?: ExecutedAgreementResolvers<ContextType>;
  ExpenseRatio?: ExpenseRatioResolvers<ContextType>;
  ExternallyAdvisedPlanPortfolio?: ExternallyAdvisedPlanPortfolioResolvers<ContextType>;
  FeeAttempt?: FeeAttemptResolvers<ContextType>;
  FeeAttemptBatch?: FeeAttemptBatchResolvers<ContextType>;
  FeeAttemptFailure?: FeeAttemptFailureResolvers<ContextType>;
  FeeAttemptInputAccount?: FeeAttemptInputAccountResolvers<ContextType>;
  FeeAttemptInputAmount?: FeeAttemptInputAmountResolvers<ContextType>;
  FeeAttemptsResult?: FeeAttemptsResultResolvers<ContextType>;
  FeeConfiguration?: FeeConfigurationResolvers<ContextType>;
  FinancialSecurity?: FinancialSecurityResolvers<ContextType>;
  FinancialSecurityFund?: FinancialSecurityFundResolvers<ContextType>;
  FinancialSecurityOrderRequest?: FinancialSecurityOrderRequestResolvers<ContextType>;
  FinancialSecuritySellOrderTaxImpactPreview?: FinancialSecuritySellOrderTaxImpactPreviewResolvers<ContextType>;
  FinancialSecurityStock?: FinancialSecurityStockResolvers<ContextType>;
  Firm?: FirmResolvers<ContextType>;
  FourOhOneKDocument?: FourOhOneKDocumentResolvers<ContextType>;
  FourOhOneKOnboardingTask?: FourOhOneKOnboardingTaskResolvers<ContextType>;
  FourOhOneKPlan?: FourOhOneKPlanResolvers<ContextType>;
  FourOhOneKPlanFiduciary?: FourOhOneKPlanFiduciaryResolvers<ContextType>;
  FourOhOneKPlanManager?: FourOhOneKPlanManagerResolvers<ContextType>;
  FourOhOneKPlanOnboarding?: FourOhOneKPlanOnboardingResolvers<ContextType>;
  FourOhOneKPlanPerformanceIndicators?: FourOhOneKPlanPerformanceIndicatorsResolvers<ContextType>;
  FourOhOneKPlanSupportAgent?: FourOhOneKPlanSupportAgentResolvers<ContextType>;
  FourOhOneKPlanSupportResource?: FourOhOneKPlanSupportResourceResolvers<ContextType>;
  FourOhOneKReport?: FourOhOneKReportResolvers<ContextType>;
  FourOhOneKReportCreationOption?: FourOhOneKReportCreationOptionResolvers<ContextType>;
  FourOhOneKReportInputOption?: FourOhOneKReportInputOptionResolvers<ContextType>;
  FourOhOneKThirdPartyAdministrator?: FourOhOneKThirdPartyAdministratorResolvers<ContextType>;
  FuturePortfolio?: FuturePortfolioResolvers<ContextType>;
  Gains?: GainsResolvers<ContextType>;
  GainsDetails?: GainsDetailsResolvers<ContextType>;
  HTML?: GraphQLScalarType;
  HistoricalPerformance?: HistoricalPerformanceResolvers<ContextType>;
  Household?: HouseholdResolvers<ContextType>;
  HouseholdResult?: HouseholdResultResolvers<ContextType>;
  InvalidAccountString?: InvalidAccountStringResolvers<ContextType>;
  InvalidAmountString?: InvalidAmountStringResolvers<ContextType>;
  InvalidFeeAttemptBatch?: InvalidFeeAttemptBatchResolvers<ContextType>;
  IraContributions?: IraContributionsResolvers<ContextType>;
  IraContributionsProjection?: IraContributionsProjectionResolvers<ContextType>;
  IraContributionsResult?: IraContributionsResultResolvers<ContextType>;
  LegacyGoal?: LegacyGoalResolvers<ContextType>;
  LegacyID?: GraphQLScalarType;
  LegacySecurity?: LegacySecurityResolvers<ContextType>;
  LegacySubAccount?: LegacySubAccountResolvers<ContextType>;
  LegacyUUID?: GraphQLScalarType;
  LegalAccount?: LegalAccountResolvers<ContextType>;
  LegalAccountBeneficiary?: LegalAccountBeneficiaryResolvers<ContextType>;
  LegalSubAccount?: LegalSubAccountResolvers<ContextType>;
  LinkModelPortfolioResource?: LinkModelPortfolioResourceResolvers<ContextType>;
  Logo?: LogoResolvers<ContextType>;
  ManagedAccount?: ManagedAccountResolvers<ContextType>;
  ManagedAccountPendingAction?: ManagedAccountPendingActionResolvers<ContextType>;
  ManagedPortfolio?: ManagedPortfolioResolvers<ContextType>;
  ManagedSubAccount?: ManagedSubAccountResolvers<ContextType>;
  Message?: MessageResolvers<ContextType>;
  MessageCta?: MessageCtaResolvers<ContextType>;
  MessageCtaLink?: MessageCtaLinkResolvers<ContextType>;
  MessageCtaModal?: MessageCtaModalResolvers<ContextType>;
  ModelPortfolioProvider?: ModelPortfolioProviderResolvers<ContextType>;
  ModelPortfolioProviderConnection?: ModelPortfolioProviderConnectionResolvers<ContextType>;
  ModelPortfolioProviderEdge?: ModelPortfolioProviderEdgeResolvers<ContextType>;
  ModelPortfolioResource?: ModelPortfolioResourceResolvers<ContextType>;
  ModelPortfolioRiskLevel?: ModelPortfolioRiskLevelResolvers<ContextType>;
  ModelPortfolioSecurityGroup?: ModelPortfolioSecurityGroupResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  NotSharedPlatformFeeAllocation?: NotSharedPlatformFeeAllocationResolvers<ContextType>;
  OutboundIntegration?: OutboundIntegrationResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  PayrollContributionConfig?: PayrollContributionConfigResolvers<ContextType>;
  PayrollContributionConfigAccount?: PayrollContributionConfigAccountResolvers<ContextType>;
  PayrollContributionConfigValue?: PayrollContributionConfigValueResolvers<ContextType>;
  PayrollContributionConfigValueAmount?: PayrollContributionConfigValueAmountResolvers<ContextType>;
  PayrollContributionConfigValuePercent?: PayrollContributionConfigValuePercentResolvers<ContextType>;
  PendingAction?: PendingActionResolvers<ContextType>;
  Percent?: GraphQLScalarType;
  Performance?: PerformanceResolvers<ContextType>;
  PerformanceAccount?: PerformanceAccountResolvers<ContextType>;
  PerformanceHistory?: PerformanceHistoryResolvers<ContextType>;
  PerformanceInterest?: PerformanceInterestResolvers<ContextType>;
  PerformanceTotals?: PerformanceTotalsResolvers<ContextType>;
  PlatformFeeAllocation?: PlatformFeeAllocationResolvers<ContextType>;
  PlatformFeeTier?: PlatformFeeTierResolvers<ContextType>;
  PortfolioChangePendingAction?: PortfolioChangePendingActionResolvers<ContextType>;
  PortfolioMigrationPendingAction?: PortfolioMigrationPendingActionResolvers<ContextType>;
  Projection?: ProjectionResolvers<ContextType>;
  ProviderModelPortfolio?: ProviderModelPortfolioResolvers<ContextType>;
  ProviderModelPortfolioConnection?: ProviderModelPortfolioConnectionResolvers<ContextType>;
  ProviderModelPortfolioEdge?: ProviderModelPortfolioEdgeResolvers<ContextType>;
  PublishSolo401kConversionIntentMutationPayload?: PublishSolo401kConversionIntentMutationPayloadResolvers<ContextType>;
  Purpose?: PurposeResolvers<ContextType>;
  PurposeEmergencyFund?: PurposeEmergencyFundResolvers<ContextType>;
  PurposeMajorPurchase?: PurposeMajorPurchaseResolvers<ContextType>;
  PurposeRetirementGrowth?: PurposeRetirementGrowthResolvers<ContextType>;
  PurposeRetirementIncome?: PurposeRetirementIncomeResolvers<ContextType>;
  PurposeRetirementIncomeProjection?: PurposeRetirementIncomeProjectionResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  Rebalance?: RebalanceResolvers<ContextType>;
  RebalanceNowPendingAction?: RebalanceNowPendingActionResolvers<ContextType>;
  RecordNotFoundResult?: RecordNotFoundResultResolvers<ContextType>;
  RecurringTransactionConfig?: RecurringTransactionConfigResolvers<ContextType>;
  RecurringTransactionFrequency?: RecurringTransactionFrequencyResolvers<ContextType>;
  RecurringTransactionFrequencyAnnually?: RecurringTransactionFrequencyAnnuallyResolvers<ContextType>;
  RecurringTransactionFrequencyEveryOtherWeek?: RecurringTransactionFrequencyEveryOtherWeekResolvers<ContextType>;
  RecurringTransactionFrequencyMonthly?: RecurringTransactionFrequencyMonthlyResolvers<ContextType>;
  RecurringTransactionFrequencyTwiceAMonth?: RecurringTransactionFrequencyTwiceAMonthResolvers<ContextType>;
  RecurringTransactionFrequencyWeekly?: RecurringTransactionFrequencyWeeklyResolvers<ContextType>;
  RemoveSolo401kQdiaFundLineupMutationPayload?: RemoveSolo401kQdiaFundLineupMutationPayloadResolvers<ContextType>;
  Result?: ResultResolvers<ContextType>;
  RiskLevelBasedPortfolio?: RiskLevelBasedPortfolioResolvers<ContextType>;
  RiskLevelSecurityGroupAllocation?: RiskLevelSecurityGroupAllocationResolvers<ContextType>;
  SblocLoan?: SblocLoanResolvers<ContextType>;
  SecuritiesLending?: SecuritiesLendingResolvers<ContextType>;
  Security?: SecurityResolvers<ContextType>;
  SecurityCategoryGroup?: SecurityCategoryGroupResolvers<ContextType>;
  SecurityFund?: SecurityFundResolvers<ContextType>;
  SecurityGroupPosition?: SecurityGroupPositionResolvers<ContextType>;
  SecurityGroupSummary?: SecurityGroupSummaryResolvers<ContextType>;
  SecurityPosition?: SecurityPositionResolvers<ContextType>;
  SecurityPositionsBySecurity?: SecurityPositionsBySecurityResolvers<ContextType>;
  SecurityPositionsBySubAccount?: SecurityPositionsBySubAccountResolvers<ContextType>;
  SecurityStock?: SecurityStockResolvers<ContextType>;
  SelfDirectedPortfolio?: SelfDirectedPortfolioResolvers<ContextType>;
  SendClientSecuritiesLendingInvitationMutationPayload?: SendClientSecuritiesLendingInvitationMutationPayloadResolvers<ContextType>;
  SharedPlatformFeeAllocation?: SharedPlatformFeeAllocationResolvers<ContextType>;
  SingleBillingRate?: SingleBillingRateResolvers<ContextType>;
  Solo401kClientEnvelope?: Solo401kClientEnvelopeResolvers<ContextType>;
  Solo401kConversionContributionDetail?: Solo401kConversionContributionDetailResolvers<ContextType>;
  Solo401kConversionIntent?: Solo401kConversionIntentResolvers<ContextType>;
  Solo401kPlan?: Solo401kPlanResolvers<ContextType>;
  SoloFourOhOneKParticipant?: SoloFourOhOneKParticipantResolvers<ContextType>;
  SoloFourOhOneKPlan?: SoloFourOhOneKPlanResolvers<ContextType>;
  StandardFourOhOneKPlan?: StandardFourOhOneKPlanResolvers<ContextType>;
  StrategyChangePendingAction?: StrategyChangePendingActionResolvers<ContextType>;
  Summary?: SummaryResolvers<ContextType>;
  SupportContact?: SupportContactResolvers<ContextType>;
  SupportResources?: SupportResourcesResolvers<ContextType>;
  TIN?: GraphQLScalarType;
  TaxImpact?: TaxImpactResolvers<ContextType>;
  TaxYear?: TaxYearResolvers<ContextType>;
  ThemedAsset?: ThemedAssetResolvers<ContextType>;
  TradePreview?: TradePreviewResolvers<ContextType>;
  TradePreviewExpectedSecurityGroupTrade?: TradePreviewExpectedSecurityGroupTradeResolvers<ContextType>;
  TradePreviewExpectedSecurityTrade?: TradePreviewExpectedSecurityTradeResolvers<ContextType>;
  TradePreviewExpectedTrade?: TradePreviewExpectedTradeResolvers<ContextType>;
  Trust?: TrustResolvers<ContextType>;
  URL?: GraphQLScalarType;
  UnenrollClientFromSecuritiesLendingMutationPayload?: UnenrollClientFromSecuritiesLendingMutationPayloadResolvers<ContextType>;
  UpdateBillingPlanPaymentTypesMutationPayload?: UpdateBillingPlanPaymentTypesMutationPayloadResolvers<ContextType>;
  UpdateClientEnvelopeBankAccountsMutationPayload?: UpdateClientEnvelopeBankAccountsMutationPayloadResolvers<ContextType>;
  UpdateClientEnvelopeBeneficiariesMutationPayload?: UpdateClientEnvelopeBeneficiariesMutationPayloadResolvers<ContextType>;
  UpdateDefaultBillingPlanMutationPayload?: UpdateDefaultBillingPlanMutationPayloadResolvers<ContextType>;
  UpdateHouseholdBillingPlanMutationPayload?: UpdateHouseholdBillingPlanMutationPayloadResolvers<ContextType>;
  UpdateManagedPortfolioRebalancingMutationPayload?: UpdateManagedPortfolioRebalancingMutationPayloadResolvers<ContextType>;
  UpdateOutboundIntegrationSubscriptionMutationPayload?: UpdateOutboundIntegrationSubscriptionMutationPayloadResolvers<ContextType>;
  UpdatePlanFeedConsentMutationPayload?: UpdatePlanFeedConsentMutationPayloadResolvers<ContextType>;
  UpdateQdiaFundLineupMutationPayload?: UpdateQdiaFundLineupMutationPayloadResolvers<ContextType>;
  UpdateSolo401kConversionIntentContributionsMutationPayload?: UpdateSolo401kConversionIntentContributionsMutationPayloadResolvers<ContextType>;
  UpdateSolo401kConversionIntentFundsTypeMutationPayload?: UpdateSolo401kConversionIntentFundsTypeMutationPayloadResolvers<ContextType>;
  UpsertBillingPlanMutationPayload?: UpsertBillingPlanMutationPayloadResolvers<ContextType>;
  UserPortfolioControls?: UserPortfolioControlsResolvers<ContextType>;
  ValidCents?: ValidCentsResolvers<ContextType>;
  ValidateClientEnvelopeBeneficiaryMutationPayload?: ValidateClientEnvelopeBeneficiaryMutationPayloadResolvers<ContextType>;
  ValidateFinancialSecurityOrderRequest?: ValidateFinancialSecurityOrderRequestResolvers<ContextType>;
  ValidateFinancialSecurityOrderRequestMutationPayload?: ValidateFinancialSecurityOrderRequestMutationPayloadResolvers<ContextType>;
  ValidateSolo401kConversionIntentMutationPayload?: ValidateSolo401kConversionIntentMutationPayloadResolvers<ContextType>;
  ValidateSolo401kPlanFormMutationPayload?: ValidateSolo401kPlanFormMutationPayloadResolvers<ContextType>;
  ValidatedSolo401kPlanForm?: ValidatedSolo401kPlanFormResolvers<ContextType>;
  Vested?: VestedResolvers<ContextType>;
  YtdReturn?: YtdReturnResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  expensive?: ExpensiveDirectiveResolver<any, any, ContextType>;
  owned?: OwnedDirectiveResolver<any, any, ContextType>;
};
